import { Component, OnInit, ViewChild, ElementRef, AfterViewInit } from "@angular/core";
import { ActivatedRoute, Router,NavigationEnd  } from "@angular/router";
import { ENDPOINTS, ORG_DETAILS } from "src/app/app.config";
import { AppService } from "src/app/app.service";
import { ProductSlider,ProductSlider1,ProductSlider6,ProductSlider7,ProductSlider3,ProductSlider5,ProductSlider4,ProductSlider9} from "../../../../Components/sliders/slider"
import {
  ProductDetailsMainSlider,
  ProductDetailsThumbSlider,
} from "src/app/Components/sliders/slider";
import metaData from "src/assets/data/default/product-details.json";
import { MetaDataMapService } from "src/app/meta-data-map.service";
import { LocalStorageService } from "src/app/Services/auth-service/local-storage.service";
import { AlertsService } from "src/app/Components/alerts/alerts.service";
import { DomSanitizer } from "@angular/platform-browser";
import { OwlOptions } from "ngx-owl-carousel-o/lib/models/owl-options.model";
import { config } from "src/configs/config";
import { CustomerLoginStorageService } from 'src/app/Lazy-loaded-Modules/Checkout-new/checkout-login/customer-login-storage.service';
import {
  UntypedFormGroup,
  UntypedFormBuilder,
  Validators,
  FormGroup,
  FormArray
} from "@angular/forms";
import { HostListener } from '@angular/core';
import * as moment from 'moment';
import { CartService } from "src/app/Lazy-loaded-Modules/Cart-module/cart-page/cart-page.service";
import { HttpHeaders } from '@angular/common/http';
import { CheckoutApiService } from 'src/app/Lazy-loaded-Modules/Checkout-new/checkout-api.service';
import { CheckoutLocalStorageService } from 'src/app/Lazy-loaded-Modules/Checkout-new/checkout-local-storage.service';
import { LoaderService } from "src/app/Components/loader/loader.service";
import { LoginService } from "src/app/Lazy-loaded-Modules/Account-Modules/login-new/login-new.service";
import { MetadataService } from "src/app/Services/seo_services/head_metadata.service";
import { SEO_VARIABLES } from "src/seo/seo.config";
import { ProductDetailsService } from './product-details.service';
import { coerceStringArray } from "@angular/cdk/coercion";
import { SEOService } from 'src/app/seo.service';
import {HeaderService} from '../../../../Components/Common/header/header-two/header.service';

/**
 * individual interface  for each instance of a product
 */
interface bestGiftsProductEntry {
  maskImages: string[],
  text: string,
  quantity: number,
}


@Component({
  selector: "app-product-details",
  templateUrl: "./product-details.component.html",
  styleUrls: ['./product-details.component.scss']
})

export class ProductDetailsComponent implements AfterViewInit {
  
  @ViewChild('closeModal') private closeModal: ElementRef;
  typeSelected: string;
  vimpro_pro_name;
  
  id : any;
  parameters: any;
  parentid : any;
  review: any;
  reviewData: any;
  review_list : any = []
  total_rating : number = 0;
  one_star : number = 0;
  two_star : number = 0;
  three_star : number = 0;
  four_star : number = 0;
  five_star : number = 0;
  productId: any;
  public req_filter_data2;
  showOffer : boolean = false
  number_of_reviews : number = 0;
  width1 : number = 0;
  width2 : number=0;
  width3 : number=0;
  width4 : number=0;
  width5 : number=0;
  product_rating : number;
  varianName:any;
  childName:any;
  socialMediaData:any = [];
  ImageArr:any = [];
  imageMobileArr:any = [];
  facebookLink;
  allProducts
  instagramLink;
  similarProduct;
  whatsappLink;
  hobCateURL
  twitterLink;
  deera_price_data : any;
  deera_variant_price : any;
  deera_variant_id : any;
  baby_variant_id : any;
  baby_variant_price : any
  productRating : UntypedFormGroup;
  material_vimpro:any=[];
  imgFile2 : string="";
  color_vimpro:any=[];
  usage_vimpro:any=["One Time","Recycle"];
  maxValuetemp: Number = 200;
  listcategory = [];
  config = config;
  totalPrice = 0;
  acceptanceTiming:any;
  imageNotFound = config.noImageAvailable;
  public ProductDetailsMainSliderConfig: any = ProductDetailsMainSlider;
  public ProductDetailsThumbConfig: any = ProductDetailsThumbSlider;
  public activeSlide: any = 0;
  public imageUploadCount;
  public imageUploadCount1;
  public imageUploadCount2;
  public totalLength;
  queryParams: any;
  public ProductSliderConfig: any = ProductSlider;
  public ProductSliderConfig1: any = ProductSlider1;
  public ProductSliderConfig6: any = ProductSlider6;
  public ProductSliderConfig5: any = ProductSlider5;
  public ProductSliderConfig7: any = ProductSlider7;
  public ProductSliderConfig3: any = ProductSlider3;
  public ProductSliderConfig4: any = ProductSlider4;
  public ProductSliderConfig9: any =ProductSlider9
  newProductDetails: any;
  featureProductsApiData:any;
  relatedProducts:any = []
  recommededProducts:any = []
  recommededProductsLush:any = []
  activeMenu: string;
  specialadd : boolean = false;
  specialval:boolean = false;
  multiImage:boolean = false;
  currentRating;
  dataMap = {};
  price: any;
  sizeVariable: any;
  respData: any;
  showPrice = false;
  checkVariantInCart: any;
  isValid = false;
  groups = [];
  isSimilar: boolean = false;
  isDisabled: boolean = false;
  isIncrease: boolean = false;
  isDecrease: boolean = false;
  isDecreased: boolean = false;
  addImage: boolean = false;
  showtype: boolean = false;
  increaseQuantity;
  decreaseQuantity;
  roundedPercentage;
  public maskFiles: any;
  showSize = false;
  variantName: any;
  public executionData = [];
  variants = [];
  public req_filter_data1;
  priceOfVariant: any;
  msrpofVariant: any;
  unitofVariant:any;
  showHint: any;
  generalInfo: boolean = false;
  addCart = false;
  descriptionData: any;
  innnerhtmlData: any;
  additionData: any;
  perPeice: any;
  products1;
  totalProducts:any = 0;
  totalItemsOrProducts:any = 0;
  isActive: any;
  isActive1:any=0;
  public cartData = [];
  productObj = [];
  productType: any;
  showAlerts = false;
  approved:any;
  customerType:any;
  productQuantity1 = false;
  options = {
    autoClose: true,
    keepAfterRouteChange: false,
  };
  tableHead = [];
  bulletPoints;
  congratulationsBannerMessage;
  eligibleBannerMessage = [];
  upsellBannerMessage;
  tableData = [];
  description: any;
  shortDescription: any;
  instructionDescription:any;
  metaDescription: any;
  Description: any;
  otherDescription: any;
  validateForm: boolean=true;
  mainImagePreview: any;
  SchiftOfferMessage:any;
  offerDisplay: boolean = false;
  showImage: boolean = false;
  showVideo: boolean = false;
  image_preview: boolean = false;
  showInstruction: boolean = false;
  video_preview: boolean = false;
  disableColor: boolean = false;
  reviews = "0";
  imageAssets = [];
  videoAssets = [];
  maskImages:any;
  chartImages:any;
  special_pro_name;
  availableLocation: boolean = false;
  notAvailableLocation: boolean = false;
  banner = "";
  promotionData: any;
  imageIndexes1 = [];
  products = [];
  offers = [];
  finalMaskImageData: any = [];
  customOptions: OwlOptions = {
    autoplay: false,
    loop: false,
    navSpeed: 300,
    stagePadding: 130,
    navText: [
      '<i class="fa fa-chevron-left"></i>',
      '<i class="fa fa-chevron-right"></i>',
    ],
    responsive: {
      0: {
        items: 1,
      },
      10: {
        items: 2,
      },
      20: {
        items: 3,
      },
    },
    nav: true,
  };
  instructionDesc: any;
  ImageVideoPreview = [];
  mainImage: any;
  mainViewVideo: any;
  productViewVideo:boolean=false;
  productViewVideo1:any;
  viewVideo:boolean=true;
  viewVideo1:boolean=false;
  displayURL: any;
  disableindex
  unDisable
  attributeTitle: any;
  showData: boolean = false;
  productIdSchift: any;
  productChildId: any;
  mayanId: any;
  schiftId:any;
  detailForm: UntypedFormGroup;
  numPattern = /^[0-9]*$/;
  showSpinner: boolean = false;
  locationName: string;
  courierObj: any;
  courierName: any;
  estdDelivery: any;
  showStorage: boolean = false;
  variantMSRP=0;
  variantUnit=0;
  what_you_will_learn;
  selection_process=[];
  public category;
  newActive;
  public priceStrikeOutInDetailScreen;
  public showPricekey;
  public strikeOutPriceKey;
  public congratulationBanner: any;
  public congratulationBanner1: any;
  public upsellBanner;
  public percentageValue;
  public fixedAmount;
  public discountValue;
  public promotionType: any;
  public quantityPromotion;
  public productPromotion;
  public productQuantity = 0;
  public onloadvarId;
  public onloadvarCost;
  public onloadvarQuantity;
  public onloadId;
  public onloadCost;
  public onloadQuantity;
  public imageList = {};
  public newId;
  memberId: any = "";
  companyName;
  imgSrc: string;
  enquiryForm: UntypedFormGroup;
  enquiryForm_vimpro: UntypedFormGroup;
  enquiryForm_special: UntypedFormGroup;
  product: any;
  owner: any = "";
  public current_index = 0;
  public child_index=0;
  public variant_index=-1;
  public asset_index=0;

  establised: any = "";
  imageName: string = "";
  // imgFile : string="";
  imgFile = [];
  imgFile1 = [];
  previewImgUrl: string = "";

  productMaskImageForm: FormGroup;
  validateMaskImageForm: boolean = false;
  imagelist: any = {};
  maskImageData: any;
  editImage: boolean = false;
  enableEdit = true;
  customerLogin: boolean = false;
  customer_id;
  taz_prod;
  taz_parent;
  customerType1:any;
  x: number = 0;
  checkoutAlerts: boolean = false;
  content1: any;
  contentOtherDesc : any;
  eventValue;
  selectedboth: boolean = false;
  selectedOption1: any;
  selectedOption2: any;
  selectedSCH: any;
  existingCartProduts = [];
  sub_product_data: any;
  option1: any;
  option2: any;
  bcrumbs_category;
  bombayhardwareprice;

  // Best gift variables
  currentUserType: any;
  numberOfProductsBestGifts: number;
  numberOfMaskUploads: number;
  imageListForUpload: any = {};
  refinedMaskImages: any = {};
  localRefinedMaskImages: any = {};
  imageListBestGifts: any = []
  imageListBackup: any = []
  tempCartBestGifts: any = this.appService.cartProducts;
  editModeBestGifts: boolean = false;
  deletedFlag = false;
  saveFlag = false;
  checkoutRedirectFlag: boolean = false;
  currentProductListBestGifts: bestGiftsProductEntry[] = []
  imageListForConversion:any = []

  modelForBindingInputs: any = {

  }
  modelForBindingTextInputs: any = {

  }
  selectedProduct
  schiftCategory;
  previousUrl: string | null = null;
  currentUrl: string | null = null;
  currentPageUrl;
  avonSealsPrice: any;
  avonSealsDescription: any;
  avonSealsWeight: any;
  linenRajPrice: any;
  linenRajDescription: any;
  linenRajWeight: any;
  active: any;
  freeOfferProduct : any;
  filtersApiData: any;
  childPaulid: any;
  totalNumberOfProducts: any;
  paulIndex: number= 0;
  defaultPromotion: boolean = false;
  public outletId;

  constructor(
    public appService: AppService,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    public metaDataMapService: MetaDataMapService,
    private cartService: CartService,
    private localService: LocalStorageService,
    private alertService: AlertsService,
    private sanitizer: DomSanitizer,
    private formBuilder: UntypedFormBuilder,
    private customerLoginStorageService: CustomerLoginStorageService,
    private route: ActivatedRoute,
    private checkoutApiService: CheckoutApiService,
    private checkoutLocalStorageService: CheckoutLocalStorageService,
    private loaderService: LoaderService,
    private LoginService:LoginService,
    private metadataService: MetadataService,
    private productDetailsService: ProductDetailsService,
    private seoService: SEOService,
    private headerService: HeaderService


  ) { 
    if(ORG_DETAILS.NAME!=='LinenRaj' && ORG_DETAILS.NAME !== 'Babys Pride'){
      console.log("test2")
      this.metadataService.configureMetadata(SEO_VARIABLES.PRODUCT_DETAILS.DESCRIPTION, SEO_VARIABLES.PRODUCT_DETAILS.KEYWORDS, SEO_VARIABLES.PRODUCT_DETAILS.TITLE)
      
    }
    if(ORG_DETAILS.NAME==='LinenRaj'){
    try{
      if(this.router.getCurrentNavigation().extras.state.checkoutRedirect) {
        this.checkoutRedirectFlag = true
      }
    } catch {
      this.checkoutRedirectFlag = false
    }
    console.log("test1")
    this.metadataService.configureMetadata(SEO_VARIABLES.PRODUCT_DETAILS.DESCRIPTION, SEO_VARIABLES.PRODUCT_DETAILS.KEYWORDS, SEO_VARIABLES.PRODUCT_DETAILS.TITLE)
    }
    
  }

  themes: any;
  ngAfterViewInit(): void {
    console.log("this.groups[5].fields[0].labelname",this.groups[5].fields[0].labelname)
    if(this.config.title!=="Srimaware" && this.config.title!=="HOB" && this.config.title!=="PaulCaroline" && this.config.title !=='UrbanBox'){
      this.changeTab(this.groups[5].fields[0].labelname);
    }
   
      console.log("After init: ", this.groups);

    
   

    // document.getElementById("bestgiftsloader").style.display="none"
  }
  staticAttributes = [
    {
      attr_name: "Category",
      attr_value: "-",
    },
    {
      attr_name: "Brand",
      attr_value: "-",
    },
    {
      attr_name: "SKU",
      attr_value: "-",
    },
    {
      attr_name: "Sale Price",
      attr_value: "-",
    },
    {
      attr_name: "Stock Status",
      attr_value: "-",
    },
  ];
  ngOnInit(): void {
// below code is used for to set product id from routing because of changed to path routing for SEO
if(ORG_DETAILS.NAME==='HOB' || ORG_DETAILS.NAME==='PaulCaroline'){
const uniqueName = this.activatedRoute.snapshot.params['category'].replace(/-/g, ' ');
this.hobCateURL = [uniqueName];
console.log("Category Demostration",this.hobCateURL)
}
this.activatedRoute.queryParamMap.subscribe((params) => {
  console.log(this.activatedRoute.snapshot, this.activatedRoute.snapshot.params.uniquename, "iqqq", this.activatedRoute.snapshot.queryParams.length)
  if(this.config.title!=="BombayHardware" && this.config.title!=="LushNGreen"){
  this.schiftCategory = this.activatedRoute.snapshot.params.category.replace(/-/g, ' ');
  console.log("CategorySchiftURL",this.schiftCategory)
  }
  if (this.activatedRoute.snapshot.params === undefined || this.activatedRoute.snapshot.queryParams.length == undefined) {



    console.log("this.activatedRoute.snapshot ", this.activatedRoute.snapshot);



    var uniqueName: String;
    var uniqueNameArrayValue = [];
    uniqueName = this.activatedRoute.snapshot.url[this.activatedRoute.snapshot.url.length - 2].path;
    console.log(uniqueName, "uniqueName")
    uniqueNameArrayValue = this.activatedRoute.snapshot.params.uniquename.split('-'); //[""]
    console.log(uniqueNameArrayValue)
    console.log("lkajsldkhkdaf",uniqueNameArrayValue[uniqueNameArrayValue.length - 2])
    if(this.config.title==="LushNGreen" || this.config.title==="Srimaware"){
     if (!isNaN(uniqueNameArrayValue[uniqueNameArrayValue.length - 2])) {
      this.splitProductString(this.activatedRoute.snapshot.params.uniquename);
     }
     else{
      console.log("balabalab",uniqueNameArrayValue)
      this.productId = Number(uniqueNameArrayValue[uniqueNameArrayValue.length - 1]);
      this.productChildId = Number(uniqueNameArrayValue[uniqueNameArrayValue.length - 2]);
      let requestBody = {
        domain_name: ORG_DETAILS.DOMAIN_NAME,
        user_id: ORG_DETAILS.USER_ID,
        extras: {
          find: {
            id: Number(this.productId),
            // outlet_id:this.outletId,
          },
          pagination: false,
          paginationDetails: {
            limit: 0,
            pageSize: 2,
          },
          sorting: true,
          sortingDetails: {
            sortfield: "",
            sortorder: 1,
          },
        },
      };
      this.getProductDetailsById(requestBody);
      console.log("product Details",this.product,this.newProductDetails)
     }
    }
    else if(this.config.title==="HOB" || this.config.title==="PaulCaroline" || this.config.title==="Carience"){
        this.req_filter_data2 = {
          domain_name: ORG_DETAILS.DOMAIN_NAME,
          user_id: null,
          extras: {
            find: {
              brand: [],
              category: this.hobCateURL,
              theme:[],
              finish:[],
              feature:[],
              price:[],
              size:[],
              thickness:[],
              color:[],
              type:[],
              product_material:[],
                  age:[],
                    affiliation:[],
                      standard:[],
                    subject:[],
                    year:[],
                    price_range:[],
                  author:[],
              last90days: false,
              last30days: false,
              includeoutofstock: false,
              isglobalfilter: true,
            },
            pagination: true,
            paginationDetails: {
              limit: 1
            },
            sorting: true,
            sortingDetails: {
              sortfield: "name",
              sortorder: -1,
            },
            subcategoryfilter: false,
          },
        };
        this.appService
        .postApiCall(this.req_filter_data2, ENDPOINTS.GET_FILTER_PRODUCTS)
        .subscribe(
          (resp) => {
            let filtersApiData = resp;
            this.allProducts = filtersApiData.result.data
console.log("all Products of the category",this.hobCateURL,":",this.allProducts)
const parts = uniqueNameArrayValue;
const possibleId = parts[parts.length - 1];
console.log("Id to be retrieved",possibleId)
const matchingProduct = this.allProducts.find(product => Number(product.id) === Number(possibleId));

  if (matchingProduct) {
    // Store the value in a variable
    this.selectedProduct = matchingProduct;
    console.log('Matching Product Found:', this.selectedProduct);
    this.productId = possibleId
  } else {
    console.log(`No product found with ID: ${possibleId}`);
    this.productId = parts[parts.length - 2];
    this.productChildId = possibleId
    this.childPaulid = possibleId
  }
  let requestBody = {
    domain_name: ORG_DETAILS.DOMAIN_NAME,
    user_id: ORG_DETAILS.USER_ID,
    extras: {
      find: {
        id: Number(this.productId),
        // outlet_id:this.outletId,
      },
      pagination: false,
      paginationDetails: {
        limit: 0,
        pageSize: 2,
      },
      sorting: true,
      sortingDetails: {
        sortfield: "",
        sortorder: 1,
      },
    },
  };
  this.similarProduct = []
  this.getProductDetailsById(requestBody);
  this.getProductDetails(this.productId)
          }
        )
     }
    else{
      this.productId = Number(uniqueNameArrayValue[uniqueNameArrayValue.length - 1]);
      this.productChildId = Number(uniqueNameArrayValue[uniqueNameArrayValue.length - 2]);
    }
    
    console.log(uniqueNameArrayValue, "iqqq", this.productId, this.productChildId)

    // console.log(this.queryParams.params["id"], "id value");
    // here the this.activatedRoute.snapshot.params value is assigned because of changed to path routing for SEO
    this.activatedRoute.snapshot.params = {
      "id": this.productId,
      "cid": this.productChildId
    }
    this.activatedRoute.snapshot.queryParams = {
      "id": this.productId,
      "cid": this.productChildId
    }


    // this.queryParams.params["cid"] = Number(uniqueNameArrayValue[uniqueNameArrayValue.length - 2])


  }
});

    this.currentPageUrl = this.getCurrentURL()
    this.seoService.updateCanonicalUrl(this.currentPageUrl);
    this.typeSelected = 'ball-fussion';
    document.getElementById("bestgiftsloader").style.display="none"
    this.productDetailsService.clearEvent();
    this.outletId = this.appService.outletId;
    if(this.outletId==1){
      this.outletId = this.localService.get('karupattirajaOutletId');
    }
  
    if(this.config.title=="Karupattiraja"){
      if(this.outletId=="0"|| this.outletId==0||this.outletId==""|| this.outletId==null ){
        this.outletId=1;
      }
      
    }
    let tempCart = this.appService.cartProducts;
    console.log("CART: ", tempCart)
    if (this.localService.get('CustomerData')) {
      this.currentUserType = JSON.parse(this.localService.get('CustomerData')).type
      console.log("currentUser: ", (this.currentUserType == "business customer"))

      console.log("currentUser: business customer")
    } else {
      this.currentUserType = "individual customer"
      console.log("currentUser: ", this.currentUserType)
    }
    this.productRating = new UntypedFormGroup({
      rating: this.formBuilder.control(0, [])
    })
    
    if(ORG_DETAILS.NAME!=='Schift Cosmetics'){
      this.route.queryParams.subscribe(params => {
        this.parameters = this.route.snapshot.params;
        this.id = this.parameters['id']
        this.parentid = this.parameters['product.parent.id']
        console.log("this.parameters['parent.id']",this.parameters['product.parent.id'])
        console.log("121212",this.parameters)
      });
    }
   else{
      this.activatedRoute.queryParams.subscribe(params => {
        this.bcrumbs_category = params['url'];
        console.log(this.bcrumbs_category, "this.bcrumbs_category");
        this.id = params['id']
        this.schiftId = params['id']
        this.productId = params['id']
        this.getProductDetails(this.productId)
      });
    }
if(ORG_DETAILS.NAME==='Taazah'){
  console.log("ggggggggggggggggggggggggg")
  this.activatedRoute.queryParams.subscribe(params => {
    this.taz_parent=this.parameters['product.parent.id']
    this.taz_prod=params['id']
    console.log("ggggggggggggggggggggggggg",params['id'])
    this.onConfirm1(this.product.variant.option_values,this.taz_prod, 1)
  });

  
}
    this.activatedRoute.queryParams.subscribe(params => {
      this.bcrumbs_category = params['url'];
      console.log(this.bcrumbs_category, "this.bcrumbs_category");

    });
    if(ORG_DETAILS.NAME!=='Schift Cosmetics' && ORG_DETAILS.NAME!=='HOB' && ORG_DETAILS.NAME!=='PaulCaroline'){
    this.route.queryParamMap.subscribe(params => {
      let queryParams = this.route.snapshot;
      console.log(queryParams,"queryParams")
      this.productId = queryParams.params['id'];
      console.log(this.productId, 'category')
      this.getProductDetails(this.productId)

    })
  }
    this.route.queryParams.subscribe(params => {
      if (params.fromLogin == 'fromLogin') {
        this.customerLogin = true;
      }
    });

    this.customer_id = this.localService.get('UserId');
    this.checkoutAlerts = true;
    this.enquiryForm = new UntypedFormGroup({
      name: this.formBuilder.control('', [Validators.required, Validators.maxLength(80)]),
      email: this.formBuilder.control('', [Validators.required, Validators.maxLength(50), Validators.pattern("^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,4}$")]),
      phone_number: this.formBuilder.control('', [Validators.required, Validators.maxLength(10), Validators.pattern("^[+]*[(]{0,1}[0-9]{10}[)]{0,1}[-\s\./0-9]*$")]),
      category: this.formBuilder.control('', [Validators.required]),
      message: this.formBuilder.control('', [Validators.required, Validators.maxLength(600)])
    })
    let userId = this.localService.get('UserId');
 
   if(ORG_DETAILS.NAME==='BestGifts'){
    if(userId){
      this.getBestGiftsProfileDetails(this.localService.get('UserId')!=null?Number(this.localService.get('UserId')):'');
    } else {
      this.customerType1 = "individual customer"
    }
   }
   if(ORG_DETAILS.NAME==='Schift Cosmetics'){
    this.customerType1 = "individual customer"
   }


    this.detailForm = new UntypedFormGroup({
      zipcode: this.formBuilder.control("", [
        Validators.pattern('^[0-9]{6}$'),
      ]),
    });
    this.enquiryForm_special = new UntypedFormGroup({
      name: this.formBuilder.control("", [
        Validators.required,
        Validators.maxLength(80),
      ]),
      email: this.formBuilder.control("", [
        Validators.required,
        Validators.maxLength(50),
        Validators.pattern("^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,4}$"),
      ]),
      phone_number: this.formBuilder.control("", [
        Validators.required,
        Validators.maxLength(10), Validators.minLength(10),
        Validators.pattern("^[+]*[(]{0,1}[0-9]{10}[)]{0,1}[-s./0-9]*$"),
      ]),
      category: this.formBuilder.control(""),
      drawing: this.formBuilder.control(""),
      diameter: this.formBuilder.control(""),
      imageFile: this.formBuilder.control(""),
      e_length: this.formBuilder.control(""),
      quantity: this.formBuilder.control(""),
      product_name: this.formBuilder.control("", [Validators.required]),
      message: this.formBuilder.control("", [
        Validators.required,
        Validators.maxLength(600),
      ]),
    });
    this.enquiryForm_vimpro = new UntypedFormGroup({
      name: this.formBuilder.control("", [
        Validators.required,
        Validators.maxLength(80),
      ]),
      email: this.formBuilder.control("", [
        Validators.required,
        Validators.maxLength(50),
        Validators.pattern("^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,4}$"),
      ]),
      phone_number: this.formBuilder.control("", [
        Validators.required,
        Validators.maxLength(10),
        Validators.pattern("^[+]*[(]{0,1}[0-9]{10}[)]{0,1}[-s./0-9]*$"),
      ]),
      category: this.formBuilder.control("", [Validators.required]),
      product_name: this.formBuilder.control("", [Validators.required]),
      length: this.formBuilder.control(""),
       thickness: this.formBuilder.control(""),
       height: this.formBuilder.control(""),
       width: this.formBuilder.control(""),
       quantity: this.formBuilder.control(""),
      material: this.formBuilder.control(""),
      color: this.formBuilder.control(""),
      usage: this.formBuilder.control(""),
      message: this.formBuilder.control("", [
        Validators.required,
        Validators.maxLength(600),
      ]),
    });
    this.productMaskImageForm = new FormGroup({
      lists: this.formBuilder.array([this.addProductMaskImageForm()])
    })
    this.newActive = 0;
    this.cartService.updateCartItem(this.appService.cartProducts.results);
    this.groups = metaData.groups;
    console.log(this.groups);
    document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
    this.activatedRoute.queryParamMap.subscribe((params) => {
      this.queryParams = this.activatedRoute.snapshot;
      this.productId = this.queryParams.params["id"];
      console.log("indexfinding for id",this.queryParams.params)
      this.childPaulid = this.queryParams.params["cid"];
      
      console.log("Index and id finding Paul",this.current_index,this.paulIndex,this.childPaulid)
      if (this.queryParams.params["id"]) {

        let requestBody = {
          domain_name: ORG_DETAILS.DOMAIN_NAME,
          user_id: ORG_DETAILS.USER_ID,
          extras: {
            find: {
              id: Number(this.queryParams.params["id"]),
              // outlet_id:this.outletId,
            },
            pagination: false,
            paginationDetails: {
              limit: 0,
              pageSize: 2,
            },
            sorting: true,
            sortingDetails: {
              sortfield: "",
              sortorder: 1,
            },
          },
        };
        this.getProductDetailsById(requestBody);
        if (this.config.title !== 'Schift') {
        this.getReviewDetails();
        }
        // this.assignMaskImageData();
        if (this.config.title === 'Deera') {
          this.getPromotionBanner();
        }
      }
      else if (this.mayanId) {
        let requestBody = {
          domain_name: ORG_DETAILS.DOMAIN_NAME,
          user_id: ORG_DETAILS.USER_ID,
          extras: {
            find: {
              id: Number(this.mayanId),
            },
            pagination: false,
            paginationDetails: {
              limit: 0,
              pageSize: 2,
            },
            sorting: true,
            sortingDetails: {
              sortfield: "",
              sortorder: 1,
            },
          },
        };
        this.getProductDetailsById(requestBody);

      }
      else if (this.schiftId) {
        let requestBody = {
          domain_name: ORG_DETAILS.DOMAIN_NAME,
          user_id: ORG_DETAILS.USER_ID,
          extras: {
            find: {
              id: Number(this.schiftId),
            },
            pagination: false,
            paginationDetails: {
              limit: 0,
              pageSize: 2,
            },
            sorting: true,
            sortingDetails: {
              sortfield: "",
              sortorder: 1,
            },
          },
        };
        this.getProductDetailsById(requestBody);

      }
    });
    for (let i = 0; i < this.appService.cartProducts.results.length; i++) {
      this.cartData.push(this.appService.cartProducts.results[i].product_id);
    }

    this.priceStrikeOutInDetailScreen = this.localService.get(
      "price_strikeout_in_detail_screen"
    );

    this.showPricekey = this.localService.get("show_price_key");
    this.strikeOutPriceKey = this.localService.get("strike_out_price_key");
    this.sub_product_data = this.localService.get('subProduct');
    this.option1 = this.localService.get('option1');
    this.option2 = this.localService.get('option2');
    this.selectedSCH = this.option1;


    if (this.customerLogin == true) {

      let obj1 = {
        domain_name: ORG_DETAILS.DOMAIN_NAME,
        user_id: ORG_DETAILS.USER_ID,
        extras: {
          find: {
            "customer_id": this.customer_id
          },
        },
      };
      try {
        this.appService.postApiCall(obj1, ENDPOINTS.GET_ALL_OFFERS_CUSTID).subscribe(
          (resp) => {
            console.log("THE HECK IS THIS: ", resp)
            if (resp) {
              this.offers = resp.result.data.eligible_banner_message;

              console.log("ON LAUNCH: ", resp)

            }
          },
          (err) => {
            if (err.error.statusCode === 403) {
            } else if (err.error.error.message) {
            } else {
            }
          }
        );
      } catch (err) {
        console.log("[ERROR]: error in firing api")
      }



    }
    else {
      let obj1 = {
        domain_name: ORG_DETAILS.DOMAIN_NAME,
        user_id: ORG_DETAILS.USER_ID,
        extras: {
          find: {

          },
        },

      };

      try {
        this.appService.postApiCall(obj1, ENDPOINTS.GET_ALL_OFFERS).subscribe(
          (resp) => {
            if (resp) {
              if (resp.result.data.eligible_banner_message) {
                this.offers = resp.result.data.eligible_banner_message;
              }
            }
          },
          (err) => {
            if (err.error.statusCode === 403) {
            } else if (err.error.error.message) {
            } else {
            }
          }
        );
      } catch (err) {
        console.log("[ERROR]: error in firing api")
      }
    }
if(ORG_DETAILS.NAME !== "Deera" && ORG_DETAILS.NAME !== "KatbookStore" && ORG_DETAILS.NAME !== "UrbanBox"){
    var req_feature_product_data = {
      "domain_name": ORG_DETAILS.DOMAIN_NAME,
      "user_id": null,
      // "outlet_id":Number(this.outletId),
      // "outlet_id":"",
      "extras": {
        "find": {
          // "outlet_id":this.outletId,
        },
        "pagination": true,
        "paginationDetails": {
          "limit": 1,
          "pagesize": 300
        },
        "sorting": true,
        "sortingDetails": {
          "sortfield": "id",
          "sortorder": -1
        }
      }
    }
    this.appService.postApiCall(req_feature_product_data, ENDPOINTS.GET_FEATURED_PRODUCTS).subscribe(
      resp => {
        this.featureProductsApiData = resp;
        console.log("this.featureProductsApiData",this.featureProductsApiData,this.newProductDetails)
        if(ORG_DETAILS.NAME !== "Babys Pride" && ORG_DETAILS.NAME !== "MAYAN" && ORG_DETAILS.NAME !== "ShubhCards" && ORG_DETAILS.NAME !== "HOB" && ORG_DETAILS.NAME !== "PaulCarline"){
        this.recommededProducts = this.featureProductsApiData.result.data.filter(element =>{
          
          return element.name != this.newProductDetails.name
          }
                    );
                    console.log("Recommended Products",this.recommededProducts)
                  }
                    if(ORG_DETAILS.NAME === "Babys Pride" || ORG_DETAILS.NAME === "ShubhCards"|| ORG_DETAILS.NAME === "PaulCarline"){
                      this.recommededProducts = this.featureProductsApiData.result.data
                    }
      },
      err => {
        if (err.error.error.message) {
          console.log(err.error.error.message)
        }
        else{
          console.log('Something bad happened; Please try again!')
        }
      })
    }

    this.productDetailsService.currentData.subscribe(currentData => {
      let data:any = currentData;
      if(data.name === "removeCart"){
        console.log("data.name"+data.name)
        if(this.newProductDetails.product_type==="Simple"){
          this.productQuantity1 = false;
        for (let j = 0; j < this.appService.cartProducts.results.length; j++) {                   
            console.log("this.appService.cartProducts.results[j].product_id"+this.appService.cartProducts.results[j].product_id)
            console.log("this.queryParams.params"+this.queryParams.params["id"])
            console.log("this.queryParams.paramsSSSSSSS"+this.queryParams.params["id"])
            if (
              Number(this.appService.cartProducts.results[j].product_id) ===
              Number(this.queryParams.params["id"])
            ) {
              console.log("this.queryParams.paramsSSSSSSS")
              this.onloadId = this.appService.cartProducts.results[j].product_id;
              this.onloadCost =
                this.appService.cartProducts.results[j].product.pricing.raw.cost;
              this.onloadQuantity =
                this.appService.cartProducts.results[j].quantity;

                let tempArray = this.appService.cartProducts.results;
                let obj = {
                  domain_name: ORG_DETAILS.DOMAIN_NAME,
                  user_id: ORG_DETAILS.USER_ID,
                  extras: {
                    find: {
                      product_id: Number(this.onloadId),
                      product_cost: Number(this.onloadCost),
                      quantity: Number(this.onloadQuantity),
                    },
                  },
                };
          
                try {
                  this.appService.postApiCall(obj, ENDPOINTS.QUANTITY_PROMOTION).subscribe(
                    (resp) => {
                      if (resp) {
          
                        console.log("ON LAUNCH: ", resp)
                        if (resp.success === 1 && resp.status_code === 200) {
                          for (
                            let k = 0;
                            k < this.appService.cartProducts.results.length;
                            k++
                          ) {
                            if(this.newProductDetails.product_type==="Simple"){
                              if (
                                this.appService.cartProducts.results[k].product.id ===
                                Number(this.queryParams.params["id"])
                              ) {
                                this.appService.cartProducts.results[
                                  k
                                ].product.discount_value = Number(
                                  resp.result.data.discount_applied_to_product_value
                                );
                                this.appService.cartProducts.results[
                                  k
                                ].product.per_quantity_amount = Number(resp.result.data.per_quantity_amount);
                                this.appService.cartProducts.results[
                                  k
                                ].product.discount_amount = Number(
                                  resp.result.data.discount_amount
                                );
                                this.appService.cartProducts.results[k].product.fixed_amount =
                                  Number(resp.result.data.fixed_amount);
                                this.appService.cartProducts.results[
                                  k
                                ].product.discount_percentage = Number(
                                  resp.result.data.discount_percentage
                                );
                                this.congratulationBanner =
                                  resp.result.data.congratulations_banner_message;
                                // this.congratulationBanner.forEach((element, index) => {
                                //     this.congratulationBanner1 = element
                                // });
                                // this.upsellBanner = resp.result.data.upsell_banner_message;
                                this.percentageValue = Number(
                                  resp.result.data.discount_percentage
                                );
                                this.fixedAmount = Number(resp.result.data.fixed_amount);
                                this.discountValue = Number(
                                  resp.result.data.discount_applied_to_product_value
                                );
                                this.promotionType = resp.result.data.promotion_type;
                                this.promotionType.forEach((element, index) => {
                                  if (element === 'Product discount') {
                                    this.productPromotion = 'Product discount'
                                  }
                                  if (element === 'Quantity discount') {
                                    this.quantityPromotion = 'Quantity discount'
                                  }
                                });
                                console.log("[DATA]: Respoonse: ", resp.result.data)
                                this.productQuantity = Number(
                                  this.appService.cartProducts.results[k].quantity
                                );
            
                                this.productQuantity1 = true;
                              }
                            }
                      
                          }
          
                          // this.productQuantity1 = true;
                        } else if (resp.success === 0) {
                          if (resp.message) {
                          }
                        } else if (resp.message && resp.status_code !== 200) {
                        } else {
                        }
                      }
                    },
                    (err) => {
                      if (err.error.statusCode === 403) {
                      } else if (err.error.error.message) {
                      } else {
                      }
                    }
                  );
                } catch (err) {
                  console.log("[ERROR]: error in firing api")
                }
          }
           
         }
        }
        if(ORG_DETAILS.NAME === "Babys Pride"){
        this.relatedProducts=this.product.related_products
        }
         if(this.newProductDetails.product_type==="Variable"){
           
           
            for (let j = 0; j < this.product.variant.option_values.length; j++) {
              console.log("index2222222222222222222222",)
              this.productQuantity1 = false;
              console.log(this.product.variant.option_values[j].id,"j")
              console.log(this.product.variant.option_values[j].id, "i")
              // this.product.variant.option_values[j].is_default = false
              let tempArray = this.appService.cartProducts.results;
              tempArray.forEach((element, index) => {
                console.log("rrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrr"+Number(element.product_id))
                console.log("rrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrr"+Number(this.product.variant.option_values[j].id))

                if (Number(element.product_id) === Number(this.product.variant.option_values[this.current_index].id)) {
                  console.log("777777777777777777777777777777")
                  let obj = {
                    domain_name: ORG_DETAILS.DOMAIN_NAME,
                    user_id: ORG_DETAILS.USER_ID,
                    extras: {
                      find: {
                        product_id: Number(element.product_id),
                        product_cost: Number(element.product.pricing.raw.price),
                        quantity: Number(element.quantity),
                      },
                    },
                  };
            
                  try {
                    this.appService.postApiCall(obj, ENDPOINTS.QUANTITY_PROMOTION).subscribe(
                      (resp) => {
                        if (resp) {
            
                          console.log("ON LAUNCH: ", resp)
                          if (resp.success === 1 && resp.status_code === 200) {
                            for (
                              let k = 0;
                              k < this.appService.cartProducts.results.length;
                              k++
                            ) {
          
                              if(this.newProductDetails.product_type==="Variable"){
                                if (
                                  this.appService.cartProducts.results[k].product.id ===
                                  Number(element.product_id)
                                ) {
                                  console.log("rrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrr")
                                  this.appService.cartProducts.results[
                                    k
                                  ].product.discount_value = Number(
                                    resp.result.data.discount_applied_to_product_value
                                  );
                                  this.appService.cartProducts.results[
                                    k
                                  ].product.per_quantity_amount = Number(resp.result.data.per_quantity_amount);
                                  this.appService.cartProducts.results[
                                    k
                                  ].product.discount_amount = Number(
                                    resp.result.data.discount_amount
                                  );
                                  this.appService.cartProducts.results[k].product.fixed_amount =
                                    Number(resp.result.data.fixed_amount);
                                  this.appService.cartProducts.results[
                                    k
                                  ].product.discount_percentage = Number(
                                    resp.result.data.discount_percentage
                                  );
                                  this.congratulationBanner =
                                    resp.result.data.congratulations_banner_message;
                                  // this.congratulationBanner.forEach((element, index) => {
                                  //     this.congratulationBanner1 = element
                                  // });
                                  // this.upsellBanner = resp.result.data.upsell_banner_message;
                                  this.percentageValue = Number(
                                    resp.result.data.discount_percentage
                                  );
                                  this.fixedAmount = Number(resp.result.data.fixed_amount);
                                  this.discountValue = Number(
                                    resp.result.data.discount_applied_to_product_value
                                  );
                                  this.promotionType = resp.result.data.promotion_type;
                                  this.promotionType.forEach((element, index) => {
                                    if (element === 'Product discount') {
                                      this.productPromotion = 'Product discount'
                                    }
                                    if (element === 'Quantity discount') {
                                      this.quantityPromotion = 'Quantity discount'
                                    }
                                  });
                                  console.log("[DATA]: Respoonse: ", resp.result.data)
                                  this.productQuantity = Number(
                                    this.appService.cartProducts.results[k].quantity
                                  );
              
                                  this.productQuantity1 = true;
                                }
                              }
                        
                            }
            
                            // this.productQuantity1 = true;
                          } else if (resp.success === 0) {
                            if (resp.message) {
                            }
                          } else if (resp.message && resp.status_code !== 200) {
                          } else {
                          }
                        }
                      },
                      (err) => {
                        if (err.error.statusCode === 403) {
                        } else if (err.error.error.message) {
                        } else {
                        }
                      }
                    );
                  } catch (err) {
                    console.log("[ERROR]: error in firing api")
                  }
                }
              });
            // }
          }
          
  
          }
        
      
    }
      })
      // if(this.config.title=='PaulCaroline' || this.config.title=='HOB'){
      // this.findIndexById (Number(this.childPaulid))
      // }
    //  console.log("category of product",this.product.categories[0].categories)
  }
  
  @HostListener('window:popstate', ['$event'])
  onPopState(event) {
    if (document.getElementById('statusModel').classList.contains('show')) {
      document.getElementById('launch-model').click()
    }
    if (document.getElementById('statusModelAccel').classList.contains('show')) {
      document.getElementById('launch-model-accel').click()
    }
    if(document.getElementById('bestGiftsUploadModal')){
      document.getElementById('closebgbt').click()


    }

  }

  get f2() { return this.enquiryForm.controls; }
  get f_vimpro() {
    if(this.config.title === "Vimpro"){
    return this.enquiryForm_vimpro.controls;
    }
  }
  get f_special() {
    if(this.config.title === "SpecialWires"){
    return this.enquiryForm_special.controls;
    }
  }
  getProductDetails(id) {
    let requestData = {
      "domain_name": ORG_DETAILS.DOMAIN_NAME,
      "user_id": ORG_DETAILS.USER_ID,
      "outlet_id":Number(this.outletId),
      // "outlet_id":"",
      "extras": {
        "find": {
          "id": Number(id),
          // "outlet_id":this.outletId,
        },
        "pagination": false,
        "paginationDetails": {
          "limit": 0,
          "pageSize": 2
        },
        "sorting": true,
        "sortingDetails": {
          "sortfield": "sort_order",
          "sortorder": 1
        }
      }
    }
    this.appService.postApiCall(requestData, ENDPOINTS.PRODUCT_DETAILS).subscribe(
      resp => {
        if (resp.success == 1) {
          if (resp.result.data.length > 0) {
            window.scrollTo(0, 0)
            this.product = resp.result.data[0];
            if(this.config.title==='HOB'){
              const originalValue = this.product.pricing.raw.price;
              const newValue = this.product.pricing.raw.msrp;
              const percentageIncrease = ((newValue - originalValue) / originalValue) * 100;
              this.roundedPercentage = Math.round(percentageIncrease);
            }
            if(this.config.title!=='UrbanBox'){
            this.similarProduct = this.product.related_products
            console.log("this.similarProduct",this.similarProduct,this.similarProduct.length)
            if(this.similarProduct.length>0){
              this.isSimilar = true
            }
            else{
              this.isSimilar = false
            }
          }
            this.newProductDetails = resp.result.data[0];
            if(this.config.title=='PaulCaroline' || this.config.title=='HOB' || this.config.title=='Srimaware'){
              console.log("this.childPaulid",this.childPaulid,this.similarProduct,this.isSimilar)
              if(this.product.variant.option_values[0].child){
              this.findIndexById(Number(this.childPaulid));
            }
               console.log("indexingcheck",this.paulIndex )
             
                          }
            console.log("dataaa")
            for (let i = 0; i < this.product.categorynames.length; i++) {
              this.listcategory.push(this.product.categorynames[i].name);



            }
            //this.listcategory=(JSON.stringify(categories))




            // this.product.subname=this.sub_product_data
            if (this.option1 !== "" && this.option1 !== "undefined" && this.option1 !== null && this.product.dropdown_consider.length == 2) {
              console.log("insidehere1")
              this.selectFirstSCH(this.option1)
            }
            if(this.option1 !== "" && this.option1!=="undefined" && this.option1!==null && this.product.dropdown_consider.length ==1){
              this.selectOption1(this.option1)
            }
            if(this.option2 !== "" && this.option2!==null && this.option2!=="undefined"){
              this.selectSecondSCH(this.option2)
            }


            // this.product.size[0]=this.option1;
            // this.product.size[1]=this.option2;
            // this.owner = this.product.company_profile['ceo/md/owner name']
            //this.establised = this.product.company_profile['established_since']
            this.memberId = this.product.memberId;
            if(this.config.title!=='AvonSeals' && this.config.title!=='Vimpro' && this.config.title!=='Deera' && this.config.title!=='Babys Pride'){
              this.content1 = this.product.description.short_desc;
              this.contentOtherDesc = this.product.description.other_description
            }
            // if (this.config.title === 'PaulCaroline') {
            //   console.log("ids Pauls Caroline",this.productId, this.childPaulid)
            //   this.selectColour("red", this.productId, this.childPaulid)
            //   }

            // if(this.config.title=='Carience'){
            //   for(let i=0;i<this.products.length;i++){
            //     this.selectOptionCarience(this.products[i].variant.option_values[0].option,this.products[i].id,0)

            //      this.selectColour(this.products[i].variant.option_values[0].child[0].color,this.products[i].id,0)

            //  }

            //  }
            //document.getElementById('aboutus-content').innerHTML = ththis.producis.content1;
            if (this.customerLogin === true) {
             
              
            }
            if (this.customerLogin === true) {
              this.submitEnquiryForVimpro(this.product);
            }
            if (this.customerLogin === true) {
              this.submitEnquiryForSpecial(this.product);
            }
          
            
            if(this.config.title==='AvonSeals'){
              console.log("appService.cartProducts.results"+JSON.stringify(this.appService.cartProducts.results))
              // for (let i = 0; i <this.appService.cartProducts.results.length; i++) {
              //   for (let j = 0; j < this.product.variant.option_values.length; j++) {
                //  console.log("this.appService.cartProducts.results[i].id"+this.appService.cartProducts.results[i].product_id)
                //  console.log("this.product.variant.option_values[j].id"+this.product.variant.option_values[j].id)
                  // this.product.variant.option_values[j].is_default = false
                  // if (this.appService.cartProducts.results[i].product_id===this.product.variant.option_values[j].id) {
                    // this.product.variant.option_values[j].is_default = true;
                    // this.avonSealsPrice = this.product.variant.option_values[j].pricing.raw.price;
                    // this.avonSealsDescription = this.product.variant.option_values[j].description;
                    // this.avonSealsWeight = this.product.variant.option_values[j].weight;
                  // }
                // }
              // }
            }

            if(ORG_DETAILS.NAME==='PaulCaroline'  || this.config.title=='HOB'){

                console.log("childPaulid",this.childPaulid)
                if(this.childPaulid != "" && this.childPaulid != undefined && !isNaN(this.childPaulid)){
                  this.findVariant()
                }
                else{
                  this.route.queryParams.subscribe(params => {
                    this.parameters = this.route.snapshot.params;
                    this.id = this.parameters['id']
                    console.log("this.parameters['parent.id']",this.parameters['id'])
                    console.log("121212",this.parameters,"++"+this.id,"++"+JSON.stringify(this.product.variant.option_values))
    
                    this.onConfirmPaul(this.product.variant.option_values,this.id, 0)
                  });
                }
            
            }
            if(ORG_DETAILS.NAME==='LushNGreen'){
              console.log("childPaulid",this.childPaulid)
              if(this.childPaulid != "" && this.childPaulid != undefined && !isNaN(this.childPaulid)){
                this.findVariant()
              }
              else{
              this.route.queryParams.subscribe(params => {
                this.parameters = this.route.snapshot.params;
                this.id = this.parameters['id']
                console.log("this.parameters['parent.id']",this.parameters['id'])
                console.log("121212",this.parameters,"++"+this.id,"++"+JSON.stringify(this.product.variant.option_values))

                this.onConfirm1(this.product.variant.option_values,this.id, 0)
              });
            }
            }
            if(ORG_DETAILS.NAME==='Srimaware'){
              console.log("childPaulid",this.childPaulid)
              if(this.childPaulid != "" && this.childPaulid != undefined && !isNaN(this.childPaulid)){
                this.findVariant()
              }
              else{
                this.route.queryParams.subscribe(params => {
                  this.parameters = this.route.snapshot.params;
                  this.id = this.parameters['id']
                  console.log("this.parameters['parent.id']",this.parameters['id'])
                  console.log("121212",this.parameters,"++"+this.id,"++"+JSON.stringify(this.product.variant.option_values))
  
                  this.onConfirm1(this.product.variant.option_values,this.id, 0)
                });
              }
          }
        }
        }
        if(this.checkoutRedirectFlag) {
          setTimeout( () => {
            document.getElementById("editButtonBestGifts").click();
          }, 1000)
        }
      })
  }


  get f() {
    return this.detailForm.controls;
  }
  get f1() { return this.productMaskImageForm.controls.lists["controls"] };
  get productImageControlList() {
    return (<FormArray>this.productMaskImageForm.get('lists')).controls;
  }
  getFilterByProduct(category){
    this.active = category.name;   
    {  
    this.req_filter_data1 = {"domain_name":ORG_DETAILS.DOMAIN_NAME,
    "user_id": null,
    "extras"    :{
    "find":{
    "brand":[],
    "category":[category.name],
    "theme":[],
    "finish":[],
    "feature":[],
    "price":[],
    "size":[],
    "thickness":[],
    "color":[],
    "type":[],
    "product_material":[],

    "last90days":false,
    "last30days":false,
    "includeoutofstock":false,
    },
    "pagination":true,
    "paginationDetails":{
    "limit":0,
    "pagesize":77
    },
    "sorting":true,
    "sortingDetails":{
    "sortfield":"name",
    "sortorder":  -1
    },
    "subcategoryfilter":false
    }
      

    }


      this.appService.postApiCall(this.req_filter_data1, ENDPOINTS.GET_FILTER_PRODUCTS).subscribe(
        resp => {
          this.filtersApiData = resp;
          this.products1 = this.filtersApiData.result.data;
          this.totalNumberOfProducts = this.filtersApiData.result.total;
        //  if(!this.isfilter)
        //  {
          //this.isfilter=true;
        
          this.totalItemsOrProducts = this.filtersApiData.result.total.value ? this.filtersApiData.result.total.value : 0;
          
          this.totalProducts = this.filtersApiData.result.total ? this.filtersApiData.result.total : 0;
        //  this.totalLength = this.filtersApiData.result.total ? this.filtersApiData.result.total : 0;
      
          this.totalLength = this.totalItemsOrProducts = this.filtersApiData.result.total.value ? this.filtersApiData.result.total.value : 0;
          
          
        },
        err => {
          if (err.error.error.message) {
            console.log(err.error.error.message)
          }
          else{
            console.log('Something bad happened; Please try again!')
          }
        })
    }
  }
  addCreateForm() {
    if (this.addImage) {
      console.log("this.addImageeee" + this.addImage)
      this.alertService.error('Please Save Image!', this.options);
    } else {
      console.log("this.addImagefff" + this.addImage)
      var imageformControl = <FormArray>this.productMaskImageForm.get('lists');
      // if(imageformControl.value.length >= 5){
      // this.notify.emit({name:"error", value: "Not allowed to add more than 5 product Images"})
      // }
      // else{

      this.imagelist.push("");
      // for (let i = 0; i < 3; i++) {
      //   console.log ("Block statement execution no." + i);
      //   (<FormArray>this.productMaskImageForm.get('lists')).push(this.addProductMaskImageForm());
      // }
      this.imageUploadCount1 = this.imageUploadCount + this.productImageControlList.length;
      //  this.imageUploadCount2 = Number(this.imageUploadCount1+this.imageUploadCount)
      console.log("this.imageUploadCount111111111111" + this.imageUploadCount1)
      console.log("this.imageUploadCount222222222222" + this.imageUploadCount2)
      for (let i = 0; i < this.imageUploadCount; i++) {
        console.log("Block statement execution no." + i);
        (<FormArray>this.productMaskImageForm.get('lists')).push(this.addProductMaskImageForm());
      }
      // (<FormArray>this.productMaskImageForm.get('lists')).push(this.addProductMaskImageForm());
      // }
    }

  }

  removeCreateForm(i, j) {
    console.log("i" + i)
    console.log("j"+j)
    let tempArray = <FormArray>this.productMaskImageForm.get('lists');
    if (this.imageUploadCount === 1) {
      tempArray.removeAt(i);
      delete this.imagelist[i];
    }
    if (this.imageUploadCount > 1) {
      // var number = this.imageUploadCount;
      var number = i;


      for (var m = 0; m < this.imageUploadCount - 1; m++) {
        number++;
        console.log("numberrrrrrr" + number);
        console.log("mmmmmmmrrrrrrr" + m);
        tempArray.removeAt(number);
        delete this.imagelist[number];
      }
      // tempArray.removeAt(i);
      // delete this.imagelist[i];
      let count = Number(i + this.imageUploadCount - 1);
      console.log("countttt" + count);
      let k = i;
      tempArray.removeAt(i);
      delete this.imagelist[i];
      // tempArray.removeAt(count);
      // delete this.imagelist[count];
      for (; k > i + this.imageUploadCount - 1;) {
        // for (let j = 0; j < i+this.imageUploadCount; j++) { 
        // let data = i + this.imageUploadCount;
        console.log("Block statement execution no." + k);
        // j++
        // tempArray.removeAt(i);
        // delete this.imagelist[i];
        // tempArray.removeAt(i);
        // delete this.imagelist[i];
      }
    }
    let tempArray1 = this.appService.cartProducts.results;

    console.log(tempArray1);
    if (this.appService.cartProducts.results[this.increaseQuantity].quantity === 1) {
      this.appService.cartProducts.results.splice(this.increaseQuantity, 1);
      this.cartData = [];

      for (let i = 0; i < this.appService.cartProducts.results.length; i++) {
        this.cartData.push(
          this.appService.cartProducts.results[i].product_id
        );
      }
      this.appService.totalCartItems = this.cartService.totalCartItems();
      this.cartService.updateCartItem(this.appService.cartProducts.results);

      return;
    }

    tempArray1[this.increaseQuantity].quantity = Number(tempArray1[this.increaseQuantity].quantity) - 1;
    tempArray1[this.increaseQuantity].sub_total =
      Number(tempArray1[this.increaseQuantity].quantity) * Number(tempArray1[this.increaseQuantity].cost);
    console.log("decrement222");

    this.appService.cartProducts.results = tempArray1;
    this.appService.totalCartItems = this.cartService.totalCartItems();
    this.cartService.updateCartItem(this.appService.cartProducts.results);
    // for(let i =0;i<this.appService.maskImages.results.length;i++){ 
    //   console.log("daata111"+JSON.stringify(this.appService.maskImages.results[i]));
    //   // this.imagelist[i] = this.appService.maskImages.results[i].image_source
    //   this.appService.maskImages.results.splice(this.increaseQuantity,1)
    //   // this.imagelist.splice(this.increaseQuantity,1)
    // }
    this.appService.maskImages.results.forEach((element, index) => {
      console.log("element.image_source" + element.image_source)
      console.log("j" + j)
      if (element.image_source === j) {
        this.appService.maskImages.results.splice(element)
      }
    });
    this.isDecreased = true;
  }

  addProductMaskImageForm() {
    return new FormGroup(
      {
        image_bc: this.formBuilder.control(''),
        image_source: this.formBuilder.control(''),
      }
    )
  }

  imageupload1(id: any) {
    if (this.imagelist[id] == "") {
      (document.getElementById(id) as HTMLInputElement).value = ""
    }
    document.getElementById(id).click();
  }

  imageupload(event: any, i, index): void {


    console.log("index being uploaded: ", i)
    if(Number(this.localService.get('max_cart_qty')) <= this.bestGiftsCalculateCartAndCurrentQuantity()) {
      this.alertService.error('maximum Cart value has been reached!', this.options);
      return
    }

    console.log("IMAGE UPLOAD FIRED!")
    let dragEvent = false
    let file_data = { name: "", size: 0 }
    //CHECKING DRAG EVENT OR UPLOAD EVENT
    if (event.target && event.target.files && event.target.files[0]) {

      file_data = event.target.files[0]
    }
    else {
      // file_data = event.dataTransfer.files[0]
      dragEvent = true
    }

    var reader = new FileReader();

    this.imageName = file_data.name
    console.log(event)
    // this.imageList.push(event.value)


    let splitFileName = this.imageName.split(".")
    //CHECKING FILE NAME
    if (splitFileName.length == 0) {
      // this.tableBookingSettingForm.controls['imageFile'].setErrors({'invalid': true});
      return
    }

    if (file_data.size == 0) {
      // this.tableBookingSettingForm.controls['imageFile'].setErrors({'sizezero': true});
      return
    }

    if (Math.round((file_data.size / 1000)) > 11000) {
      // this.tableBookingSettingForm.controls['imageFile'].setErrors({'sizehigh': true});
      return
    }

    //CHECKING FILE TYPE
    if (!["jpg", "jpeg", "png", "gif", "JPG", "JPEG", "PNG", "GIF"].includes(splitFileName[splitFileName.length - 1])) {
      // this.tableBookingSettingForm.controls['imageFile'].setErrors({'type': true});
      return
    }
    // this.tableBookingSettingForm.controls['imageFile'].setErrors({'invalid': false});
    // this.tableBookingSettingForm.controls['imageFile'].setErrors({'type': false});
    // this.tableBookingSettingForm.controls['imageFile'].setErrors({'sizehigh': false});
    // this.tableBookingSettingForm.controls['imageFile'].setErrors({'sizezero': false}); 

    reader.onload = (evt: any) => {

      this.imgFile = [];
      this.imgFile.push(event.target.files[0]);
      this.imagelist[i] = (<FileReader>evt.target).result
      console.log("Inside the upload button : ", this.imagelist)

      this.imgFile.forEach((element, index) => {
        console.log("elementnnnnn" + element)
        this.imgFile1.push(element)
        this.addImage = true;
        this.imageListForUpload[i] = element
      });

      console.log("image list: ", this.imagelist)
      console.log("image list for upload: ", this.imageListForUpload)
      console.log("img file: ", this.imgFile)

      this.modelForBindingInputs['individualQuantity_' + index] = 1
      // this.validateForm2();
    }

    //BASED ON EVENT READ FILE 
    if (!dragEvent) {
      reader.readAsDataURL(event.target.files[0]);
      // this.imgFile=event.target.files[0];
      // this.imgFile.push(event.target.files[0]);
    }
    else {
      reader.readAsDataURL(event.dataTransfer.files[0]);
      //  this.imgFile=event.dataTransfer.files[0];
      //  this.imgFile.push(event.target.files[0]);
    }
  }



  validateForm2() {
    if (this.productMaskImageForm.valid) {
      this.loaderService.emitLoading();
      this.validateMaskImageForm = false;
      var imageformControl = <FormArray>this.productMaskImageForm.get('lists');
      let validImageForm: boolean = false;
      for (let i = 0; i < this.productMaskImageForm.value.lists.length; i++) {
        var imageControls = (<FormGroup>imageformControl.controls[i])
        this.productMaskImageForm.value.lists[i].image_source = imageControls.value.imageControls;
        this.productMaskImageForm.value.lists[i].image_bc = imageControls.value.image_bc;
        if (this.productMaskImageForm.value.lists[i].image_source === "" && i === 0 && !this.editImage) {
          this.validateMaskImageForm = true;
          imageControls.controls['image_source'].setErrors({ 'required': true })
          // this.notify.emit({name:"invalidForm"})
        }
        else if (this.editImage && i === 0 && this.productMaskImageForm.value.lists[i].image_bc === "") {
          this.validateMaskImageForm = true;
          imageControls.controls['image_source'].setErrors({ 'required': true })
          // this.notify.emit({name:"invalidForm"})
        }
        else if (this.productMaskImageForm.value.lists[i].image_source === "" && i > 0 && (this.productMaskImageForm.value.lists[i].idescription > 0 || this.productMaskImageForm.value.lists[i].iremarks || this.productMaskImageForm.value.lists[i].ititle > 0) && !this.editImage) {
          this.validateMaskImageForm = true;
          imageControls.controls['image_source'].setErrors({ 'required': true })
          // this.notify.emit({name:"invalidForm"})
        }
        else {
          validImageForm = true;
        }
      }
      if (validImageForm) {
        let productImages = this.productMaskImageForm.value.lists.filter((pimage) => {
          return pimage.image_bc !== "";
        })
        // this.notify.emit({name:"validForm", value: productImages})
        console.log("dataaaaaa")
        var maskImageData = new FormData();

        // this.finalMaskImageData = [];
        let j = 0;
        this.imgFile1.forEach((element, index) => {
          console.log("element......" + element)
          // this.finalMaskImageData.push({
          //   image_source: element.image_bc,
          // })
          // if(typeof element.image_bc === 'object'){
          this.imageIndexes1.push({
            imageIndex: index,
            s3Index: j
          })
          maskImageData.append("upload", element)
          j = j + 1;
          // }
        });

        // maskImageData.append('upload',this.imgFile);
        // if(this.imageIndexes1.length > 0){
        // if(this.imgFile!==''){
        console.log("333")
        // this.appService.sendImage(maskImageData, headers).subscribe(
        if (this.isDecreased === true) {
          document.getElementById('modal_close_button').click();
        }
        this.appService.postApiCall1(maskImageData, ENDPOINTS.UPLOAD_MASK_IMAGE).subscribe(
          resp => {
            if (resp && resp.status_code === 200 && resp.success === 1 && resp.result.data.length !== 0) {
              resp.result.data.forEach((imagesResult, index) => {
                // this.finalMaskImageData[this.imageIndexes1[index].imageIndex].image_source = imagesResult.location;
                // this.finalMaskImageData.push({
                //   image_source: imagesResult.location,
                //   productId: this.productId
                // })
                this.appService.maskImages.results.push({
                  image_source: imagesResult.location,
                  productId: this.productId
                })

              });
              for (let i = 0; i < this.appService.maskImages.results.length; i++) {
                console.log("daata111" + JSON.stringify(this.appService.maskImages.results[i]));
              }
              this.imgFile1 = [];
              let maskItemsString = JSON.stringify(this.appService.maskImages.results);
              this.localService.set("maskimage", maskItemsString);
              this.maskFiles = JSON.parse(this.localService.get('maskimage'));
              this.maskFiles.forEach((item) => {
                console.log("idddd" + item.productId)
                if (Number(item.productId) === this.newId) {
                  this.productObj.push(item.image_source);
                }
              });

              console.log("this.productObj['mask_files']" + this.productObj.length)

              this.cartService.addToCart(this.newProductDetails);
              this.addCart = true;
              this.addImage = false;
              for (let i = 0; i < this.appService.cartProducts.results.length; i++) {
                this.cartData.push(this.appService.cartProducts.results[i].product_id);
              }
              this.loaderService.emitComplete();
              document.getElementById('modal_close_button').click();

              let tempArray = this.appService.cartProducts.results;
              let cartQty = 0;

              tempArray.forEach((item) => {
                cartQty += item.quantity;
              });

              tempArray[this.increaseQuantity].quantity = (Number(tempArray[this.increaseQuantity].quantity) + 1)

              tempArray[this.increaseQuantity].sub_total =
                Number(tempArray[this.increaseQuantity].quantity) * Number(tempArray[this.increaseQuantity].cost);
              this.appService.cartProducts.results = tempArray;
              this.appService.totalCartItems = this.cartService.totalCartItems();
              this.cartService.updateCartItem(this.appService.cartProducts.results);
              document.getElementById('modal_close_button').click();
            }
            else {
              // resolve(false);
            }
          }
        )
        // }
        // else{
        // this.orderDetails['mask_image'] = this.finalMaskImageData;
        // resolve(true);
        // } 
      }
    }
    else {
      // this.notify.emit({name:"invalidForm"})
      this.validateMaskImageForm = true;
    }
  }

  removeImage(i, j) {
    var imageformControl = <FormArray>this.productMaskImageForm.get('lists');
    var imageControls = (<FormGroup>imageformControl.controls[i])
    imageControls.controls['image_source'].setValue('');
    imageControls.controls['image_bc'].setValue('');
    this.appService.maskImages.results.forEach((element, index) => {
      console.log("element.image_source" + element.image_source)
      console.log("j" + j)
      if (element.image_source === j) {
        console.log("element" + element)
        this.appService.maskImages.results.splice(element.image_source)
        this.appService.maskImages.results.splice(element.productId)
      }
    });
    this.imagelist[i] = "";

    let tempArray1 = this.appService.cartProducts.results;

    console.log(tempArray1);
    if (this.appService.cartProducts.results[this.increaseQuantity].quantity === 1) {
      this.appService.cartProducts.results.splice(this.increaseQuantity, 1);
      this.cartData = [];

      for (let i = 0; i < this.appService.cartProducts.results.length; i++) {
        this.cartData.push(
          this.appService.cartProducts.results[i].product_id
        );
      }
      this.appService.totalCartItems = this.cartService.totalCartItems();
      this.cartService.updateCartItem(this.appService.cartProducts.results);

      return;
    }

    tempArray1[this.increaseQuantity].quantity = Number(tempArray1[this.increaseQuantity].quantity) - 1;
    tempArray1[this.increaseQuantity].sub_total =
      Number(tempArray1[this.increaseQuantity].quantity) * Number(tempArray1[this.increaseQuantity].cost);
    console.log("decrement222");

    this.appService.cartProducts.results = tempArray1;
    this.appService.totalCartItems = this.cartService.totalCartItems();
    this.cartService.updateCartItem(this.appService.cartProducts.results);


    this.isDecreased = true;
  }


  removeImage1(image_source) {
    // this.maskFiles = JSON.parse(this.localService.get('maskimage'));
    // this.maskFiles.forEach((item) => {
    //   console.log("idddd"+item.productId)
    //   if(Number(item.productId)===this.newId){
    //     if(item.image_source===image_source){
    //       // item.splice(this.decreaseQuantity,1);
    //       this.appService.maskImages.results.splice(this.decreaseQuantity,1)
    //     }
    //   }
    // });


    this.maskFiles = JSON.parse(this.localService.get('maskimage'));
    this.maskFiles.forEach((item) => {
      console.log("idddd" + item.productId)
      if (Number(item.productId) === this.newId) {
        if (item.image_source === image_source) {
          this.appService.maskImages.results.splice(this.decreaseQuantity, 1)
        }
      }
    });
    let maskItemsString = JSON.stringify(this.appService.maskImages.results);
    this.localService.set("maskimage", maskItemsString);
  }

  assignMaskImageData() {
    console.log("maskimage");
    (<FormArray>this.productMaskImageForm.get('lists')).clear();
    this.maskImageData.forEach((element, i) => {
      (<FormArray>this.productMaskImageForm.get('lists')).push(
        new FormGroup(
          {
            image_bc: this.formBuilder.control(element.image_source),
            image_source: this.formBuilder.control(''),
          }
        )
      )
      this.imagelist[i] = element.image_source;
    });
  }


  imagePreview(i, index) {
    this.image_preview = true;
    this.video_preview = false;
    this.mainImagePreview = i.image_source;
    this.mainImage = i.image_source;
    console.log(i, index);
    this.isActive = index;
    this.newActive = index;
    console.log(this.mainImagePreview)
  }

  productVideoPreview(){
    // this.video_preview = true;
    // this.image_preview = false;
    // this.productViewVideo = item.link
    this.viewVideo = true;
    this.viewVideo1 = false;
    this.isActive1 = 0;
    console.log("productViewVideoggggggggggggg"+this.productViewVideo)
    document.getElementById("launch-video2").click();
  }

  productVideoPreview1(video,index){
    // this.video_preview = true;
    // this.image_preview = false;
    this.viewVideo = false;
    this.viewVideo1 = true;
    this.isActive1 = index;
    this.productViewVideo1 = video.link
    console.log("productViewVideoggggggggggggg"+this.productViewVideo1)
  }
  videoPreview(videoUrl) {
    this.video_preview = true;
    this.image_preview = false;
    this.mainViewVideo = this.sanitizer.bypassSecurityTrustResourceUrl(
      videoUrl.link
    );
    document.getElementById("launch-video1").click();
  }
  finndBroken() {
    this.newProductDetails.assets[0].image_source = this.imageNotFound;
  }


  /**
   * @function increaseItem: increments the items in the cart
   * @param index - number, index of the product to be added
   */
  async increaseItem(index: number, dataForBestgifts?) {

    await  this.getProfileDetails(this.localService.get('UserId')!=null?Number(this.localService.get('UserId')):'');
  console.log("daytaaaaaaaaaaaaaa")
  if(String(this.approved)!=='Approved'&&ORG_DETAILS.NAME === "Karupattiraja")
{
  this.logout();
}
else{

  let currentIndex;
  console.log("Promotion Type: ", this.promotionType)
  // Clears the current alerts
  this.alertService.clear();

  // Temporary variables Variables
  let tempArray = this.appService.cartProducts.results;
  let cartQty = 0;
  
  // In the case of any website or best gifts with no mask uploads
  if (ORG_DETAILS.NAME !== "BestGifts" || (ORG_DETAILS.NAME === "BestGifts" && this.numberOfMaskUploads == 0)) {
    console.log("temparray",tempArray)
    tempArray.forEach((item, i) => {
      cartQty += Number(item.quantity);
      console.log("quantity",cartQty)
      if (i == index && ORG_DETAILS.NAME == "BestGifts") {
        cartQty = cartQty - item.quantity
        console.log(item)
        item.quantity = item.quantity + 1
        
      }
    });
  } 
  // The case of best gifts with mask image uploades 
  else {
    // a check for the optional data
    if (dataForBestgifts) {
      tempArray.forEach((item, i) => {
        if (item.product_id == index) {
          currentIndex = i;
          cartQty = cartQty - item.quantity
          item.quantity = dataForBestgifts.quantity
          item.uploaded_images = dataForBestgifts['uploaded_images']
          console.log("painful images: ", dataForBestgifts['uploaded_images'])
        }
      })
      cartQty = cartQty + dataForBestgifts.quantity
    }
  }
  if (ORG_DETAILS.NAME === "SpecialWires") {
    //let tempArray = this.appService.cartProducts.results;
    let obj = {
      domain_name: ORG_DETAILS.DOMAIN_NAME,
      user_id: ORG_DETAILS.USER_ID,
      extras: {
        find: {
          product_id: Number(tempArray[index].product_id),
          product_cost: Number(tempArray[index].cost),
          quantity: Number(tempArray[index].quantity),
          weight: Number(tempArray[index].product.shipping.weight_to_consider) * Number(tempArray[index].quantity),
          weight_to_consider:true
        },
      },
    };

    this.appService.postApiCall(obj, ENDPOINTS.STRUCTURED_PROMOTION).subscribe(
      (resp) => {
        if (resp) {
          if (resp.success === 1 && resp.status_code === 200) {
            for (let j = 0; j < this.appService.cartProducts.results.length;j++) {
              if (
                this.appService.cartProducts.results[j].product_id === tempArray[index].id
                
              )
              console.log("resp.result.data.discount_summary[0].discount_amount",resp.result.data.discount_summary[0].discount_amount);
               {                      
                  this.appService.cartProducts.results[j]["discount_amount"] =
                    resp.result.data.discount_summary[0].discount_amount;
           
                this.appService.cartProducts.results[j][
                  "after_dicount_price"
                ] = resp.result.data.discount_summary[0].after_dicount_price;
                console.log(
                  "this.appService.cartProducts.results[i].product.fixed_amount" +
                  this.appService.cartProducts.results[j].
                    after_dicount_price
                );
                this.cartService.updateCartItem(
                  this.appService.cartProducts.results
                );
                console.log(
                  "this.appService.cartProducts.results[i].product.fixed_amount" +
                    this.appService.cartProducts.results[j].discount_amount
                );
              }
            }
            this.cartService.updateCartItem(
              this.appService.cartProducts.results
            );

            console.log(
              "tempArray[index].product.discount_value" +
                tempArray[index].product.discount_value
            );
          } else if (resp.success === 0) {
            if (resp.message) {
              //this.alertService.error(resp.message, this.options);
            }
          } else if (resp.message && resp.status_code !== 200) {
            //this.alertService.error(resp.message, this.options);
          } else {
            //this.alertService.error('Something bad happened. Please try again!', this.options);
          }
        }
      },
      (err) => {
        if (err.error.statusCode === 403) {
          //this.alertService.error('Session Time Out! Please login Again', this.options)
        } else if (err.error.error.message) {
          //this.alertService.error(err.error.error.message, this.options)
        } else {
          //this.alertService.error('Something bad happened. Please try again!', this.options);
        }
      }
    );
    tempArray[index].sub_total =
      Number(tempArray[index].quantity) * Number(tempArray[index].cost);
    this.appService.cartProducts.results = tempArray;
    this.appService.totalCartItems = this.cartService.totalCartItems();
    this.cartService.updateCartItem(this.appService.cartProducts.results);
    if (ORG_DETAILS.NAME === "SpecialWires") {
      let cartItemsString = JSON.stringify(
        this.appService.cartProducts.results
      );
      this.localService.set("cart", cartItemsString);
    }
  }

  if (ORG_DETAILS.NAME === 'ShubhCards') {
    tempArray[index].quantity = (Number(tempArray[index].quantity) + tempArray[index].product.pricing.raw.incrementvalue)
  } else {
    if (ORG_DETAILS.NAME !== 'BestGifts') {
      if (Number(this.localService.get('max_cart_qty')) <= cartQty) {
        this.showAlerts = true;
        window.scrollTo(0, 0);
        // this.alertService.error("Maximum allowed quantity is " +this.localService.get('max_cart_qty') +" only",this.options)
        if (config.title === 'BombayHardware') {
          //this.alertService.error("Maximum allowed quantity is 1 only",this.options)
          this.alertService.error("Maximum allowed quantity is " + this.localService.get('max_cart_qty') + " only", this.options)
        } else if (config.title === 'Deera' || config.title === 'Babys Pride' || config.title === 'BestGifts' || config.title === 'LushNGreen' || config.title === 'Taazah') {
          this.alertService.error("Maximum allowed quantity is " + this.localService.get('max_cart_qty') + " only", this.options)
        }
        else {
          this.alertService.error("Maximum allowed quantity is " + this.localService.get('max_cart_qty') + " only", this.options)
        }
        return
      }
      if(tempArray[index].product.pricing.raw.incrementvalue>0)
      {
        tempArray[index].quantity = (Number(tempArray[index].quantity) + Number(tempArray[index].product.pricing.raw.incrementvalue));
      } else {
        tempArray[index].quantity = (Number(tempArray[index].quantity) + 1);
      }

      // tempArray[index].quantity = (Number(tempArray[index].quantity) + 1)
    }
  }
  if (ORG_DETAILS.NAME === 'Babys Pride') {
    let obj =
    {
      "domain_name": ORG_DETAILS.DOMAIN_NAME,
      "user_id": ORG_DETAILS.USER_ID,
      "extras": {
        "find": {
          "product_id": Number(tempArray[index].product_id),
          "product_cost": Number(tempArray[index].cost),
          "quantity": Number(tempArray[index].quantity)
        }
      }
    }

    this.appService.postApiCall(obj, ENDPOINTS.QUANTITY_PROMOTION).subscribe(
      resp => {
        if (resp) {
          if (resp.success === 1 && resp.status_code === 200) {
            console.log("tempArray[index].quantity: ", tempArray[index]);
            tempArray[index].product.discount_value = resp.result.data.discount_applied_to_product_value;
            tempArray[index].product.per_quantity_amount = resp.result.data.per_quantity_amount;
            tempArray[index].product.discount_amount = resp.result.data.discount_amount;
            tempArray[index].product.fixed_amount = resp.result.data.fixed_amount;
            tempArray[index].product.discount_percentage = resp.result.data.discount_percentage;
            console.log("tempArray[index].product.discount_percentageeeee" + tempArray[index].product.discount_percentage)
            this.congratulationBanner = resp.result.data.congratulations_banner_message;
            console.log("tempArray[index].discount_percentageeeee: ", tempArray[index]);
            //   this.congratulationBanner.forEach((element, index) => {
            //     this.congratulationBanner1 = element
            // });
            // this.upsellBanner = resp.result.data.upsell_banner_message;
            this.percentageValue = Number(resp.result.data.discount_percentage);
            this.fixedAmount = Number(resp.result.data.fixed_amount);
            this.discountValue = Number(resp.result.data.discount_applied_to_product_value);
            this.promotionType = resp.result.data.promotion_type;
            this.promotionType.forEach((element, index) => {
              if (element === 'Product discount') {
                this.productPromotion = 'Product discount'
              }
              if (element === 'Quantity discount') {
                this.quantityPromotion = 'Quantity discount'
              }
            });
            this.productQuantity = Number(tempArray[index].quantity);
            this.productQuantity1 = true;
            if (resp.result.data.discount_percentage > 0) {
              this.appService.cartProducts.results[index]['fixed_amount'] = resp.result.data.discount_amount;
            }
            else {
              this.appService.cartProducts.results[index]['fixed_amount'] = resp.result.data.fixed_amount;
            }
            this.cartService.updateCartItem(this.appService.cartProducts.results);
            console.log("Updating cart: ", this.appService.cartProducts.results)
          } else if (resp.success === 0) {
            if (resp.message) {
              //this.alertService.error(resp.message, this.options);
            }
          } else if (resp.message && resp.status_code !== 200) {
            //this.alertService.error(resp.message, this.options);
          } else {
            //this.alertService.error('Something bad happened. Please try again!', this.options);
          }
        }
      },
      (err) => {
        if (err.error.statusCode === 403) {
          //this.alertService.error('Session Time Out! Please login Again', this.options)
        } else if (err.error.error.message) {
          //this.alertService.error(err.error.error.message, this.options)
        } else {
          //this.alertService.error('Something bad happened. Please try again!', this.options);
        }
      }
    );
  }
  // if (ORG_DETAILS.NAME === 'LushNGreen') {
  //   let obj =
  //   {
  //     "domain_name": ORG_DETAILS.DOMAIN_NAME,
  //     "user_id": ORG_DETAILS.USER_ID,
  //     "extras": {
  //       "find": {
  //         "product_id": Number(tempArray[index].product_id),
  //         "product_cost": Number(tempArray[index].cost),
  //         "quantity": Number(tempArray[index].quantity)
  //       }
  //     }
  //   }

  //   this.appService.postApiCall(obj, ENDPOINTS.QUANTITY_PROMOTION).subscribe(
  //     resp => {
  //       if (resp) {
  //         if (resp.success === 1 && resp.status_code === 200) {
  //           console.log("tempArray[index].quantity: ", tempArray[index]);
  //           tempArray[index].product.discount_value = resp.result.data.discount_applied_to_product_value;
  //           tempArray[index].product.per_quantity_amount = resp.result.data.per_quantity_amount;
  //           tempArray[index].product.discount_amount = resp.result.data.discount_amount;
  //           tempArray[index].product.fixed_amount = resp.result.data.fixed_amount;
  //           tempArray[index].product.discount_percentage = resp.result.data.discount_percentage;
  //           console.log("tempArray[index].product.discount_percentageeeee" + tempArray[index].product.discount_percentage)
  //           this.congratulationBanner = resp.result.data.congratulations_banner_message;
  //           console.log("tempArray[index].discount_percentageeeee: ", tempArray[index]);
  //           this.percentageValue = Number(resp.result.data.discount_percentage);
  //           this.fixedAmount = Number(resp.result.data.fixed_amount);
  //           this.discountValue = Number(resp.result.data.discount_applied_to_product_value);
  //           this.promotionType = resp.result.data.promotion_type;
  //           this.promotionType.forEach((element, index) => {
  //             if (element === 'Product discount') {
  //               this.productPromotion = 'Product discount'
  //             }
  //             if (element === 'Quantity discount') {
  //               this.quantityPromotion = 'Quantity discount'
  //             }
  //           });
  //           this.productQuantity = Number(tempArray[index].quantity);
  //           this.productQuantity1 = true;
  //           if (resp.result.data.discount_percentage > 0) {
  //             this.appService.cartProducts.results[index]['fixed_amount'] = resp.result.data.discount_amount;
  //           }
  //           else {
  //             this.appService.cartProducts.results[index]['fixed_amount'] = resp.result.data.fixed_amount;
  //           }
  //           this.cartService.updateCartItem(this.appService.cartProducts.results);
  //           console.log("Updating cart: ", this.appService.cartProducts.results)
  //         } else if (resp.success === 0) {
  //           if (resp.message) {
  //           }
  //         } else if (resp.message && resp.status_code !== 200) {

  //         } else {
  //         }
  //       }
  //     },
  //     (err) => {
  //       if (err.error.statusCode === 403) {

  //       } else if (err.error.error.message) {

  //       } else {

  //       }
  //     }
  //   );
  // }
  if (ORG_DETAILS.NAME === 'Deera') {
    let obj =
    {
      "domain_name": ORG_DETAILS.DOMAIN_NAME,
      "user_id": ORG_DETAILS.USER_ID,
      "extras": {
        "find": {
          "product_id": Number(tempArray[index].product_id),
          "product_cost": Number(tempArray[index].cost),
          "quantity": Number(tempArray[index].quantity)
        }
      }
    }

    this.appService.postApiCall(obj, ENDPOINTS.QUANTITY_PROMOTION).subscribe(
      resp => {
        if (resp) {
          if (resp.success === 1 && resp.status_code === 200) {
            console.log("tempArray[index].quantity: ", tempArray[index]);
            tempArray[index].product.discount_value = resp.result.data.discount_applied_to_product_value;
            tempArray[index].product.per_quantity_amount = resp.result.data.per_quantity_amount;
            tempArray[index].product.discount_amount = resp.result.data.discount_amount;
            tempArray[index].product.fixed_amount = resp.result.data.fixed_amount;
            tempArray[index].product.discount_percentage = resp.result.data.discount_percentage;
            console.log("tempArray[index].product.discount_percentageeeee" + tempArray[index].product.discount_percentage)
            this.congratulationBanner = resp.result.data.congratulations_banner_message;
            console.log("tempArray[index].discount_percentageeeee: ", tempArray[index]);
            //   this.congratulationBanner.forEach((element, index) => {
            //     this.congratulationBanner1 = element
            // });
            // this.upsellBanner = resp.result.data.upsell_banner_message;
            this.percentageValue = Number(resp.result.data.discount_percentage);
            this.fixedAmount = Number(resp.result.data.fixed_amount);
            this.discountValue = Number(resp.result.data.discount_applied_to_product_value);
            this.promotionType = resp.result.data.promotion_type;
            this.promotionType.forEach((element, index) => {
              if (element === 'Product discount') {
                this.productPromotion = 'Product discount'
              }
              if (element === 'Quantity discount') {
                this.quantityPromotion = 'Quantity discount'
              }
            });
            this.productQuantity = Number(tempArray[index].quantity);
            this.productQuantity1 = true;
            if (resp.result.data.discount_percentage > 0) {
              this.appService.cartProducts.results[index]['fixed_amount'] = resp.result.data.discount_amount;
            }
            else {
              this.appService.cartProducts.results[index]['fixed_amount'] = resp.result.data.fixed_amount;
            }
            this.cartService.updateCartItem(this.appService.cartProducts.results);
            console.log("Updating cart: ", this.appService.cartProducts.results)
          } else if (resp.success === 0) {
            if (resp.message) {
              //this.alertService.error(resp.message, this.options);
            }
          } else if (resp.message && resp.status_code !== 200) {
            //this.alertService.error(resp.message, this.options);
          } else {
            //this.alertService.error('Something bad happened. Please try again!', this.options);
          }
        }
      },
      (err) => {
        if (err.error.statusCode === 403) {
          //this.alertService.error('Session Time Out! Please login Again', this.options)
        } else if (err.error.error.message) {
          //this.alertService.error(err.error.error.message, this.options)
        } else {
          //this.alertService.error('Something bad happened. Please try again!', this.options);
        }
      }
    );
  }
  if (ORG_DETAILS.NAME === "BestGifts") {
    document.getElementById("bestgiftsloader").style.display="block"
    console.log("tempArray[index].product_id"+index)
    console.log("tempArray[index].product_id"+JSON.stringify(tempArray))
    //  let tempArray = this.appService.cartProducts.results
    tempArray.forEach((item,i) => {
      console.log("this.newProductDetails.id"+this.newProductDetails.id)
      if(this.newProductDetails.id===item.product_id){
        console.log("item.pricing.raw.price"+item.product.pricing.raw.price)
        console.log("item.pricing.raw.price"+JSON.stringify(item))
        console.log("BestGiftsSSSSSSSSSSSSSSSSSSSSSSSSSSSSSSSSSSSSSSSSSSSSSSSSSSSSSSSSSSSSSSSSSSSSSSSSSSSSSSSSSSSSSSSSSSSSSSSSSSSS")
        let obj =
        {
          "domain_name": ORG_DETAILS.DOMAIN_NAME,
          "user_id": ORG_DETAILS.USER_ID,
          "extras": {
            "find": {
              "product_id": Number(item.product_id),
              "product_cost": Number(item.product.pricing.raw.price),
              "quantity": Number(item.quantity),
              "customer_id": Number(this.customer_id),
              "customer_type":this.customerType1
            }
          }
        }
   
        this.appService.postApiCall(obj, ENDPOINTS.STRUCTURED_PROMOTION).subscribe(
          resp => {
            if (resp) {
              if (resp.success === 1 && resp.status_code === 200) {
                console.log("tempArray[index].quantity: ", tempArray[index]);
                tempArray.forEach((item,i) => {
                  console.log("this.newProductDetails.id"+this.newProductDetails.id)
                  if(this.newProductDetails.id===item.product_id){
                    item["discount_amount"] =
                    resp.result.data.discount_summary[0].discount_amount;
           
                    item[
                  "after_dicount_price"
                ] = resp.result.data.discount_summary[0].after_dicount_price; 
                item[
                  "per_quantity_amount"
                ] = resp.result.data.discount_summary[0].per_quantity_amount;              
                  this.discountValue = Number(resp.result.data.discount_summary[0].after_dicount_price);
                  }})
                  this.appService.cartProducts.results = tempArray;
                // this.productQuantity = Number(tempArray[index].quantity);
                // this.productQuantity1 = true;
      
                this.cartService.updateCartItem(this.appService.cartProducts.results);
                document.getElementById("bestgiftsloader").style.display="none"
                console.log("Updating cart: ", this.appService.cartProducts.results)
              } else if (resp.success === 0) {
                if (resp.message) {
                  //this.alertService.error(resp.message, this.options);
                }
              } else if (resp.message && resp.status_code !== 200) {
                //this.alertService.error(resp.message, this.options);
              } else {
                //this.alertService.error('Something bad happened. Please try again!', this.options);
              }
            }
          },
          (err) => {
            if (err.error.statusCode === 403) {
              //this.alertService.error('Session Time Out! Please login Again', this.options)
            } else if (err.error.error.message) {
              //this.alertService.error(err.error.error.message, this.options)
            } else {
              //this.alertService.error('Something bad happened. Please try again!', this.options);
            }
          }
        );
      }
    })


  }
  if ( ORG_DETAILS.NAME === "Schift Cosmetics") {
    document.getElementById("bestgiftsloader").style.display="block"
    console.log("tempArray[index].product_id"+index)
    console.log("tempArray[index].product_id"+JSON.stringify(tempArray))
    //  let tempArray = this.appService.cartProducts.results
    tempArray.forEach((item,i) => {
      console.log("this.newProductDetails.id"+this.newProductDetails.id)
      if(this.newProductDetails.id===item.product_id){
        console.log("item.pricing.raw.price"+item.product.pricing.raw.price)
        console.log("item.pricing.raw.price"+JSON.stringify(item))
        console.log("BestGiftsSSSSSSSSSSSSSSSSSSSSSSSSSSSSSSSSSSSSSSSSSSSSSSSSSSSSSSSSSSSSSSSSSSSSSSSSSSSSSSSSSSSSSSSSSSSSSSSSSSSS")
        let obj =
        {
          "domain_name": ORG_DETAILS.DOMAIN_NAME,
          "user_id": ORG_DETAILS.USER_ID,
          "extras": {
            "find": {
              "product_id": Number(item.product_id),
              "product_cost": Number(item.product.pricing.raw.price),
              "quantity": Number(item.quantity),
              "customer_id": Number(this.customer_id),
              "customer_type":this.customerType1
            }
          }
        }
   
        this.appService.postApiCall(obj, ENDPOINTS.STRUCTURED_PROMOTION).subscribe(
          resp => {
            if (resp) {
              if (resp.success === 1 && resp.status_code === 200) {
                console.log("tempArray[index].quantity: ", tempArray[index]);
                tempArray.forEach((item,i) => {
                  console.log("this.newProductDetails.id"+this.newProductDetails.id)
                  if(this.newProductDetails.id===item.product_id){
                    item["discount_amount"] =
                    resp.result.data.discount_summary[0].discount_amount;
           
                    item[
                  "after_dicount_price"
                ] = resp.result.data.discount_summary[0].after_dicount_price; 
                item[
                  "per_quantity_amount"
                ] = resp.result.data.discount_summary[0].per_quantity_amount;              
                  this.discountValue = Number(resp.result.data.discount_summary[0].after_dicount_price);
                  }})
                  this.appService.cartProducts.results = tempArray;
                // this.productQuantity = Number(tempArray[index].quantity);
                // this.productQuantity1 = true;
      
                this.cartService.updateCartItem(this.appService.cartProducts.results);
                document.getElementById("bestgiftsloader").style.display="none"
                console.log("Updating cart: ", this.appService.cartProducts.results)
              } else if (resp.success === 0) {
                if (resp.message) {
                  //this.alertService.error(resp.message, this.options);
                }
              } else if (resp.message && resp.status_code !== 200) {
                //this.alertService.error(resp.message, this.options);
              } else {
                //this.alertService.error('Something bad happened. Please try again!', this.options);
              }
            }
          },
          (err) => {
            if (err.error.statusCode === 403) {
              //this.alertService.error('Session Time Out! Please login Again', this.options)
            } else if (err.error.error.message) {
              //this.alertService.error(err.error.error.message, this.options)
            } else {
              //this.alertService.error('Something bad happened. Please try again!', this.options);
            }
          }
        );
      }
    })


  }
  if (ORG_DETAILS.NAME === "PaulCaroline") {
    document.getElementById("bestgiftsloader").style.display="block"
    console.log("tempArray[index].product_id"+index)
    console.log("tempArray[index].product_id"+JSON.stringify(tempArray))
    //  let tempArray = this.appService.cartProducts.results
        let obj =
        {
          "domain_name": ORG_DETAILS.DOMAIN_NAME,
          "user_id": ORG_DETAILS.USER_ID,
          "extras": {
            "find": {
              "product_id": Number(tempArray[index].product_id),
              "product_cost": Number(tempArray[index].cost),
              "quantity": Number(tempArray[index].quantity),
            }
          }
        }
   
        this.appService.postApiCall(obj, ENDPOINTS.STRUCTURED_PROMOTION).subscribe(
          resp => {
            if (resp) {
              if (resp.success === 1 && resp.status_code === 200) {
                console.log("tempArray[index].quantity: ", tempArray[index]);
                tempArray.forEach((item,i) => {
                  console.log("this.newProductDetails.id"+this.newProductDetails.id)
                  if(this.newProductDetails.id===item.product_id){
                    item["discount_amount"] =
                    resp.result.data.discount_summary[0].discount_amount;
           
                    item[
                  "after_dicount_price"
                ] = resp.result.data.discount_summary[0].after_dicount_price; 
                item[
                  "per_quantity_amount"
                ] = resp.result.data.discount_summary[0].per_quantity_amount;              
                  this.discountValue = Number(resp.result.data.discount_summary[0].after_dicount_price);
                  }})
                  this.appService.cartProducts.results = tempArray;
                // this.productQuantity = Number(tempArray[index].quantity);
                // this.productQuantity1 = true;
      
                this.cartService.updateCartItem(this.appService.cartProducts.results);
                let cartItemsString = JSON.stringify(
                  this.appService.cartProducts.results
                );
                this.localService.set("cart", cartItemsString);
                document.getElementById("bestgiftsloader").style.display="none"
                console.log("Updating cart: ", this.appService.cartProducts.results)
              } else if (resp.success === 0) {
                if (resp.message) {
                  //this.alertService.error(resp.message, this.options);
                }
              } else if (resp.message && resp.status_code !== 200) {
                //this.alertService.error(resp.message, this.options);
              } else {
                //this.alertService.error('Something bad happened. Please try again!', this.options);
              }
            }
          },
          (err) => {
            if (err.error.statusCode === 403) {
              //this.alertService.error('Session Time Out! Please login Again', this.options)
            } else if (err.error.error.message) {
              //this.alertService.error(err.error.error.message, this.options)
            } else {
              //this.alertService.error('Something bad happened. Please try again!', this.options);
            }
          }
        );
      
  


  }
  if (ORG_DETAILS.NAME !== "BestGifts" || (ORG_DETAILS.NAME === "BestGifts" && this.numberOfMaskUploads == 0)) {
    tempArray[index].sub_total =
      Number(tempArray[index].quantity) * Number(tempArray[index].cost);
    
      console.log("inside the if statement not the else")
      console.log(tempArray)
    this.appService.cartProducts.results = tempArray;
    this.appService.totalCartItems = this.cartService.totalCartItems();
    this.cartService.updateCartItem(this.appService.cartProducts.results);
    if (ORG_DETAILS.NAME === "Deera" || ORG_DETAILS.NAME === "Babys Pride" || ORG_DETAILS.NAME === "LushNGreen" || ORG_DETAILS.NAME === "LinenRaj") {
      let cartItemsString = JSON.stringify(
        this.appService.cartProducts.results
      );
      this.localService.set("cart", cartItemsString);
    }
  } else {

    console.log("error check: ", tempArray)
    // Best gifts upload
    tempArray[currentIndex].sub_total = Number(tempArray[currentIndex].quantity) * Number(tempArray[currentIndex].cost);

    
    console.log("error check: ", tempArray)
    console.log(this.appService.cartProducts.results)
    console.log(tempArray)
    this.appService.cartProducts.results = tempArray;

    console.log("App service test: ", this.appService.cartProducts.results)
    this.appService.totalCartItems = this.cartService.totalCartItems();

    this.cartService.updateCartItem(this.appService.cartProducts.results);
    
  }
  if(this.config.title === "HOB" || this.config.title === "PaulCaroline" || this.config.title=='Srimaware'){
    console.log("gggggggggggggggggggggggggggggggggggggggg")
    this.headerService.updateAdminFormEvent({name: "subTotal"});
  }
}
   
  
  }
  increaseItemSpecial(index) {
    this.alertService.clear();
    let userId = this.localService.get('UserId');
    let tempArray = this.appService.cartProducts.results;
    let cartQty = 0;
console.log("4554444", tempArray[index].product.shipping.weight_to_consider);
    let increment;
    tempArray.forEach((item) => {
      cartQty += item.quantity;
    });

      if (Number(this.localService.get("max_cart_qty")) <= cartQty) {
        this.showAlerts = true;
        window.scrollTo(0, 0);
          // tempArray[index].quantity = Number(this.localService.get("max_cart_qty")) - cartQty;
          this.alertService.error(
            "Maximum allowed quantity in the cart is " +
              this.localService.get("max_cart_qty") +
              " only",
            this.options
          );
     
        return;
      }
   if(ORG_DETAILS.NAME === "SpecialWires"){
    tempArray[index].quantity = (Number(tempArray[index].quantity) + Number(tempArray[index].product.pricing.raw.incrementvalue));
   }
   else{
    tempArray[index].quantity = (Number(tempArray[index].quantity) + Number(1));
   }
        
        

    console.log("55553333333", tempArray[index].product.shipping.weight_to_consider);
    if (ORG_DETAILS.NAME === "SpecialWires") {
      let obj = {
        domain_name: ORG_DETAILS.DOMAIN_NAME,
        user_id: ORG_DETAILS.USER_ID,
        extras: {
          find: {
            product_id: Number(tempArray[index].product_id),
            product_cost: Number(tempArray[index].cost),
            quantity: Number(tempArray[index].quantity),
            customer_id: Number(userId),
            weight: Number(tempArray[index].product.shipping.weight_to_consider) * Number(tempArray[index].quantity),
            weight_to_consider:true
          },
        },
      };

      try {
        this.appService
          .postApiCall(obj, ENDPOINTS.STRUCTURED_PROMOTION)
          .subscribe(
            (resp) => {
              if (resp) {
                if (resp.success === 1 && resp.status_code === 200) {
                  for (let j = 0; j < this.appService.cartProducts.results.length;j++) {
                    if (
                      this.appService.cartProducts.results[j].product_id === tempArray[index].id
                      
                    )
                    console.log("resp.result.data.discount_summary[0].discount_amount",resp.result.data.discount_summary[0].discount_amount);
                     {                      
                        this.appService.cartProducts.results[j]["discount_amount"] =
                          resp.result.data.discount_summary[0].discount_amount;
                 
                      this.appService.cartProducts.results[j][
                        "after_dicount_price"
                      ] = resp.result.data.discount_summary[0].after_dicount_price;
                      console.log(
                        "this.appService.cartProducts.results[i].product.fixed_amount" +
                        this.appService.cartProducts.results[j].
                          after_dicount_price
                      );
                      this.cartService.updateCartItem(
                        this.appService.cartProducts.results
                      );
                      console.log(
                        "this.appService.cartProducts.results[i].product.fixed_amount" +
                          this.appService.cartProducts.results[j].discount_amount
                      );
                    }
                  }
                  this.cartService.updateCartItem(
                    this.appService.cartProducts.results
                  );
    
                  console.log(
                    "tempArray[index].product.discount_value" +
                      tempArray[index].product.discount_value
                  );
                } else if (resp.success === 0) {
                  if (resp.message) {
                    //this.alertService.error(resp.message, this.options);
                  }
                } else if (resp.message && resp.status_code !== 200) {
                  //this.alertService.error(resp.message, this.options);
                } else {
                  //this.alertService.error('Something bad happened. Please try again!', this.options);
                }
              }
            },
            (err) => {
              if (err.error.statusCode === 403) {
                //this.alertService.error('Session Time Out! Please login Again', this.options)
              } else if (err.error.error.message) {
                //this.alertService.error(err.error.error.message, this.options)
              } else {
                //this.alertService.error('Something bad happened. Please try again!', this.options);
              }
            }
          );
      } catch (err) {
        console.log("ERROR IN ADDING ITEM: ", err);
      }
    }

    //tempArray[index].quantity = (Number(tempArray[index].quantity) + 2)
    tempArray[index].sub_total =
      Number(tempArray[index].quantity) * Number(tempArray[index].cost);
    this.appService.cartProducts.results = tempArray;
    this.appService.totalCartItems = this.cartService.totalCartItems();
    this.cartService.updateCartItem(this.appService.cartProducts.results);
    if (ORG_DETAILS.NAME === "SpecialWires" || ORG_DETAILS.NAME === "LushNGreen") {
      let cartItemsString = JSON.stringify(
        this.appService.cartProducts.results
      );
      this.localService.set("cart", cartItemsString);
    }
  }
  increaseItemNew(index: number, dataForBestgifts?): void {
    let currentIndex;
    console.log("Promotion Type: ", this.promotionType)
    // Clears the current alerts
    this.alertService.clear();
    let userId = this.localService.get('UserId');
    // Temporary variables Variables
    let tempArray = this.appService.cartProducts.results;
    let cartQty = 0;

    // In the case of any website or best gifts with no mask uploads
    if (ORG_DETAILS.NAME !== "BestGifts" || (ORG_DETAILS.NAME === "BestGifts" && this.numberOfMaskUploads == 0)) {
      tempArray.forEach((item, i) => {
        cartQty += item.quantity;
        if (i == index && ORG_DETAILS.NAME == "BestGifts") {
          cartQty = cartQty - item.quantity
          console.log(item)
          item.quantity = item.quantity + 1
          
        }
      });
    } 
    // The case of best gifts with mask image uploades 
    else {
      // a check for the optional data
      if (dataForBestgifts) {
        tempArray.forEach((item, i) => {
          if (item.product_id == index) {
            currentIndex = i;
            cartQty = cartQty - item.quantity
            item.quantity = dataForBestgifts.quantity
            item.uploaded_images = dataForBestgifts['uploaded_images']
            console.log("painful images: ", dataForBestgifts['uploaded_images'])
          }
        })
        cartQty = cartQty + dataForBestgifts.quantity
      }
    }


    if (ORG_DETAILS.NAME === 'ShubhCards') {
      tempArray[index].quantity = (Number(tempArray[index].quantity) + tempArray[index].product.pricing.raw.incrementvalue)
    } else {
      if (ORG_DETAILS.NAME !== 'BestGifts') {
        if (Number(this.localService.get('max_cart_qty')) <= cartQty) {
          this.showAlerts = true;
          window.scrollTo(0, 0);
          // this.alertService.error("Maximum allowed quantity is " +this.localService.get('max_cart_qty') +" only",this.options)
          if (config.title === 'BombayHardware') {
            //this.alertService.error("Maximum allowed quantity is 1 only",this.options)
            this.alertService.error("Maximum allowed quantity is " + this.localService.get('max_cart_qty') + " only", this.options)
          } else if (config.title === 'Deera' || ORG_DETAILS.NAME === "Babys Pride" || ORG_DETAILS.NAME === "LushNGreen" || config.title === 'BestGifts') {
            this.alertService.error("Maximum allowed quantity is " + this.localService.get('max_cart_qty') + " only", this.options)
          }
          else {
            this.alertService.error("Maximum allowed quantity is " + this.localService.get('max_cart_qty') + " only", this.options)
          }
          return
        }
        tempArray[index].quantity = (Number(tempArray[index].quantity) + 1)
      }
    }
    if (ORG_DETAILS.NAME === 'SpecialWires' || ORG_DETAILS.NAME === 'Vistas' || ORG_DETAILS.NAME === 'LinenRaj') {
      let obj =
      {
        "domain_name": ORG_DETAILS.DOMAIN_NAME,
        "user_id": ORG_DETAILS.USER_ID,
        "extras": {
          "find": {
            "product_id": Number(tempArray[index].product_id),
            "product_cost": Number(tempArray[index].cost),
            "quantity": Number(tempArray[index].quantity),
            "customer_id": Number(userId)
          }
        }
      }

      this.appService.postApiCall(obj, ENDPOINTS.STRUCTURED_PROMOTION).subscribe(
        resp => {
          if (resp) {
            if (resp.success === 1 && resp.status_code === 200) {
              console.log("tempArray[index].quantity: ", tempArray[index]);
              this.appService.cartProducts.results[index]["discount_amount"] =
                resp.result.data.discount_summary[0].discount_amount;
       
            this.appService.cartProducts.results[index][
              "after_dicount_price"
            ] = resp.result.data.discount_summary[0].after_dicount_price;             
              this.discountValue = Number(resp.result.data.discount_summary[0].after_dicount_price);
              this.productQuantity = Number(tempArray[index].quantity);
              this.productQuantity1 = true;
    
              this.cartService.updateCartItem(this.appService.cartProducts.results);
              console.log("Updating cart: ", this.appService.cartProducts.results)
            } else if (resp.success === 0) {
              if (resp.message) {
                //this.alertService.error(resp.message, this.options);
              }
            } else if (resp.message && resp.status_code !== 200) {
              //this.alertService.error(resp.message, this.options);
            } else {
              //this.alertService.error('Something bad happened. Please try again!', this.options);
            }
          }
        },
        (err) => {
          if (err.error.statusCode === 403) {
            //this.alertService.error('Session Time Out! Please login Again', this.options)
          } else if (err.error.error.message) {
            //this.alertService.error(err.error.error.message, this.options)
          } else {
            //this.alertService.error('Something bad happened. Please try again!', this.options);
          }
        }
      );
    }
    if (ORG_DETAILS.NAME !== "BestGifts" || (ORG_DETAILS.NAME === "BestGifts" && this.numberOfMaskUploads == 0)) {
      tempArray[index].sub_total =
        Number(tempArray[index].quantity) * Number(tempArray[index].cost);
      
        console.log(tempArray)
      this.appService.cartProducts.results = tempArray;
      this.appService.totalCartItems = this.cartService.totalCartItems();
      this.cartService.updateCartItem(this.appService.cartProducts.results);
      if (ORG_DETAILS.NAME === "SpecialWires" || ORG_DETAILS.NAME === "BestGifts" || ORG_DETAILS.NAME === "Vistas" || ORG_DETAILS.NAME === 'LinenRaj') {
        let cartItemsString = JSON.stringify(
          this.appService.cartProducts.results
        );
        this.localService.set("cart", cartItemsString);
      }
    } else {

      // Best gifts upload
      tempArray[currentIndex].sub_total = Number(tempArray[currentIndex].quantity) * Number(tempArray[currentIndex].cost);

      console.log(this.appService.cartProducts.results)
      console.log(tempArray)
      this.appService.cartProducts.results = tempArray;

      console.log("App service test: ", this.appService.cartProducts.results)
      this.appService.totalCartItems = this.cartService.totalCartItems();

      this.cartService.updateCartItem(this.appService.cartProducts.results);
    }
  }

  increaseItemVistas(index) {
    this.alertService.clear();
    let userId = this.localService.get('UserId');
    let tempArray = this.appService.cartProducts.results;
    let cartQty = 0;

    let increment;
    tempArray.forEach((item) => {
      cartQty += item.quantity;
    });

      if (Number(this.localService.get("max_cart_qty")) <= cartQty) {
        this.showAlerts = true;
        window.scrollTo(0, 0);

     if ( ORG_DETAILS.NAME === "Vistas") {
          // tempArray[index].quantity = Number(this.localService.get("max_cart_qty")) - cartQty;
          this.alertService.error(
            "Maximum allowed quantity in the cart is " +
              this.localService.get("max_cart_qty") +
              " only",
            this.options
          );
        } else {
          this.alertService.error(
            "Maximum allowed quantity is " +
              this.localService.get("max_cart_qty") +
              " only",
            this.options
          );
        }
        return;
      }
      tempArray[index].quantity = (Number(tempArray[index].quantity) + 1);

    if (ORG_DETAILS.NAME === "Vistas") {
      let obj = {
        domain_name: ORG_DETAILS.DOMAIN_NAME,
        user_id: ORG_DETAILS.USER_ID,
        extras: {
          find: {
            product_id: Number(tempArray[index].product_id),
            product_cost: Number(tempArray[index].cost),
            quantity: Number(tempArray[index].quantity),
            customer_id: Number(userId)
          },
        },
      };

      try {
        this.appService
          .postApiCall(obj, ENDPOINTS.STRUCTURED_PROMOTION)
          .subscribe(
            (resp) => {
              if (resp) {
                if (resp.success === 1 && resp.status_code === 200) {
                  this.appService.cartProducts.results[index]["discount_amount"] =
                resp.result.data.discount_summary[0].discount_amount;
       
            this.appService.cartProducts.results[index][
              "after_dicount_price"
            ] = resp.result.data.discount_summary[0].after_dicount_price;
                   
                    // this.percentageValue = Number(resp.result.data.discount_percentage);
                    // this.fixedAmount = Number(resp.result.data.fixed_amount);
                    // this.discountValue = Number(resp.result.data.discount_applied_to_product_value);
                    // this.promotionType = resp.result.data.promotion_type;
                    // this.productQuantity = Number(tempArray[index].quantity);
                    // this.productQuantity1 = true;
                  this.cartService.updateCartItem(
                    this.appService.cartProducts.results
                  );
                } else if (resp.success === 0) {
                  if (resp.message) {
                    //this.alertService.error(resp.message, this.options);
                  }
                } else if (resp.message && resp.status_code !== 200) {
                  //this.alertService.error(resp.message, this.options);
                } else {
                  //this.alertService.error('Something bad happened. Please try again!', this.options);
                }
              }
            },
            (err) => {
              if (err.error.statusCode === 403) {
                //this.alertService.error('Session Time Out! Please login Again', this.options)
              } else if (err.error.error.message) {
                //this.alertService.error(err.error.error.message, this.options)
              } else {
                //this.alertService.error('Something bad happened. Please try again!', this.options);
              }
            }
          );
      } catch (err) {
        console.log("ERROR IN ADDING ITEM: ", err);
      }
    }

    //tempArray[index].quantity = (Number(tempArray[index].quantity) + 2)
    tempArray[index].sub_total =
      Number(tempArray[index].quantity) * Number(tempArray[index].cost);
    this.appService.cartProducts.results = tempArray;
    this.appService.totalCartItems = this.cartService.totalCartItems();
    this.cartService.updateCartItem(this.appService.cartProducts.results);
    if (ORG_DETAILS.NAME === "Vistas") {
      let cartItemsString = JSON.stringify(
        this.appService.cartProducts.results
      );
      this.localService.set("cart", cartItemsString);
    }
  }

  increaseItemBestGiftsNew(index) {
    this.alertService.clear();
    console.log("gggggggggggggggggggggggg")
    let userId = this.localService.get('UserId');
    let tempArray = this.appService.cartProducts.results;
    let cartQty = 0;

    let increment;
    tempArray.forEach((item) => {
      cartQty += item.quantity;
    });
      if (Number(this.localService.get("max_cart_qty")) <= cartQty) {
        this.showAlerts = true;
        window.scrollTo(0, 0);

     if ( ORG_DETAILS.NAME === "BestGifts") {
          // tempArray[index].quantity = Number(this.localService.get("max_cart_qty")) - cartQty;
          this.alertService.error(
            "Maximum allowed quantity in the cart is " +
              this.localService.get("max_cart_qty") +
              " only",
            this.options
          );
        } else {
          this.alertService.error(
            "Maximum allowed quantity is " +
              this.localService.get("max_cart_qty") +
              " only",
            this.options
          );
        }
        return;
      }
      tempArray[index].quantity = (Number(tempArray[index].quantity) + 1);

    if (ORG_DETAILS.NAME === "BestGifts") {
      document.getElementById("bestgiftsloader").style.display="block";
      let obj = {
        domain_name: ORG_DETAILS.DOMAIN_NAME,
        user_id: ORG_DETAILS.USER_ID,
        extras: {
          find: {
            product_id: Number(tempArray[index].product_id),
            product_cost: Number(tempArray[index].cost),
            quantity: Number(tempArray[index].quantity),
            customer_id: Number(userId),
            customer_type:this.customerType1
          },
        },
      };

      try {
        this.appService
          .postApiCall(obj, ENDPOINTS.STRUCTURED_PROMOTION)
          .subscribe(
            (resp) => {
              if (resp) {
                if (resp.success === 1 && resp.status_code === 200) {
                  this.appService.cartProducts.results[index]["discount_amount"] =
                resp.result.data.discount_summary[0].discount_amount;
       
            this.appService.cartProducts.results[index][
              "after_dicount_price"
            ] = resp.result.data.discount_summary[0].after_dicount_price;
            this.appService.cartProducts.results[index][
              "per_quantity_amount"
            ] = resp.result.data.discount_summary[0].per_quantity_amount;
                    // this.percentageValue = Number(resp.result.data.discount_percentage);
                    // this.fixedAmount = Number(resp.result.data.fixed_amount);
                    // this.discountValue = Number(resp.result.data.discount_applied_to_product_value);
                    // this.promotionType = resp.result.data.promotion_type;
                    // this.productQuantity = Number(tempArray[index].quantity);
                    // this.productQuantity1 = true;
                  this.cartService.updateCartItem(
                    this.appService.cartProducts.results
                  );
                  
                } else if (resp.success === 0) {
                  if (resp.message) {
                    //this.alertService.error(resp.message, this.options);
                  }
                } else if (resp.message && resp.status_code !== 200) {
                  //this.alertService.error(resp.message, this.options);
                } else {
                  //this.alertService.error('Something bad happened. Please try again!', this.options);
                }
              }
            },
            (err) => {
              if (err.error.statusCode === 403) {
                //this.alertService.error('Session Time Out! Please login Again', this.options)
              } else if (err.error.error.message) {
                //this.alertService.error(err.error.error.message, this.options)
              } else {
                //this.alertService.error('Something bad happened. Please try again!', this.options);
              }
            }
          );
      } catch (err) {
        console.log("ERROR IN ADDING ITEM: ", err);
      }
    }

    //tempArray[index].quantity = (Number(tempArray[index].quantity) + 2)
    tempArray[index].sub_total =
      Number(tempArray[index].quantity) * Number(tempArray[index].cost);
    this.appService.cartProducts.results = tempArray;
    this.appService.totalCartItems = this.cartService.totalCartItems();
    this.cartService.updateCartItem(this.appService.cartProducts.results);
    if (ORG_DETAILS.NAME === "Vistas") {
      let cartItemsString = JSON.stringify(
        this.appService.cartProducts.results
      );
      this.localService.set("cart", cartItemsString);
    }
    document.getElementById("bestgiftsloader").style.display="none"
  }

  selectOption1(value) {
    this.selectedboth = true;
    this.product.subname = this.product.name + " - " + value + this.product.dropdown_consider[0]
    this.selectedOption1 = value;
    this.product.size[0] = value;
  }
  selectFirst(value, id) {
    this.selectedboth = false;
    this.product.subname = value + this.product.dropdown_consider[0] + " - " + this.product.name
    this.selectedSCH = value;
    this.product.size[0] = value;
    this.product.size[1] = "";
  }
  selectFirstSCH(value) {
    this.selectedboth = false;
    this.product.subname = this.product.name + " - " + value + this.product.dropdown_consider[1]
    this.selectedSCH = value;
    this.product.size[0] = value;
    this.product.size[1] = "";
    this.product.size[2] = value
    var type_filter = this.product.childs.type.filter(values => {
      if (String(values.sch_value) == value) {
        return value;
      }
    })
    if (this.product.dropdown_consider[0] == 'inch') {
      this.selectSecondSCH(type_filter[0].values[0].inch);
    }
    else if (this.product.dropdown_consider[0] == 'mm') {
      this.selectSecondSCH(type_filter[0].values[0].mm);
    }
    else if (this.product.dropdown_consider[0] == 'Thickness/Class') {
      this.selectSecondSCH(type_filter[0].values[0].Thickness);
    } else if (this.product.dropdown_consider[0] == 'class') {
      this.selectSecondSCH(type_filter[0].values[0].class);
    }
    else if (this.product.dropdown_consider[0] == 'Thickness') {
      this.selectSecondSCH(type_filter[0].values[0].Thickness);
    }
    else if (this.product.dropdown_consider[0] == 'SCH') {
      this.selectSecondSCH(type_filter[0].values[0].sch);
    }
  }
  selectedBoth() {
    this.selectedboth = true;

  }
  selectSecond(value, id) {
    this.product.subname = this.selectedSCH + this.product.dropdown_consider[0] + " - " + this.product.name + " - " + value + this.product.dropdown_consider[1]
    this.selectedboth = true;
    this.selectedOption2 = value;
    this.product.size[1] = value;
  }
  selectSecondSCH(value) {
    this.product.subname = this.product.name + " - " + this.selectedSCH + this.product.dropdown_consider[1] + " - " + value + this.product.dropdown_consider[0]
    this.selectedboth = true;
    this.selectedOption2 = value;
    this.product.size[1] = value;
  }
  loadCartBombay() {
    for (let j = 0; j < this.appService.cartProducts.results.length; j++) {
      if (this.product.id == this.appService.cartProducts.results[j].product_id) {
        this.product.subcart = this.appService.cartProducts.results[j].subcart
        this.product.subquantity = this.appService.cartProducts.results[j].subquantity
        this.product.price = this.appService.cartProducts.results[j].price
      }
      else {
        this.product.subcart = []
        this.product.subquantity = []
        this.product.price=[]
      }
    }
    if (this.appService.cartProducts.results.length == 0) {
      this.product.subcart = []
      this.product.subquantity = []
      this.product.price=[]
    }
  }
  addSubProduct(item) {
    this.alertService.clear();
    this.loadCartBombay()
    if (item.subname != item.name && !this.product.subcart.includes(item.subname)) {
      if (!this.product.subcart.includes(item.subname) || !this.appService.subProductinCart.includes(item.subname)) {
        for (let z = 0; z < this.appService.cartProducts.results.length; z++) {
          if (item.id == this.appService.cartProducts.results[z].product_id) {
            this.product.subcart = this.appService.cartProducts.results[z].subcart;
            this.product.subquantity = this.appService.cartProducts.results[z].subquantity;
            //this.product.price=  this.appService.cartProducts.results[z].price;
            this.product.price=  this.product.price.length>=0? this.product.price:[]
         
           
          }




        }
        if(this.product.childs.type.length>0){
            for(let p =0;p<this.product.childs.type.length;p++){
              for(let q=0;q<this.product.childs.type[p].values.length;q++){
               

                if(this.product.childs.type[p].sch_value==this.selectedOption1 || this.product.childs.type[p].sch_value==this.selectedSCH)
                {
                  
                 // console.log(this.products[i].childs.type[p].values[q].mm,"this.products[i].childs.type[p].value[q]")
                 
                  if(this.product.childs.type[p].values[q].mm===this.selectedOption2 || this.product.childs.type[p].values[q].mm===this.selectedOption1 ){
                    console.log(this.product.childs.type[p].values[q].price,"this.products[i].childs.type[p].values[q].mm");
                    this.bombayhardwareprice=''
                    console.log("type1")
                    this.bombayhardwareprice=this.product.childs.type[p].values[q].price
                    
                   

                  }
                  else if(this.product.childs.type[p].values[q].inch==this.selectedOption2 || this.product.childs.type[p].values[q].inch==this.selectedOption1){
                    console.log(this.product.childs.type[p].values[q].price,"this.products[i].childs.type[p].values[q].mm")
                    this.bombayhardwareprice='';
                    console.log("type2")
                    this.bombayhardwareprice= this.product.childs.type[p].values[q].price;
                   


                  }
                  if(this.product.childs.type[p].values[q].price==undefined){
                    this.bombayhardwareprice=0;

                  }
                  

                 }
               
                 
                


              }
            }}
        if(this.product.childs.size.length>0){
              console.log("inside size")
              for(let r=0;r<this.product.childs.size.length;r++){
              
                
                
                  if(this.product.childs.size[r].value===this.selectedOption1 || this.product.childs.size[r].value===this.selectedOption2){
                    console.log(this.product.childs.size[r].price,"this.products[i].childs.size[r].price")
                    this.bombayhardwareprice=''
                    this.bombayhardwareprice=this.product.childs.size[r].price;
                    
                    
                  
                    //console.log(this.products[i].childs.type[r].values[q].price,"this.products[i].childs.type[p].values[q].mm")
                   

                  


                  

                

               
               }
                 if(this.product.childs.size[r].price==undefined){
                  this.bombayhardwareprice=0

                 }

            }}
        if(this.product.childs.size_pn.length>0){
              console.log("inside size_pn")
              for(let r=0;r<this.product.childs.size_pn.length;r++){
                
                  
                  if(this.product.childs.size_pn[r].mm===this.selectedOption1 || this.product.childs.size_pn[r].mm===this.selectedOption2){
                    console.log(this.product.childs.size_pn[r].price,"mmthis.products[i].childs.size[r].price")
                    this.bombayhardwareprice=''
                    this.bombayhardwareprice=this.product.childs.size_pn[r].price;
                    

                    
                  
                    //console.log(this.products[i].childs.type[r].values[q].price,"this.products[i].childs.type[p].values[q].

               
               

                }
               
                  if(this.product.childs.size_pn[r].pn===this.selectedOption1|| this.product.childs.size_pn[r].pn===this.selectedOption2){
                    console.log(this.product.childs.size_pn[r].price,"pnthis.products[i].childs.size_pn.price")
                    this.bombayhardwareprice=''
                    this.bombayhardwareprice=this.product.childs.size_pn[r].price;
                   

  
                  }
                  if(this.product.childs.size_pn[r].price==undefined){
                    this.bombayhardwareprice=0

                  }

                
                
              
                
                

            }
              

            }
        if(this.product.childs.size_ml.length>0){
              for(let r=0;r<this.product.childs.size_ml.length;r++){
                if(this.product.childs.size_ml[r].value===this.selectedOption1 || this.product.childs.size_ml[r].value===this.selectedOption2){
                  console.log(this.product.childs.size_ml[r].price,"mlthis.products[i].childs.size[r].price")
                  this.bombayhardwareprice=''
                  this.bombayhardwareprice=this.product.childs.size_ml[r].price
                
                  
                
                  //console.log(this.products[i].childs.type[r].values[q].price,"this.products[i].childs.type[p].values[q].

             
             

              }
              else if(this.product.childs.size_ml[r].price==undefined){
                this.bombayhardwareprice=0;

              }


              }
              

            }
        if(this.product.childs.size_pipe.length>0){
              for(let r=0;r<this.product.childs.size_pipe.length;r++){
                if(this.product.childs.size_pipe[r].mm===this.selectedOption1 || this.product.childs.size_pipe[r].mm===this.selectedOption2){
                  console.log(this.product.childs.size_pipe[r].price,"mlthis.products[i].childs.size[r].price");
                  this.bombayhardwareprice=''
                  this.bombayhardwareprice=this.product.childs.size_pipe[r].price
                 
                  
                
                  //console.log(this.products[i].childs.type[r].values[q].price,"this.products[i].childs.type[p].values[q].

             
             

              }
              else if(this.product.childs.size_pipe[r].inch===this.selectedOption1 || this.product.childs.size_pipe[r].inch===this.selectedOption2){
                console.log(this.product.childs.size_pipe[r].price,"mlthis.products[i].childs.size[r].price");
                this.bombayhardwareprice='';
                this.bombayhardwareprice=this.product.childs.size_pipe[r].price
               

                
              
                //console.log(this.products[i].childs.type[r].values[q].price,"this.products[i].childs.type[p].values[q].

           
           

            }
              if(this.product.childs.size_pipe[r].price==undefined){
                this.bombayhardwareprice=0;

              }


              }
              

            }
        if(this.product.childs.diameter.length>0){
              for(let r=0;r<this.product.childs.diameter.length;r++){
                if(this.product.childs.diameter[r].value===this.selectedOption1 || this.product.childs.diameter[r].value===this.selectedOption2){
                  console.log("diameter")
                  if(this.product.childs.diameter[r].price!=undefined){
                    
                    console.log(this.product.childs.diameter[r].price,"diameterlthis.products[i].childs.size[r].price");
                    this.bombayhardwareprice='';
                    this.bombayhardwareprice=this.product.childs.diameter[r].price
                    
                  }
                  else if(this.product.childs.diameter[r].price==undefined){
                    this.bombayhardwareprice=0;

                  }

                

                }

              }
              
            }




        let tempprice=[]

        tempprice.push(this.bombayhardwareprice);
       // console.log( tempprice," tempprice")
       // console.log(this.products,"this.products[i]")
        //console.log(this.product.price.length,"length of price")       
        this.product.subquantity.push(1)
        this.product.subcart.push(item.subname)
        this.product.price.push(this.bombayhardwareprice)
        this.appService.subProductinCart.push(item.subname);
        this.cartService.addToCartSub(this.product);
       
      }
    }
    this.cartService.updateCartItem(this.appService.cartProducts.results);
    for (let i = 0; i < this.appService.cartProducts.results.length; i++) {
      this.cartData.push(this.appService.cartProducts.results[i].product_id);
    }
  }
  increaseSubItem(i, j) {
    this.alertService.clear();

    let tempArray = this.appService.cartProducts.results;
    if (tempArray[i].subquantity[j] < 1000) {
      tempArray[i].subquantity[j] += 1;
      this.product.subquantity[j] = tempArray[i].subquantity[j]
      tempArray[i].sub_total = (Number(tempArray[i].quantity) * Number(tempArray[i].cost))
      this.appService.cartProducts.results = tempArray;
      this.calculateTotal();
      this.cartService.updateCartItem(this.appService.cartProducts.results);
      this.loadExistingCart()
    }
    else{
      this.alertService.error("Maximum allowed quantity is 1000 only",this.options);
    }

  }
  decreaseSubItem(i, j) {
    this.alertService.clear();
    let tempArray = this.appService.cartProducts.results;
    // if (tempArray[i].product.pricing !== undefined) {
      // if (this.appService.cartProducts.results[i].subquantity[j] === 1 || this.appService.cartProducts.results[i].quantity < tempArray[i].product.pricing.raw.minimumorderquantity) {
        if (this.appService.cartProducts.results[i].subquantity[j] === 1) {
        for (let x = 0; x < this.product.subcart.length; x++) {
          if (this.product.subname == this.product.subcart[x])
            this.product.subcart.splice(x, 1)
          this.product.subquantity.splice(x, 1)
        }
        this.removeSubItem(i, j)
        return
      }
    // }
    tempArray[i].subquantity[j] = (Number(tempArray[i].subquantity[j]) - 1)
    this.product.subquantity[j] = tempArray[i].subquantity[j]
    this.appService.cartProducts.results = tempArray;
    this.calculateTotal();
    this.cartService.updateCartItem(this.appService.cartProducts.results);
    this.loadExistingCart()

  }
  minQuantity0(i, j, event) {
    this.alertService.clear();
    let tempArray=this.appService.cartProducts.results
    this.cartService.updateCartItem(this.appService.cartProducts.results);
    if(tempArray[i].subquantity[j]<=0){
      this.removeSubItem(i,j)
    }
    else if(event.srcElement.value>1000){
      this.alertService.error("Maximum allowed quantity is 1000 only",this.options)
      event.srcElement.value =1000
      this.appService.cartProducts.results[i].subquantity[j]=1000
      this.cartService.updateCartItem(this.appService.cartProducts.results);
      return;
    }

  }
  removeSubItem(i, j) {
    console.log(this.appService.cartProducts.results)
    this.appService.cartProducts.results[i].subcart.splice(j, 1)
    this.appService.cartProducts.results[i].subquantity.splice(j, 1)
    for (let x = 0; x < this.product.subcart.length; x++) {
      if (this.product.subname == this.product.subcart[x])
        this.product.subcart.splice(x, 1)
      this.product.subquantity.splice(x, 1)
    }
    // for(let z=0;z<this.appService.subProductinCart.length;z++){
    //   if(this.appService.subProductinCart[z]==this.product.subname){
    //     this.appService.subProductinCart.splice(z,1)
    //   }
    // }

    // this.appService.cartProducts.results.splice(i,1);
    this.appService.totalCartItems = this.cartService.totalCartItems();
    if (this.appService.cartProducts.results[i].subcart.length == 0) {
      this.appService.cartProducts.results.splice(i, 1)
    }
    // this.calculateTotal();
    this.cartService.updateCartItem(this.appService.cartProducts.results);
    // this.loadExistingCart()
  }
  loadExistingCart() {
    this.existingCartProduts = [];
    this.appService.cartProducts.results.forEach(value => {
      this.existingCartProduts.push(value.product_id);
    })
  }
  increaseItem1(index) {
    this.isDecrease = false;
    // this.imagelist = [""];
    // this.maskImageData = undefined;
    // this.validateMaskImageForm = false;
    // (<FormArray>this.productMaskImageForm.get('lists')).clear();
    // (<FormArray>this.productMaskImageForm.get('lists')).controls.push(this.addProductMaskImageForm());
    console.log("this.imageUpload"+this.imageUploadCount)
    // for (let i = 0; i < this.imageUploadCount-1; i++) {
    //   console.log ("Block statement execution no." + i);
    //   (<FormArray>this.productMaskImageForm.get('lists')).push(this.addProductMaskImageForm());
    // }
    // this.isIncrease = true;
    this.increaseQuantity = index;
    for (let i = 0; i < this.appService.maskImages.results.length; i++) {
      console.log("daata111" + JSON.stringify(this.appService.maskImages.results[i]));
      this.imagelist[i] = this.appService.maskImages.results[i].image_source
    }

    console.log("this.increaseQuantity" + this.increaseQuantity)
  }

  increaseItemBestGifts() {
    this.numberOfProductsBestGifts = this.numberOfProductsBestGifts + 1;
  }

  increaseBestGiftQuantity() {
    this.alertService.clear();
    let tempArray = this.appService.cartProducts.results;
    let cartQty = 0;

    tempArray.forEach((item) => {
      cartQty += item.quantity;
    });

    tempArray[this.increaseQuantity].quantity = (Number(tempArray[this.increaseQuantity].quantity) + 1)

    tempArray[this.increaseQuantity].sub_total =
      Number(tempArray[this.increaseQuantity].quantity) * Number(tempArray[this.increaseQuantity].cost);
    this.appService.cartProducts.results = tempArray;
    this.appService.totalCartItems = this.cartService.totalCartItems();
    this.cartService.updateCartItem(this.appService.cartProducts.results);
    document.getElementById('modal_close_button').click();
    this.increaseQuantity = "";
    this.isIncrease = false;



    // }
    // else{
    // this.orderDetails['mask_image'] = this.finalMaskImageData;
    // resolve(true);
    // } 

  }



  decreaseItem1(index) {
    this.increaseQuantity = index;
    console.log("this.increaseQuantity" + this.increaseQuantity)
    this.isDecrease = false;
    for (let i = 0; i < this.appService.maskImages.results.length; i++) {
      console.log("daata111" + JSON.stringify(this.appService.maskImages.results[i]));
      this.imagelist[i] = this.appService.maskImages.results[i].image_source
    }
    console.log("this.increaseQuantity" + this.increaseQuantity)


  }

  decreaseBestGiftQuantity() {

    let tempArray = this.appService.cartProducts.results;

    console.log(tempArray);
    if (this.appService.cartProducts.results[this.decreaseQuantity].quantity === 1) {
      this.appService.cartProducts.results.splice(this.decreaseQuantity, 1);
      this.cartData = [];

      for (let i = 0; i < this.appService.cartProducts.results.length; i++) {
        this.cartData.push(
          this.appService.cartProducts.results[i].product_id
        );
      }
      this.appService.totalCartItems = this.cartService.totalCartItems();
      this.cartService.updateCartItem(this.appService.cartProducts.results);

      return;
    }

    tempArray[this.decreaseQuantity].quantity = Number(tempArray[this.decreaseQuantity].quantity) - 1;
    tempArray[this.decreaseQuantity].sub_total =
      Number(tempArray[this.decreaseQuantity].quantity) * Number(tempArray[this.decreaseQuantity].cost);
    console.log("decrement222");

    this.appService.cartProducts.results = tempArray;
    this.appService.totalCartItems = this.cartService.totalCartItems();
    this.cartService.updateCartItem(this.appService.cartProducts.results);
    document.getElementById('modal_close_button').click();
    // this.decreaseQuantity = "";
    this.isDecrease = false;

  }

  ChangeValue(index) {
    this.alertService.clear();
    let tempArray = this.appService.cartProducts.results;
    if (ORG_DETAILS.NAME === "ShubhCards") {
      //let tempArray = this.appService.cartProducts.results;
      if (
        this.appService.cartProducts.results[index].quantity <
        tempArray[index].product.pricing.raw.minimumorderquantity
      ) {
        var moq = tempArray[index].product.pricing.raw.minimumorderquantity;
        this.appService.cartProducts.results.splice(index, 1);
        this.cartData = [];
        for (let i = 0; i < this.appService.cartProducts.results.length; i++) {
          this.cartData.push(
            this.appService.cartProducts.results[i].product_id
          );
        }
        this.appService.totalCartItems = this.cartService.totalCartItems();
        this.cartService.updateCartItem(this.appService.cartProducts.results);
        this.showAlerts = true;
        window.scrollTo(0, 0);
        this.alertService.error(
          "Minimum Order Quantity for this product is " + moq,
          this.options
        );
        return;
      }
      tempArray[index].quantity = Number(tempArray[index].quantity);
      tempArray[index].sub_total =
        Number(tempArray[index].quantity) * Number(tempArray[index].cost);
      this.appService.cartProducts.results = tempArray;
      this.appService.totalCartItems = this.cartService.totalCartItems();
      this.cartService.updateCartItem(this.appService.cartProducts.results);
    }
  }

  // changeAvonSealsValue(index) {
  //   this.alertService.clear();
  //   let tempArray = this.appService.cartProducts.results;
  //   if (ORG_DETAILS.NAME === "AvonSeals") {
  //     //let tempArray = this.appService.cartProducts.results;
  //     if (
  //       this.appService.cartProducts.results[index].quantity <
  //       tempArray[index].product.pricing.raw.minimumorderquantity
  //     ) {
  //       var moq = tempArray[index].product.pricing.raw.minimumorderquantity;
  //       this.appService.cartProducts.results.splice(index, 1);
  //       this.cartData = [];
  //       for (let i = 0; i < this.appService.cartProducts.results.length; i++) {
  //         this.cartData.push(
  //           this.appService.cartProducts.results[i].product_id
  //         );
  //       }
  //       this.appService.totalCartItems = this.cartService.totalCartItems();
  //       this.cartService.updateCartItem(this.appService.cartProducts.results);
  //       this.showAlerts = true;
  //       window.scrollTo(0, 0);
  //       this.alertService.error(
  //         "Minimum Order Quantity for this product is " + moq,
  //         this.options
  //       );
  //       return;
  //     }
  //     tempArray[index].quantity = Number(tempArray[index].quantity);
  //     tempArray[index].sub_total =
  //       Number(tempArray[index].quantity) * Number(tempArray[index].cost);
  //     this.appService.cartProducts.results = tempArray;
  //     this.appService.totalCartItems = this.cartService.totalCartItems();
  //     this.cartService.updateCartItem(this.appService.cartProducts.results);
  //   }
  // }

  // changeAvonSealsValue(index, event) {
  //   console.log("index" + index)
  //   this.eventValue = event.target.value;
  //   console.log("event.target.value" + event.target.value)
     
  //   if (this.eventValue==0) {
  //     console.log("truee")
  //     this.appService.cartProducts.results.splice(index, 1);
  //     this.cartData = [];
  //     for (let i = 0; i < this.appService.cartProducts.results.length; i++) {
  //       this.cartData.push(
  //         this.appService.cartProducts.results[i].product_id
  //       );
  //     }
  //     this.appService.totalCartItems = this.cartService.totalCartItems();
  //     this.cartService.updateCartItem(this.appService.cartProducts.results);
  //   }
  //   if (!this.eventValue) {
  //     console.log("truee")
  //     this.appService.cartProducts.results.splice(index, 1);
  //     this.cartData = [];
  //     for (let i = 0; i < this.appService.cartProducts.results.length; i++) {
  //       this.cartData.push(
  //         this.appService.cartProducts.results[i].product_id
  //       );
  //     }
  //     this.appService.totalCartItems = this.cartService.totalCartItems();
  //     this.cartService.updateCartItem(this.appService.cartProducts.results);
  //   } else {
  //     console.log("falsee")
  //     this.alertService.clear();
  //     let tempArray = this.appService.cartProducts.results;
  //     let cartQty = 0;
  
  
  //     let tempCartQty: number = 0;
  //     tempArray.forEach((item) => {
  //       cartQty += item.quantity;
  
  //       if (item.product.id != this.product.id) {
  //         tempCartQty += item.quantity
  //         console.log("item.quantity"+item.quantity)
  //       }
  //     });
  
  //     if (cartQty > Number(this.localService.get("max_cart_qty"))) {
  //       console.log("truee444444444444")
  //       console.log("truee")
  //       this.appService.cartProducts.results[index].quantity = Number(this.localService.get("max_cart_qty")) - tempCartQty;
  //       event.srcElement.value = String(Number(this.localService.get("max_cart_qty")) - tempCartQty)
  //       event.srcElement.blur()
  //       this.alertService.error(
  //         "Maximum allowed quantity in the cart is " +
  //           this.localService.get("max_cart_qty") +
  //           " only",
  //         this.options
  //       );
  //     }
   
  //     if (Number(this.localService.get("max_cart_qty")) < cartQty) {
  //       this.showAlerts = true;
  //       window.scrollTo(0, 0);
  //       this.maxValuetemp = Number(this.localService.get("max_cart_qty"))
        
  //      if (config.title === "AvonSeals") {
  //         tempArray[index].quantity = Number(this.localService.get("max_cart_qty")) - tempCartQty
  //         event.srcElement.value = String(Number(this.localService.get("max_cart_qty")) - tempCartQty)
  //         event.srcElement.blur()
  //       } else {
         
  //       }
  //       return;
  //     }
  //     if (
  //       this.appService.cartProducts.results[index].quantity <
  //       tempArray[index].product.pricing.raw.minimumorderquantity
  //     ) {
  //       this.appService.cartProducts.results.splice(index, 1);
  //       this.cartData = [];
  //       for (let i = 0; i < this.appService.cartProducts.results.length; i++) {
  //         this.cartData.push(this.appService.cartProducts.results[i].product_id);
  //       }
  //       this.appService.totalCartItems = this.cartService.totalCartItems();
  //       this.cartService.updateCartItem(this.appService.cartProducts.results);
  //       return;
  //     }
  //   }
  // }

  changeAvonSealsValue(index, event) {
    console.log(event)
    console.log("index : "+index)
    this.eventValue = event.target.value;
    let tempArray = this.appService.cartProducts.results;
    if (this.eventValue==0) {
      console.log("truee")
      this.appService.cartProducts.results.splice(index, 1);
      this.cartData = [];
      for (let i = 0; i < this.appService.cartProducts.results.length; i++) {
        this.cartData.push(
          this.appService.cartProducts.results[i].product_id
        );
      }
      this.appService.totalCartItems = this.cartService.totalCartItems();
      this.cartService.updateCartItem(this.appService.cartProducts.results);
    }
    if (!this.eventValue) {
      // if(tempArray[index].product.pricing !== undefined){
        // if(this.appService.cartProducts.results[index].quantity === 1 || this.appService.cartProducts.results[index].quantity  < tempArray[index].product.pricing.raw.minimumorderquantity) {
        console.log("- button pressed!")
          this.appService.cartProducts.results.splice(index,1);
          this.appService.totalCartItems = this.cartService.totalCartItems();
          // this.calculateTotal();
          this.cartService.updateCartItem(this.appService.cartProducts.results);
          if(this.config.title==='AvonSeals' || this.config.name==='Cle' || this.config.title==='LinenRaj'){
            let cartItemsString = JSON.stringify(this.appService.cartProducts.results);
            this.localService.set("cart", cartItemsString);
            }
          // this.loadExistingCart()
          return
      // }
    // }
    }
    
    else {
      this.alertService.clear();
      let tempArray = this.appService.cartProducts.results;
  
      let cartQty = 0
      console.log("insidee")
      let tempId: number = 0
      let tempCartQty: number = 0;
      tempArray.forEach((item) => {
        cartQty += item.quantity;
        let count = 0;
        if(item != tempArray[index]) {
          tempCartQty += item.quantity
        }
      });
  
      if(Number(this.localService.get('max_cart_qty')) <= cartQty)
      {
        this.showAlerts = true;
        window.scrollTo(0,0);
     if(this.config.name==='AvonSeals' || this.config.name==='Cle'){
          tempArray[index].quantity = String(Number(this.localService.get('max_cart_qty')) - tempCartQty);
          event.srcElement.value = String(Number(this.localService.get('max_cart_qty')) - tempCartQty);
          console.log("insidee11")
  
          event.srcElement.blur();
          this.alertService.error("Maximum allowed quantity is " +this.localService.get('max_cart_qty') +" only",this.options)
        }
        else {
          this.alertService.error("Maximum allowed quantity is " +this.localService.get('max_cart_qty') +" only",this.options)
        }
      }
        // tempArray[index].quantity = (Number(tempArray[index].quantity) + 1)
        if(this.appService.cartProducts.results[index].quantity  < tempArray[index].product.pricing.raw.minimumorderquantity)
        {
            this.appService.cartProducts.results.splice(index,1);
            console.log("insidee22")
            this.appService.totalCartItems = this.cartService.totalCartItems();
            this.cartService.updateCartItem(this.appService.cartProducts.results);
            // this.calculateTotal();
            if(this.config.title==='AvonSeals' || this.config.title==='Cle' || this.config.title==='LinenRaj'){
              let cartItemsString = JSON.stringify(this.appService.cartProducts.results);
              this.localService.set("cart", cartItemsString);
              }
            // this.loadExistingCart()
            return
        }

        tempArray[index].quantity = (Number(tempArray[index].quantity));
        tempArray[index].sub_total = (Number(tempArray[index].quantity) * Number(tempArray[index].cost))
        this.appService.cartProducts.results = tempArray;
        // this.calculateTotal();
        this.cartService.updateCartItem(this.appService.cartProducts.results);
        // this.loadExistingCart();
    }
  


  }
  changeVistasValue(index, event) {
    let userId = this.localService.get('UserId');
    this.alertService.clear();
    let tempArray = this.appService.cartProducts.results;
    let cartQty = 0;
    let tempCartQty: number = 0;
    tempArray.forEach((item) => {
      cartQty += item.quantity;
      let count = 0;
      if(item != tempArray[index]) {
        tempCartQty += item.quantity
      }
    });
    this.eventValue = event.target.value;
    console.log("event.target.value" + event.target.value)
    if (this.eventValue==0) {
      console.log("truee")
      this.appService.cartProducts.results.splice(index, 1);
      this.cartData = [];
      for (let i = 0; i < this.appService.cartProducts.results.length; i++) {
        this.cartData.push(
          this.appService.cartProducts.results[i].product_id
        );
      }
      this.appService.totalCartItems = this.cartService.totalCartItems();
      this.cartService.updateCartItem(this.appService.cartProducts.results);
    }
    if (Number(this.localService.get("max_cart_qty")) < cartQty) {
      this.showAlerts = true;
      window.scrollTo(0, 0);

        this.appService.cartProducts.results[index].quantity = Number(this.localService.get("max_cart_qty")) - tempCartQty;
        event.srcElement.value = String(Number(this.localService.get("max_cart_qty")) - tempCartQty)
        event.srcElement.blur()
        this.alertService.error(
          "Maximum allowed quantity in the cart is " +
            this.localService.get("max_cart_qty") +
            " only",
          this.options
        );

      return;
    }
    //tempArray[index].quantity = (Number(tempArray[index].quantity) + 1)
    // let tempArray = this.appService.cartProducts.results;
    if (
      this.appService.cartProducts.results[index].quantity <
      tempArray[index].product.pricing.raw.minimumorderquantity
    ) {
      this.appService.cartProducts.results.splice(index, 1);
      this.cartData = [];
      for (let i = 0; i < this.appService.cartProducts.results.length; i++) {
        this.cartData.push(this.appService.cartProducts.results[i].product_id);
      }
      this.appService.totalCartItems = this.cartService.totalCartItems();
      this.cartService.updateCartItem(this.appService.cartProducts.results);

        let cartItemsString = JSON.stringify(
          this.appService.cartProducts.results
        );
        this.localService.set("cart", cartItemsString);
      return;
    }

    // tempArray[index].quantity = (Number(tempArray[index].quantity) - 1)
    tempArray[index].sub_total =
      Number(tempArray[index].quantity) * Number(tempArray[index].cost);
   
    if (ORG_DETAILS.NAME === "Vistas"){
      let obj = {
        domain_name: ORG_DETAILS.DOMAIN_NAME,
        user_id: ORG_DETAILS.USER_ID,
        extras: {
          find: {
            product_id: Number(tempArray[index].product_id),
            product_cost: Number(tempArray[index].cost),
            quantity: Number(tempArray[index].quantity),
            customer_id: Number(userId)
          },
        },
      };

      try {
        this.appService
          .postApiCall(obj, ENDPOINTS.STRUCTURED_PROMOTION)
          .subscribe(
            (resp) => {
              if (resp) {
                if (resp.success === 1 && resp.status_code === 200) {
                  this.appService.cartProducts.results[index]["discount_amount"] =
                resp.result.data.discount_summary[0].discount_amount;
       
            this.appService.cartProducts.results[index][
              "after_dicount_price"
            ] = resp.result.data.discount_summary[0].after_dicount_price;
                  this.cartService.updateCartItem(
                    this.appService.cartProducts.results
                  );
                } else if (resp.success === 0) {
                  if (resp.message) {
                    //this.alertService.error(resp.message, this.options);
                  }
                } else if (resp.message && resp.status_code !== 200) {
                  //this.alertService.error(resp.message, this.options);
                } else {
                  //this.alertService.error('Something bad happened. Please try again!', this.options);
                }
              }
            },
            (err) => {
              if (err.error.statusCode === 403) {
                //this.alertService.error('Session Time Out! Please login Again', this.options)
              } else if (err.error.error.message) {
                //this.alertService.error(err.error.error.message, this.options)
              } else {
                //this.alertService.error('Something bad happened. Please try again!', this.options);
              }
            }
          );
      } catch (err) {
        console.log("ERROR IN ADDING ITEM: ", err);
      }
    }
    tempArray[index].sub_total =
    Number(tempArray[index].quantity) * Number(tempArray[index].cost);
  this.appService.cartProducts.results = tempArray;
  this.appService.totalCartItems = this.cartService.totalCartItems();
  this.cartService.updateCartItem(this.appService.cartProducts.results);
  if (ORG_DETAILS.NAME === "Vistas") {
    let cartItemsString = JSON.stringify(
      this.appService.cartProducts.results
    );
    this.localService.set("cart", cartItemsString);
  }
  }
  changeSpecialValue(index, event) {
    this.alertService.clear();
    let tempArray = this.appService.cartProducts.results;
    let cartQty = 0;
    let tempCartQty: number = 0;
    tempArray.forEach((item) => {
      cartQty += item.quantity;
      let count = 0;
      if(item != tempArray[index]) {
        tempCartQty += item.quantity
      }
    });
    this.eventValue = event.target.value;
    console.log("event.target.value" + event.target.value)
    if (this.eventValue==0) {
      console.log("truee")
      this.appService.cartProducts.results.splice(index, 1);
      this.cartData = [];
      for (let i = 0; i < this.appService.cartProducts.results.length; i++) {
        this.cartData.push(
          this.appService.cartProducts.results[i].product_id
        );
      }
      this.appService.totalCartItems = this.cartService.totalCartItems();
      this.cartService.updateCartItem(this.appService.cartProducts.results);
    }
    if (Number(this.localService.get("max_cart_qty")) < cartQty) {
      this.showAlerts = true;
      window.scrollTo(0, 0);

      if (this.config.title === "SpecialWires") {
        this.appService.cartProducts.results[index].quantity = Number(this.localService.get("max_cart_qty")) - tempCartQty;
        event.srcElement.value = String(Number(this.localService.get("max_cart_qty")) - tempCartQty)
        event.srcElement.blur()
        this.alertService.error(
          "Maximum allowed quantity in the cart is " +
            this.localService.get("max_cart_qty") +
            " only",
          this.options
        );
      } else {
        this.alertService.error(
          "Maximum allowed quantity is " +
            this.localService.get("max_cart_qty") +
            " only",
          this.options
        );
      }
      return;
    }
    //tempArray[index].quantity = (Number(tempArray[index].quantity) + 1)
    // let tempArray = this.appService.cartProducts.results;
    if (
      this.appService.cartProducts.results[index].quantity <
      tempArray[index].product.pricing.raw.minimumorderquantity
    ) {
      this.appService.cartProducts.results.splice(index, 1);
      this.cartData = [];
      for (let i = 0; i < this.appService.cartProducts.results.length; i++) {
        this.cartData.push(this.appService.cartProducts.results[i].product_id);
      }
      this.appService.totalCartItems = this.cartService.totalCartItems();
      this.cartService.updateCartItem(this.appService.cartProducts.results);
      if (this.config.title === "SpecialWires") {
        let cartItemsString = JSON.stringify(
          this.appService.cartProducts.results
        );
        this.localService.set("cart", cartItemsString);
      }
      return;
    }

    // tempArray[index].quantity = (Number(tempArray[index].quantity) - 1)
    tempArray[index].sub_total =
      Number(tempArray[index].quantity) * Number(tempArray[index].cost);
      if (ORG_DETAILS.NAME === "SpecialWires") {
        //let tempArray = this.appService.cartProducts.results;
        let obj = {
          domain_name: ORG_DETAILS.DOMAIN_NAME,
          user_id: ORG_DETAILS.USER_ID,
          extras: {
            find: {
              product_id: Number(tempArray[index].product_id),
              product_cost: Number(tempArray[index].cost),
              quantity: Number(tempArray[index].quantity),
              weight: Number(tempArray[index].product.shipping.weight_to_consider) * Number(tempArray[index].quantity),
              weight_to_consider:true
            },
          },
        };
  
        this.appService.postApiCall(obj, ENDPOINTS.STRUCTURED_PROMOTION).subscribe(
          (resp) => {
            if (resp) {
              if (resp.success === 1 && resp.status_code === 200) {
                for (let j = 0; j < this.appService.cartProducts.results.length;j++) {
                  if (
                    this.appService.cartProducts.results[j].product_id === tempArray[index].id
                    
                  )
                  console.log("resp.result.data.discount_summary[0].discount_amount",resp.result.data.discount_summary[0].discount_amount);
                   {                      
                      this.appService.cartProducts.results[j]["discount_amount"] =
                        resp.result.data.discount_summary[0].discount_amount;
               
                    this.appService.cartProducts.results[j][
                      "after_dicount_price"
                    ] = resp.result.data.discount_summary[0].after_dicount_price;
                    console.log(
                      "this.appService.cartProducts.results[i].product.fixed_amount" +
                      this.appService.cartProducts.results[j].
                        after_dicount_price
                    );
                    this.cartService.updateCartItem(
                      this.appService.cartProducts.results
                    );
                    console.log(
                      "this.appService.cartProducts.results[i].product.fixed_amount" +
                        this.appService.cartProducts.results[j].discount_amount
                    );
                  }
                }
                this.cartService.updateCartItem(
                  this.appService.cartProducts.results
                );
  
                console.log(
                  "tempArray[index].product.discount_value" +
                    tempArray[index].product.discount_value
                );
              } else if (resp.success === 0) {
                if (resp.message) {
                  //this.alertService.error(resp.message, this.options);
                }
              } else if (resp.message && resp.status_code !== 200) {
                //this.alertService.error(resp.message, this.options);
              } else {
                //this.alertService.error('Something bad happened. Please try again!', this.options);
              }
            }
          },
          (err) => {
            if (err.error.statusCode === 403) {
              //this.alertService.error('Session Time Out! Please login Again', this.options)
            } else if (err.error.error.message) {
              //this.alertService.error(err.error.error.message, this.options)
            } else {
              //this.alertService.error('Something bad happened. Please try again!', this.options);
            }
          }
        );
        tempArray[index].sub_total =
          Number(tempArray[index].quantity) * Number(tempArray[index].cost);
        this.appService.cartProducts.results = tempArray;
        this.appService.totalCartItems = this.cartService.totalCartItems();
        this.cartService.updateCartItem(this.appService.cartProducts.results);
        if (ORG_DETAILS.NAME === "SpecialWires") {
          let cartItemsString = JSON.stringify(
            this.appService.cartProducts.results
          );
          this.localService.set("cart", cartItemsString);
        }
      }
    if (ORG_DETAILS.NAME === "Vistas") {
      let userId = this.localService.get('UserId');

      let obj = {
        domain_name: ORG_DETAILS.DOMAIN_NAME,
        user_id: ORG_DETAILS.USER_ID,
        extras: {
          find: {
            customer_id: Number(userId),
            product_id: Number(tempArray[index].id),
            product_cost: Number(tempArray[index].cost),
            quantity: 1,
          },
        },
      };
      this.appService.postApiCall(obj, ENDPOINTS.STRUCTURED_PROMOTION).subscribe(
        (resp) => {
          if (resp) {
            if (resp.success === 1 && resp.status_code === 200) {
              for (let j = 0; j < this.appService.cartProducts.results.length;j++) {
                if (
                  this.appService.cartProducts.results[j].product_id === tempArray[index].id
                  
                )
                console.log("resp.result.data.discount_summary[0].discount_amount",resp.result.data.discount_summary[0].discount_amount);
                 {                      
                    this.appService.cartProducts.results[j]["discount_amount"] =
                      resp.result.data.discount_summary[0].discount_amount;
             
                  this.appService.cartProducts.results[j][
                    "after_dicount_price"
                  ] = resp.result.data.discount_summary[0].after_dicount_price;
                  console.log(
                    "this.appService.cartProducts.results[i].product.fixed_amount" +
                    this.appService.cartProducts.results[j].
                      after_dicount_price
                  );
                  this.cartService.updateCartItem(
                    this.appService.cartProducts.results
                  );
                  console.log(
                    "this.appService.cartProducts.results[i].product.fixed_amount" +
                      this.appService.cartProducts.results[j].discount_amount
                  );
                }
              }
              let cartItemsString = JSON.stringify(
                this.appService.cartProducts.results
              );
              this.localService.set("cart", cartItemsString);
            } else if (resp.success === 0) {
              if (resp.message) {
              }
            } else if (resp.message && resp.status_code !== 200) {
            } else {
            }
          }
        },
        (err) => {
          if (err.error.statusCode === 403) {
          } else if (err.error.error.message) {
          } else {
          }
        }
      );
      }
  }

  checkOutOfBounds(i) {
    let tempArray = this.appService.cartProducts.results;
    let cartQty = 0;


    tempArray.forEach((item) => {
      cartQty += item.quantity;
    });

  }
  changeDeeraVarValue(index, event) {
    this.eventValue = event.target.value;
    let tempArray = this.appService.cartProducts.results;
    if (this.eventValue==0) {
      console.log("truee")
      this.appService.cartProducts.results.splice(index, 1);
      this.cartData = [];
      for (let i = 0; i < this.appService.cartProducts.results.length; i++) {
        this.cartData.push(
          this.appService.cartProducts.results[i].product_id
        );
      }
      this.appService.totalCartItems = this.cartService.totalCartItems();
      this.cartService.updateCartItem(this.appService.cartProducts.results);
    }
    if (!this.eventValue) {
      // if(tempArray[index].product.pricing !== undefined){
        // if(this.appService.cartProducts.results[index].quantity === 1 || this.appService.cartProducts.results[index].quantity  < tempArray[index].product.pricing.raw.minimumorderquantity) {
        console.log("- button pressed!")
          this.appService.cartProducts.results.splice(index,1);
          this.appService.totalCartItems = this.cartService.totalCartItems();
          // this.calculateTotal();
          this.cartService.updateCartItem(this.appService.cartProducts.results);
          if(this.config.title==='Deera' || this.config.name==='Cle' || this.config.title==='LinenRaj'){
            let cartItemsString = JSON.stringify(this.appService.cartProducts.results);
            this.localService.set("cart", cartItemsString);
            }
          // this.loadExistingCart()
          return
      // }
    // }
    }
    
    else {
      this.alertService.clear();
      let tempArray = this.appService.cartProducts.results;
  
      let cartQty = 0
      console.log("insidee")
      let tempId: number = 0
      let tempCartQty: number = 0;
      tempArray.forEach((item) => {
        cartQty += item.quantity;
        let count = 0;
        if(item != tempArray[index]) {
          tempCartQty += item.quantity
        }
      });
  
      if(Number(this.localService.get('max_cart_qty')) <= cartQty)
      {
        this.showAlerts = true;
        window.scrollTo(0,0);
     if(this.config.name==='Deera' || this.config.name==='Cle'){
          tempArray[index].quantity = String(Number(this.localService.get('max_cart_qty')) - tempCartQty);
          event.srcElement.value = String(Number(this.localService.get('max_cart_qty')) - tempCartQty);
          console.log("insidee11")
  
          event.srcElement.blur();
          this.alertService.error("Maximum allowed quantity is " +this.localService.get('max_cart_qty') +" only",this.options)
        }
        else {
          this.alertService.error("Maximum allowed quantity is " +this.localService.get('max_cart_qty') +" only",this.options)
        }
      }
        // tempArray[index].quantity = (Number(tempArray[index].quantity) + 1)
        if(this.appService.cartProducts.results[index].quantity  < tempArray[index].product.pricing.raw.minimumorderquantity)
        {
            this.appService.cartProducts.results.splice(index,1);
            console.log("insidee22")
            this.appService.totalCartItems = this.cartService.totalCartItems();
            this.cartService.updateCartItem(this.appService.cartProducts.results);
            // this.calculateTotal();
            if(this.config.title==='Deera' || this.config.title==='Cle' || this.config.title==='LinenRaj'){
              let cartItemsString = JSON.stringify(this.appService.cartProducts.results);
              this.localService.set("cart", cartItemsString);
              }
            // this.loadExistingCart()
            return
        }

        tempArray[index].quantity = (Number(tempArray[index].quantity));
        tempArray[index].sub_total = (Number(tempArray[index].quantity) * Number(tempArray[index].cost))
        this.appService.cartProducts.results = tempArray;
        // this.calculateTotal();
        this.cartService.updateCartItem(this.appService.cartProducts.results);
        // this.loadExistingCart();
    }
    if (this.config.name === "Deera") {
      //let tempArray = this.appService.cartProducts.results;
      let obj = {
        domain_name: ORG_DETAILS.DOMAIN_NAME,
        user_id: ORG_DETAILS.USER_ID,
        extras: {
          find: {
            product_id: Number(tempArray[index].product_id),
            product_cost: Number(tempArray[index].product.pricing.raw.price),
            quantity: Number(tempArray[index].quantity),
          },
        },
      };
  
      this.appService.postApiCall(obj, ENDPOINTS.QUANTITY_PROMOTION).subscribe(
        (resp) => {
          if (resp) {
            if (resp.success === 1 && resp.status_code === 200) {
              console.log(
                "tempArray[index].quantity" + tempArray[index].product.id
              );
              console.log(
                "tempArray[index].quantity" + tempArray[index].product.id
              );
              console.log(
                "resp.result.data.discount_applied_to_product_value" +
                  resp.result.data.discount_applied_to_product_value
              );
              tempArray[index].product.discount_value =
                resp.result.data.discount_applied_to_product_value;
                tempArray[index].product.per_quantity_amount = resp.result.data.per_quantity_amount;
              tempArray[index].product.discount_amount =
                resp.result.data.discount_amount;
              tempArray[index].product.fixed_amount =
                resp.result.data.fixed_amount;
              tempArray[index].product.discount_percentage =
                resp.result.data.discount_percentage;
                this.congratulationBanner =
                resp.result.data.congratulations_banner_message;
              // this.congratulationBanner.forEach((element, index) => {
              //     this.congratulationBanner1 = element
              // });
              // this.upsellBanner = resp.result.data.upsell_banner_message;
              this.percentageValue = Number(
                resp.result.data.discount_percentage
              );
              this.fixedAmount = Number(resp.result.data.fixed_amount);
              this.discountValue = Number(
                resp.result.data.discount_applied_to_product_value
              );
              this.promotionType = resp.result.data.promotion_type;
              this.promotionType.forEach((element, index) => {
                if (element === 'Product discount') {
                  this.productPromotion = 'Product discount'
                }
                if (element === 'Quantity discount') {
                  this.quantityPromotion = 'Quantity discount'
                }
              });
              console.log("[DATA]: Respoonse: ", resp.result.data)
              this.productQuantity = Number(tempArray[index].quantity);

              this.productQuantity1 = true;
              if (resp.result.data.discount_percentage > 0) {
                this.appService.cartProducts.results[index]["fixed_amount"] =
                  resp.result.data.discount_amount;
              } else {
                this.appService.cartProducts.results[index]["fixed_amount"] =
                  resp.result.data.fixed_amount;
              }
              this.cartService.updateCartItem(
                this.appService.cartProducts.results
              );
  
              console.log(
                "tempArray[index].product.discount_value" +
                  tempArray[index].product.discount_value
              );
            } else if (resp.success === 0) {
              if (resp.message) {
                //this.alertService.error(resp.message, this.options);
              }
            } else if (resp.message && resp.status_code !== 200) {
              //this.alertService.error(resp.message, this.options);
            } else {
              //this.alertService.error('Something bad happened. Please try again!', this.options);
            }
          }
        },
        (err) => {
          if (err.error.statusCode === 403) {
            //this.alertService.error('Session Time Out! Please login Again', this.options)
          } else if (err.error.error.message) {
            //this.alertService.error(err.error.error.message, this.options)
          } else {
            //this.alertService.error('Something bad happened. Please try again!', this.options);
          }
        }
      );
  
      // tempArray[index].quantity = (Number(tempArray[index].quantity));
      // tempArray[index].sub_total = (Number(tempArray[index].quantity) * Number(tempArray[index].cost))
      // this.appService.cartProducts.results = tempArray;
      // this.appService.totalCartItems = this.cartService.totalCartItems();
      // this.cartService.updateCartItem(this.appService.cartProducts.results);
      // tempArray[index].quantity = (Number(tempArray[index].quantity));
      tempArray[index].sub_total =
        Number(tempArray[index].quantity) * Number(tempArray[index].cost);
      this.appService.cartProducts.results = tempArray;
      this.appService.totalCartItems = this.cartService.totalCartItems();
      this.cartService.updateCartItem(this.appService.cartProducts.results);
      if (this.config.name === "Deera") {
        let cartItemsString = JSON.stringify(
          this.appService.cartProducts.results
        );
        this.localService.set("cart", cartItemsString);
      }
    }
  }
  changeBabyVarValue(index, event) {
    this.eventValue = event.target.value;
    let tempArray = this.appService.cartProducts.results;
    if (this.eventValue==0) {
      console.log("truee")
      this.appService.cartProducts.results.splice(index, 1);
      this.cartData = [];
      for (let i = 0; i < this.appService.cartProducts.results.length; i++) {
        this.cartData.push(
          this.appService.cartProducts.results[i].product_id
        );
      }
      this.appService.totalCartItems = this.cartService.totalCartItems();
      this.cartService.updateCartItem(this.appService.cartProducts.results);
    }
    if (!this.eventValue) {
      // if(tempArray[index].product.pricing !== undefined){
        // if(this.appService.cartProducts.results[index].quantity === 1 || this.appService.cartProducts.results[index].quantity  < tempArray[index].product.pricing.raw.minimumorderquantity) {
        console.log("- button pressed!")
          this.appService.cartProducts.results.splice(index,1);
          this.appService.totalCartItems = this.cartService.totalCartItems();
          // this.calculateTotal();
          this.cartService.updateCartItem(this.appService.cartProducts.results);
          if(this.config.title==='Babys Pride' || ORG_DETAILS.NAME === "LushNGreen"){
            let cartItemsString = JSON.stringify(this.appService.cartProducts.results);
            this.localService.set("cart", cartItemsString);
            }
          // this.loadExistingCart()
          return
      // }
    // }
    }
    
    else {
      this.alertService.clear();
      let tempArray = this.appService.cartProducts.results;
  
      let cartQty = 0
      console.log("insidee")
      let tempId: number = 0
      let tempCartQty: number = 0;
      tempArray.forEach((item) => {
        cartQty += item.quantity;
        let count = 0;
        if(item != tempArray[index]) {
          tempCartQty += item.quantity
        }
      });
  
      if(Number(this.localService.get('max_cart_qty')) <= cartQty)
      {
        this.showAlerts = true;
        window.scrollTo(0,0);
     if(this.config.name==='Babys Pride' || ORG_DETAILS.NAME === "LushNGreen"){
          tempArray[index].quantity = String(Number(this.localService.get('max_cart_qty')) - tempCartQty);
          event.srcElement.value = String(Number(this.localService.get('max_cart_qty')) - tempCartQty);
          console.log("insidee11")
  
          event.srcElement.blur();
          this.alertService.error("Maximum allowed quantity is " +this.localService.get('max_cart_qty') +" only",this.options)
        }
        else {
          this.alertService.error("Maximum allowed quantity is " +this.localService.get('max_cart_qty') +" only",this.options)
        }
      }
        // tempArray[index].quantity = (Number(tempArray[index].quantity) + 1)
       console.log("tempArray[index].product.pricing.raw.minimumorderquantity",tempArray[index].product.pricing.raw.minimumorderquantity)
        if(this.appService.cartProducts.results[index].quantity  < tempArray[index].product.pricing.raw.minimumorderquantity)
        {
            this.appService.cartProducts.results.splice(index,1);
            console.log("insidee22")
            this.appService.totalCartItems = this.cartService.totalCartItems();
            this.cartService.updateCartItem(this.appService.cartProducts.results);
            // this.calculateTotal();
            if(this.config.title==='Babys Pride' || ORG_DETAILS.NAME === "LushNGreen"){
              let cartItemsString = JSON.stringify(this.appService.cartProducts.results);
              this.localService.set("cart", cartItemsString);
              }
            // this.loadExistingCart()
            return
        }

        tempArray[index].quantity = (Number(tempArray[index].quantity));
        tempArray[index].sub_total = (Number(tempArray[index].quantity) * Number(tempArray[index].cost))
        this.appService.cartProducts.results = tempArray;
        // this.calculateTotal();
        this.cartService.updateCartItem(this.appService.cartProducts.results);
        // this.loadExistingCart();
    }
    if (this.config.name === "Babys Pride" || ORG_DETAILS.NAME === "LushNGreen") {
      //let tempArray = this.appService.cartProducts.results;
      let obj = {
        domain_name: ORG_DETAILS.DOMAIN_NAME,
        user_id: ORG_DETAILS.USER_ID,
        extras: {
          find: {
            product_id: Number(tempArray[index].product_id),
            product_cost: Number(tempArray[index].product.pricing.raw.price),
            quantity: Number(tempArray[index].quantity),
          },
        },
      };
  
      this.appService.postApiCall(obj, ENDPOINTS.QUANTITY_PROMOTION).subscribe(
        (resp) => {
          if (resp) {
            if (resp.success === 1 && resp.status_code === 200) {
              console.log(
                "tempArray[index].quantity" + tempArray[index].product.id
              );
              console.log(
                "tempArray[index].quantity" + tempArray[index].product.id
              );
              console.log(
                "resp.result.data.discount_applied_to_product_value" +
                  resp.result.data.discount_applied_to_product_value
              );
              tempArray[index].product.discount_value =
                resp.result.data.discount_applied_to_product_value;
                tempArray[index].product.per_quantity_amount = resp.result.data.per_quantity_amount;
              tempArray[index].product.discount_amount =
                resp.result.data.discount_amount;
              tempArray[index].product.fixed_amount =
                resp.result.data.fixed_amount;
              tempArray[index].product.discount_percentage =
                resp.result.data.discount_percentage;
                this.congratulationBanner =
                resp.result.data.congratulations_banner_message;
              // this.congratulationBanner.forEach((element, index) => {
              //     this.congratulationBanner1 = element
              // });
              // this.upsellBanner = resp.result.data.upsell_banner_message;
              this.percentageValue = Number(
                resp.result.data.discount_percentage
              );
              this.fixedAmount = Number(resp.result.data.fixed_amount);
              this.discountValue = Number(
                resp.result.data.discount_applied_to_product_value
              );
              this.promotionType = resp.result.data.promotion_type;
              this.promotionType.forEach((element, index) => {
                if (element === 'Product discount') {
                  this.productPromotion = 'Product discount'
                }
                if (element === 'Quantity discount') {
                  this.quantityPromotion = 'Quantity discount'
                }
              });
              console.log("[DATA]: Respoonse: ", resp.result.data)
              this.productQuantity = Number(tempArray[index].quantity);

              this.productQuantity1 = true;
              if (resp.result.data.discount_percentage > 0) {
                this.appService.cartProducts.results[index]["fixed_amount"] =
                  resp.result.data.discount_amount;
              } else {
                this.appService.cartProducts.results[index]["fixed_amount"] =
                  resp.result.data.fixed_amount;
              }
              this.cartService.updateCartItem(
                this.appService.cartProducts.results
              );
  
              console.log(
                "tempArray[index].product.discount_value" +
                  tempArray[index].product.discount_value
              );
            } else if (resp.success === 0) {
              if (resp.message) {
                //this.alertService.error(resp.message, this.options);
              }
            } else if (resp.message && resp.status_code !== 200) {
              //this.alertService.error(resp.message, this.options);
            } else {
              //this.alertService.error('Something bad happened. Please try again!', this.options);
            }
          }
        },
        (err) => {
          if (err.error.statusCode === 403) {
            //this.alertService.error('Session Time Out! Please login Again', this.options)
          } else if (err.error.error.message) {
            //this.alertService.error(err.error.error.message, this.options)
          } else {
            //this.alertService.error('Something bad happened. Please try again!', this.options);
          }
        }
      );
  
      // tempArray[index].quantity = (Number(tempArray[index].quantity));
      // tempArray[index].sub_total = (Number(tempArray[index].quantity) * Number(tempArray[index].cost))
      // this.appService.cartProducts.results = tempArray;
      // this.appService.totalCartItems = this.cartService.totalCartItems();
      // this.cartService.updateCartItem(this.appService.cartProducts.results);
      // tempArray[index].quantity = (Number(tempArray[index].quantity));
      tempArray[index].sub_total =
        Number(tempArray[index].quantity) * Number(tempArray[index].cost);
      this.appService.cartProducts.results = tempArray;
      this.appService.totalCartItems = this.cartService.totalCartItems();
      this.cartService.updateCartItem(this.appService.cartProducts.results);
      if (this.config.name === "Babys Pride" || ORG_DETAILS.NAME === "LushNGreen") {
        let cartItemsString = JSON.stringify(
          this.appService.cartProducts.results
        );
        this.localService.set("cart", cartItemsString);
      }
    }
  }
  changeDeeraValue(index, event) {
    console.log("event" + event.target.value)
    this.eventValue = event.target.value;
    if (!this.eventValue) {
      console.log("truee")
    } else {
      console.log("falsee")
    }
    this.alertService.clear();
    let tempArray = this.appService.cartProducts.results;
    let cartQty = 0;


    let tempCartQty: number = 0;
    tempArray.forEach((item) => {
      cartQty += item.quantity;

      if (item.product.id != this.product.id) {
        tempCartQty += item.quantity
      }
    });


    console.log(tempArray[index].quantity);
    console.log(this.appService.cartProducts.results[index].quantity)
    console.log("Cart qty: ", cartQty)
    if (Number(this.localService.get("max_cart_qty")) < cartQty) {
      this.showAlerts = true;
      window.scrollTo(0, 0);
      this.maxValuetemp = Number(this.localService.get("max_cart_qty"))
      if(this.config.title==='Babys Pride' || ORG_DETAILS.NAME === "LushNGreen"){
      if(this.appService.cartProducts.results[index].quantity  < tempArray[index].product.pricing.raw.minimumorderquantity)
      {
          this.appService.cartProducts.results.splice(index,1);
          console.log("insidee22")
          this.appService.totalCartItems = this.cartService.totalCartItems();
          this.cartService.updateCartItem(this.appService.cartProducts.results);
          // this.calculateTotal();
          if(this.config.title==='Deera' || this.config.title==='Babys Pride' || ORG_DETAILS.NAME === "LushNGreen"){
            let cartItemsString = JSON.stringify(this.appService.cartProducts.results);
            this.localService.set("cart", cartItemsString);
            }
          // this.loadExistingCart()
          return
      }
    }
      // this.alertService.error("Maximum allowed quantity is " +this.localService.get('max_cart_qty') +" only",this.options)
      if (config.title === "BombayHardware") {
        //this.alertService.error("Maximum allowed quantity is 10 only",this.options);
        this.alertService.error("Maximum allowed quantity is " + this.localService.get("max_cart_qty") + " only", this.options);
      } 
      else if (config.title === "Deera") {
        tempArray[index].quantity = Number(this.localService.get("max_cart_qty")) - tempCartQty
        event.srcElement.value = String(Number(this.localService.get("max_cart_qty")) - tempCartQty)
        event.srcElement.blur()
        this.alertService.error("Maximum allowed quantity in the cart is " + this.localService.get("max_cart_qty") + " only", this.options);
      }
      else if (  this.config.title==='Babys Pride' || ORG_DETAILS.NAME === "LushNGreen") {
        console.log("123123")
        if(this.appService.cartProducts.results[index].quantity  < tempArray[index].product.pricing.raw.minimumorderquantity)
        {
            this.appService.cartProducts.results.splice(index,1);
            console.log("insidee22")
            this.appService.totalCartItems = this.cartService.totalCartItems();
            this.cartService.updateCartItem(this.appService.cartProducts.results);
            // this.calculateTotal();
            if(this.config.title==='Deera' || this.config.title==='Babys Pride' || ORG_DETAILS.NAME === "LushNGreen"){
              let cartItemsString = JSON.stringify(this.appService.cartProducts.results);
              this.localService.set("cart", cartItemsString);
              }
            // this.loadExistingCart()
            return
        }
        // tempArray[index].quantity = Number(this.localService.get("max_cart_qty")) - tempCartQty
        // event.srcElement.value = String(Number(this.localService.get("max_cart_qty")) - tempCartQty)
        // event.srcElement.blur()
        // this.alertService.error("Maximum allowed quantity in the cart is " + this.localService.get("max_cart_qty") + " only", this.options);
        // if (
        //   this.appService.cartProducts.results[index].quantity <
        //   tempArray[index].product.pricing.raw.minimumorderquantity
        // ) {
        //   this.appService.cartProducts.results.splice(index, 1);
        //   this.cartData = [];
        //   for (let i = 0; i < this.appService.cartProducts.results.length; i++) {
        //     this.cartData.push(this.appService.cartProducts.results[i].product_id);
        //   }
        //   this.appService.totalCartItems = this.cartService.totalCartItems();
        //   this.cartService.updateCartItem(this.appService.cartProducts.results);
    
        //     let cartItemsString = JSON.stringify(
        //       this.appService.cartProducts.results
        //     );
        //     this.localService.set("cart", cartItemsString);
        //   return;
        // }
      } else {
        this.alertService.error(
          "Maximum allowed quantity is " +
          this.localService.get("max_cart_qty") +
          " only",
          this.options
        );
      }
      return;
    }
    if (
      this.appService.cartProducts.results[index].quantity <
      tempArray[index].product.pricing.raw.minimumorderquantity
    ) {
      this.appService.cartProducts.results.splice(index, 1);
      this.cartData = [];
      for (let i = 0; i < this.appService.cartProducts.results.length; i++) {
        this.cartData.push(this.appService.cartProducts.results[i].product_id);
      }
      this.appService.totalCartItems = this.cartService.totalCartItems();
      this.cartService.updateCartItem(this.appService.cartProducts.results);
      if (config.title === "Deera" || this.config.title==='Babys Pride' || ORG_DETAILS.NAME === "LushNGreen") {
        let cartItemsString = JSON.stringify(
          this.appService.cartProducts.results
        );
        this.localService.set("cart", cartItemsString);
      }
      
      return;
      
    }
    if (ORG_DETAILS.NAME === "Deera") {
      //let tempArray = this.appService.cartProducts.results;
      let obj = {
        domain_name: ORG_DETAILS.DOMAIN_NAME,
        user_id: ORG_DETAILS.USER_ID,
        extras: {
          find: {
            product_id: Number(tempArray[index].product_id),
            product_cost: Number(tempArray[index].cost),
            quantity: Number(tempArray[index].quantity),
          },
        },
      };
      this.appService
        .postApiCall(obj, ENDPOINTS.QUANTITY_PROMOTION)
        .subscribe(
          (resp) => {
            if (resp) {
              if (resp.success === 1 && resp.status_code === 200) {
                tempArray[index].product.discount_value =
                  resp.result.data.discount_applied_to_product_value;
                tempArray[index].product.per_quantity_amount = resp.result.data.per_quantity_amount;
                tempArray[index].product.discount_amount =
                  resp.result.data.discount_amount;
                tempArray[index].product.fixed_amount =
                  resp.result.data.fixed_amount;
                tempArray[index].product.discount_percentage =
                  resp.result.data.discount_percentage;
                this.congratulationBanner =
                  resp.result.data.congratulations_banner_message;
                //   this.congratulationBanner.forEach((element, index) => {
                //     this.congratulationBanner1 = element
                // });
                // this.upsellBanner = resp.result.data.upsell_banner_message;
                this.percentageValue = Number(
                  resp.result.data.discount_percentage
                );
                this.fixedAmount = Number(resp.result.data.fixed_amount);
                this.discountValue = Number(
                  resp.result.data.discount_applied_to_product_value
                );
                this.promotionType = resp.result.data.promotion_type;
                this.promotionType.forEach((element, index) => {
                  if (element === 'Product discount') {
                    this.productPromotion = 'Product discount'
                  }
                  if (element === 'Quantity discount') {
                    this.quantityPromotion = 'Quantity discount'
                  }
                });
                this.productQuantity = Number(tempArray[index].quantity);
                console.log(
                  "Number(tempArray[index].quantity)" +
                  Number(tempArray[index].quantity)
                );
                console.log("productQuantity" + this.productQuantity);
                this.productQuantity1 = true;
                if (resp.result.data.discount_percentage > 0) {
                  this.appService.cartProducts.results[index][
                    "fixed_amount"
                  ] = resp.result.data.discount_amount;
                } else {
                  this.appService.cartProducts.results[index][
                    "fixed_amount"
                  ] = resp.result.data.fixed_amount;
                }
                this.cartService.updateCartItem(
                  this.appService.cartProducts.results
                );
              } else if (resp.success === 0) {
                if (resp.message) {
                  //this.alertService.error(resp.message, this.options);
                }
              } else if (resp.message && resp.status_code !== 200) {
                //this.alertService.error(resp.message, this.options);
              } else {
                //this.alertService.error('Something bad happened. Please try again!', this.options);
              }
            }
          },
          (err) => {
            if (err.error.statusCode === 403) {
              //this.alertService.error('Session Time Out! Please login Again', this.options)
            } else if (err.error.error.message) {
              //this.alertService.error(err.error.error.message, this.options)
            } else {
              //this.alertService.error('Something bad happened. Please try again!', this.options);
            }
          }
        );

      // tempArray[index].quantity = (Number(tempArray[index].quantity));
      // tempArray[index].sub_total = (Number(tempArray[index].quantity) * Number(tempArray[index].cost))
      // this.appService.cartProducts.results = tempArray;
      // this.appService.totalCartItems = this.cartService.totalCartItems();
      // this.cartService.updateCartItem(this.appService.cartProducts.results);
      // tempArray[index].quantity = (Number(tempArray[index].quantity));
      tempArray[index].sub_total =
        Number(tempArray[index].quantity) * Number(tempArray[index].cost);
      this.appService.cartProducts.results = tempArray;
      this.appService.totalCartItems = this.cartService.totalCartItems();
      this.cartService.updateCartItem(this.appService.cartProducts.results);
      if (ORG_DETAILS.NAME === "Deera") {
        let cartItemsString = JSON.stringify(
          this.appService.cartProducts.results
        );
        this.localService.set("cart", cartItemsString);
      }
    }
  }

  decreaseItemSpecial(index) {
    console.log("dataaaaaa")
    let userId = this.localService.get('UserId');
    let tempArray = this.appService.cartProducts.results;
      if(ORG_DETAILS.NAME == "SpecialWires" || ORG_DETAILS.NAME == "LushNGreen"){
      let tempArray = this.appService.cartProducts.results;
if(tempArray[index].quantity<=tempArray[index].product.pricing.raw.minimumorderquantity)
{
  tempArray[index].quantity =Number(tempArray[index].quantity)-tempArray[index].product.pricing.raw.minimumorderquantity;
}
else {
  if(tempArray[index].product.pricing.raw.decrementvalue>0)
  {
    console.log("trueeeeeee")
    tempArray[index].quantity = Number(tempArray[index].quantity) - Number(tempArray[index].product.pricing.raw.decrementvalue);
  } 
  // else {
  //   tempArray[index].quantity = Number(tempArray[index].quantity) - 1;
  // }
  // tempArray[index].quantity=Number(tempArray[index].quantity)-1;
}
if(tempArray[index].quantity<=0)
{
  this.appService.cartProducts.results.splice(index, 1);
}
}
  this.appService.totalCartItems = this.cartService.totalCartItems();
  this.cartService.updateCartItem(this.appService.cartProducts.results);

      tempArray[index].sub_total =
        Number(tempArray[index].quantity) * Number(tempArray[index].cost);
      if (ORG_DETAILS.NAME === "SpecialWires") {
        let obj = {
          domain_name: ORG_DETAILS.DOMAIN_NAME,
          user_id: ORG_DETAILS.USER_ID,
          extras: {
            find: {
              product_id: Number(tempArray[index].product_id),
              product_cost: Number(tempArray[index].cost),
              quantity: Number(tempArray[index].quantity),
              customer_id: Number(userId),
              weight: Number(tempArray[index].product.shipping.weight_to_consider) * Number(tempArray[index].quantity),
            weight_to_consider:true
            },
          },
        };

        this.appService
          .postApiCall(obj, ENDPOINTS.STRUCTURED_PROMOTION)
          .subscribe(
            (resp) => {
              if (resp) {
                if (resp.success === 1 && resp.status_code === 200) {
           
                    this.appService.cartProducts.results[index]["discount_amount"] =
                    resp.result.data.discount_summary[0].discount_amount;
           
                this.appService.cartProducts.results[index][
                  "after_dicount_price"
                ] = resp.result.data.discount_summary[0].after_dicount_price;
                   
                   
                  this.cartService.updateCartItem(
                    this.appService.cartProducts.results
                  );
                  console.log(
                    "tempArray[index].product.discount_value" +
                      tempArray[index].product.discount_value
                  );
                } else if (resp.success === 0) {
                  if (resp.message) {
                    //this.alertService.error(resp.message, this.options);
                  }
                } else if (resp.message && resp.status_code !== 200) {
                  //this.alertService.error(resp.message, this.options);
                } else {
                  //this.alertService.error('Something bad happened. Please try again!', this.options);
                }
              }
            },
            (err) => {
              if (err.error.statusCode === 403) {
                //this.alertService.error('Session Time Out! Please login Again', this.options)
              } else if (err.error.error.message) {
                //this.alertService.error(err.error.error.message, this.options)
              } else {
                //this.alertService.error('Something bad happened. Please try again!', this.options);
              }
            }
          );
      }
      this.appService.cartProducts.results = tempArray;
      this.appService.totalCartItems = this.cartService.totalCartItems();
      this.cartService.updateCartItem(this.appService.cartProducts.results);
      if (ORG_DETAILS.NAME === "SpecialWires" || ORG_DETAILS.NAME == "LushNGreen") {
        let cartItemsString = JSON.stringify(
          this.appService.cartProducts.results
        );
        this.localService.set("cart", cartItemsString);
      }
    
  }

  decreaseItem(index) {
    let tempArray = this.appService.cartProducts.results;
    if (ORG_DETAILS.NAME === "ShubhCards") {
      if (
        this.appService.cartProducts.results[index].quantity -
        tempArray[index].product.pricing.raw.decrementvalue <
        tempArray[index].product.pricing.raw.minimumorderquantity
      ) {
        this.appService.cartProducts.results.splice(index, 1);
        this.cartData = [];
        for (let i = 0; i < this.appService.cartProducts.results.length; i++) {
          this.cartData.push(
            this.appService.cartProducts.results[i].product_id
          );
        }
        this.appService.totalCartItems = this.cartService.totalCartItems();
        this.cartService.updateCartItem(this.appService.cartProducts.results);
        return;
      }

      tempArray[index].quantity =
        Number(tempArray[index].quantity) -
        tempArray[index].product.pricing.raw.decrementvalue;
      tempArray[index].sub_total =
        Number(tempArray[index].quantity) * Number(tempArray[index].cost);
      this.appService.cartProducts.results = tempArray;
      this.appService.totalCartItems = this.cartService.totalCartItems();
      this.cartService.updateCartItem(this.appService.cartProducts.results);
    } 
    else {
      console.log(tempArray);
      if (this.appService.cartProducts.results[index].quantity === 1) {
        this.appService.cartProducts.results.splice(index, 1);
        this.cartData = [];
        if (ORG_DETAILS.NAME === "Deera") {
          // this.appService.cartProducts.results[index].quantity = 0;
          // this.appService.cartProducts.results[index].discount_value = 0;
          // this.appService.cartProducts.results[index].discount_percentage = 0;
          // this.appService.cartProducts.results[index].discount_amount = 0;
          // this.appService.cartProducts.results[index].fixed_amount = 0;
          // this.upsellBanner = "";
          // this.congratulationBanner = "";
          this.congratulationBanner = [];
          this.percentageValue = 0;
          this.fixedAmount = 0;
          this.discountValue = 0;
          // this.promotionType = 0;
          this.promotionType = [];
          this.productQuantity = 0;
        }
        for (let i = 0; i < this.appService.cartProducts.results.length; i++) {
          this.cartData.push(
            this.appService.cartProducts.results[i].product_id
          );
        }
        this.appService.totalCartItems = this.cartService.totalCartItems();
        this.cartService.updateCartItem(this.appService.cartProducts.results);
        if (ORG_DETAILS.NAME === "Deera" || ORG_DETAILS.NAME === "Babys Pride" || ORG_DETAILS.NAME === "LushNGreen") {
          let cartItemsString = JSON.stringify(
            this.appService.cartProducts.results
          );
          this.localService.set("cart", cartItemsString);
        }
        return;
      }

      tempArray[index].quantity = Number(tempArray[index].quantity) - 1;
      tempArray[index].sub_total =
        Number(tempArray[index].quantity) * Number(tempArray[index].cost);
      console.log("decrement222");
     
      if (ORG_DETAILS.NAME === 'SpecialWires') {
        let obj =
        {
          "domain_name": ORG_DETAILS.DOMAIN_NAME,
          "user_id": ORG_DETAILS.USER_ID,
          "extras": {
            "find": {
              "product_id": Number(tempArray[index].product_id),
              "product_cost": Number(tempArray[index].cost),
              "quantity": Number(tempArray[index].quantity),
              "weight": Number(tempArray[index].product.shipping.weight_to_consider) * Number(tempArray[index].quantity),
              "weight_to_consider":true
            }
          }
        }
  
        this.appService.postApiCall(obj, ENDPOINTS.STRUCTURED_PROMOTION).subscribe(
          (resp) => {
            if (resp) {
              if (resp.success === 1 && resp.status_code === 200) {
                for (let j = 0; j < this.appService.cartProducts.results.length;j++) {
                  if (
                    this.appService.cartProducts.results[j].product_id === tempArray[index].id
                    
                  )
                  console.log("resp.result.data.discount_summary[0].discount_amount",resp.result.data.discount_summary[0].discount_amount);
                   {                      
                      this.appService.cartProducts.results[j]["discount_amount"] =
                        resp.result.data.discount_summary[0].discount_amount;
               
                    this.appService.cartProducts.results[j][
                      "after_dicount_price"
                    ] = resp.result.data.discount_summary[0].after_dicount_price;
                    console.log(
                      "this.appService.cartProducts.results[i].product.fixed_amount" +
                      this.appService.cartProducts.results[j].
                        after_dicount_price
                    );
                    this.cartService.updateCartItem(
                      this.appService.cartProducts.results
                    );
                    console.log(
                      "this.appService.cartProducts.results[i].product.fixed_amount" +
                        this.appService.cartProducts.results[j].discount_amount
                    );
                  }
                }
                this.cartService.updateCartItem(
                  this.appService.cartProducts.results
                );
  
                console.log(
                  "tempArray[index].product.discount_value" +
                    tempArray[index].product.discount_value
                );
              } else if (resp.success === 0) {
                if (resp.message) {
                  //this.alertService.error(resp.message, this.options);
                }
              } else if (resp.message && resp.status_code !== 200) {
                //this.alertService.error(resp.message, this.options);
              } else {
                //this.alertService.error('Something bad happened. Please try again!', this.options);
              }
            }
          },
          (err) => {
            if (err.error.statusCode === 403) {
              //this.alertService.error('Session Time Out! Please login Again', this.options)
            } else if (err.error.error.message) {
              //this.alertService.error(err.error.error.message, this.options)
            } else {
              //this.alertService.error('Something bad happened. Please try again!', this.options);
            }
          }
        );
        tempArray[index].sub_total =
        Number(tempArray[index].quantity) * Number(tempArray[index].cost);
      this.appService.cartProducts.results = tempArray;
      this.appService.totalCartItems = this.cartService.totalCartItems();
      this.cartService.updateCartItem(this.appService.cartProducts.results);
        let cartItemsString = JSON.stringify(
          this.appService.cartProducts.results
        );
        this.localService.set("cart", cartItemsString);
      }
      if (ORG_DETAILS.NAME === "Babys Pride") {
        let obj = {
          domain_name: ORG_DETAILS.DOMAIN_NAME,
          user_id: ORG_DETAILS.USER_ID,
          extras: {
            find: {
              product_id: Number(tempArray[index].product_id),
              product_cost: Number(tempArray[index].cost),
              quantity: Number(tempArray[index].quantity),
            },
          },
        };

        this.appService
          .postApiCall(obj, ENDPOINTS.QUANTITY_PROMOTION)
          .subscribe(
            (resp) => {
              if (resp) {
                if (resp.success === 1 && resp.status_code === 200) {
                  console.log(
                    "tempArray[index].quantity" + tempArray[index].product.id
                  );
                  console.log(
                    "discount value = ",
                    tempArray[index].product.discount_value
                  );
                  tempArray[index].product.discount_value =
                    resp.result.data.discount_applied_to_product_value;
                  tempArray[index].product.per_quantity_amount = resp.result.data.per_quantity_amount;
                  tempArray[index].product.discount_amount =
                    resp.result.data.discount_amount;
                  tempArray[index].product.fixed_amount =
                    resp.result.data.fixed_amount;
                  tempArray[index].product.discount_percentage =
                    resp.result.data.discount_percentage;
                  this.congratulationBanner =
                    resp.result.data.congratulations_banner_message;
                  //   this.congratulationBanner.forEach((element, index) => {
                  //     this.congratulationBanner1 = element
                  // });
                  // this.upsellBanner = resp.result.data.upsell_banner_message;
                  this.percentageValue = Number(
                    resp.result.data.discount_percentage
                  );
                  this.fixedAmount = Number(resp.result.data.fixed_amount);
                  this.discountValue = Number(
                    resp.result.data.discount_applied_to_product_value
                  );
                  this.promotionType = resp.result.data.promotion_type;
                  this.promotionType.forEach((element, index) => {
                    if (element === 'Product discount') {
                      this.productPromotion = 'Product discount'
                    }
                    if (element === 'Quantity discount') {
                      this.quantityPromotion = 'Quantity discount'
                    }
                  });
                  this.productQuantity = Number(tempArray[index].quantity);
                  console.log(
                    "Number(tempArray[index].quantity)" +
                    Number(tempArray[index].quantity)
                  );
                  console.log("productQuantity" + this.productQuantity);
                  this.productQuantity1 = true;
                  this.cartService.updateCartItem(
                    this.appService.cartProducts.results
                  );
                } else if (resp.success === 0) {
                  if (resp.message) {
                    //this.alertService.error(resp.message, this.options);
                  }
                } else if (resp.message && resp.status_code !== 200) {
                  //this.alertService.error(resp.message, this.options);
                } else {
                  //this.alertService.error('Something bad happened. Please try again!', this.options);
                }
              }
            },
            (err) => {
              if (err.error.statusCode === 403) {
                //this.alertService.error('Session Time Out! Please login Again', this.options)
              } else if (err.error.error.message) {
                //this.alertService.error(err.error.error.message, this.options)
              } else {
                //this.alertService.error('Something bad happened. Please try again!', this.options);
              }
            }
          );
      }
      if (ORG_DETAILS.NAME === "LushNGreen") {
        let obj = {
          domain_name: ORG_DETAILS.DOMAIN_NAME,
          user_id: ORG_DETAILS.USER_ID,
          extras: {
            find: {
              product_id: Number(tempArray[index].product_id),
              product_cost: Number(tempArray[index].cost),
              quantity: Number(tempArray[index].quantity),
            },
          },
        };

        this.appService
          .postApiCall(obj, ENDPOINTS.QUANTITY_PROMOTION)
          .subscribe(
            (resp) => {
              if (resp) {
                if (resp.success === 1 && resp.status_code === 200) {
                  console.log(
                    "tempArray[index].quantity" + tempArray[index].product.id
                  );
                  console.log(
                    "discount value = ",
                    tempArray[index].product.discount_value
                  );
                  tempArray[index].product.discount_value =
                    resp.result.data.discount_applied_to_product_value;
                  tempArray[index].product.per_quantity_amount = resp.result.data.per_quantity_amount;
                  tempArray[index].product.discount_amount =
                    resp.result.data.discount_amount;
                  tempArray[index].product.fixed_amount =
                    resp.result.data.fixed_amount;
                  tempArray[index].product.discount_percentage =
                    resp.result.data.discount_percentage;
                  this.congratulationBanner =
                    resp.result.data.congratulations_banner_message;
                  //   this.congratulationBanner.forEach((element, index) => {
                  //     this.congratulationBanner1 = element
                  // });
                  // this.upsellBanner = resp.result.data.upsell_banner_message;
                  this.percentageValue = Number(
                    resp.result.data.discount_percentage
                  );
                  this.fixedAmount = Number(resp.result.data.fixed_amount);
                  this.discountValue = Number(
                    resp.result.data.discount_applied_to_product_value
                  );
                  this.promotionType = resp.result.data.promotion_type;
                  this.promotionType.forEach((element, index) => {
                    if (element === 'Product discount') {
                      this.productPromotion = 'Product discount'
                    }
                    if (element === 'Quantity discount') {
                      this.quantityPromotion = 'Quantity discount'
                    }
                  });
                  this.productQuantity = Number(tempArray[index].quantity);
                  console.log(
                    "Number(tempArray[index].quantity)" +
                    Number(tempArray[index].quantity)
                  );
                  console.log("productQuantity" + this.productQuantity);
                  this.productQuantity1 = true;
                  this.cartService.updateCartItem(
                    this.appService.cartProducts.results
                  );
                } else if (resp.success === 0) {
                  if (resp.message) {
                    //this.alertService.error(resp.message, this.options);
                  }
                } else if (resp.message && resp.status_code !== 200) {
                  //this.alertService.error(resp.message, this.options);
                } else {
                  //this.alertService.error('Something bad happened. Please try again!', this.options);
                }
              }
            },
            (err) => {
              if (err.error.statusCode === 403) {
                //this.alertService.error('Session Time Out! Please login Again', this.options)
              } else if (err.error.error.message) {
                //this.alertService.error(err.error.error.message, this.options)
              } else {
                //this.alertService.error('Something bad happened. Please try again!', this.options);
              }
            }
          );
      }
      if (ORG_DETAILS.NAME === "BestGifts" || ORG_DETAILS.NAME === "Schift Cosmetics") {
        let userId = this.localService.get('UserId');
        document.getElementById("bestgiftsloader").style.display="block"
        let obj = {
          domain_name: ORG_DETAILS.DOMAIN_NAME,
          user_id: ORG_DETAILS.USER_ID,
          extras: {
            find: {
              product_id: Number(tempArray[index].product_id),
              product_cost: Number(tempArray[index].cost),
              quantity: Number(tempArray[index].quantity),
              customer_id: Number(userId),
              customer_type:this.customerType1
            },
          },
        };
  
        try {
          this.appService
            .postApiCall(obj, ENDPOINTS.STRUCTURED_PROMOTION)
            .subscribe(
              (resp) => {
                if (resp) {
                  if (resp.success === 1 && resp.status_code === 200) {
                    this.appService.cartProducts.results[index]["discount_amount"] =
                  resp.result.data.discount_summary[0].discount_amount;
         
              this.appService.cartProducts.results[index][
                "after_dicount_price"
              ] = resp.result.data.discount_summary[0].after_dicount_price;
              this.appService.cartProducts.results[index][
                "per_quantity_amount"
              ] = resp.result.data.discount_summary[0].per_quantity_amount;
                      // this.percentageValue = Number(resp.result.data.discount_percentage);
                      // this.fixedAmount = Number(resp.result.data.fixed_amount);
                      // this.discountValue = Number(resp.result.data.discount_applied_to_product_value);
                      // this.promotionType = resp.result.data.promotion_type;
                      // this.productQuantity = Number(tempArray[index].quantity);
                      // this.productQuantity1 = true;
                    this.cartService.updateCartItem(
                      this.appService.cartProducts.results
                    );
                    document.getElementById("bestgiftsloader").style.display="none"
                  } else if (resp.success === 0) {
                    if (resp.message) {
                      //this.alertService.error(resp.message, this.options);
                    }
                  } else if (resp.message && resp.status_code !== 200) {
                    //this.alertService.error(resp.message, this.options);
                  } else {
                    //this.alertService.error('Something bad happened. Please try again!', this.options);
                  }
                }
              },
              (err) => {
                if (err.error.statusCode === 403) {
                  //this.alertService.error('Session Time Out! Please login Again', this.options)
                } else if (err.error.error.message) {
                  //this.alertService.error(err.error.error.message, this.options)
                } else {
                  //this.alertService.error('Something bad happened. Please try again!', this.options);
                }
              }
            );
        } catch (err) {
          console.log("ERROR IN ADDING ITEM: ", err);
        }
      }
      this.appService.cartProducts.results = tempArray;
      this.appService.totalCartItems = this.cartService.totalCartItems();
      this.cartService.updateCartItem(this.appService.cartProducts.results);
      if (ORG_DETAILS.NAME === "Deera" || ORG_DETAILS.NAME === "Babys Pride" || ORG_DETAILS.NAME === "LushNGreen" || ORG_DETAILS.NAME==="BestGifts") {
        let cartItemsString = JSON.stringify(
          this.appService.cartProducts.results
        );
        this.localService.set("cart", cartItemsString);
      }
    }
  }

  decreaseItemNew(index) {
    let userId = this.localService.get('UserId');
    let tempArray = this.appService.cartProducts.results;
    if (ORG_DETAILS.NAME === "ShubhCards") {
      if (
        this.appService.cartProducts.results[index].quantity -
        tempArray[index].product.pricing.raw.decrementvalue <
        tempArray[index].product.pricing.raw.minimumorderquantity
      ) {
        this.appService.cartProducts.results.splice(index, 1);
        this.cartData = [];

        for (let i = 0; i < this.appService.cartProducts.results.length; i++) {
          this.cartData.push(
            this.appService.cartProducts.results[i].product_id
          );
        }
        this.appService.totalCartItems = this.cartService.totalCartItems();
        this.cartService.updateCartItem(this.appService.cartProducts.results);
        return;
      }

      tempArray[index].quantity =
        Number(tempArray[index].quantity) -
        tempArray[index].product.pricing.raw.decrementvalue;
      tempArray[index].sub_total =
        Number(tempArray[index].quantity) * Number(tempArray[index].cost);
      this.appService.cartProducts.results = tempArray;
      this.appService.totalCartItems = this.cartService.totalCartItems();
      this.cartService.updateCartItem(this.appService.cartProducts.results);
    } 
    else {
      if(ORG_DETAILS.NAME !=="SpecialWires"){
      if (
        this.appService.cartProducts.results[index].quantity === 1 ||
        this.appService.cartProducts.results[index].quantity <=
          tempArray[index].product.pricing.raw.minimumorderquantity
      ) {
        this.appService.cartProducts.results.splice(index, 1);
        this.cartData = [];
   if(ORG_DETAILS.NAME === "Srimaware"){
window.scroll(0,100);
        }
        for (let i = 0; i < this.appService.cartProducts.results.length; i++) {
          this.cartData.push(
            this.appService.cartProducts.results[i].product_id
          );
        }
        this.appService.totalCartItems = this.cartService.totalCartItems();
        this.cartService.updateCartItem(this.appService.cartProducts.results);
        if (ORG_DETAILS.NAME === "Deera" || ORG_DETAILS.NAME === "Babys Pride" || ORG_DETAILS.NAME === "LushNGreen" || ORG_DETAILS.NAME==="Beaubelle" || ORG_DETAILS.NAME === "AvonSeals" || ORG_DETAILS.NAME === "Vistas" || ORG_DETAILS.NAME === "Linenraj" || ORG_DETAILS.NAME === "LushNGreen" || ORG_DETAILS.NAME === "Srimaware") {
          let cartItemsString = JSON.stringify(
            this.appService.cartProducts.results
          );
          this.localService.set("cart", cartItemsString);
        }
        return;
      }
    }
      if(ORG_DETAILS.NAME === "SpecialWires"){
      let tempArray = this.appService.cartProducts.results;
if(tempArray[index].quantity<=tempArray[index].product.pricing.raw.minimumorderquantity)
{
  tempArray[index].quantity =Number(tempArray[index].quantity)-tempArray[index].product.pricing.raw.minimumorderquantity;
}
else {
  if(tempArray[index].product.pricing.raw.decrementvalue>0)
  {
    console.log("trueeeeeee")
    tempArray[index].quantity = Number(tempArray[index].quantity) - Number(tempArray[index].product.pricing.raw.decrementvalue);
  } 
  // else {
  //   tempArray[index].quantity = Number(tempArray[index].quantity) - 1;
  // }
  // tempArray[index].quantity=Number(tempArray[index].quantity)-1;
}
if(tempArray[index].quantity<=0)
{
  this.appService.cartProducts.results.splice(index, 1);
}
}
  this.appService.totalCartItems = this.cartService.totalCartItems();
  this.cartService.updateCartItem(this.appService.cartProducts.results);



      tempArray[index].quantity = Number(tempArray[index].quantity) - 1;
      tempArray[index].sub_total =
        Number(tempArray[index].quantity) * Number(tempArray[index].cost);
      if (ORG_DETAILS.NAME === "SpecialWires") {
        let obj = {
          domain_name: ORG_DETAILS.DOMAIN_NAME,
          user_id: ORG_DETAILS.USER_ID,
          extras: {
            find: {
              product_id: Number(tempArray[index].product_id),
              product_cost: Number(tempArray[index].cost),
              quantity: Number(tempArray[index].quantity),
              customer_id: Number(userId),
              weight: Number(tempArray[index].product.shipping.weight_to_consider) * Number(tempArray[index].quantity),
            weight_to_consider:true
            },
          },
        };

        this.appService
          .postApiCall(obj, ENDPOINTS.STRUCTURED_PROMOTION)
          .subscribe(
            (resp) => {
              if (resp) {
                if (resp.success === 1 && resp.status_code === 200) {
           
                    this.appService.cartProducts.results[index]["discount_amount"] =
                    resp.result.data.discount_summary[0].discount_amount;
           
                this.appService.cartProducts.results[index][
                  "after_dicount_price"
                ] = resp.result.data.discount_summary[0].after_dicount_price;
                   
                   
                  this.cartService.updateCartItem(
                    this.appService.cartProducts.results
                  );
                  console.log(
                    "tempArray[index].product.discount_value" +
                      tempArray[index].product.discount_value
                  );
                } else if (resp.success === 0) {
                  if (resp.message) {
                    //this.alertService.error(resp.message, this.options);
                  }
                } else if (resp.message && resp.status_code !== 200) {
                  //this.alertService.error(resp.message, this.options);
                } else {
                  //this.alertService.error('Something bad happened. Please try again!', this.options);
                }
              }
            },
            (err) => {
              if (err.error.statusCode === 403) {
                //this.alertService.error('Session Time Out! Please login Again', this.options)
              } else if (err.error.error.message) {
                //this.alertService.error(err.error.error.message, this.options)
              } else {
                //this.alertService.error('Something bad happened. Please try again!', this.options);
              }
            }
          );
      }
      if (ORG_DETAILS.NAME === "PaulCaroline") {
        document.getElementById("bestgiftsloader").style.display="block"
        console.log("tempArray[index].product_id"+index)
        console.log("tempArray[index].product_id"+JSON.stringify(tempArray))
        //  let tempArray = this.appService.cartProducts.results
            let obj =
            {
              "domain_name": ORG_DETAILS.DOMAIN_NAME,
              "user_id": ORG_DETAILS.USER_ID,
              "extras": {
                "find": {
                  "product_id": Number(tempArray[index].product_id),
                  "product_cost": Number(tempArray[index].cost),
                  "quantity": Number(tempArray[index].quantity),
                }
              }
            }
       
            this.appService.postApiCall(obj, ENDPOINTS.STRUCTURED_PROMOTION).subscribe(
              resp => {
                if (resp) {
                  if (resp.success === 1 && resp.status_code === 200) {
                    console.log("tempArray[index].quantity: ", tempArray[index]);
                    tempArray.forEach((item,i) => {
                      console.log("this.newProductDetails.id"+this.newProductDetails.id)
                      if(this.newProductDetails.id===item.product_id){
                        item["discount_amount"] =
                        resp.result.data.discount_summary[0].discount_amount;
               
                        item[
                      "after_dicount_price"
                    ] = resp.result.data.discount_summary[0].after_dicount_price; 
                    item[
                      "per_quantity_amount"
                    ] = resp.result.data.discount_summary[0].per_quantity_amount;              
                      this.discountValue = Number(resp.result.data.discount_summary[0].after_dicount_price);
                      }})
                      this.appService.cartProducts.results = tempArray;
                    // this.productQuantity = Number(tempArray[index].quantity);
                    // this.productQuantity1 = true;
          
                    this.cartService.updateCartItem(this.appService.cartProducts.results);
                    let cartItemsString = JSON.stringify(
                      this.appService.cartProducts.results
                    );
                    this.localService.set("cart", cartItemsString);
                    document.getElementById("bestgiftsloader").style.display="none"
                    console.log("Updating cart: ", this.appService.cartProducts.results)
                  } else if (resp.success === 0) {
                    if (resp.message) {
                      //this.alertService.error(resp.message, this.options);
                    }
                  } else if (resp.message && resp.status_code !== 200) {
                    //this.alertService.error(resp.message, this.options);
                  } else {
                    //this.alertService.error('Something bad happened. Please try again!', this.options);
                  }
                }
              },
              (err) => {
                if (err.error.statusCode === 403) {
                  //this.alertService.error('Session Time Out! Please login Again', this.options)
                } else if (err.error.error.message) {
                  //this.alertService.error(err.error.error.message, this.options)
                } else {
                  //this.alertService.error('Something bad happened. Please try again!', this.options);
                }
              }
            );
          
      
    
    
      }
      this.appService.cartProducts.results = tempArray;
      this.appService.totalCartItems = this.cartService.totalCartItems();
      this.cartService.updateCartItem(this.appService.cartProducts.results);
      if (ORG_DETAILS.NAME === "SpecialWires" || ORG_DETAILS.NAME === "Vistas") {
        let cartItemsString = JSON.stringify(
          this.appService.cartProducts.results
        );
        this.localService.set("cart", cartItemsString);
      }
    }
  }

  decreaseItemVistas(index) {
    let userId = this.localService.get('UserId');
    let tempArray = this.appService.cartProducts.results;
      if (
        this.appService.cartProducts.results[index].quantity === 1 ||
        this.appService.cartProducts.results[index].quantity <
          tempArray[index].product.pricing.raw.minimumorderquantity
      ) {
        this.appService.cartProducts.results.splice(index, 1);
        this.cartData = [];
   
        for (let i = 0; i < this.appService.cartProducts.results.length; i++) {
          this.cartData.push(
            this.appService.cartProducts.results[i].product_id
          );
        }
        this.appService.totalCartItems = this.cartService.totalCartItems();
        this.cartService.updateCartItem(this.appService.cartProducts.results);
        if (ORG_DETAILS.NAME === "Vistas") {
          let cartItemsString = JSON.stringify(
            this.appService.cartProducts.results
          );
          this.localService.set("cart", cartItemsString);
        }
        return;
      }

      tempArray[index].quantity = Number(tempArray[index].quantity) - 1;
      tempArray[index].sub_total =
        Number(tempArray[index].quantity) * Number(tempArray[index].cost);
      if (ORG_DETAILS.NAME === "Vistas") {
        let obj = {
          domain_name: ORG_DETAILS.DOMAIN_NAME,
          user_id: ORG_DETAILS.USER_ID,
          extras: {
            find: {
              product_id: Number(tempArray[index].product_id),
              product_cost: Number(tempArray[index].cost),
              quantity: Number(tempArray[index].quantity),
              customer_id: Number(userId)
            },
          },
        };

        this.appService
          .postApiCall(obj, ENDPOINTS.STRUCTURED_PROMOTION)
          .subscribe(
            (resp) => {
              if (resp) {
                if (resp.success === 1 && resp.status_code === 200) {
           
                    this.appService.cartProducts.results[index]["discount_amount"] =
                    resp.result.data.discount_summary[0].discount_amount;
           
                this.appService.cartProducts.results[index][
                  "after_dicount_price"
                ] = resp.result.data.discount_summary[0].after_dicount_price;
                   
                   
                  this.cartService.updateCartItem(
                    this.appService.cartProducts.results
                  );
                  console.log(
                    "tempArray[index].product.discount_value" +
                      tempArray[index].product.discount_value
                  );
                } else if (resp.success === 0) {
                  if (resp.message) {
                    //this.alertService.error(resp.message, this.options);
                  }
                } else if (resp.message && resp.status_code !== 200) {
                  //this.alertService.error(resp.message, this.options);
                } else {
                  //this.alertService.error('Something bad happened. Please try again!', this.options);
                }
              }
            },
            (err) => {
              if (err.error.statusCode === 403) {
                //this.alertService.error('Session Time Out! Please login Again', this.options)
              } else if (err.error.error.message) {
                //this.alertService.error(err.error.error.message, this.options)
              } else {
                //this.alertService.error('Something bad happened. Please try again!', this.options);
              }
            }
          );
      }
      this.appService.cartProducts.results = tempArray;
      this.appService.totalCartItems = this.cartService.totalCartItems();
      this.cartService.updateCartItem(this.appService.cartProducts.results);
      if (ORG_DETAILS.NAME === "Vistas") {
        let cartItemsString = JSON.stringify(
          this.appService.cartProducts.results
        );
        this.localService.set("cart", cartItemsString);
      }
    
  }

  decreaseItemBestGifts(indexOfImage, formdata) {
    let tempArray = this.appService.cartProducts.results;

    

    console.log("Temp App service: ", tempArray)
    let index = this.newProductDetails.id;

    console.log(this.imagelist)

    console.log("App service: ", this.appService.cartProducts.results)
    let emptyDeleteFlag = false
    for (let i = 0; i < this.numberOfMaskUploads; i++) {
      let tempIndexForProduct = indexOfImage - 1;
      console.log('maskImage_' + tempIndexForProduct + "_" + i)
      if(this.imagelist['maskImage_' + tempIndexForProduct + "_" + i] == "") {
        emptyDeleteFlag = true
      }
      delete this.imagelist['maskImage_' + tempIndexForProduct + "_" + i]
      delete this.imageListForUpload['maskImage_' + tempIndexForProduct + "_" + i]
    }
    
    console.log("App service: ", this.appService.cartProducts.results)
    this.reorderImageListForUpload()
    this.numberOfProductsBestGifts = this.numberOfProductsBestGifts - 1;
    if(emptyDeleteFlag) {
      this.reorderImages()
      return
    }

    console.log(this.imagelist)

    console.log("App service: ", this.appService.cartProducts.results)
    tempArray.forEach((item, i) => {
      if (item.product_id == index) {
        // item.quantity = item.quantity - 1;
        item.uploaded_images.forEach((element, j) => {
          if (Object.keys(element)[0] == "quantity_" + indexOfImage && !this.deletedFlag) {
            console.log(item)
            // item.uploaded_images.splice(j, 1)
            // this.deletedFlag = true
            for (let k = 0; k < this.numberOfMaskUploads; k++) {
              let tempindex = indexOfImage - 1;
              delete this.imagelist['maskImage_' + tempindex + '_' + k]
            }
          }
        });
      }
    })

    this.onDeleteInBestGifts(indexOfImage)
    this.reorderImages();

    console.log("App service: ", this.appService.cartProducts.results)
  }

  onConfirm(items) {
    this.sizeVariable = items;
    this.isValid = true;
    this.showPrice = true;
    this.isDisabled = false;
    this.activeMenu = items.option;
    this.checkVariantInCart = items.id;
    this.priceOfVariant = items.pricing.raw.price;
    
  }
   onConfirm1(items, id , index) {
    this.current_index = index
    this.child_index = 0
    console.log(index, id ,"index11")
    console.log("121111",this.product)
    // for(let i=0;i<this.DeeraOption.length;i++){
      // if(this.products[i].product_type == "Variable"){



    for (let j = 0; j < this.product.variant.option_values.length; j++) {
      console.log("index222222222",index)
      
      console.log(this.product.variant.option_values[j].id,"j")
      console.log(this.product.variant.option_values[index].id, "i")
      this.product.variant.option_values[j].is_default = false
      // this.products[i].variant.option_values[j].is_default = false
      // this.product.variant.option_values[j].is_default = false
      // if (index == j) {
        // this.product.variant.option_values[index].is_default = true; 
      // } 
      if (this.product.variant.option_values[j].id===this.product.variant.option_values[index].id) {
        console.log("truee")
        // this.router.navigate(["/product-details", this.product.variant.option_values[j].id], {
        //   relativeTo: this.route,
        //   skipLocationChange: false,
        // });
        this.product.variant.option_values[index].is_default = true;
        let tempArray = this.appService.cartProducts.results;
      
        console.log("WWWWWWWWWWWWWWWWWWWWWWWW"+JSON.stringify(tempArray))
        this.current_index=index;
        this.specialval = true;
        console.log("specialval"+this.specialval)
        this.child_index=0;
        this.paulIndex =0
        // product['current_index']=index;
        // product['child_index']=0;
        if(this.product.variant.variant_child)
                        {
        this.selectColour(this.product.variant.option_values[index].child[this.child_index].color,this.product.id,0)
      }
      }
    // }
  }
  // }
    this.sizeVariable = items;
    this.isValid = true;
    this.showPrice = true;
    this.showtype = true;
    this.isDisabled = false;
    this.activeMenu = items.option;
    this.checkVariantInCart = items.id;
  //   if(this.config.title === 'LushNGreen'){
  //   this.priceOfVariant = items.pricing.raw.price;
  //   this.msrpofVariant = items.pricing.raw.msrp;
  // }
    this.unitofVariant = items.unit;
  }
  onConfirmPaul(items, id , index) {
    this.current_index = index
    console.log(index, id ,"index11")
    console.log("121111",this.product)
    // for(let i=0;i<this.DeeraOption.length;i++){
      // if(this.products[i].product_type == "Variable"){



    for (let j = 0; j < this.product.variant.option_values.length; j++) {
      console.log("index222222222",index)
      
      console.log(this.product.variant.option_values[j].id,"j")
      console.log(this.product.variant.option_values[index].id, "i")
      this.product.variant.option_values[j].is_default = false
      // this.products[i].variant.option_values[j].is_default = false
      // this.product.variant.option_values[j].is_default = false
      // if (index == j) {
        // this.product.variant.option_values[index].is_default = true; 
      // } 
      if (this.product.variant.option_values[j].id===this.product.variant.option_values[index].id) {
        console.log("truee")
        // this.router.navigate(["/product-details", this.product.variant.option_values[j].id], {
        //   relativeTo: this.route,
        //   skipLocationChange: false,
        // });
        this.product.variant.option_values[index].is_default = true;
        
        let tempArray = this.appService.cartProducts.results;
      
        console.log("WWWWWWWWWWWWWWWWWWWWWWWW"+JSON.stringify(tempArray))
        this.current_index=index;
        this.specialval = true;
        console.log("specialval"+this.specialval)
        this.paulIndex =0
        // product['current_index']=index;
        // product['child_index']=0;
        if(this.product.variant.variant_child)
                        {
        this.selectColourPaul(this.product.variant.option_values[index].child[this.child_index].color,this.product.id,this.child_index)
        this.stikeouttype(this.product.variant.option_values[index].child[this.paulIndex].type)
      }
      }
    // }
    break;
  }
  // }
    this.sizeVariable = items;
    this.isValid = true;
    this.showPrice = true;
    this.showtype = true;
    this.isDisabled = false;
    this.activeMenu = items.option;
    this.checkVariantInCart = items.id;
  //   if(this.config.title === 'LushNGreen'){
  //   this.priceOfVariant = items.pricing.raw.price;
  //   this.msrpofVariant = items.pricing.raw.msrp;
  // }
    this.unitofVariant = items.unit;
  }
  onConfirm2(items, id , index) {
    this.current_index = index
    console.log(index, id ,"index11")
    console.log("121111",this.product)
    // for(let i=0;i<this.DeeraOption.length;i++){
      // if(this.products[i].product_type == "Variable"){



    for (let j = 0; j < this.product.variant.option_values.length; j++) {
      console.log("index222222222",index)
      
      console.log(this.product.variant.option_values[j].id,"j")
      console.log(this.product.variant.option_values[index].id, "i")
      this.product.variant.option_values[j].is_default = false
      // this.products[i].variant.option_values[j].is_default = false
      // this.product.variant.option_values[j].is_default = false
      // if (index == j) {
        // this.product.variant.option_values[index].is_default = true; 
      // } 
      if (this.product.variant.option_values[j].id===this.product.variant.option_values[index].id) {
        console.log("truee")
        // this.router.navigate(["/product-details", this.product.variant.option_values[j].id], {
        //   relativeTo: this.route,
        //   skipLocationChange: false,
        // });
        this.product.variant.option_values[index].is_default = true;
        let tempArray = this.appService.cartProducts.results;
      
        console.log("WWWWWWWWWWWWWWWWWWWWWWWW"+JSON.stringify(tempArray))
        this.current_index=index;
        this.specialval = true;
        console.log("specialval"+this.specialval)
        this.child_index=0;
        // product['current_index']=index;
        // product['child_index']=0;
        if(this.product.variant.variant_child)
                        {
        this.selectColour(this.product.variant.option_values[index].child[this.child_index].color,this.product.id,0)
      }
      }
    // }
  }
  // }
    this.sizeVariable = items;
    this.isValid = true;
    this.showPrice = true;
    this.showtype = true;
    this.isDisabled = false;
    this.activeMenu = items.option;
    this.checkVariantInCart = items.id;
  //   if(this.config.title === 'LushNGreen'){
  //   this.priceOfVariant = items.pricing.raw.price;
  //   this.msrpofVariant = items.pricing.raw.msrp;
  // }
    this.unitofVariant = items.unit;
  }
  changeTab(tab) {
    console.log("test for specialwires")
    document
      .getElementById("nav-" + tab + "tab")
      .setAttribute("class", "nav-item nav-link active");
    document
      .getElementById("nav-" + tab)
      .setAttribute("class", "tab-pane fade show active");
    this.groups[5].fields.forEach((element) => {
      if (element.labelname != tab) {
        document
          .getElementById("nav-" + element.labelname + "tab")
          .setAttribute("class", "nav-item nav-link");
        document
          .getElementById("nav-" + element.labelname)
          .setAttribute("class", "tab-pane fade");
      }
    });
  }
  backToCategory(category) {
    this.router.navigate(['/']).then(() => {
      this.router.navigate([`/productListing`], { queryParams: { terms: [[], [category], [], [], [], [], [], [], [], [], [], [], []], type: 'combine' }, relativeTo: this.route, skipLocationChange: false });
    });
  }
  productsListTazTest1(category){
    const params = category.split('/').map(param => param.replace(/\s+/g, '-'));
    console.log("URL BBJAH", params)
    this.router.navigate(['/productListing', ...params]);
  }
  backToListing(category) {
    const params = category.split('/').map(param => param.replace(/\s+/g, '-'));
    console.log("URL BBJAH", params)
    this.router.navigate(['/productListing', ...params]);
  }
  gobacktobrand(brand) {
    this.router.navigate(['/']).then(() => {
      this.router.navigate([`/productListing`], { queryParams: { terms: [[brand], [], [], [], [], [], [], [], [], [], [], [], []], type: 'combine' }, relativeTo: this.route, skipLocationChange: false });

    });
  }

  backToList() {
    this.router.navigate(['/']).then(() => {
      this.router.navigate([`/productListing`], { queryParams: { terms: [[], [], [], [], [], [], [], [], [], [], [], [], []], type: 'combine' }, relativeTo: this.route, skipLocationChange: false });
    });
  }
  backToListSri(){
    this.router.navigate([`/productListing`]);
  }
  gobacktoCategory(category) {
    this.router.navigate([`/product`], {
      queryParams: {
        terms: [category, "category"],
        type: "searchresults",
      },
      relativeTo: this.activatedRoute,
      skipLocationChange: false,
    });
  }
  productListingSchift(category){
    this.router.navigate([`/productListing`], {
      queryParams: {
        terms: [[], [category], [], [], [], [], [], [], [], [], [], []],
        type: "combine",
      },
      relativeTo: this.activatedRoute,
      skipLocationChange: false,
    });
  }
  productListing() {
    
    if (config.title === "Tams") {
      this.router.navigate([`/product`], {
        queryParams: {
          terms: [this.category, "category"],
          type: "searchresults",
        },
        relativeTo: this.activatedRoute,
        skipLocationChange: false,
      });
    }
    else if (config.title === "Mayan") {
      // this.router.navigate([`/product`], { queryParams: { }, relativeTo: this.activatedRoute, skipLocationChange: false });
      this.router.navigate([`/product`], {
        queryParams: {
          terms: ['Decor', "category"],
          type: "searchresults",
        },
        relativeTo: this.activatedRoute,
        skipLocationChange: false,
      });
    }
    
    else {
      if (config.title === "Deera") {
        this.router.navigate([`/productListing`], { queryParams: { terms: [[], [], [], [], [], [], [], [], [], [], [], [], [],[],[],[],[],[],[]], type: 'combine' }, relativeTo: this.route, skipLocationChange: false });

      } else {
        this.router.navigate([`/productListing`], { queryParams: { terms: [[], [], [], [], [], [], [], [], [], [], [], [], []], type: 'combine' }, relativeTo: this.route, skipLocationChange: false });

      }
    }
  }

  checkServiceAvailablity() {
    if (this.detailForm.valid) {
      this.showSpinner = true;
      let zipcode = this.detailForm.controls.zipcode.value;
      let requestData = {
        domain_name: ORG_DETAILS.DOMAIN_NAME,
        user_id: ORG_DETAILS.USER_ID,
        payload: {
          courier_serviceability: {
            pickup_postcode: 600005,
            delivery_postcode: zipcode,
            cod: 0,
            weight: 1,
          },
        },
      };
      this.appService
        .postApiCall(requestData, ENDPOINTS.DELIVERY_AVAILABILITY)
        .subscribe(
          (resp) => {
            if (resp) {
              if (resp.success == 1) {
                if (resp.result.data.status == 200) {
                  let recommended_id =
                    resp.result.data.data.recommended_courier_company_id;

                  resp.result.data.data.available_courier_companies.forEach(
                    (element) => {
                      if (
                        element.courier_company_id == recommended_id &&
                        element.blocked == 0
                      ) {
                        this.courierObj = element;
                        this.courierName = this.courierObj.courier_name;
                        this.estdDelivery = this.courierObj.etd;
                        this.showSpinner = false;
                        this.availableLocation = true;
                        this.notAvailableLocation = false;
                        return;
                      }
                    }
                  );
                } else {
                  this.showSpinner = false;
                  this.notAvailableLocation = true;
                  this.availableLocation = false;
                }
              } else {
                this.showSpinner = false;
                this.notAvailableLocation = true;
                this.availableLocation = false;
              }
            }
          },
          (err) => {
            console.log("ERROR:", err);
            if (err.error.message) {
              console.log(err.error.message);
            } else {
              console.log(err.error.message);
            }
          }
        );
    } else {
      this.notAvailableLocation = false;
      this.availableLocation = false;
      this.showSpinner = false;
      this.validateForm = true;
    }
  }
  checkZipcode() {
    if (this.detailForm.valid) {
      this.showSpinner = true;
      let zipcode = this.detailForm.controls.zipcode.value;
      let requestData = {
        domain_name: ORG_DETAILS.DOMAIN_NAME,
        user_id: ORG_DETAILS.USER_ID,
        payload: {
          service_availability: {
            filter_codes: zipcode,
          },
        },
      };
      this.appService
        .postApiCall(requestData, ENDPOINTS.SERVICE_AVAILABILITY)
        .subscribe(
          (resp) => {
            if (resp) {
              console.log(resp);
              if (resp.success == 1) {
                if (
                  resp.result.data &&
                  resp.result.data.delivery_codes &&
                  resp.result.data.delivery_codes.length > 0
                ) {
                  resp.result.data.delivery_codes.forEach((element) => {
                    if (
                      element.postal_code.pin == zipcode &&
                      element.postal_code.repl == "Y"
                    ) {
                      this.locationName = element.postal_code.inc;
                      this.showSpinner = false;
                      this.availableLocation = true;
                      this.notAvailableLocation = false;
                    } else {
                      this.showSpinner = false;
                      this.notAvailableLocation = true;
                      this.availableLocation = false;
                    }
                  });
                } else {
                  this.showSpinner = false;
                  this.notAvailableLocation = true;
                  this.availableLocation = false;
                }
              }
            }
          },
          (err) => {
            console.log("ERROR:", err);
            if (err.error.message) {
              console.log(err.error.message);
            } else {
              console.log(err.error.message);
            }
          }
        );
    } else {
      this.notAvailableLocation = false;
      this.availableLocation = false;
      this.showSpinner = false;
      this.validateForm = true;
    }
  }

  getProductDetailsById(requestBody: any) {
    // document.body.scrollTop = 0; // For Safari
    document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
    try {
      console.log("product Details",this.product,this.newProductDetails)
      this.appService
        .postApiCall(requestBody, ENDPOINTS.PRODUCT_DETAILS)
        .subscribe(
          (resp) => {
            if (resp) {

              if (resp.success == 1) {
                this.product = resp.result.data[0]
                if(this.config.title!=='UrbanBox'){
                this.similarProduct = this.product.related_products
                console.log("this.similarProduct",this.similarProduct,this.similarProduct.length)
                if(this.similarProduct.length > 0){
                  this.isSimilar = true
                }
                else{
                  this.isSimilar = false
                }
                console.log("response for product id: ", resp,this.isSimilar)
              }
this.productIdSchift = String(resp.result.data[0].id) ;
                
                const metadetails = resp.result.data[0].description;
                // if(this.config.title !== 'Babys Pride'){
                console.log("metadetails",metadetails)
                if(metadetails.meta_title !== ""){
                this.metadataService.configureMetadata(metadetails.meta_description, metadetails.meta_keywords, metadetails.meta_title);
              } else {
                this.metadataService.configureMetadata(SEO_VARIABLES.PRODUCT_DETAILS.DESCRIPTION, SEO_VARIABLES.PRODUCT_DETAILS.KEYWORDS, SEO_VARIABLES.PRODUCT_DETAILS.TITLE)

              }
            // }
                console.log("nnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnn")
                this.newProductDetails = resp.result.data[0];
                console.log("this.newProductDetails.product_type ", this.newProductDetails.product_type)
                if(ORG_DETAILS.NAME === "UrbanBox"){
                  var req_feature_product_data = {
                    "domain_name": ORG_DETAILS.DOMAIN_NAME,
                    "user_id": null,
                    // "outlet_id":Number(this.outletId),
                    // "outlet_id":"",
                    "extras": {
                      "find": {
                        // "outlet_id":this.outletId,
                      },
                      "pagination": true,
                      "paginationDetails": {
                        "limit": 1,
                        "pagesize": 300
                      },
                      "sorting": true,
                      "sortingDetails": {
                        "sortfield": "id",
                        "sortorder": -1
                      }
                    }
                  }
                  this.appService.postApiCall(req_feature_product_data, ENDPOINTS.GET_FEATURED_PRODUCTS).subscribe(
                    resp => {
                      this.featureProductsApiData = resp;
                      console.log("this.featureProductsApiData",this.featureProductsApiData,this.newProductDetails)

                      this.recommededProducts = this.featureProductsApiData.result.data.filter(element =>{
                        
                        return element.name != this.newProductDetails.name
                        }
                                  );
                                  console.log("Recommended Products",this.recommededProducts)
                    },
                    err => {
                      if (err.error.error.message) {
                        console.log(err.error.error.message)
                      }
                      else{
                        console.log('Something bad happened; Please try again!')
                      }
                    })
                  }
                this.newId = resp.result.data[0].id;
                this.variantName =
                this.newProductDetails.variant != undefined
                  ? this.newProductDetails.variant.name
                  : "";
                // if(this.config.title==='Deera'){
                //  if (resp.result.data[0].quantity===0){
                //     this.productQuantity1 =true;
                //  }
                // }
                
                this.imageAssets = resp.result.data[0].assets;
                console.log( this.imageAssets," this.imageAssets")
                if(resp.result.data[0].video_assets){
                  // resp.result.data[0].video_assets.forEach((element, index) => {
                  //   this.videoAssets.push({"link":element.link})
                  // })
                  if(resp.result.data[0].video_assets.length>0){
                    if(resp.result.data[0].video_assets[0].link!==''){
                      this.productViewVideo=true;
                    }
                  }
                }
                console.log("gggggggggggg0"+JSON.stringify(this.videoAssets.length))
                
                if(this.config.title === 'Accel'){
                  this.what_you_will_learn= resp.result.data[0].course_duration.what_you_will_learn
                  if(resp.result.data[0].selection_process)
                  for(let i =0;i<resp.result.data[0].selection_process.length;i++){
                    this.selection_process.push(resp.result.data[0].selection_process[i].name)
                }
                  //this.selection_process.push(resp.result.data[0].selection_process);
                  console.log(this.what_you_will_learn,this.selection_process,"testdata")
                }
                if(this.config.title === 'BestGifts'){
                  this.maskImages = resp.result.data[0].mask_image[0].image_source;
                }
                if(this.config.title === 'AvonSeals' ||this.config.title === 'HOB'){
                  if(resp.result.data[0].chart_image && resp.result.data[0].chart_image !== undefined && resp.result.data[0].chart_image.length !== 0){
                    this.chartImages = resp.result.data[0].chart_image[0].image_source;
                  }
                 
                }
                // if(this.config.title === 'LushNGreen'){
                //   if(resp.result.data[0].chart_image){
                //     this.chartImages = resp.result.data[0].chart_image[0].image_source;
                //   }
                 
                // }
                if(this.config.title === 'Deera'){
                  // console.log(resp.result.data[0].chart_image.length,"resp.result.data[0].chart_image[0].length")
                  if(resp.result.data[0].chart_image !== undefined && resp.result.data[0].chart_image.length !== 0 ){
                    this.chartImages = resp.result.data[0].chart_image[0].image_source;
                  }
                 
                }
                if(this.config.title === 'LinenRaj'){
                  if(resp.result.data[0].chart_image){
                    this.chartImages = resp.result.data[0].chart_image[0].image_source;
                  }
                 
                }
                if(this.config.title === 'SpecialWires'){
                  if(resp.result.data[0].assets[1]){
                    this.chartImages = resp.result.data[0].assets[1].image_source;
                  }
                 
                }
                console.log("this.maskImages"+this.maskImages)
                // if(ORG_DETAILS.NAME === "Babys Pride"){
                //   console.log("baby test",this.product.variant.option_values)
                // }
                if (ORG_DETAILS.NAME === "Deera") {

                  if (this.queryParams.params["cid"]) {
                    for (let j = 0; j < this.product.variant.option_values.length; j++) {
                      console.log("index2222222222222222222222",)
                      
                      console.log(this.product.variant.option_values[j].id,"j")
                      console.log(this.product.variant.option_values[j].id, "i")
                      this.product.variant.option_values[j].is_default = false
                    
                      if (this.product.variant.option_values[j].id===Number(this.queryParams.params["cid"])) {
                        console.log("truee")
                       
                        this.product.variant.option_values[j].is_default = true;
                        this.variantMSRP =  this.product.variant.option_values[j].pricing.raw.msrp;
                        this.variantUnit = this.product.variant.option_values[j].unit;
                         
                        let tempArray = this.appService.cartProducts.results;
                        tempArray.forEach((element, index) => {
                          console.log("6666666666666666666666666666666"+JSON.stringify(element))
                          if (element.product_id === Number(this.queryParams.params["cid"])) {
                            console.log("777777777777777777777777777777"+element)
                            let obj = {
                              domain_name: ORG_DETAILS.DOMAIN_NAME,
                              user_id: ORG_DETAILS.USER_ID,
                              extras: {
                                find: {
                                  product_id: Number(this.queryParams.params["cid"]),
                                  product_cost: Number(element.product.pricing.raw.price),
                                  quantity: Number(element.quantity),
                                },
                              },
                            };
                      
                            try {
                              this.appService.postApiCall(obj, ENDPOINTS.QUANTITY_PROMOTION).subscribe(
                                (resp) => {
                                  if (resp) {
                      
                                    console.log("ON LAUNCH: ", resp)
                                    if (resp.success === 1 && resp.status_code === 200) {
                                      for (
                                        let k = 0;
                                        k < this.appService.cartProducts.results.length;
                                        k++
                                      ) {
                    
                                        if(this.newProductDetails.product_type==="Variable"){
                                          if (
                                            this.appService.cartProducts.results[k].product.id ===
                                            Number(this.queryParams.params["cid"])
                                          ) {
                                            console.log("rrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrr")
                                            this.appService.cartProducts.results[
                                              k
                                            ].product.discount_value = Number(
                                              resp.result.data.discount_applied_to_product_value
                                            );
                                            this.appService.cartProducts.results[
                                              k
                                            ].product.per_quantity_amount = Number(resp.result.data.per_quantity_amount);
                                            this.appService.cartProducts.results[
                                              k
                                            ].product.discount_amount = Number(
                                              resp.result.data.discount_amount
                                            );
                                            this.appService.cartProducts.results[k].product.fixed_amount =
                                              Number(resp.result.data.fixed_amount);
                                            this.appService.cartProducts.results[
                                              k
                                            ].product.discount_percentage = Number(
                                              resp.result.data.discount_percentage
                                            );
                                            this.congratulationBanner =
                                              resp.result.data.congratulations_banner_message;
                                            // this.congratulationBanner.forEach((element, index) => {
                                            //     this.congratulationBanner1 = element
                                            // });
                                            // this.upsellBanner = resp.result.data.upsell_banner_message;
                                            this.percentageValue = Number(
                                              resp.result.data.discount_percentage
                                            );
                                            this.fixedAmount = Number(resp.result.data.fixed_amount);
                                            this.discountValue = Number(
                                              resp.result.data.discount_applied_to_product_value
                                            );
                                            this.promotionType = resp.result.data.promotion_type;
                                            this.promotionType.forEach((element, index) => {
                                              if (element === 'Product discount') {
                                                this.productPromotion = 'Product discount'
                                              }
                                              if (element === 'Quantity discount') {
                                                this.quantityPromotion = 'Quantity discount'
                                              }
                                            });
                                            console.log("[DATA]: Respoonse: ", resp.result.data)
                                            this.productQuantity = Number(
                                              this.appService.cartProducts.results[k].quantity
                                            );
                        
                                            this.productQuantity1 = true;
                                          }
                                        }
                                  
                                      }
                      
                                      // this.productQuantity1 = true;
                                    } else if (resp.success === 0) {
                                      if (resp.message) {
                                      }
                                    } else if (resp.message && resp.status_code !== 200) {
                                    } else {
                                    }
                                  }
                                },
                                (err) => {
                                  if (err.error.statusCode === 403) {
                                  } else if (err.error.error.message) {
                                  } else {
                                  }
                                }
                              );
                            } catch (err) {
                              console.log("[ERROR]: error in firing api")
                            }
                          }
                        });
                      }
                    // }
                  }
                  }
      
                  for (let j = 0; j < this.appService.cartProducts.results.length; j++) {                   
                   if(this.newProductDetails.product_type==="Simple"){
                    if (
                      this.appService.cartProducts.results[j].product_id ===
                      Number(this.queryParams.params["id"])
                    ) {
                        this.onloadId = this.appService.cartProducts.results[j].product_id;
                        this.onloadCost =
                          this.appService.cartProducts.results[j].product.pricing.raw.cost;
                        this.onloadQuantity =
                          this.appService.cartProducts.results[j].quantity;

                          let tempArray = this.appService.cartProducts.results;
                          let obj = {
                            domain_name: ORG_DETAILS.DOMAIN_NAME,
                            user_id: ORG_DETAILS.USER_ID,
                            extras: {
                              find: {
                                product_id: Number(this.onloadId),
                                product_cost: Number(this.onloadCost),
                                quantity: Number(this.onloadQuantity),
                              },
                            },
                          };
                    
                          try {
                            this.appService.postApiCall(obj, ENDPOINTS.QUANTITY_PROMOTION).subscribe(
                              (resp) => {
                                if (resp) {
                    
                                  console.log("ON LAUNCH: ", resp)
                                  if (resp.success === 1 && resp.status_code === 200) {
                                    for (
                                      let k = 0;
                                      k < this.appService.cartProducts.results.length;
                                      k++
                                    ) {
                                      if(this.newProductDetails.product_type==="Simple"){
                                        if (
                                          this.appService.cartProducts.results[k].product.id ===
                                          Number(this.queryParams.params["id"])
                                        ) {
                                          this.appService.cartProducts.results[
                                            k
                                          ].product.discount_value = Number(
                                            resp.result.data.discount_applied_to_product_value
                                          );
                                          this.appService.cartProducts.results[
                                            k
                                          ].product.per_quantity_amount = Number(resp.result.data.per_quantity_amount);
                                          this.appService.cartProducts.results[
                                            k
                                          ].product.discount_amount = Number(
                                            resp.result.data.discount_amount
                                          );
                                          this.appService.cartProducts.results[k].product.fixed_amount =
                                            Number(resp.result.data.fixed_amount);
                                          this.appService.cartProducts.results[
                                            k
                                          ].product.discount_percentage = Number(
                                            resp.result.data.discount_percentage
                                          );
                                          this.congratulationBanner =
                                            resp.result.data.congratulations_banner_message;
                                          // this.congratulationBanner.forEach((element, index) => {
                                          //     this.congratulationBanner1 = element
                                          // });
                                          // this.upsellBanner = resp.result.data.upsell_banner_message;
                                          this.percentageValue = Number(
                                            resp.result.data.discount_percentage
                                          );
                                          this.fixedAmount = Number(resp.result.data.fixed_amount);
                                          this.discountValue = Number(
                                            resp.result.data.discount_applied_to_product_value
                                          );
                                          this.promotionType = resp.result.data.promotion_type;
                                          this.promotionType.forEach((element, index) => {
                                            if (element === 'Product discount') {
                                              this.productPromotion = 'Product discount'
                                            }
                                            if (element === 'Quantity discount') {
                                              this.quantityPromotion = 'Quantity discount'
                                            }
                                          });
                                          console.log("[DATA]: Respoonse: ", resp.result.data)
                                          this.productQuantity = Number(
                                            this.appService.cartProducts.results[k].quantity
                                          );
                      
                                          this.productQuantity1 = true;
                                        }
                                      }
                                
                                    }
                    
                                    // this.productQuantity1 = true;
                                  } else if (resp.success === 0) {
                                    if (resp.message) {
                                    }
                                  } else if (resp.message && resp.status_code !== 200) {
                                  } else {
                                  }
                                }
                              },
                              (err) => {
                                if (err.error.statusCode === 403) {
                                } else if (err.error.error.message) {
                                } else {
                                }
                              }
                            );
                          } catch (err) {
                            console.log("[ERROR]: error in firing api")
                          }
                    }
                   } 
                  }
                  if(this.newProductDetails.product_type==="Variable"){
                    console.log("rrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrr"+this.queryParams.params["cid"])
                    if(this.queryParams.params["cid"]===undefined){
                      for(let cart_index = 0; cart_index < this.appService.cartProducts.results.length; cart_index++) {
                        for(let m=0; m<this.product.variant.option_values.length; m++) {
                          if(this.product.variant.option_values[m].is_default === true) {
                            if(this.product.variant.option_values[m].id===this.appService.cartProducts.results[cart_index].product.id){
                              console.log("zzzzzzzzzzzzzzzz"+this.product.variant.option_values[m].id)
                              console.log("zzzzzzzzzzzzzzzz"+this.product.variant.option_values[m].id)
                              console.log("zzzzzzzzzzzzzzzz"+this.appService.cartProducts.results[cart_index].product.id)
                              this.onloadId = this.appService.cartProducts.results[cart_index].product.id;
                          this.onloadCost =
                            this.appService.cartProducts.results[cart_index].product.pricing.raw.price;
                          this.onloadQuantity =
                            this.appService.cartProducts.results[cart_index].quantity;
                            this.variantMSRP =  this.appService.cartProducts.results[cart_index].product.pricing.raw.msrp;
                            this.variantUnit = this.appService.cartProducts.results[cart_index].product.unit;
                            let tempArray = this.appService.cartProducts.results;
                            let obj = {
                              domain_name: ORG_DETAILS.DOMAIN_NAME,
                              user_id: ORG_DETAILS.USER_ID,
                              extras: {
                                find: {
                                  product_id: Number(this.onloadId),
                                  product_cost: Number(this.onloadCost),
                                  quantity: Number(this.onloadQuantity),
                                },
                              },
                            };
                      
                            try {
                              this.appService.postApiCall(obj, ENDPOINTS.QUANTITY_PROMOTION).subscribe(
                                (resp) => {
                                  if (resp) {
                      
                                    console.log("ON LAUNCH: ", resp)
                                    if (resp.success === 1 && resp.status_code === 200) {
                                      for (
                                        let k = 0;
                                        k < this.appService.cartProducts.results.length;
                                        k++
                                      ) {
                                        if(this.newProductDetails.product_type==="Variable"){
                                          if (
                                            this.appService.cartProducts.results[k].product.id ===
                                            Number(this.onloadId)
                                          ) {
                                            console.log("rrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrr")
                                            this.appService.cartProducts.results[
                                              k
                                            ].product.discount_value = Number(
                                              resp.result.data.discount_applied_to_product_value
                                            );
                                            this.appService.cartProducts.results[
                                              k
                                            ].product.per_quantity_amount = Number(resp.result.data.per_quantity_amount);
                                            this.appService.cartProducts.results[
                                              k
                                            ].product.discount_amount = Number(
                                              resp.result.data.discount_amount
                                            );
                                            this.appService.cartProducts.results[k].product.fixed_amount =
                                              Number(resp.result.data.fixed_amount);
                                            this.appService.cartProducts.results[
                                              k
                                            ].product.discount_percentage = Number(
                                              resp.result.data.discount_percentage
                                            );
                                            this.congratulationBanner =
                                              resp.result.data.congratulations_banner_message;
                                            // this.congratulationBanner.forEach((element, index) => {
                                            //     this.congratulationBanner1 = element
                                            // });
                                            // this.upsellBanner = resp.result.data.upsell_banner_message;
                                            this.percentageValue = Number(
                                              resp.result.data.discount_percentage
                                            );
                                            this.fixedAmount = Number(resp.result.data.fixed_amount);
                                            this.discountValue = Number(
                                              resp.result.data.discount_applied_to_product_value
                                            );
                                            this.promotionType = resp.result.data.promotion_type;
                                            this.promotionType.forEach((element, index) => {
                                              if (element === 'Product discount') {
                                                this.productPromotion = 'Product discount'
                                              }
                                              if (element === 'Quantity discount') {
                                                this.quantityPromotion = 'Quantity discount'
                                              }
                                            });
                                            console.log("[DATA]: Respoonse: ", resp.result.data)
                                            this.productQuantity = Number(
                                              this.appService.cartProducts.results[k].quantity
                                            );
                        
                                            this.productQuantity1 = true;
                                          }
                                        }
                                  
                                      }
                      
                                      // this.productQuantity1 = true;
                                    } else if (resp.success === 0) {
                                      if (resp.message) {
                                      }
                                    } else if (resp.message && resp.status_code !== 200) {
                                    } else {
                                    }
                                  }
                                },
                                (err) => {
                                  if (err.error.statusCode === 403) {
                                  } else if (err.error.error.message) {
                                  } else {
                                  }
                                }
                              );
                            } catch (err) {
                              console.log("[ERROR]: error in firing api")
                            }
                            } else {
                              this.productQuantity1 = false;
                            }
                          }
                     
                        
                    
                            // for(let i=0; i<this.newProductDetails.variant.option_values.length; i++) {
                              
                            //   if(this.newProductDetails.variant.option_values[i].id == variant_id) {
                            //     console.log("zzzzzzzzzzzzzzzz"+this.newProductDetails.variant.option_values[i].id)
                            //     console.log("zzzzzzzzzzzzzzzz"+variant_id)
                            //     this.onloadId = this.appService.cartProducts.results[cart_index].product.id;
                            // this.onloadCost =
                            //   this.appService.cartProducts.results[cart_index].product.pricing.raw.price;
                            // this.onloadQuantity =
                            //   this.appService.cartProducts.results[cart_index].quantity;
                            //   this.variantMSRP =  this.appService.cartProducts.results[cart_index].product.pricing.raw.msrp;
                            //   this.variantUnit = this.appService.cartProducts.results[cart_index].product.unit;
                            //     break
                            //   }
                            // }
            
                          
                    
                      
                      }
                    }
                    }
           
                   }
               
            
      
                }
                if(this.config.title !== 'AvonSeals'){
                this.category = resp.result.data[0].categories[0].categories;
                }
                // if (this.config.title == 'Carience') {

                //   for (let i = 0; i < this.products.length; i++) {

                //     this.selectOptionCarience(this.products[i].variant.option_values[0].option, this.products[i].id, 0)

                //     this.selectColour(this.products[i].variant.option_values[0].child[0].color, this.products[i].id, 0)

                //   }

                // }
                if (this.config.title !== 'HOB' && this.config.title !== 'PaulCaroline' && this.config.title !== 'Srimaware' && this.config.title !== 'LushNGreen' && this.config.title !=='UrbanBox') {
                  if (this.newProductDetails.assets[0].image_source == "") {
                    this.mainImage = this.imageNotFound;
                    this.mainImagePreview = this.imageNotFound;
                  } else {
                    this.mainImage =
                      this.newProductDetails.assets[0].image_source;
                      console.log("this.mainImage"+this.mainImage)
                  }
                }
                else if(this.config.title === 'HOB' || this.config.title === 'PaulCaroline' || this.config.title === 'Srimaware' || this.config.title === 'LushNGreen'){
                  if(this.newProductDetails.product_type =='Simple'){
                    if (this.newProductDetails.assets[0].image_source == "") {
                      this.mainImage = this.imageNotFound;
                      this.mainImagePreview = this.imageNotFound;
                    } else {
                      this.mainImage =
                        this.newProductDetails.assets[0].image_source;
                        console.log("this.mainImage"+this.mainImage)
                    }
                }
                else{
                  if (this.newProductDetails.assets[0].image_source == "") {
                    this.ImageArr = this.imageNotFound;
                    this.mainImagePreview = this.imageNotFound;
                  }
                  else {
                    for (let j = 0; j < this.newProductDetails.assets.length; j++) {
                      this.imageMobileArr = this.newProductDetails.assets[0].image_source;
                      this.ImageArr = this.newProductDetails.assets;
                      if(this.ImageArr.length >1){
                        this.multiImage = true
                        console.log("true multiple")
                      }
                      else{
                        this.multiImage = false
                        console.log("false multiple")
                      }
                      console.log("this.mainImagetest"+this.ImageArr,this.ImageArr.length)
                    }
                      
                      console.log("this.mainImage"+this.mainImage)
                  }
                }
                }
                else{
                  if (this.newProductDetails.assets[0].image_source == "") {
                    this.ImageArr = this.imageNotFound;
                    this.mainImagePreview = this.imageNotFound;
                  }
                  else {
                    for (let j = 0; j < this.newProductDetails.assets.length; j++) {
                      this.imageMobileArr = this.newProductDetails.assets[0].image_source;
                      this.ImageArr = this.newProductDetails.assets;
                      if(this.ImageArr.length >1){
                        this.multiImage = true
                        console.log("true multiple")
                      }
                      else{
                        this.multiImage = false
                        console.log("false multiple")
                      }
                      console.log("this.mainImagetest"+this.ImageArr,this.ImageArr.length)
                    }
                      
                      console.log("this.mainImage"+this.mainImage)
                  }
                
                }
                if (this.config.title == 'SpecialWires' || this.config.title == 'Carience' || this.config.title == 'Vimpro') {
            console.log("111111111111111111111111111111111111111111")
            console.log(" this.newProductDetails.id"+ this.newProductDetails.id)
            
            for (let i = 0; i < this.products.length; i++) {

              this.selectOptionCarience(this.products[i].variant.option_values[0].option, this.products[i].id, 0)
            
              this.selectColour(this.products[i].variant.option_values[0].child[0].color, this.products[i].id, 0)

            }
            // console.log("new product details: ", this.newProductDetails)
            // console.log("products: ", this.products)
            // console.log("this.appService.cartProducts.results.length",this.appService.cartProducts.results)


            // Function to get variant from cart details id

            for(let cart_index = 0; cart_index < this.appService.cartProducts.results.length; cart_index++) {
              // console.warn("inside the first loop: ", this.appService.cartProducts.results[cart_index].product.parent.id)
             if(this.appService.cartProducts.results[cart_index].product.parent){
              if(this.appService.cartProducts.results[cart_index].product.parent.id == this.newProductDetails.id) {
                // console.warn("parent id: ", this.newProductDetails.id)
                // current cart_index is the index of product in cartproducts.results
                let variant_id = this.appService.cartProducts.results[cart_index].product.id;
                console.log(variant_id,'variant_id',this.newProductDetails.variant.option_values.length,this.newProductDetails.variant.option_values)

                // loop to map variant id to values
                for(let i=0; i<this.newProductDetails.variant.option_values.length; i++) {

                  // console.log("inside the map loop")
                  for(let j=0; j<this.newProductDetails.variant.option_values[i].child.length; j++) {

                    if(this.newProductDetails.variant.option_values[i].child[j].id == variant_id) {
                      console.log("inside fn check carience")
                      let required_variant = this.newProductDetails.variant.option_values[i].child[j]
                      let required_variant_length =  this.newProductDetails.variant.option_values[i].option
                      this.child_index = j
                      this.current_index = i;
                      let required_variant_weight = required_variant.type 
                      this.specialval = true;
                      this.specialadd = true;
                      console.log("current variant id: ", required_variant)
                      console.log("current variant length: ", variant_id)
                      this.variant_index = variant_id;
                      // console.log("current variant weight: ", this.product.variant.option_values[this.current_index].child[this.variant_index])
                      this.showtype = true
                      break
                    }

                  }
                }

              }

             }
              
            }
  
        }
        if (this.config.title == 'LushNGreen') {
          console.log("111111111111111111111111111111111111111111")
          console.log(" this.newProductDetails.id"+ this.newProductDetails.id)
          
          
          // console.log("new product details: ", this.newProductDetails)
          // console.log("products: ", this.products)
          // console.log("this.appService.cartProducts.results.length",this.appService.cartProducts.results)


          // Function to get variant from cart details id

          for(let cart_index = 0; cart_index < this.appService.cartProducts.results.length; cart_index++) {
            // console.warn("inside the first loop: ", this.appService.cartProducts.results[cart_index].product.parent.id)
           if(this.appService.cartProducts.results[cart_index].product.parent){
            if(this.appService.cartProducts.results[cart_index].product.parent.id == this.newProductDetails.id) {
              // console.warn("parent id: ", this.newProductDetails.id)
              // current cart_index is the index of product in cartproducts.results
              let variant_id = this.appService.cartProducts.results[cart_index].product.id;
              console.log(variant_id,'variant_id',this.newProductDetails.variant.option_values.length,this.newProductDetails.variant.option_values)

              // loop to map variant id to values
              for(let i=0; i<this.newProductDetails.variant.option_values.length; i++) {

                // console.log("inside the map loop")
                for(let j=0; j<this.newProductDetails.variant.option_values[i].child.length; j++) {

                  if(this.newProductDetails.variant.option_values[i].child[j].id == variant_id) {
                    console.log("inside fn check carience")
                    let required_variant = this.newProductDetails.variant.option_values[i].child[j]
                    let required_variant_length =  this.newProductDetails.variant.option_values[i].option
                    this.child_index = 0
                    this.current_index = i;
                    let required_variant_weight = required_variant.type 
                    this.specialval = true;
                    this.specialadd = true;
                    console.log("current variant id: ", required_variant)
                    console.log("current variant length: ", variant_id)
                    this.variant_index = variant_id;
                    // console.log("current variant weight: ", this.product.variant.option_values[this.current_index].child[this.variant_index])
                    this.showtype = true
                    console.log("child_index in refresh",this.child_index)
                    for (let i = 0; i < this.products.length; i++) {

                      this.onConfirm1(this.products[i].variant.option_values, this.products[i].id, 0)
                    
                      this.selectColour(this.products[i].variant.option_values[0].child[0].color, this.products[i].id, 0)
          
                    }
                    break
                  }

                }
              }

            }

           }
            
          }
          
      }
        if (this.config.title === 'LinenRaj') {
          for (let j = 0; j < this.newProductDetails.variant.option_values.length; j++) {
            if (this.newProductDetails.variant.option_values[j].is_default === true) {
              console.log("truee")
              this.linenRajPrice = this.newProductDetails.variant.option_values[j].pricing.raw.price;
              this.linenRajDescription = this.newProductDetails.variant.option_values[j].description;
              this.linenRajWeight = this.newProductDetails.variant.option_values[j].weight;
            }
          }
          document.getElementById('star-gold').style.width = (this.newProductDetails.review.review_rating * 20) + "%"
      }
                if (this.config.title == 'Vimpro' && this.newProductDetails.product_type=='Variable') {
                  //this.current_index=0;
                  //this.child_index=0;
                  var localvalue=this.localService.get('redirected_from_cart');
                  this.localService.set('redirected_from_cart','null')
                  if(localvalue!=null||localvalue!=undefined){
                    var val=Number(localvalue);
                    this.product.variant.option_values.forEach((element,index)=>{
                     
                      if(element.id!=null&&element.id==val&&element.id!=undefined)
                      {
                        //alert('element'+element.id+'val'+val)
                        this.current_index=index
                      }
                   
                   
                   
                    })
                  
                      this.product.variant.option_values.forEach((element,index)=>{
                        if(element.child!=null)
                        {
                          element.child.forEach((sub_element,sub_index)=>{
                            //sub_element.is_default=false;
                           // alert('sub_index'+sub_index)
                            if(sub_element.id!=null&&sub_element.id==val&&sub_element.id!=undefined)
                            {
                              //alert('child'+sub_element.id+'val'+val+'sub_index'+sub_index)
                              this.current_index=index
                              this.child_index=sub_index
                              sub_element.is_default=true;
                              if(sub_index!=0)
                              {
                                this.product.variant.option_values[index].child[0].is_default=false;
                  
                              }
                             
                            }
                           
                  
                           
                         
                            // if(this.localService.get('redirected_from_cart')=='null'&&index==0&&sub_index==0)
                            // {
                            //   // alert('ready')
                            //   // alert(this.localService.get('redirected_from_cart'))
                            // sub_element.is_default=true;
                            // }
                            //console.log(sub_element)
                         
                         
                          })
                        }
                       
                     
                     
                     
                      })
                  
                   
                    }
                   
                                    // for (let i = 0; i < this.products.length; i++) {
                  
                                    //   this.selectOptionCarience(this.products[i].variant.option_values[0].option, this.products[i].id, 0)
                                    //           if(!this.newProductDetails.variant.child)
                                    //           {
                                    //             this.selectColour(this.products[i].variant.option_values[0].child[0].color, this.products[i].id, 0)
                  
                                    //           }
                                     
                                    // }
                  
                                  }
                  

                if (this.config.title === 'AvonSeals') {
                  for (let j = 0; j < this.newProductDetails.variant.option_values.length; j++) {
                    if (this.newProductDetails.variant.option_values[j].is_default === true) {
                      console.log("truee")
                      this.avonSealsPrice = this.newProductDetails.variant.option_values[j].pricing.raw.price;
                      this.avonSealsDescription = this.newProductDetails.variant.option_values[j].description;
                      this.avonSealsWeight = this.newProductDetails.variant.option_values[j].weight;
                    }
                  }
           
              }
                if (this.config.title === 'BestGifts') {
                  // if(this.customerType==='individual customer'){
                  if (resp.result.data[0].image_upload) {
                    this.imageUploadCount = Number(resp.result.data[0].image_upload.total_number_of_images);
                    this.numberOfMaskUploads = Number(resp.result.data[0].image_upload.total_number_of_images);
                    for (let i = 0; i < this.numberOfMaskUploads; i++) {
                      this.imagelist['maskImage_0_' + i] = ""
                    }
                  }
                  // } 
                  // else if(this.customerType==='business customer'){
                  //   this.imageUploadCount = 1;
                  // }

                  // for (let i = 0; i < 3; i++) {
                  for (let i = 0; i < this.imageUploadCount - 1; i++) {
                    console.log("Block statement execution no." + i);
                    (<FormArray>this.productMaskImageForm.get('lists')).push(this.addProductMaskImageForm());
                  }
                }
                
                if(this.config.title === 'Babys Pride'){
                  var req_feature_product_data = {
                    "domain_name": ORG_DETAILS.DOMAIN_NAME,
                    "user_id": null,
                    "extras": {
                      "find": {
                      },
                      "pagination": true,
                      "paginationDetails": {
                        "limit": 1,
                        "pagesize": 300
                      },
                      "sorting": true,
                      "sortingDetails": {
                        "sortfield": "id",
                        "sortorder": -1
                      }
                    }
                  }
                  this.appService.postApiCall(req_feature_product_data, ENDPOINTS.GET_FEATURED_PRODUCTS).subscribe(
                    resp => {
                  
                  this.recommededProducts = this.featureProductsApiData.result.data.filter(element =>{
                    return element.name != this.newProductDetails.name
                              }
                              );
                            })
                            }
                            if(this.config.title === "PaulCaroline" || this.config.title=='Srimaware'){
                              var req_feature_product_data = {
                                "domain_name": ORG_DETAILS.DOMAIN_NAME,
                                "user_id": null,
                                "extras": {
                                  "find": {
                                  },
                                  "pagination": true,
                                  "paginationDetails": {
                                    "limit": 1,
                                    "pagesize": 300
                                  },
                                  "sorting": true,
                                  "sortingDetails": {
                                    "sortfield": "id",
                                    "sortorder": -1
                                  }
                                }
                              }
                              this.appService.postApiCall(req_feature_product_data, ENDPOINTS.GET_FEATURED_PRODUCTS).subscribe(
                                resp => {
                              
                              this.recommededProducts = this.featureProductsApiData.result.data.filter(element =>{
                                return element.name != this.newProductDetails.name
                                          }
                                          
                                          );
                                          console.log("asdasdasfcsc",this.recommededProducts)
                                        })
                                        
                                        }
                            if(this.config.title === 'LushNGreen'){
                              var req_feature_product_data = {
                                "domain_name": ORG_DETAILS.DOMAIN_NAME,
                                "user_id": null,
                                "extras": {
                                  "find": {
                                  },
                                  "pagination": true,
                                  "paginationDetails": {
                                    "limit": 1,
                                    "pagesize": 300
                                  },
                                  "sorting": true,
                                  "sortingDetails": {
                                    "sortfield": "id",
                                    "sortorder": -1
                                  }
                                }
                              }
                              this.appService.postApiCall(req_feature_product_data, ENDPOINTS.GET_FEATURED_PRODUCTS).subscribe(
                                resp => {
                              
                              this.recommededProducts = this.featureProductsApiData.result.data.filter(element =>{
                                return element.name != this.newProductDetails.name
                                          }
                                          );
                                          this.recommededProductsLush = this.featureProductsApiData.result.data.filter(element =>{
                                            return element.name != this.newProductDetails.name
                                                      }
                                                      ).slice(0,4);
                                        })
                                        }
                           else if(this.config.title === 'KatbookStore'){
                              var req_feature_product_data = {
                                "domain_name": ORG_DETAILS.DOMAIN_NAME,
                                "user_id": null,
                                "extras": {
                                  "find": {
                                  },
                                  "pagination": true,
                                  "paginationDetails": {
                                    "limit": 1,
                                    "pagesize": 300
                                  },
                                  "sorting": true,
                                  "sortingDetails": {
                                    "sortfield": "id",
                                    "sortorder": -1
                                  }
                                }
                              }
                              this.appService.postApiCall(req_feature_product_data, ENDPOINTS.GET_FEATURED_PRODUCTS).subscribe(
                                resp => {
                                  console.log("recommended",resp.result.data)
                              this.recommededProducts = resp.result.data.filter(element =>{
                                return element.name != this.newProductDetails.name
                                          }
                                          
                                          );
                                          
                                        })
                                        }
                else if(this.config.title === 'Vistas'){
                  var req_feature_product_data = {
                    "domain_name": ORG_DETAILS.DOMAIN_NAME,
                    "user_id": null,
                    "extras": {
                      "find": {
                      },
                      "pagination": true,
                      "paginationDetails": {
                        "limit": 1,
                        "pagesize": 300
                      },
                      "sorting": true,
                      "sortingDetails": {
                        "sortfield": "id",
                        "sortorder": -1
                      }
                    }
                  }
                  this.appService.postApiCall(req_feature_product_data, ENDPOINTS.GET_FEATURED_PRODUCTS).subscribe(
                    resp => {
                  
                  this.recommededProducts = this.featureProductsApiData.result.data.filter(element =>{
                    return element.name != this.newProductDetails.name
                              }
                              );
                            })
                            }
                            if(this.config.title === 'LinenRaj'){
                              console.log("ffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff")
                              var req_feature_product_data = {
                                "domain_name": ORG_DETAILS.DOMAIN_NAME,
                                "user_id": null,
                                "extras": {
                                  "find": {
                                  },
                                  "pagination": true,
                                  "paginationDetails": {
                                    "limit": 1,
                                    "pagesize": 300
                                  },
                                  "sorting": true,
                                  "sortingDetails": {
                                    "sortfield": "id",
                                    "sortorder": -1
                                  }
                                }
                              }
                              this.appService.postApiCall(req_feature_product_data, ENDPOINTS.GET_FEATURED_PRODUCTS).subscribe(
                                resp => {
                              
                              this.recommededProducts = this.featureProductsApiData.result.data.filter(element =>{
                                return element.name != this.newProductDetails.name && element.product_type!=='Variation'
                                          }
                                          );
                                        })
                                        }
                let tempFlag = false
                if (ORG_DETAILS.NAME == "BestGifts") {
                  console.log("NEW PRODUCT DETAILS", this.newProductDetails)
                  this.tempCartBestGifts.results.forEach(element => {
                    if (element.product_id == this.newProductDetails.id) {
                      console.log(element)
                      this.editModeBestGifts = true
                      this.imageListBestGifts = element.uploaded_images;
                      this.imageListBackup = this.imageListBestGifts
                      this.numberOfProductsBestGifts = element.quantity
                      this.imgFromCartToLocal()
                      tempFlag = true
                    }
                  });
                }
                if (!tempFlag) {
                  this.numberOfProductsBestGifts = 1
                }

                if (
                  this.newProductDetails.videos != undefined &&
                  this.newProductDetails.videos != ""
                ) {
                  this.newProductDetails.videos.forEach((element) => {
                    let tempVariableVideo = element;
                    // tempVariableVideo["type"]="video"
                    tempVariableVideo["safeLink"] =
                      this.sanitizer.bypassSecurityTrustResourceUrl(
                        element.link
                      );
                    this.ImageVideoPreview.push(tempVariableVideo);
                  });
                }

                // if (
                //   this.newProductDetails.video != undefined &&
                //   this.newProductDetails.video != ""
                // ) {
                //   this.newProductDetails.video.forEach((element) => {
                //     let tempVariableVideo = element;
                //     // tempVariableVideo["type"]="video"
                //     tempVariableVideo["safeLink"] =
                //       this.sanitizer.bypassSecurityTrustResourceUrl(
                //         element.image_source
                //       );
                //     this.ImageVideoPreview.push(tempVariableVideo);
                //   });
                // }
       
                if (
                  config.title !== "Tams" &&
                  config.title !== "Deera" &&
                  config.title !== "Babys Pride" &&
                  config.title !== "LushNGreen" &&
                  config.title !== "Haven" &&
                  config.title !== "BestGifts" &&
                  config.title !== 'Beaubelle' && config.title !== 'Schift Cosmetics' && config.title !== 'Mayan' && config.title !== 'Carience' && config.title !== 'Vimpro' && config.title !== 'BombayHardware' && config.title !== 'Taazah'
                ) {
                  if (
                    this.newProductDetails.theme != undefined &&
                    this.newProductDetails.theme != ""
                  ) {
                    this.newProductDetails.theme.forEach((element) => {
                      this.themes = this.themes + "," + element.name;
                    });
                  }
                  if(this.config.title!=="AvonSeals" && this.config.title!=="Karupattiraja" && this.config.title!=="SriSenbaga" && this.config.title!=="Vistas"&& this.config.title!=="SpecialWires"&& this.config.title!=="LinenRaj"&& this.config.title!=="Accel"&& this.config.title!=="HOB" && this.config.title!=="PaulCaroline" && this.config.title !=='Srimaware' && this.config.title !=='UrbanBox'){
                    this.themes = this.themes.replace("undefined,", "");
                  }
                 
                }

                this.respData = resp.result.data[0].description.description;
                let shortDesc =
                  resp.result.data[0].description.short_desc.replace(
                    /\\n/g,
                    ""
                  );
                  if(this.config.title === "Schift Cosmetics" ){
                    for(let k =0;k<resp.result.data.length;k++){
                  if(resp.result.data[k].discounts_text){
                  if(resp.result.data[0].discounts_text.length > 0){
                  let offerBanner = 
                  resp.result.data[0].discounts_text[0].eligible_banner_message.replace(
                    /\\n/g,
                    ""
                  );
                  this.SchiftOfferMessage = offerBanner.replace(/\\s/g, "");
                  this.offerDisplay = true;
                }
              }
            }

                  let instructionDesc =
                  resp.result.data[0].description.instruction_description.replace(
                    /\\n/g,
                    ""
                  );
                  this.instructionDescription = instructionDesc.replace(/\\s/g, "");
                }
                if(this.config.title !== "LushNGreen" && this.config.title !== "Srimaware"){
                  console.log("description check",resp.result.data[0].description)
                  if(resp.result.data[0].description.description){
                    let Desc =
                    resp.result.data[0].description.description.replace(
                      /\\n/g,
                      ""
                    );
                    this.description = Desc.replace(/\\s/g, "");
                    this.Description = Desc.replace(/\\s/g, "");
                  }
                 else{
                  this.description = "";
                    this.Description = "";
                 }
                  if(this.config.title !== "HOB" && this.config.title !=='UrbanBox'){
                  let metaDesc =
                  resp.result.data[0].description.meta_description.replace(
                    /\\n/g,
                    ""
                  );
                  this.metaDescription = metaDesc.replace(/\\s/g, "");
                }
                }
                this.shortDescription = shortDesc.replace(/\\s/g, "");
                
                
                console.log("shortDescdddddddddddddddddddddddddddddddddddddddddddd"+this.shortDescription)
              
                console.log("gg------------------------------------------------------------------------------------------aaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaag-kgkg"+this.description)
                if (resp.result.data[0].description.other_description) {
                  let otherDesc =
                    resp.result.data[0].description.other_description.replace(
                      /\\n/g,
                      ""
                    );
                  this.otherDescription = otherDesc.replace(/\\s/g, "");
                }
                this.instructionDesc =
                  resp.result.data[0].description.instruction_description;
                // let bulletpoints = resp.result.data[0].description.bullet_points.replace(/\\n/g, '');
                // this.bulletPoints=bulletpoints.replace(/\\s/g, '');
                this.bulletPoints =
                  resp.result.data[0].description.bullet_points;
                // this.eligibleBannerMessage= resp.result.data[0].discounts_text;
                if (resp.result.data[0].discounts_text) {
                  resp.result.data[0].discounts_text.forEach((element) => {
                    //  if(new Date(element.start_date)==new Date() || new Date(element.end_date)==new Date()){
                    //   if(new Date(element.start_date).getDate()==new Date().getDate() || new Date(element.end_date).getDate()==new Date().getDate()){

                    //   const now =  new Date().getHours() + ':' + new Date().getMinutes();
                    //   var standarddate = '01/01/2011'
                    //   console.log("format"+ (standarddate+''+element.start_time))

                    //   console.log("correct1"+ (Date.parse('01/01/2011 10:20') > Date.parse('01/01/2011 5:10')))
                    //   console.log("correct2"+ (Date.parse(standarddate+''+element.start_time) > Date.parse(standarddate+''+now)))

                    //   console.log("000"+(element.end_time<now))
                    //   if(element.start_time>=now && element.end_time<=now){
                    //     console.log("000"+(element.eligible_banner_message))
                    //     this.eligibleBannerMessage.push(element.eligible_banner_message)
                    //   }
                    //  }
                    // if(new Date(element.start_date)>=new Date() && new Date(element.end_date)<=new Date()){
                    console.log(
                      "element.eligible_banner_message: ",
                      element.eligible_banner_message
                    );
                    if (
                      new Date() >= new Date(element.start_date) &&
                      new Date() <= new Date(element.end_date)
                    ) {
                      // if(new Date("2022-12-31")<=new Date() && new Date("2022-12-31")>=new Date()){
                        console.log("ffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff")
                        
                      this.eligibleBannerMessage.push(
                        element.eligible_banner_message
                      );
                    }
                  });
                }
                // this.congratulationsBannerMessage= resp.result.data[0].discounts_text.congratulations_banner_message;
                // this.upsellBannerMessage= resp.result.data[0].discounts_text.upsell_banner_message;
                if (resp.result.data[0].discounts_text) {
                  resp.result.data[0].discounts_text.forEach((element) => {
                    if (element.upsell_banner_message) {
                      console.log("upselllll" + element.upsell_banner_message);
                      this.upsellBannerMessage = element.upsell_banner_message;
                    }
                  });
                }
                if(this.config.title !== "LushNGreen" && this.config.title !== "Srimaware" && this.config.title !== "HOB" && this.config.title !=='UrbanBox' ){
                this.innnerhtmlData = this.respData.replace(/\\n/g, "");
                this.innnerhtmlData = this.innnerhtmlData.replace(/\\s/g, "");
                }
                this.additionData =
                  resp.result.data[0].description.bullet_points;
                this.perPeice =
                  resp.result.data[0].pricing.raw.price /
                  resp.result.data[0].unit;
                this.perPeice = this.perPeice.toFixed(2);

                
                //to check producttype is varaible//
                if (
                  this.newProductDetails.product_type == "Variable" ||
                  this.newProductDetails.type == "Variable"
                ) {
                  this.showSize = true;
                  this.variantName =
                    this.newProductDetails.variant != undefined
                      ? this.newProductDetails.variant.name
                      : "";
                  this.showHint = true;
                  this.isDisabled = true;
                } else {
                  this.showSize = false;
                  this.showHint = false;
                  this.isDisabled = false;
                }

                
                //to get options from variants//
                if (
                  resp.result.data[0].variant != undefined &&
                  resp.result.data[0].variant.option_values.length > 0
                ) {
                  this.variants = resp.result.data[0].variant.option_values;
                }
                //reviews//
                this.currentRating =
                  this.newProductDetails.reviews != undefined
                    ? this.newProductDetails.reviews.average
                    : "0";
                this.reviews =
                  this.newProductDetails.reviews != undefined
                    ? this.newProductDetails.reviews.total_reviews
                    : "0";
                console.log("review1122",this.currentRating);
                if(this.config.title ==="Schift Cosmetics"){
                  console.log("Review id of the product",this.productIdSchift)
                  this.getReviewDetailsSchift(this.productIdSchift);
                }
                if (
                  this.newProductDetails.additional_info != undefined &&
                  this.newProductDetails.additional_info != ""
                ) {
                  this.showData = true;
                } else {
                  this.showData = false;
                }
                if(this.config.title !== "LushNGreen" && this.config.title !== "Srimaware" ){
                if (
                  this.newProductDetails.additional_info.how_to_store !=
                  undefined &&
                  this.newProductDetails.additional_info.how_to_store != ""
                ) {
                  this.showStorage = true;
                } else {
                  this.showStorage = false;
                } 
              }
                if (config.title !== 'Vistas' && config.title !== "LushNGreen" && config.title !== 'Babys Pride' && config.title !== 'LinenRaj' && config.title !== 'Taazah' && config.title !== 'HOB' && config.title !== 'PaulCaroline' && this.config.title !=='Srimaware' && this.config.title !=='UrbanBox' &&
                  this.newProductDetails.attributes != undefined &&
                  this.newProductDetails.attributes[0].section_title !=
                  undefined
                ) {
                  this.attributeTitle =
                    this.newProductDetails.attributes[0].section_title;
                  this.newProductDetails.attributes[0].header_name
                    .split("-")
                    .forEach((element) => {
                      this.tableHead.push(element);
                    });

                  this.tableHead.push(
                    this.newProductDetails.attributes[0].header_value
                  );
                  this.newProductDetails.attributes.forEach((element) => {
                    element.attr.forEach((element) => {
                      let tempArray = [];
                      element.attr_name.split("/").forEach((elementTwo) => {
                        tempArray.push(elementTwo);
                      });
                      tempArray.push(element.attr_value);
                      this.tableData.push(tempArray);
                    });
                    //  element.attr[0].attr_name.split("/").forEach(elementtwo => {
                    //    tempArray.push(elementtwo)

                    //  });
                    //  tempArray.push(element.attr[0].attr_value)
                    //  this.tableData.push(tempArray)
                  });
                }
                this.descriptionData =
                  this.newProductDetails.categories[0].categories;
                this.productType = resp.result.data[0].type;

                if (
                  this.newProductDetails.hasOwnProperty("description") &&
                  this.newProductDetails.description.instruction_title != "" &&
                  this.newProductDetails.description.instruction_description !==
                  undefined
                ) {
                  this.showInstruction = true;
                } else {
                  this.showInstruction = false;
                }
                if (this.newProductDetails.pricing.raw.price == "") {
                  this.price = this.newProductDetails.pricing.raw.price_range;
                } else {
                  this.price = this.newProductDetails.pricing.raw.price;
                }
                this.setStaticAttributes();
              } else {
                console.log(resp.message);
              }
            }
            console.log("Successfully obtained product! ", this.newProductDetails)
            // console.log("Checking for object in cart: ", this.appService.productIdinCart.indexOf(this.newProductDetails.id));
          },
          (err) => {
            console.log("ERROR:", err);
            if (err.error.message) {
              console.log(err.error.message);
            } else {
              console.log(err.error.message);
            }
          }
        );
    } catch (err) {
      console.log("Error in getting product: ", err);
    }
    
  }
  setStaticAttributes() {
    if (this.newProductDetails.categories) {
      if (this.newProductDetails.categories.length > 0) {
        this.staticAttributes[0].attr_value =
          this.newProductDetails.categories[0].categories;
        this.descriptionData = this.newProductDetails.categories[0].categories;
      }
    }
    if (this.newProductDetails.brand) {
      this.staticAttributes[1].attr_value = this.newProductDetails.brand.name;
    }
    this.staticAttributes[2].attr_value = this.newProductDetails.sku;
  }
  addToCarts(item) {
    let tempArray = this.appService.cartProducts.results;
    this.cartService.addToCart(item);
    for (let i = 0; i < this.appService.cartProducts.results.length; i++) {
      this.cartData.push(this.appService.cartProducts.results[i].product_id);
    }
  }
  
  addToCartcarience(item_id) {
    let requestData = {
      "domain_name": ORG_DETAILS.DOMAIN_NAME,
      "user_id": ORG_DETAILS.USER_ID,
      "extras": {
        "find": {
          "id": item_id
        },
        "pagination": false,
        "paginationDetails": {
          "limit": 0,
          "pageSize": 2
        },
        "sorting": true,
        "sortingDetails": {
          "sortfield": "", "sortorder": 1
        }
      }
    }
    this.checkoutApiService.checkoutAPICall(ENDPOINTS.PRODUCT_DETAILS, requestData).then(
      respData => {
        let res: any = respData;
        if (res.success) {
          // this.newProductDetails=res.data[0];
          //return res;
          let tempArray = this.appService.cartProducts.results;
          let cartQty = 0;

          tempArray.forEach((item) => {
            cartQty += item.quantity;
          });
          var data = res.data[0];
          var sale_price = data['pricing']['raw']['sale_price'];
          data['pricing']['raw']['price'] = sale_price;

          this.cartService.addToCart(data);
        }
      }
    )

  }

  addToCartSpecialWires(item_id) {
    let userId = this.localService.get('UserId');
    if(userId){
      let maxorderedquantity=this.appService.cartProducts.results.reduce((partialSum, a) => partialSum + a.quantity, 0)
      if(maxorderedquantity>=Number(this.localService.get('max_cart_qty')))
      {
        this.alertService.error("Maximum allowed quantity is " + this.localService.get('max_cart_qty') + " only", this.options)
            return false;
      }
      
      let requestData = {
        "domain_name": ORG_DETAILS.DOMAIN_NAME,
        "user_id": ORG_DETAILS.USER_ID,
        "extras": {
          "find": {
            "id": item_id
          },
          "pagination": false,
          "paginationDetails": {
            "limit": 0,
            "pageSize": 2
          },
          "sorting": true,
          "sortingDetails": {
            "sortfield": "", "sortorder": 1
          }
        }
      }
      this.checkoutApiService.checkoutAPICall(ENDPOINTS.PRODUCT_DETAILS, requestData).then(
        respData => {
          let res: any = respData;
          if (res.success) {
            // this.newProductDetails=res.data[0];
            //return res;
            let tempArray = this.appService.cartProducts.results;
            let cartQty = 0;
  
            tempArray.forEach((item) => {
              cartQty += item.quantity;
            });
            var data = res.data[0];
            var sale_price = data['pricing']['raw']['sale_price'];
            data['pricing']['raw']['price'] = sale_price;
            data['pricing']['raw']['cost']=sale_price;
  
            this.cartService.addToCart(data);
  
          let obj =
            {
              domain_name: ORG_DETAILS.DOMAIN_NAME,
              user_id: ORG_DETAILS.USER_ID,
              extras: {
                find: {
                  product_id: Number(data.id),
                  product_cost: Number(data['pricing']['raw']['cost']),
                  quantity: 1,
                  customer_id: Number(userId),
                  weight: Number(data['shipping']['weight_to_consider'])*Number(data.quantity),
                  weight_to_consider:true
                },
              },
            };
  
          this.appService.postApiCall(obj, ENDPOINTS.STRUCTURED_PROMOTION).subscribe(
            (resp) => {
              if (resp) {
                if (resp.success === 1 && resp.status_code === 200) {
                  for (let j = 0; j < this.appService.cartProducts.results.length;j++) {
                    if (
                      this.appService.cartProducts.results[j].product_id === data.id
                    ) {                      
                        this.appService.cartProducts.results[j]["discount_amount"] =
                          resp.result.data.discount_summary[0].discount_amount;
                 
                      this.appService.cartProducts.results[j][
                        "after_dicount_price"
                      ] = resp.result.data.discount_summary[0].after_dicount_price;
                      console.log(
                        "this.appService.cartProducts.results[i].product.fixed_amount" +
                        this.appService.cartProducts.results[j].
                          after_dicount_price
                      );
                      this.cartService.updateCartItem(
                        this.appService.cartProducts.results
                      );
                      console.log(
                        "this.appService.cartProducts.results[i].product.fixed_amount" +
                          this.appService.cartProducts.results[j].discount_amount
                      );
                    }
                  }
                  let cartItemsString = JSON.stringify(
                    this.appService.cartProducts.results
                  );
                  this.localService.set("cart", cartItemsString);
                } else if (resp.success === 0) {
                  if (resp.message) {
                  }
                } else if (resp.message && resp.status_code !== 200) {
                } else {
                }
              }
            },
            (err) => {
              if (err.error.statusCode === 403) {
              } else if (err.error.error.message) {
              } else {
              }
            }
          );
          }
        }
      )
    } 
    else {
      this.router.navigate([`/login-new`], { skipLocationChange: false });
    }


  }
  addToCartLush(item_id) {
      // let maxorderedquantity=this.appService.cartProducts.results.reduce((partialSum, a) => partialSum + a.quantity, 0)
      // if(maxorderedquantity>=Number(this.localService.get('max_cart_qty')))
      // {
      //   this.alertService.error("Maximum allowed quantity is " + this.localService.get('max_cart_qty') + " only", this.options)
      //       return false;
      // }
      let tempArray = this.appService.cartProducts.results;
      let cartQty = 0;
console.log("Temparrrrrr",tempArray)
      tempArray.forEach((item) => {
        cartQty += Number(item.quantity);
        console.log("ppppppossosos",cartQty)
      });
      if(cartQty>=Number(this.localService.get('max_cart_qty')))
        {
          this.alertService.error("Maximum allowed quantity is " + this.localService.get('max_cart_qty') + " only", this.options)
              return false;
        }
        if(ORG_DETAILS.NAME === "Srimaware"){
window.scroll(0,100);
        }
      let requestData = {
        "domain_name": ORG_DETAILS.DOMAIN_NAME,
        "user_id": ORG_DETAILS.USER_ID,
        "extras": {
          "find": {
            "id": item_id
          },
          "pagination": false,
          "paginationDetails": {
            "limit": 0,
            "pageSize": 2
          },
          "sorting": true,
          "sortingDetails": {
            "sortfield": "", "sortorder": 1
          }
        }
      }
      this.checkoutApiService.checkoutAPICall(ENDPOINTS.PRODUCT_DETAILS, requestData).then(
        respData => {
          let res: any = respData;
          if (res.success) {
            // this.newProductDetails=res.data[0];
            //return res;
            let tempArray = this.appService.cartProducts.results;
            let cartQty = 0;
  
            tempArray.forEach((item) => {
              cartQty += item.quantity;
            });
            var data = res.data[0];
            var sale_price = data['pricing']['raw']['sale_price'];
            data['pricing']['raw']['price'] = sale_price;
            data['pricing']['raw']['cost']=sale_price;
  
            this.cartService.addToCart(data);
  
          let obj =
            {
              domain_name: ORG_DETAILS.DOMAIN_NAME,
              user_id: ORG_DETAILS.USER_ID,
              extras: {
                find: {
                  product_id: Number(data.id),
                  product_cost: Number(data['pricing']['raw']['cost']),
                  quantity: 1,
                },
              },
            };
  
          this.appService.postApiCall(obj, ENDPOINTS.STRUCTURED_PROMOTION).subscribe(
            (resp) => {
              if (resp) {
                if (resp.success === 1 && resp.status_code === 200) {
                  for (let j = 0; j < this.appService.cartProducts.results.length;j++) {
                    if (
                      this.appService.cartProducts.results[j].product_id === data.id
                    ) {                      
                        this.appService.cartProducts.results[j]["discount_amount"] =
                          resp.result.data.discount_summary[0].discount_amount;
                 
                      this.appService.cartProducts.results[j][
                        "after_dicount_price"
                      ] = resp.result.data.discount_summary[0].after_dicount_price;
                      console.log(
                        "this.appService.cartProducts.results[i].product.fixed_amount" +
                        this.appService.cartProducts.results[j].
                          after_dicount_price
                      );
                      this.cartService.updateCartItem(
                        this.appService.cartProducts.results
                      );
                      console.log(
                        "this.appService.cartProducts.results[i].product.fixed_amount" +
                          this.appService.cartProducts.results[j].discount_amount
                      );
                    }
                  }
                  let cartItemsString = JSON.stringify(
                    this.appService.cartProducts.results
                  );
                  this.localService.set("cart", cartItemsString);
                } else if (resp.success === 0) {
                  if (resp.message) {
                  }
                } else if (resp.message && resp.status_code !== 200) {
                } else {
                }
              }
            },
            (err) => {
              if (err.error.statusCode === 403) {
              } else if (err.error.error.message) {
              } else {
              }
            }
          );
          }
        }
      )
   


  }
  addToCartAvonSeals(item_id) {
    let tempArray = this.appService.cartProducts.results;
    let cartQty = 0;

    tempArray.forEach((item, i) => {
      cartQty += item.quantity;
    });

    if (Number(this.localService.get('max_cart_qty')) <= cartQty) {
      this.showAlerts = true;
      window.scrollTo(0, 0);
      // this.alertService.error("Maximum allowed quantity is " +this.localService.get('max_cart_qty') +" only",this.options)
  if (config.title === 'AvonSeals') {
        this.alertService.error("Maximum allowed quantity is " + this.localService.get('max_cart_qty') + " only", this.options)
      }

      return
    } else {
      let requestData = {
        "domain_name": ORG_DETAILS.DOMAIN_NAME,
        "user_id": ORG_DETAILS.USER_ID,
        "extras": {
          "find": {
            "id": item_id
          },
          "pagination": false,
          "paginationDetails": {
            "limit": 0,
            "pageSize": 2
          },
          "sorting": true,
          "sortingDetails": {
            "sortfield": "", "sortorder": 1
          }
        }
      }
      this.checkoutApiService.checkoutAPICall(ENDPOINTS.PRODUCT_DETAILS, requestData).then(
        respData => {
          let res: any = respData;
          if (res.success) {
            // this.newProductDetails=res.data[0];
            //return res;
            // let tempArray = this.appService.cartProducts.results;
            // let cartQty = 0;
  
            // tempArray.forEach((item) => {
            //   cartQty += item.quantity;
            // });
            // var data = res.data[0];
            var data = res.data[0];
            // var sale_price = data['pricing']['raw']['sale_price'];
            // data['pricing']['raw']['price'] = sale_price;
  
            this.cartService.addToCart(data);
          }
        }
      )
    }

  }

  addToCartLinenRaj(item_id) {
    let tempArray = this.appService.cartProducts.results;
    let cartQty = 0;

    tempArray.forEach((item, i) => {
      cartQty += item.quantity;
    });

    if (Number(this.localService.get('max_cart_qty')) <= cartQty) {
      this.showAlerts = true;
      window.scrollTo(0, 0);
      // this.alertService.error("Maximum allowed quantity is " +this.localService.get('max_cart_qty') +" only",this.options)
  if (config.title === 'AvonSeals') {
        this.alertService.error("Maximum allowed quantity is " + this.localService.get('max_cart_qty') + " only", this.options)
      }

      return
    } else {
      let requestData = {
        "domain_name": ORG_DETAILS.DOMAIN_NAME,
        "user_id": ORG_DETAILS.USER_ID,
        "extras": {
          "find": {
            "id": item_id
          },
          "pagination": false,
          "paginationDetails": {
            "limit": 0,
            "pageSize": 2
          },
          "sorting": true,
          "sortingDetails": {
            "sortfield": "", "sortorder": 1
          }
        }
      }
      this.checkoutApiService.checkoutAPICall(ENDPOINTS.PRODUCT_DETAILS, requestData).then(
        respData => {
          let res: any = respData;
          if (res.success) {
            // this.newProductDetails=res.data[0];
            //return res;
            // let tempArray = this.appService.cartProducts.results;
            // let cartQty = 0;
  
            // tempArray.forEach((item) => {
            //   cartQty += item.quantity;
            // });
            // var data = res.data[0];
            var data = res.data[0];
            // var sale_price = data['pricing']['raw']['sale_price'];
            // data['pricing']['raw']['price'] = sale_price;
  
            this.cartService.addToCart(data);
          }
        }
      )
    }

  }


  add(a,c)
  {
    let d=c;
    let b=a;
    return a+(c.quantity);
  }
  addToCartvimpro(item_id) {
    let requestData = {
      "domain_name": ORG_DETAILS.DOMAIN_NAME,
      "user_id": ORG_DETAILS.USER_ID,
      "extras": {
        "find": {
          "id": item_id
        },
        "pagination": false,
        "paginationDetails": {
          "limit": 0,
          "pageSize": 2
        },
        "sorting": true,
        "sortingDetails": {
          "sortfield": "", "sortorder": 1
        }
      }
    }
    this.checkoutApiService.checkoutAPICall(ENDPOINTS.PRODUCT_DETAILS, requestData).then(
      respData => {
        let res: any = respData;
        if (res.success) {
          // this.newProductDetails=res.data[0];
          //return res;
          let cartQty = 0;
    let tempArray = this.appService.cartProducts.results;
    tempArray.forEach((item) => {
      cartQty += item.quantity;
    });
    var max_cart_qty=(Number(this.localService.get("max_cart_qty")));
    if(max_cart_qty<=cartQty||max_cart_qty<cartQty+(this.newProductDetails.pricing.raw.minimumorderquantity!=0&&this.newProductDetails.pricing.raw.minimumorderquantity!=null?this.newProductDetails.pricing.raw.minimumorderquantity:1) ) {
      this.alertService.error(
        "Maximum allowed quantity is " +
          this.localService.get("max_cart_qty") +
          " only",
        this.options
      );
      return
    
  }
          var data = res.data[0];
          var sale_price = data['pricing']['raw']['sale_price'];
          data['pricing']['raw']['price'] = sale_price;

          this.cartService.addToCart(data);
        }
      }
    )

  }
  async  getProfileDetails(id) {
    return new Promise((resolve, reject) => {
      let requestBody = {
        "domain_name": ORG_DETAILS.DOMAIN_NAME,
        "user_id": ORG_DETAILS.USER_ID,
        "extras": {
          "find": {
            "id" : id
          }
        }
      }
      // MAKE A SERVICE CALL HERE...
      this.appService.postApiCall(requestBody,ENDPOINTS.GET_CUSTOMER,).subscribe(
        resp => {
          if (resp) {
         
            this.approved= resp.result.data[0]!=null?resp.result.data[0].status:'';
            
           
         
          }
          else{
            this.approved="";
          }
          resolve(true);
        },
        err => {
         resolve(false);
          // if (err.error.statusCode === 403) {
          //   this.alertService.error('Session Time Out! Please login Again', this.options)
          //   this.router.navigate([`/login-new`], { skipLocationChange: false });
          // }
          // else if (err.error.message) {
          //   this.alertService.error(err.error.message, this.options)
          // }
          // else {
          //   this.alertService.error('Something bad happened. Please try again!', this.options);
          // }
        }
      )
    })
   
  }
  logout()
  {
    this.appService.userLoggedIn = false;
  this.appService.userName = "";
  console.log( this.appService.userName,"login user")

  this.appService.loggedin_user = false;
  this.localService.remove('accessToken');
  this.localService.remove('refreshToken');
  this.localService.remove('expireTime');
  this.localService.remove('UserName');
  this.localService.remove('UserId');
  this.localService.remove('customerGroup');
  this.localService.remove('domainName');
  this.localService.remove('rexpireTime');
  this.localService.remove('AiemaUserName');
  this.localService.remove('couponCode');
  this.localService.remove('company_name');
  this.localService.remove('gst_number');
  this.localService.remove('company_address');
  this.appService.removeSession();
  this.checkoutLocalStorageService.clearDataonLogout();
  this.checkoutLocalStorageService.removeOrderId();
  this.LoginService.updateAdminFormEvent({name: "alert_error"});
  this.router.navigate([`/login-new`], { skipLocationChange: false });

  }
 async addtocartKarupatti()
  {
    await  this.getProfileDetails(this.localService.get('UserId')!=null?Number(this.localService.get('UserId')):'');

 
if(String(this.approved)!=='Approved'&&ORG_DETAILS.NAME === "Karupattiraja")
  {
    this.logout();
  }
  else{

    let cartQty = 0;
    let tempArray = this.appService.cartProducts.results;
    tempArray.forEach((item) => {
      cartQty += item.quantity;
    });
    var max_cart_qty=(Number(this.localService.get("max_cart_qty")));
    if(max_cart_qty<=cartQty||max_cart_qty<cartQty+(this.newProductDetails.pricing.raw.minimumorderquantity!=0&&this.newProductDetails.pricing.raw.minimumorderquantity!=null?this.newProductDetails.pricing.raw.minimumorderquantity:1) ) {
      this.alertService.error(
        "Maximum allowed quantity is " +
          this.localService.get("max_cart_qty") +
          " only",
        this.options
      );
      return
      
  }
  this.cartService.addToCart(this.newProductDetails);
  }
    
  if (ORG_DETAILS.NAME === "Vistas") {
    let userId = this.localService.get('UserId');
    let tempArray = this.appService.cartProducts.results;
    let obj = {
      domain_name: ORG_DETAILS.DOMAIN_NAME,
      user_id: ORG_DETAILS.USER_ID,
      extras: {
        find: {
          customer_id: Number(userId),
          product_id: Number(this.newProductDetails.id),
          product_cost: Number(this.newProductDetails.pricing.raw.price),
          quantity: 1,
        },
      },
    };
    this.appService.postApiCall(obj, ENDPOINTS.STRUCTURED_PROMOTION).subscribe(
      (resp) => {
        if (resp) {
          if (resp.success === 1 && resp.status_code === 200) {
            for (let j = 0; j < this.appService.cartProducts.results.length;j++) {
              if (
                this.appService.cartProducts.results[j].product_id === this.newProductDetails.id
                
              )
              console.log("resp.result.data.discount_summary[0].discount_amount",resp.result.data.discount_summary[0].discount_amount);
               {                      
                  this.appService.cartProducts.results[j]["discount_amount"] =
                    resp.result.data.discount_summary[0].discount_amount;
           
                this.appService.cartProducts.results[j][
                  "after_dicount_price"
                ] = resp.result.data.discount_summary[0].after_dicount_price;
                console.log(
                  "this.appService.cartProducts.results[i].product.fixed_amount" +
                  this.appService.cartProducts.results[j].
                    after_dicount_price
                );
                this.cartService.updateCartItem(
                  this.appService.cartProducts.results
                );
                console.log(
                  "this.appService.cartProducts.results[i].product.fixed_amount" +
                    this.appService.cartProducts.results[j].discount_amount
                );
              }
            }
            let cartItemsString = JSON.stringify(
              this.appService.cartProducts.results
            );
            this.localService.set("cart", cartItemsString);
          } else if (resp.success === 0) {
            if (resp.message) {
            }
          } else if (resp.message && resp.status_code !== 200) {
          } else {
          }
        }
      },
      (err) => {
        if (err.error.statusCode === 403) {
        } else if (err.error.error.message) {
        } else {
        }
      }
    );
    this.cartService.addToCart(this.newProductDetails);
    }
 
  if(ORG_DETAILS.NAME === 'LinenRaj'){
    this.openbagForLinenRaja()



  }
}
addtocartVistas(item)
  {
    console.log("daytaaaaaaaaaaaaaa")

    let cartQty = 0;
    let tempArray = this.appService.cartProducts.results;
    tempArray.forEach((item) => {
      cartQty += item.quantity;
    });
    var max_cart_qty=(Number(this.localService.get("max_cart_qty")));
    if(max_cart_qty<=cartQty||max_cart_qty<cartQty+(this.newProductDetails.pricing.raw.minimumorderquantity!=0&&this.newProductDetails.pricing.raw.minimumorderquantity!=null?this.newProductDetails.pricing.raw.minimumorderquantity:1) ) {
      this.alertService.error(
        "Maximum allowed quantity is " +
          this.localService.get("max_cart_qty") +
          " only",
        this.options
      );
      return
       
    }
    if (ORG_DETAILS.NAME === "Vistas") {
      let userId = this.localService.get('UserId');
      let obj =
      {
        domain_name: ORG_DETAILS.DOMAIN_NAME,
        user_id: ORG_DETAILS.USER_ID,
        extras: {
          find: {
            product_id: Number(item.id),
            product_cost: Number(item.pricing.raw.price),
            quantity: 1,
            customer_id: Number(userId)
          },
        },
      };

    this.appService.postApiCall(obj, ENDPOINTS.STRUCTURED_PROMOTION).subscribe(
      (resp) => {
        if (resp) {
          if (resp.success === 1 && resp.status_code === 200) {
            for (let j = 0; j < this.appService.cartProducts.results.length;j++) {
              if (
                this.appService.cartProducts.results[j].product_id === item.id
              ) {                      
                  this.appService.cartProducts.results[j]["discount_amount"] =
                    resp.result.data.discount_summary[0].discount_amount;
           
                this.appService.cartProducts.results[j][
                  "after_dicount_price"
                ] = resp.result.data.discount_summary[0].after_dicount_price;
                console.log(
                  "this.appService.cartProducts.results[i].product.fixed_amount" +
                  this.appService.cartProducts.results[j].
                    after_dicount_price
                );
                this.cartService.updateCartItem(
                  this.appService.cartProducts.results
                );
                console.log(
                  "this.appService.cartProducts.results[i].discount_amount" +
                    this.appService.cartProducts.results[j].discount_amount
                );
              }
            }
            let cartItemsString = JSON.stringify(
              this.appService.cartProducts.results
            );
            this.localService.set("cart", cartItemsString);
          } else if (resp.success === 0) {
            if (resp.message) {
            }
          } else if (resp.message && resp.status_code !== 200) {
          } else {
          }
        }
      },
      (err) => {
        if (err.error.statusCode === 403) {
        } else if (err.error.error.message) {
        } else {
        }
      }
    );
      }
    
      this.cartService.addToCart(this.newProductDetails);
  
    }
async decreasekarupattiitem(index)
{
 
  await  this.getProfileDetails(this.localService.get('UserId')!=null?Number(this.localService.get('UserId')):'');
  console.log("daytaaaaaaaaaaaaaa")
  if(String(this.approved)!=='Approved'&&ORG_DETAILS.NAME === "Karupattiraja")
{
  this.logout();
}
else{

  let tempArray = this.appService.cartProducts.results;
  if(tempArray[index].quantity<=tempArray[index].product.pricing.raw.minimumorderquantity)
  {
    tempArray[index].quantity =Number(tempArray[index].quantity)-tempArray[index].product.pricing.raw.minimumorderquantity;
  }
  else {
    if(tempArray[index].product.pricing.raw.decrementvalue>0)
    {
      console.log("trueeeeeee")
      tempArray[index].quantity = Number(tempArray[index].quantity) - Number(tempArray[index].product.pricing.raw.decrementvalue);
    } else {
      tempArray[index].quantity = Number(tempArray[index].quantity) - 1;
    }
    // tempArray[index].quantity=Number(tempArray[index].quantity)-1;
  }
  if(tempArray[index].quantity<=0)
  {
    this.appService.cartProducts.results.splice(index, 1);
  }
  
    this.appService.totalCartItems = this.cartService.totalCartItems();
    this.cartService.updateCartItem(this.appService.cartProducts.results);
    if (ORG_DETAILS.NAME === "SpecialWires") {
      let obj = {
        domain_name: ORG_DETAILS.DOMAIN_NAME,
        user_id: ORG_DETAILS.USER_ID,
        extras: {
          find: {
            product_id: Number(tempArray[index].product_id),
            product_cost: Number(tempArray[index].cost),
            quantity: Number(tempArray[index].quantity),
            // customer_id: Number(userId),
            weight: Number(tempArray[index].product.shipping.weight_to_consider) * Number(tempArray[index].quantity),
          weight_to_consider:true
          },
        },
      };

      this.appService
        .postApiCall(obj, ENDPOINTS.STRUCTURED_PROMOTION)
        .subscribe(
          (resp) => {
            if (resp) {
              if (resp.success === 1 && resp.status_code === 200) {
         
                  this.appService.cartProducts.results[index]["discount_amount"] =
                  resp.result.data.discount_summary[0].discount_amount;
         
              this.appService.cartProducts.results[index][
                "after_dicount_price"
              ] = resp.result.data.discount_summary[0].after_dicount_price;
                 
                 
                this.cartService.updateCartItem(
                  this.appService.cartProducts.results
                );
                console.log(
                  "tempArray[index].product.discount_value" +
                    tempArray[index].product.discount_value
                );
              } else if (resp.success === 0) {
                if (resp.message) {
                  //this.alertService.error(resp.message, this.options);
                }
              } else if (resp.message && resp.status_code !== 200) {
                //this.alertService.error(resp.message, this.options);
              } else {
                //this.alertService.error('Something bad happened. Please try again!', this.options);
              }
            }
          },
          (err) => {
            if (err.error.statusCode === 403) {
              //this.alertService.error('Session Time Out! Please login Again', this.options)
            } else if (err.error.error.message) {
              //this.alertService.error(err.error.error.message, this.options)
            } else {
              //this.alertService.error('Something bad happened. Please try again!', this.options);
            }
          }
        );
    }
}
 
}
addToCartDeera(item_id){
   
  let maxorderedquantity=this.appService.cartProducts.results.reduce((partialSum, a) => partialSum + a.quantity, 0)
  if(maxorderedquantity>=Number(this.localService.get('max_cart_qty')))
  {
    this.alertService.error("Maximum allowed quantity is " + this.localService.get('max_cart_qty') + " only", this.options)
        return false;
  }
  let tempArray = this.appService.cartProducts.results;
  let cartQty = 0;

  tempArray.forEach((item, i) => {
    cartQty += item.quantity;
  });

  if (Number(this.localService.get('max_cart_qty')) <= cartQty) {
    this.showAlerts = true;
    window.scrollTo(0, 0);
    // this.alertService.error("Maximum allowed quantity is " +this.localService.get('max_cart_qty') +" only",this.options)
    return
  }
  else{
// console.log("2222")
//     this.cartService.addToCart(this.newProductDetails);
//     this.addCart = true;
//   for (let i = 0; i < this.appService.cartProducts.results.length; i++) {
//     this.cartData.push(this.appService.cartProducts.results[i].option_values[].id);
//   }
this.product.variant.option_values.forEach((element, index) => {
  if (element.is_default === true) {
     this.deera_variant_price = element.pricing.raw.price;
    this.deera_variant_id = element.id
  }
});      
let requestData = {
"domain_name": ORG_DETAILS.DOMAIN_NAME,
"user_id": ORG_DETAILS.USER_ID,
"extras": {
  "find": {
    "id": Number(this.deera_variant_id)
  },
  "pagination": false,
  "paginationDetails": {
    "limit": 0,
    "pageSize": 2
  },
  "sorting": true,
  "sortingDetails": {
    "sortfield": "", "sortorder": 1
  }
}
}
this.checkoutApiService.checkoutAPICall(ENDPOINTS.PRODUCT_DETAILS, requestData).then(
respData => {
  let res: any = respData;
  if (res.success) {

    let tempArray = this.appService.cartProducts.results;
    let cartQty = 0;

    tempArray.forEach((item) => {
      cartQty += item.quantity;
    });
    var data = res.data[0];
    this.deera_price_data = data;
    console.log("this.deera_price_data", this.deera_price_data)
    this.variantMSRP = data['pricing']['raw']['msrp'];
    this.variantUnit = data.unit;
    this.cartService.addToCart(data);
    this.addCart = true;
for(let j = 0; j < this.appService.cartProducts.results.length; j++ ){
if(Number(this.appService.cartProducts.results[j].product_id) === Number(data.id)){
console.log("this.appService.cartProducts.results[j].quality",this.appService.cartProducts.results[j])
console.log("hhfg",this.appService.cartProducts.results[this.appService.productIdinCart.indexOf(data.id)])
// this.appService.cartProducts.results[j].product.quantity = data.pricing.raw.minimumorderquantity
this.appService.cartProducts.results[j].quantity = data.pricing.raw.minimumorderquantity
console.log("data.pricing.raw.minimumorderquantity",data)
}
}
this.cartService.updateCartItem(
this.appService.cartProducts.results
);
    // for (let i = 0; i < this.appService.cartProducts.results.length; i++) {
    //   this.cartData.push(this.appService.cartProducts.results[i].product_id);
    // }
  
    let obj = {
      domain_name: ORG_DETAILS.DOMAIN_NAME,
      user_id: ORG_DETAILS.USER_ID,
      extras: {
        find: {
          product_id: Number(this.deera_variant_id),
          product_cost: Number(this.deera_variant_price),
          quantity: data.pricing.raw.minimumorderquantity,
        },
      },
    };
    try {
      this.appService
        .postApiCall(obj, ENDPOINTS.QUANTITY_PROMOTION)
        .subscribe(
          (resp) => {
            console.log("POST API CALL RESPONSE: ", resp);
            console.log("APP service: ", this.appService);
            if (resp) {
              console.log("ADD TO CART: ", resp)
              if (resp.success === 1 && resp.status_code === 200) {
                for (
                  let j = 0;
                  j < this.appService.cartProducts.results.length;
                  j++
                ) {
                  if (
                    this.appService.cartProducts.results[j].product_id ===
                    this.deera_variant_id
                  ) {
                    console.log("VALID ENTRY?")
                    this.appService.cartProducts.results[j].product.discount_value =
                      resp.result.data.discount_applied_to_product_value;
                    ;
                    this.appService.cartProducts.results[j].product.per_quantity_amount = resp.result.data.per_quantity_amount;
                    this.appService.cartProducts.results[j].product.discount_amount =
                      Number(resp.result.data.discount_amount);
                    this.appService.cartProducts.results[j].product.fixed_amount =
                      Number(resp.result.data.fixed_amount);
                    this.appService.cartProducts.results[
                      j
                    ].product.discount_percentage = Number(
                      resp.result.data.discount_percentage
                    );
                    this.congratulationBanner =
                      resp.result.data.congratulations_banner_message;
                    //   this.congratulationBanner.forEach((element, index) => {
                    //     this.congratulationBanner1 = element
                    // });
                    this.upsellBanner =
                      resp.result.data.upsell_banner_message;
                    this.percentageValue = Number(
                      resp.result.data.discount_percentage
                    );
                    this.fixedAmount = Number(resp.result.data.fixed_amount);
                    this.discountValue = Number(
                      resp.result.data.discount_applied_to_product_value
                    );
                    this.promotionType = resp.result.data.promotion_type;
                    this.promotionType.forEach((element, index) => {
                      if (element === 'Product discount') {
                        this.productPromotion = 'Product discount'
                      }
                      if (element === 'Quantity discount') {
                        this.quantityPromotion = 'Quantity discount'
                      }
                    });
                    this.productQuantity = Number(
                      this.appService.cartProducts.results[j].quantity
                    );
                    this.productQuantity1 = true;
                    if (resp.result.data.discount_percentage > 0) {
                      this.appService.cartProducts.results[j][
                        "fixed_amount"
                      ] = resp.result.data.discount_amount;
                    } else {
                      this.appService.cartProducts.results[j][
                        "fixed_amount"
                      ] = resp.result.data.fixed_amount;
                    }
                    this.appService.cartProducts.results[j][
                      "discount_percentage"
                    ] = resp.result.data.discount_percentage;
            
                    try {
                      this.cartService.updateCartItem(
                        this.appService.cartProducts.results
                      );
                    } catch (err) {
                      console.log("Error in updating cart item")
                    }
                  }
                }
                if (ORG_DETAILS.NAME === "Deera" || ORG_DETAILS.NAME === "Taazah") {
                  let cartItemsString = JSON.stringify(
                    this.appService.cartProducts.results
                  );
                  console.log("Item in cart: ", this.appService.cartProducts.results)
                  this.localService.set("cart", cartItemsString);
                  console.log("Item in cart: ", this.appService.cartProducts.results)
                }
              } else if (resp.success === 0) {
                if (resp.message) {
                }
              } else if (resp.message && resp.status_code !== 200) {
              } else {
              }
            }
          },
          (err) => {
            if (err.error.statusCode === 403) {
            } else if (err.error.error.message) {
            } else {
            }
          }
        );
    } catch (err) {
      console.log("ERROR: Adding to cart API call failed");
    }
  }
}
)
console.log("this.appService.cartProducts.results",this.appService.cartProducts.results)

// }
}
}
addToCartBaby(item_id){
   
  let maxorderedquantity=this.appService.cartProducts.results.reduce((partialSum, a) => partialSum + a.quantity, 0)
  if(maxorderedquantity>=Number(this.localService.get('max_cart_qty')))
  {
    this.alertService.error("Maximum allowed quantity is " + this.localService.get('max_cart_qty') + " only", this.options)
        return false;
  }
  let tempArray = this.appService.cartProducts.results;
  let cartQty = 0;
  this.product.pricing.raw.minimumorderquantity  = 1
  tempArray.forEach((item, i) => {
    cartQty += item.quantity;
  });

  if (Number(this.localService.get('max_cart_qty')) <= cartQty) {
    this.showAlerts = true;
    window.scrollTo(0, 0);
    // this.alertService.error("Maximum allowed quantity is " +this.localService.get('max_cart_qty') +" only",this.options)
    return
  }
  else{
// console.log("2222")
//     this.cartService.addToCart(this.newProductDetails);
//     this.addCart = true;
//   for (let i = 0; i < this.appService.cartProducts.results.length; i++) {
//     this.cartData.push(this.appService.cartProducts.results[i].option_values[].id);
//   }
this.product.variant.option_values.forEach((element, index) => {
  if (element.is_default === true) {
     this.baby_variant_price = element.pricing.raw.price;
    this.baby_variant_id = element.id
  }
});      
let requestData = {
"domain_name": ORG_DETAILS.DOMAIN_NAME,
"user_id": ORG_DETAILS.USER_ID,
"extras": {
  "find": {
    "id": Number(this.baby_variant_id)
  },
  "pagination": false,
  "paginationDetails": {
    "limit": 0,
    "pageSize": 2
  },
  "sorting": true,
  "sortingDetails": {
    "sortfield": "", "sortorder": 1
  }
}
}
this.checkoutApiService.checkoutAPICall(ENDPOINTS.PRODUCT_DETAILS, requestData).then(
respData => {
  let res: any = respData;
  if (res.success) {

    let tempArray = this.appService.cartProducts.results;
    let cartQty = 1;

    tempArray.forEach((item) => {
      cartQty += item.quantity;
    });
    var data = res.data[0];
    this.deera_price_data = data;
    console.log("this.deera_price_data", this.deera_price_data)
    this.variantMSRP = data['pricing']['raw']['msrp'];
    this.variantUnit = data.unit;
    this.cartService.addToCart(data);
    this.addCart = true;
for(let j = 0; j < this.appService.cartProducts.results.length; j++ ){
if(Number(this.appService.cartProducts.results[j].product_id) === Number(data.id)){
console.log("this.appService.cartProducts.results[j].quality",this.appService.cartProducts.results[j])
console.log("hhfg",this.appService.cartProducts.results[this.appService.productIdinCart.indexOf(data.id)])
// this.appService.cartProducts.results[j].product.quantity = data.pricing.raw.minimumorderquantity
this.appService.cartProducts.results[j].quantity = data.pricing.raw.minimumorderquantity
console.log("this.appService.cartProducts.results[j].quantity ",this.appService.cartProducts.results[j].quantity )
console.log("data.pricing.raw.minimumorderquantity",data.pricing.raw.minimumorderquantity)
}
}
this.cartService.updateCartItem(
this.appService.cartProducts.results
);
    // for (let i = 0; i < this.appService.cartProducts.results.length; i++) {
    //   this.cartData.push(this.appService.cartProducts.results[i].product_id);
    // }
  
    let obj = {
      domain_name: ORG_DETAILS.DOMAIN_NAME,
      user_id: ORG_DETAILS.USER_ID,
      extras: {
        find: {
          product_id: Number(this.baby_variant_id),
          product_cost: Number(this.baby_variant_price),
          quantity: 1,
        },
      },
    };
    try {
      this.appService
        .postApiCall(obj, ENDPOINTS.QUANTITY_PROMOTION)
        .subscribe(
          (resp) => {
            console.log("POST API CALL RESPONSE: ", resp);
            console.log("APP service: ", this.appService);
            if (resp) {
              console.log("ADD TO CART: ", resp)
              if (resp.success === 1 && resp.status_code === 200) {
                for (
                  let j = 0;
                  j < this.appService.cartProducts.results.length;
                  j++
                ) {
                  if (
                    this.appService.cartProducts.results[j].product_id ===
                    this.baby_variant_id
                  ) {
                    console.log("VALID ENTRY?")
                    this.appService.cartProducts.results[j].product.discount_value =
                      resp.result.data.discount_applied_to_product_value;
                    ;
                    this.appService.cartProducts.results[j].product.per_quantity_amount = resp.result.data.per_quantity_amount;
                    this.appService.cartProducts.results[j].product.discount_amount =
                      Number(resp.result.data.discount_amount);
                    this.appService.cartProducts.results[j].product.fixed_amount =
                      Number(resp.result.data.fixed_amount);
                    this.appService.cartProducts.results[
                      j
                    ].product.discount_percentage = Number(
                      resp.result.data.discount_percentage
                    );
                    this.congratulationBanner =
                      resp.result.data.congratulations_banner_message;
                    //   this.congratulationBanner.forEach((element, index) => {
                    //     this.congratulationBanner1 = element
                    // });
                    this.upsellBanner =
                      resp.result.data.upsell_banner_message;
                    this.percentageValue = Number(
                      resp.result.data.discount_percentage
                    );
                    this.fixedAmount = Number(resp.result.data.fixed_amount);
                    this.discountValue = Number(
                      resp.result.data.discount_applied_to_product_value
                    );
                    this.promotionType = resp.result.data.promotion_type;
                    this.promotionType.forEach((element, index) => {
                      if (element === 'Product discount') {
                        this.productPromotion = 'Product discount'
                      }
                      if (element === 'Quantity discount') {
                        this.quantityPromotion = 'Quantity discount'
                      }
                    });
                    this.productQuantity = Number(
                      this.appService.cartProducts.results[j].quantity
                    );
                    this.productQuantity1 = true;
                    if (resp.result.data.discount_percentage > 0) {
                      this.appService.cartProducts.results[j][
                        "fixed_amount"
                      ] = resp.result.data.discount_amount;
                    } else {
                      this.appService.cartProducts.results[j][
                        "fixed_amount"
                      ] = resp.result.data.fixed_amount;
                    }
                    this.appService.cartProducts.results[j][
                      "discount_percentage"
                    ] = resp.result.data.discount_percentage;
            
                    try {
                      this.cartService.updateCartItem(
                        this.appService.cartProducts.results
                      );
                    } catch (err) {
                      console.log("Error in updating cart item")
                    }
                  }
                }

                  let cartItemsString = JSON.stringify(
                    this.appService.cartProducts.results
                  );
                  console.log("Item in cart: ", this.appService.cartProducts.results)
                  this.localService.set("cart", cartItemsString);
                  console.log("Item in cart: ", this.appService.cartProducts.results)
              } else if (resp.success === 0) {
                if (resp.message) {
                }
              } else if (resp.message && resp.status_code !== 200) {
              } else {
              }
            }
          },
          (err) => {
            if (err.error.statusCode === 403) {
            } else if (err.error.error.message) {
            } else {
            }
          }
        );
    } catch (err) {
      console.log("ERROR: Adding to cart API call failed");
    }
  }
}
)
console.log("this.appService.cartProducts.results",this.appService.cartProducts.results)

// }
}
}
addToCartTaz(item_id){
   
  let maxorderedquantity=this.appService.cartProducts.results.reduce((partialSum, a) => partialSum + a.quantity, 0)
  if(maxorderedquantity>=Number(this.localService.get('max_cart_qty')))
  {
    this.alertService.error("Maximum allowed quantity is " + this.localService.get('max_cart_qty') + " only", this.options)
        return false;
  }
  let tempArray = this.appService.cartProducts.results;
  let cartQty = 0;
  this.product.pricing.raw.minimumorderquantity  = 1
  tempArray.forEach((item, i) => {
    cartQty += item.quantity;
  });

  if (Number(this.localService.get('max_cart_qty')) <= cartQty) {
    this.showAlerts = true;
    window.scrollTo(0, 0);
    // this.alertService.error("Maximum allowed quantity is " +this.localService.get('max_cart_qty') +" only",this.options)
    return
  }
  else{
// console.log("2222")
//     this.cartService.addToCart(this.newProductDetails);
//     this.addCart = true;
//   for (let i = 0; i < this.appService.cartProducts.results.length; i++) {
//     this.cartData.push(this.appService.cartProducts.results[i].option_values[].id);
//   }
this.product.variant.option_values.forEach((element, index) => {
  if (element.is_default === true) {
     this.baby_variant_price = element.pricing.raw.price;
    this.baby_variant_id = element.id
  }
});      
let requestData = {
"domain_name": ORG_DETAILS.DOMAIN_NAME,
"user_id": ORG_DETAILS.USER_ID,
"extras": {
  "find": {
    "id": Number(item_id)
  },
  "pagination": false,
  "paginationDetails": {
    "limit": 0,
    "pageSize": 2
  },
  "sorting": true,
  "sortingDetails": {
    "sortfield": "", "sortorder": 1
  }
}
}
this.checkoutApiService.checkoutAPICall(ENDPOINTS.PRODUCT_DETAILS, requestData).then(
respData => {
  let res: any = respData;
  if (res.success) {

    let tempArray = this.appService.cartProducts.results;
    let cartQty = 1;

    tempArray.forEach((item) => {
      cartQty += item.quantity;
    });
    var data = res.data[0];
    this.deera_price_data = data;
    console.log("this.deera_price_data", this.deera_price_data)
    this.variantMSRP = data['pricing']['raw']['msrp'];
    this.variantUnit = data.unit;
    this.cartService.addToCart(data);
    this.addCart = true;
for(let j = 0; j < this.appService.cartProducts.results.length; j++ ){
if(Number(this.appService.cartProducts.results[j].product_id) === Number(data.id)){
console.log("this.appService.cartProducts.results[j].quality",this.appService.cartProducts.results[j])
console.log("hhfg",this.appService.cartProducts.results[this.appService.productIdinCart.indexOf(data.id)])
// this.appService.cartProducts.results[j].product.quantity = data.pricing.raw.minimumorderquantity
this.appService.cartProducts.results[j].quantity = data.pricing.raw.minimumorderquantity
console.log("this.appService.cartProducts.results[j].quantity ",this.appService.cartProducts.results[j].quantity )
console.log("data.pricing.raw.minimumorderquantity",data.pricing.raw.minimumorderquantity)
}
}
this.cartService.updateCartItem(
this.appService.cartProducts.results
);
if(this.config.title === "HOB" || this.config.title === "PaulCaroline" || this.config.title=='Srimaware'){
  console.log("gggggggggggggggggggggggggggggggggggggggg")
  this.headerService.updateAdminFormEvent({name: "subTotal"});
}
    // for (let i = 0; i < this.appService.cartProducts.results.length; i++) {
    //   this.cartData.push(this.appService.cartProducts.results[i].product_id);
    // }
  
    let obj = {
      domain_name: ORG_DETAILS.DOMAIN_NAME,
      user_id: ORG_DETAILS.USER_ID,
      extras: {
        find: {
          product_id: Number(this.baby_variant_id),
          product_cost: Number(this.baby_variant_price),
          quantity: 1,
        },
      },
    };
    try {
      this.appService
        .postApiCall(obj, ENDPOINTS.QUANTITY_PROMOTION)
        .subscribe(
          (resp) => {
            console.log("POST API CALL RESPONSE: ", resp);
            console.log("APP service: ", this.appService);
            if (resp) {
              console.log("ADD TO CART: ", resp)
              if (resp.success === 1 && resp.status_code === 200) {
                for (
                  let j = 0;
                  j < this.appService.cartProducts.results.length;
                  j++
                ) {
                  if (
                    this.appService.cartProducts.results[j].product_id ===
                    this.baby_variant_id
                  ) {
                    console.log("VALID ENTRY?")
                    this.appService.cartProducts.results[j].product.discount_value =
                      resp.result.data.discount_applied_to_product_value;
                    ;
                    this.appService.cartProducts.results[j].product.per_quantity_amount = resp.result.data.per_quantity_amount;
                    this.appService.cartProducts.results[j].product.discount_amount =
                      Number(resp.result.data.discount_amount);
                    this.appService.cartProducts.results[j].product.fixed_amount =
                      Number(resp.result.data.fixed_amount);
                    this.appService.cartProducts.results[
                      j
                    ].product.discount_percentage = Number(
                      resp.result.data.discount_percentage
                    );
                    this.congratulationBanner =
                      resp.result.data.congratulations_banner_message;
                    //   this.congratulationBanner.forEach((element, index) => {
                    //     this.congratulationBanner1 = element
                    // });
                    this.upsellBanner =
                      resp.result.data.upsell_banner_message;
                    this.percentageValue = Number(
                      resp.result.data.discount_percentage
                    );
                    this.fixedAmount = Number(resp.result.data.fixed_amount);
                    this.discountValue = Number(
                      resp.result.data.discount_applied_to_product_value
                    );
                    this.promotionType = resp.result.data.promotion_type;
                    this.promotionType.forEach((element, index) => {
                      if (element === 'Product discount') {
                        this.productPromotion = 'Product discount'
                      }
                      if (element === 'Quantity discount') {
                        this.quantityPromotion = 'Quantity discount'
                      }
                    });
                    this.productQuantity = Number(
                      this.appService.cartProducts.results[j].quantity
                    );
                    this.productQuantity1 = true;
                    if (resp.result.data.discount_percentage > 0) {
                      this.appService.cartProducts.results[j][
                        "fixed_amount"
                      ] = resp.result.data.discount_amount;
                    } else {
                      this.appService.cartProducts.results[j][
                        "fixed_amount"
                      ] = resp.result.data.fixed_amount;
                    }
                    this.appService.cartProducts.results[j][
                      "discount_percentage"
                    ] = resp.result.data.discount_percentage;
            
                    try {
                      this.cartService.updateCartItem(
                        this.appService.cartProducts.results
                      );
                    } catch (err) {
                      console.log("Error in updating cart item")
                    }
                  }
                }

                  let cartItemsString = JSON.stringify(
                    this.appService.cartProducts.results
                  );
                  console.log("Item in cart: ", this.appService.cartProducts.results)
                  this.localService.set("cart", cartItemsString);
                  console.log("Item in cart: ", this.appService.cartProducts.results)
              } else if (resp.success === 0) {
                if (resp.message) {
                }
              } else if (resp.message && resp.status_code !== 200) {
              } else {
              }
            }
          },
          (err) => {
            if (err.error.statusCode === 403) {
            } else if (err.error.error.message) {
            } else {
            }
          }
        );
    } catch (err) {
      console.log("ERROR: Adding to cart API call failed");
    }
  }
}
)
console.log("this.appService.cartProducts.results",this.appService.cartProducts.results)

// }
}
}
// addToCartBaby(item_id){
   
//       let maxorderedquantity=this.appService.cartProducts.results.reduce((partialSum, a) => partialSum + a.quantity, 0)
//       if(maxorderedquantity>=Number(this.localService.get('max_cart_qty')))
//       {
//         this.alertService.error("Maximum allowed quantity is " + this.localService.get('max_cart_qty') + " only", this.options)
//             return false;
//       }
//       let tempArray = this.appService.cartProducts.results;
//       let cartQty = 0;
  
//       tempArray.forEach((item, i) => {
//         cartQty += item.quantity;
//       });
  
//       if (Number(this.localService.get('max_cart_qty')) <= cartQty) {
//         this.showAlerts = true;
//         window.scrollTo(0, 0);
//         return
//       }
//       else{
//   let requestData = {
//     "domain_name": ORG_DETAILS.DOMAIN_NAME,
//     "user_id": ORG_DETAILS.USER_ID,
//     "extras": {
//       "find": {
//         "id": Number(item_id)
//       },
//       "pagination": false,
//       "paginationDetails": {
//         "limit": 0,
//         "pageSize": 2
//       },
//       "sorting": true,
//       "sortingDetails": {
//         "sortfield": "", "sortorder": 1
//       }
//     }
//   }
//   this.checkoutApiService.checkoutAPICall(ENDPOINTS.PRODUCT_DETAILS, requestData).then(
//     respData => {
//       let res: any = respData;
//       if (res.success) {

//         let tempArray = this.appService.cartProducts.results;
//         let cartQty = 0;

//         tempArray.forEach((item) => {
//           cartQty += item.quantity;
//         });
//         var data = res.data[0];
//         this.deera_price_data = data;
//         console.log("this.deera_price_data", this.deera_price_data)
//         this.variantMSRP = data['pricing']['raw']['msrp'];
//         this.variantUnit = data.unit;
//         this.cartService.addToCart(data);
//         this.addCart = true;
// for(let j = 0; j < this.appService.cartProducts.results.length; j++ ){
//   if(Number(this.appService.cartProducts.results[j].product_id) === Number(data.id)){
//     console.log("this.appService.cartProducts.results[j].quality",this.appService.cartProducts.results[j])
//     console.log("hhfg",this.appService.cartProducts.results[this.appService.productIdinCart.indexOf(data.id)])
//     this.appService.cartProducts.results[j].quantity = 1
//     console.log("data.pricing.raw.minimumorderquantity",data)
//   }
// }
// this.cartService.updateCartItem(
//   this.appService.cartProducts.results
// );
//       }
//     }
//   )
//     console.log("this.appService.cartProducts.results",this.appService.cartProducts.results)
    

// }
// }
  addTocart() {

  let maxorderedquantity=this.appService.cartProducts.results.reduce((partialSum, a) => partialSum + a.quantity, 0)
    if(maxorderedquantity>=Number(this.localService.get('max_cart_qty')))
    {
      this.alertService.error("Maximum allowed quantity is " + this.localService.get('max_cart_qty') + " only", this.options)
          return false;
    }
     if(this,config.title=='BestGifts'){
      let tempArray = this.appService.cartProducts.results;
    let cartQty = 0;

    console.log("HAHAHAHA", this.numberOfMaskUploads)
    tempArray.forEach((item) => {
      cartQty += item.quantity;
    });

    }
    if(ORG_DETAILS.NAME === "Deera"){
      console.log("2222")
      this.cartService.addToCart(this.newProductDetails);
    }

    if(ORG_DETAILS.NAME !== "Deera" && ORG_DETAILS.NAME !== "Babys Pride"){
      if (this.showSize) {
        if (this.newProductDetails.hasOwnProperty("variant")) {
          // item.pricing.raw.price=this.priceOfVariant
          let cartdetails = this.sizeVariable;
          cartdetails.brand = { name: "" };
          cartdetails.categories = [];
          cartdetails.assets = this.newProductDetails.assets;
          cartdetails.name =
            this.newProductDetails.name + " - " + this.sizeVariable.option;
          cartdetails.parentcategories = this.newProductDetails.parentcategories;
          console.log("1111")
          this.cartService.addToCart(cartdetails);
        } else {
          console.log("2222")
          this.cartService.addToCart(this.newProductDetails);
        }
      } else {
        if(this.numberOfMaskUploads == 0) {
          this.cartService.addToCart(this.newProductDetails);    
          console.log("3333")
          document.getElementById("bestgiftsloader").style.display="block"
          let obj =
          {
            "domain_name": ORG_DETAILS.DOMAIN_NAME,
            "user_id": ORG_DETAILS.USER_ID,
            "extras": {
              "find": {
                "product_id": Number(this.newProductDetails.id),
                "product_cost": Number(this.newProductDetails.pricing.raw.price),
                "quantity": 1,
                "customer_id": Number(this.customer_id),
                "customer_type":this.customerType1
              }
            }
          }
     
          this.appService.postApiCall(obj, ENDPOINTS.STRUCTURED_PROMOTION).subscribe(
            resp => {
              if (resp) {
                if (resp.success === 1 && resp.status_code === 200) {
                  this.appService.cartProducts.results.forEach((item,i) => {
                    console.log("this.newProductDetails.id"+this.newProductDetails.id)
                    if(this.newProductDetails.id===item.product_id){
                      item["discount_amount"] =
                      resp.result.data.discount_summary[0].discount_amount;
             
                      item[
                    "after_dicount_price"
                  ] = resp.result.data.discount_summary[0].after_dicount_price; 
                  item[
                    "per_quantity_amount"
                  ] = resp.result.data.discount_summary[0].per_quantity_amount;              
                    this.discountValue = Number(resp.result.data.discount_summary[0].after_dicount_price);
                    }})
                    // this.appService.cartProducts.results = tempArray;
                  // this.productQuantity = Number(tempArray[index].quantity);
                  // this.productQuantity1 = true;
        
                  this.cartService.updateCartItem(this.appService.cartProducts.results);
                  if (ORG_DETAILS.NAME === "BestGifts") {
                    let cartItemsString = JSON.stringify(
                      this.appService.cartProducts.results
                    );
                    console.log("Item in cart: ", this.appService.cartProducts.results)
                    this.localService.set("cart", cartItemsString);
                    console.log("Item in cart: ", this.appService.cartProducts.results)
                  }
                  document.getElementById("bestgiftsloader").style.display="none"
                  console.log("Updating cart: ", this.appService.cartProducts.results)
                } else if (resp.success === 0) {
                  if (resp.message) {
                    //this.alertService.error(resp.message, this.options);
                  }
                } else if (resp.message && resp.status_code !== 200) {
                  //this.alertService.error(resp.message, this.options);
                } else {
                  //this.alertService.error('Something bad happened. Please try again!', this.options);
                }
              }
            },
            (err) => {
              if (err.error.statusCode === 403) {
                //this.alertService.error('Session Time Out! Please login Again', this.options)
              } else if (err.error.error.message) {
                //this.alertService.error(err.error.error.message, this.options)
              } else {
                //this.alertService.error('Something bad happened. Please try again!', this.options);
              }
            }
          );
        }
        else{
          console.log("4444",this.customerType1)
          
          this.cartService.addToCart(this.newProductDetails);
          if(ORG_DETAILS.NAME === "Schift Cosmetics" || ORG_DETAILS.NAME === "LushNGreen"){
            let objschift =
            {
              "domain_name": ORG_DETAILS.DOMAIN_NAME,
              "user_id": ORG_DETAILS.USER_ID,
              "extras": {
                "find": {
                  "product_id": Number(this.newProductDetails.id),
                  "product_cost": Number(this.newProductDetails.pricing.raw.price),
                  "customer_type":this.customerType1,
                  "quantity": 1,
                  "customer_id": Number(0)
                  
                }
              }
            }
       
            this.appService.postApiCall(objschift, ENDPOINTS.STRUCTURED_PROMOTION).subscribe(
              resp => {
                if (resp) {
                  if (resp.success === 1 && resp.status_code === 200) {
                    this.appService.cartProducts.results.forEach((item,i) => {
                      console.log("this.newProductDetails.id"+this.newProductDetails.id)
                      if(this.newProductDetails.id===item.product_id){
                        item["discount_amount"] =
                        resp.result.data.discount_summary[0].discount_amount;
               
                        item[
                      "after_dicount_price"
                    ] = resp.result.data.discount_summary[0].after_dicount_price; 
                    item[
                      "per_quantity_amount"
                    ] = resp.result.data.discount_summary[0].per_quantity_amount;              
                      this.discountValue = Number(resp.result.data.discount_summary[0].after_dicount_price);
                      }})
                      // this.appService.cartProducts.results = tempArray;
                    // this.productQuantity = Number(tempArray[index].quantity);
                    // this.productQuantity1 = true;
                    console.log("length of discount",resp.result.data.additional_discount.length)
                    if(resp.result.data.additional_discount.length > 0){
                      
                      console.log("Free Product",resp.result.data.additional_discount[0].offer_type)
                      if(resp.result.data.additional_discount[0].offer_type){
          if(resp.result.data.additional_discount[0].offer_type === "Free Product"){
            this.appService.cartProducts.results.forEach((item,i) => {
              console.log("Discount Product id",resp.result.data.additional_discount[0].product_id)
              console.log("Product added in cart",item.product_id)
              if( resp.result.data.additional_discount[0].product_id === item.product_id){
                console.log("testtt" + item.product_id)
                item.product['free_product_name'] = resp.result.data.additional_discount[0].free_product_name
                item.product['free_product_id'] = resp.result.data.additional_discount[0].free_product_id
                item.product['free_qty'] = resp.result.data.additional_discount[0].free_qty
              }
          })
          this.cartService.updateCartItem(this.appService.cartProducts.results); 
        }     
          }
        }
          else{
            this.cartService.updateCartItem(this.appService.cartProducts.results);
          }
          
          console.log("Udated Product",this.appService.cartProducts.results)
                    
                    document.getElementById("bestgiftsloader").style.display="none"
                    console.log("Updating cart: ", this.appService.cartProducts.results)
                  } else if (resp.success === 0) {
                    if (resp.message) {
                      //this.alertService.error(resp.message, this.options);
                    }
                  } else if (resp.message && resp.status_code !== 200) {
                    //this.alertService.error(resp.message, this.options);
                  } else {
                    //this.alertService.error('Something bad happened. Please try again!', this.options);
                  }
                }
              },
              (err) => {
                if (err.error.statusCode === 403) {
                  //this.alertService.error('Session Time Out! Please login Again', this.options)
                } else if (err.error.error.message) {
                  //this.alertService.error(err.error.error.message, this.options)
                } else {
                  //this.alertService.error('Something bad happened. Please try again!', this.options);
                }
              }
            );
          }
        }
      }
    }

    this.addCart = true;
    for (let i = 0; i < this.appService.cartProducts.results.length; i++) {
      this.cartData.push(this.appService.cartProducts.results[i].product_id);
    }
    if (ORG_DETAILS.NAME === "Deera" || ORG_DETAILS.NAME === "Babys Pride") {
      let tempArray = this.appService.cartProducts.results;
      let obj = {
        domain_name: ORG_DETAILS.DOMAIN_NAME,
        user_id: ORG_DETAILS.USER_ID,
        extras: {
          find: {
            product_id: Number(this.newProductDetails.id),
            product_cost: Number(this.newProductDetails.pricing.raw.cost),
            quantity: 1,
          },
        },
      };
      try {
        this.appService
          .postApiCall(obj, ENDPOINTS.QUANTITY_PROMOTION)
          .subscribe(
            (resp) => {
              console.log("POST API CALL RESPONSE: ", resp);
              console.log("APP service: ", this.appService);
              if (resp) {
                console.log("ADD TO CART: ", resp)
                if (resp.success === 1 && resp.status_code === 200) {
                  for (
                    let j = 0;
                    j < this.appService.cartProducts.results.length;
                    j++
                  ) {
                    if (
                      this.appService.cartProducts.results[j].product_id ===
                      this.newProductDetails.id
                    ) {
                      console.log("VALID ENTRY?")
                      this.appService.cartProducts.results[j].product.discount_value =
                        resp.result.data.discount_applied_to_product_value;
                      ;
                      this.appService.cartProducts.results[j].product.per_quantity_amount = resp.result.data.per_quantity_amount;
                      this.appService.cartProducts.results[j].product.discount_amount =
                        Number(resp.result.data.discount_amount);
                      this.appService.cartProducts.results[j].product.fixed_amount =
                        Number(resp.result.data.fixed_amount);
                      this.appService.cartProducts.results[
                        j
                      ].product.discount_percentage = Number(
                        resp.result.data.discount_percentage
                      );
                      this.congratulationBanner =
                        resp.result.data.congratulations_banner_message;
                      //   this.congratulationBanner.forEach((element, index) => {
                      //     this.congratulationBanner1 = element
                      // });
                      this.upsellBanner =
                        resp.result.data.upsell_banner_message;
                      this.percentageValue = Number(
                        resp.result.data.discount_percentage
                      );
                      this.fixedAmount = Number(resp.result.data.fixed_amount);
                      this.discountValue = Number(
                        resp.result.data.discount_applied_to_product_value
                      );
                      this.promotionType = resp.result.data.promotion_type;
                      this.promotionType.forEach((element, index) => {
                        if (element === 'Product discount') {
                          this.productPromotion = 'Product discount'
                        }
                        if (element === 'Quantity discount') {
                          this.quantityPromotion = 'Quantity discount'
                        }
                      });
                      this.productQuantity = Number(
                        this.appService.cartProducts.results[j].quantity
                      );
                      this.productQuantity1 = true;
                      if (resp.result.data.discount_percentage > 0) {
                        this.appService.cartProducts.results[j][
                          "fixed_amount"
                        ] = resp.result.data.discount_amount;
                      } else {
                        this.appService.cartProducts.results[j][
                          "fixed_amount"
                        ] = resp.result.data.fixed_amount;
                      }
                      this.appService.cartProducts.results[j][
                        "discount_percentage"
                      ] = resp.result.data.discount_percentage;
                      try {
                        this.cartService.updateCartItem(
                          this.appService.cartProducts.results
                        );
                      } catch (err) {
                        console.log("Error in updating cart item")
                      }
                    }
                  }
                  if (ORG_DETAILS.NAME === "Deera" || ORG_DETAILS.NAME === "Babys Pride") {
                    let cartItemsString = JSON.stringify(
                      this.appService.cartProducts.results
                    );
                    console.log("Item in cart: ", this.appService.cartProducts.results)
                    this.localService.set("cart", cartItemsString);
                    console.log("Item in cart: ", this.appService.cartProducts.results)
                  }
                } else if (resp.success === 0) {
                  if (resp.message) {
                  }
                } else if (resp.message && resp.status_code !== 200) {
                } else {
                }
              }
            },
            (err) => {
              if (err.error.statusCode === 403) {
              } else if (err.error.error.message) {
              } else {
              }
            }
          );
      } catch (err) {
        console.log("ERROR: Adding to cart API call failed");
      }
    }
    if(ORG_DETAILS.NAME  === 'LinenRaj'){
      this.openbagForLinenRaja()



    }
  }
  buyNowDeeraVariant() {}
  buyNow() {
    let maxorderedquantity=this.appService.cartProducts.results.reduce((partialSum, a) => partialSum + a.quantity, 0)
    if(maxorderedquantity>=Number(this.localService.get('max_cart_qty')))
    {
      this.alertService.error("Maximum allowed quantity is " + this.localService.get('max_cart_qty') + " only", this.options)
          return false;
    } else {
      let tempArray = this.appService.cartProducts.results;
      let cartQty = 0;
  
      tempArray.forEach((item) => {
        cartQty += item.quantity;
      });
  
      if (this.showSize) {
        if(this.config.title!=="Deera" && this.config.title!=="Babys Pride" && this.config.title!=="LushNGreen" && this.config.title!=="KatbookStore" && this.config.title!=="Taazah"){
          if (this.newProductDetails.hasOwnProperty("variant")) {
            let cartdetails = this.sizeVariable;
            cartdetails.brand = { name: "" };
            cartdetails.categories = [];
            cartdetails.assets = this.newProductDetails.assets;
            cartdetails.name =
              this.newProductDetails.name + " - " + this.sizeVariable.option;
            cartdetails.parentcategories = this.newProductDetails.parentcategories;
            this.cartService.addToCart(cartdetails);
            this.addCart = true;
            // for (let i = 0; i < this.appService.cartProducts.results.length; i++) {
            //   this.cartData.push(this.appService.cartProducts.results[i].product_id);
            // } 
          
        
        }   else {
          this.cartService.addToCart(this.newProductDetails);
        }
        } else if((this.config.title==="Deera" || this.config.title==="Taazah")  && this.product.product_type == "Simple"){
          console.log("testforcartyou")
          this.cartService.addToCart(this.newProductDetails);
          this.router.navigate(["/checkout-new"]);
        window.scrollTo(0,0);
        }
    
      } else {
        console.log("testforcartyou22222")
        this.cartService.addToCart(this.newProductDetails);
        this.router.navigate(["/checkout-new"]);
        window.scrollTo(0,0);
      }
      if((this.config.title==="Deera" || this.config.title==="LushNGreen")  && this.product.product_type == "Variable"){
        this.product.variant.option_values.forEach((element, index) => {
          if (element.is_default === true) {
             this.deera_variant_price = element.pricing.raw.price;
            this.deera_variant_id = element.id
          }
        });
      }
      if (ORG_DETAILS.NAME === "KatbookStore") {
        let cartItemsString = JSON.stringify(
          this.appService.cartProducts.results
        );
        console.log("Item in cart: ", this.appService.cartProducts.results)
        this.localService.set("cart", cartItemsString);
        this.router.navigate(["/checkout-new"]);
        window.scrollTo(0,0);
        console.log("Item in cart: ", this.appService.cartProducts.results)
      }
      else{

      }
  // if((this.config.title==="Deera" || this.config.title==="Babys Pride" )  && this.product.product_type == "Variable"){
  //       this.product.variant.option_values.forEach((element, index) => {
  //         if (element.is_default === true) {
  //            this.deera_variant_price = element.pricing.raw.price;
  //           this.deera_variant_id = element.id
  //         }
  //       });
        
  //     }
  //  if(this.config.title==="LushNGreen"){
  //   console.log("In1",this.product.variant.option_values)
  //       for(let i=0;this.product.variant.option_values.length >= 0; i++) {
  //         console.log("In2")
  //         for( let j=0; this.product.variant.option_values[i].child.length >=0; j++){
  //           console.log("In3",i)
  //           console.log("In3",j)
  //           if(this.product.variant.option_values[i].child[j].is_default){
  //           if (this.product.variant.option_values[i].child[j].is_default === true) {
  //             console.log("In4")
  //             this.deera_variant_price = this.product.variant.option_values[i].child[j].pricing.raw.price;
  //             console.log("llldkksl",this.deera_variant_price)
  //            this.deera_variant_id = this.product.variant.option_values[i].child[j].id
  //            console.log("trysdergh",this.deera_variant_id)

  //          }
  //         }
  //         break;
  //         }
  //         break;
  //       };
  //      }
      // item.pricing.raw.price=this.priceOfVariant
      if((this.config.title==="Deera" || this.config.title==="LushNGreen") && this.product.product_type == "Variable"){
        let requestData = {
          "domain_name": ORG_DETAILS.DOMAIN_NAME,
          "user_id": ORG_DETAILS.USER_ID,
          "extras": {
            "find": {
              "id": Number(this.deera_variant_id)
            },
            "pagination": false,
            "paginationDetails": {
              "limit": 0,
              "pageSize": 2
            },
            "sorting": true,
            "sortingDetails": {
              "sortfield": "", "sortorder": 1
            }
          }
        }
        this.checkoutApiService.checkoutAPICall(ENDPOINTS.PRODUCT_DETAILS, requestData).then(
          respData => {
            let res: any = respData;
            if (res.success) {
              
              var data = res.data[0];
              this.deera_price_data = data;
              console.log("this.deera_price_data", this.deera_price_data)
              this.cartService.addToCart(data);
              this.addCart = true;
              for (let i = 0; i < this.appService.cartProducts.results.length; i++) {
                this.cartData.push(this.appService.cartProducts.results[i].product_id);
              }
              
              if (ORG_DETAILS.NAME ==="LushNGreen" && this.product.product_type == "Variable") {
                let userId = this.localService.get('UserId');
              let obj =
              {
                domain_name: ORG_DETAILS.DOMAIN_NAME,
                user_id: ORG_DETAILS.USER_ID,
                extras: {
                  find: {
                    product_id: Number(this.newProductDetails.id),
                    product_cost: Number(this.newProductDetails.pricing.raw.price),
                    quantity: 1,
                    customer_type:"individual customer",
                    customer_id: Number(userId)
                  },
                },
              };
        
            this.appService.postApiCall(obj, ENDPOINTS.STRUCTURED_PROMOTION).subscribe(
              (resp) => {
                if (resp) {
                  if (resp.success === 1 && resp.status_code === 200) {
                    for (let j = 0; j < this.appService.cartProducts.results.length;j++) {
                      if (
                        this.appService.cartProducts.results[j].product_id === this.newProductDetails.id
                      ) {                      
                          this.appService.cartProducts.results[j]["discount_amount"] =
                            resp.result.data.discount_summary[0].discount_amount;
                   
                        this.appService.cartProducts.results[j][
                          "after_dicount_price"
                        ] = resp.result.data.discount_summary[0].after_dicount_price;
                        console.log(
                          "this.appService.cartProducts.results[i].product.fixed_amount" +
                          this.appService.cartProducts.results[j].
                            after_dicount_price
                        );
                        this.cartService.updateCartItem(
                          this.appService.cartProducts.results
                        );
                        console.log(
                          "this.appService.cartProducts.results[i].discount_amount" +
                            this.appService.cartProducts.results[j].discount_amount
                        );
                      }
                    }
                    if(resp.result.data.additional_discount.length > 0){
                      if(resp.result.data.additional_discount[0].offer_type){
          if(resp.result.data.additional_discount[0].offer_type === "Free Product"){
            this.appService.cartProducts.results.forEach((item,i) => {
              console.log("Discount Product id",resp.result.data.additional_discount[0].product_id)
              console.log("Product added in cart",item.product_id)
              if( resp.result.data.additional_discount[0].product_id === item.product_id){
                console.log("testtt" + item.product_id)
                item.product['free_product_name'] = resp.result.data.additional_discount[0].free_product_name
                item.product['free_product_id'] = resp.result.data.additional_discount[0].free_product_id
                item.product['free_qty'] = resp.result.data.additional_discount[0].free_qty
              }
          })
          this.cartService.updateCartItem(this.appService.cartProducts.results); 
        }     
          }
        }
          //           let cartItemsString = JSON.stringify(
          //             this.appService.cartProducts.results
          //           );
          //           this.localService.set("cart", cartItemsString);
          //         } else if (resp.success === 0) {
          //           if (resp.message) {
          //           }
          //         } else if (resp.message && resp.status_code !== 200) {
          //         } else {
          //         }
          //       }
          //     },
          //     (err) => {
          //       if (err.error.statusCode === 403) {
          //       } else if (err.error.error.message) {
          //       } else {
          //       }
          //     }
          //   );
          //     }
        
          //             if (ORG_DETAILS.NAME === "Vistas") {
          //               let cartItemsString = JSON.stringify(
          //                 this.appService.cartProducts.results
          //               );
          //               console.log("Item in cart: ", this.appService.cartProducts.results)
          //               this.localService.set("cart", cartItemsString);
          //               this.router.navigate(["/checkout-new"]);
          //               console.log("Item in cart: ", this.appService.cartProducts.results)
                        
          //             }
                   
          // }
        
            let cartItemsString = JSON.stringify(
              this.appService.cartProducts.results
            );
            console.log("Item in cart: ", this.appService.cartProducts.results)
            this.localService.set("cart", cartItemsString);
            this.router.navigate(["/checkout-new"]);
            console.log("Item in cart: ", this.appService.cartProducts.results)
        
        } else if (resp.success === 0) {
          if (resp.message) {
          }
        } else if (resp.message && resp.status_code !== 200) {
        } else {
        }
        }
        },
        (err) => {
        if (err.error.statusCode === 403) {
        } else if (err.error.error.message) {
        } else {
        }
        }
        ); 
      }

              if (ORG_DETAILS.NAME === "Deera" && this.product.product_type == "Variable") {
                let tempArray = this.appService.cartProducts.results;
                let obj = {
                  domain_name: ORG_DETAILS.DOMAIN_NAME,
                  user_id: ORG_DETAILS.USER_ID,
                  extras: {
                    find: {
                      product_id: Number(this.deera_variant_id),
                      product_cost: Number(this.deera_variant_price),
                      quantity: 1,
                    },
                  },
                };
                try {
                  this.appService
                    .postApiCall(obj, ENDPOINTS.QUANTITY_PROMOTION)
                    .subscribe(
                      (resp) => {
                        console.log("POST API CALL RESPONSE: ", resp);
                        console.log("APP service: ", this.appService);
                        if (resp) {
                          console.log("ADD TO CART: ", resp)
                          if (resp.success === 1 && resp.status_code === 200) {
                            for (
                              let j = 0;
                              j < this.appService.cartProducts.results.length;
                              j++
                            ) {
                              if (
                                this.appService.cartProducts.results[j].product_id ===
                                this.deera_variant_id
                              ) {
                                console.log("VALID ENTRY?")
                                this.appService.cartProducts.results[j].product.discount_value =
                                  resp.result.data.discount_applied_to_product_value;
                                ;
                                this.appService.cartProducts.results[j].product.per_quantity_amount = resp.result.data.per_quantity_amount;
                                this.appService.cartProducts.results[j].product.discount_amount =
                                  Number(resp.result.data.discount_amount);
                                this.appService.cartProducts.results[j].product.fixed_amount =
                                  Number(resp.result.data.fixed_amount);
                                this.appService.cartProducts.results[
                                  j
                                ].product.discount_percentage = Number(
                                  resp.result.data.discount_percentage
                                );
                                this.congratulationBanner =
                                  resp.result.data.congratulations_banner_message;
                                //   this.congratulationBanner.forEach((element, index) => {
                                //     this.congratulationBanner1 = element
                                // });
                                this.upsellBanner =
                                  resp.result.data.upsell_banner_message;
                                this.percentageValue = Number(
                                  resp.result.data.discount_percentage
                                );
                                this.fixedAmount = Number(resp.result.data.fixed_amount);
                                this.discountValue = Number(
                                  resp.result.data.discount_applied_to_product_value
                                );
                                this.promotionType = resp.result.data.promotion_type;
                                this.promotionType.forEach((element, index) => {
                                  if (element === 'Product discount') {
                                    this.productPromotion = 'Product discount'
                                  }
                                  if (element === 'Quantity discount') {
                                    this.quantityPromotion = 'Quantity discount'
                                  }
                                });
                                this.productQuantity = Number(
                                  this.appService.cartProducts.results[j].quantity
                                );
                                this.productQuantity1 = true;
                                if (resp.result.data.discount_percentage > 0) {
                                  this.appService.cartProducts.results[j][
                                    "fixed_amount"
                                  ] = resp.result.data.discount_amount;
                                } else {
                                  this.appService.cartProducts.results[j][
                                    "fixed_amount"
                                  ] = resp.result.data.fixed_amount;
                                }
                                this.appService.cartProducts.results[j][
                                  "discount_percentage"
                                ] = resp.result.data.discount_percentage;
                                this.congratulationBanner = resp.result.data.congratulations_banner_message;
                                //   this.congratulationBanner.forEach((element, index) => {
                                //     this.congratulationBanner1 = element
                                // });
                                // this.upsellBanner = resp.result.data.upsell_banner_message;
                                this.percentageValue = Number(resp.result.data.discount_percentage);
                                this.fixedAmount = Number(resp.result.data.fixed_amount);
                                this.discountValue = Number(resp.result.data.discount_applied_to_product_value);
                                this.promotionType = resp.result.data.promotion_type;
                                this.promotionType.forEach((element, index) => {
                                  if (element === 'Product discount') {
                                    this.productPromotion = 'Product discount'
                                  }
                                  if (element === 'Quantity discount') {
                                    this.quantityPromotion = 'Quantity discount'
                                  }
                                });
                                this.productQuantity = Number(this.appService.cartProducts.results[j].quantity);
                                this.productQuantity1 = true;
                                if (resp.result.data.discount_percentage > 0) {
                                  this.appService.cartProducts.results[j]['fixed_amount'] = resp.result.data.discount_amount;
                                }
                                else {
                                  this.appService.cartProducts.results[j]['fixed_amount'] = resp.result.data.fixed_amount;
                                }
                                try {
                                  this.cartService.updateCartItem(
                                    this.appService.cartProducts.results
                                  );
                                } catch (err) {
                                  console.log("Error in updating cart item")
                                }
                              }
                            }
                            if (ORG_DETAILS.NAME === "Deera" || ORG_DETAILS.NAME === "Babys Pride" || ORG_DETAILS.NAME === "LushNGreen" ||ORG_DETAILS.NAME === "Vistas" ||ORG_DETAILS.NAME === "KatbookStore") {
                              let cartItemsString = JSON.stringify(
                                this.appService.cartProducts.results
                              );
                              console.log("Item in cart: ", this.appService.cartProducts.results)
                              this.localService.set("cart", cartItemsString);
                              this.router.navigate(["/checkout-new"]);
                              console.log("Item in cart: ", this.appService.cartProducts.results)
                            }
                          } else if (resp.success === 0) {
                            if (resp.message) {
                            }
                          } else if (resp.message && resp.status_code !== 200) {
                          } else {
                          }
                        }
                      },
                      (err) => {
                        if (err.error.statusCode === 403) {
                        } else if (err.error.error.message) {
                        } else {
                        }
                      }
                    );
                } catch (err) {
                  console.log("ERROR: Adding to cart API call failed");
                }
              }
            }
      } )}
      this.addCart = true;
      for (let i = 0; i < this.appService.cartProducts.results.length; i++) {
        this.cartData.push(this.appService.cartProducts.results[i].product_id);
      }
      if (ORG_DETAILS.NAME === "Deera" && this.product.product_type == "Simple") {
        let tempArray = this.appService.cartProducts.results;
        let obj = {
          domain_name: ORG_DETAILS.DOMAIN_NAME,
          user_id: ORG_DETAILS.USER_ID,
          extras: {
            find: {
              product_id: Number(this.newProductDetails.id),
              product_cost: Number(this.newProductDetails.pricing.raw.cost),
              quantity: 1,
            },
          },
        };
        try {
          this.appService
            .postApiCall(obj, ENDPOINTS.QUANTITY_PROMOTION)
            .subscribe(
              (resp) => {
                console.log("POST API CALL RESPONSE: ", resp);
                console.log("APP service: ", this.appService);
                if (resp) {
                  console.log("ADD TO CART: ", resp)
                  if (resp.success === 1 && resp.status_code === 200) {
                    for (
                      let j = 0;
                      j < this.appService.cartProducts.results.length;
                      j++
                    ) {
                      if (
                        this.appService.cartProducts.results[j].product_id ===
                        this.newProductDetails.id
                      ) {
                        console.log("VALID ENTRY?")
                        this.appService.cartProducts.results[j].product.discount_value =
                          resp.result.data.discount_applied_to_product_value;
                        ;
                        this.appService.cartProducts.results[j].product.per_quantity_amount = resp.result.data.per_quantity_amount;
                        this.appService.cartProducts.results[j].product.discount_amount =
                          Number(resp.result.data.discount_amount);
                        this.appService.cartProducts.results[j].product.fixed_amount =
                          Number(resp.result.data.fixed_amount);
                        this.appService.cartProducts.results[
                          j
                        ].product.discount_percentage = Number(
                          resp.result.data.discount_percentage
                        );
                        this.congratulationBanner =
                          resp.result.data.congratulations_banner_message;
                        //   this.congratulationBanner.forEach((element, index) => {
                        //     this.congratulationBanner1 = element
                        // });
                        this.upsellBanner =
                          resp.result.data.upsell_banner_message;
                        this.percentageValue = Number(
                          resp.result.data.discount_percentage
                        );
                        this.fixedAmount = Number(resp.result.data.fixed_amount);
                        this.discountValue = Number(
                          resp.result.data.discount_applied_to_product_value
                        );
                        this.promotionType = resp.result.data.promotion_type;
                        this.promotionType.forEach((element, index) => {
                          if (element === 'Product discount') {
                            this.productPromotion = 'Product discount'
                          }
                          if (element === 'Quantity discount') {
                            this.quantityPromotion = 'Quantity discount'
                          }
                        });
                        this.productQuantity = Number(
                          this.appService.cartProducts.results[j].quantity
                        );
                        this.productQuantity1 = true;
                        if (resp.result.data.discount_percentage > 0) {
                          this.appService.cartProducts.results[j][
                            "fixed_amount"
                          ] = resp.result.data.discount_amount;
                        } else {
                          this.appService.cartProducts.results[j][
                            "fixed_amount"
                          ] = resp.result.data.fixed_amount;
                        }
                        this.appService.cartProducts.results[j][
                          "discount_percentage"
                        ] = resp.result.data.discount_percentage;
                        try {
                          this.cartService.updateCartItem(
                            this.appService.cartProducts.results
                          );
                        } catch (err) {
                          console.log("Error in updating cart item")
                        }
                      }
                    }
                    if (ORG_DETAILS.NAME === "Deera" || ORG_DETAILS.NAME === "Babys Pride"||ORG_DETAILS.NAME === "Vistas"||ORG_DETAILS.NAME === "KatbookStore") {
                      let cartItemsString = JSON.stringify(
                        this.appService.cartProducts.results
                      );
                      console.log("Item in cart: ", this.appService.cartProducts.results)
                      this.localService.set("cart", cartItemsString);
                      this.router.navigate(["/checkout-new"]);
                      console.log("Item in cart: ", this.appService.cartProducts.results)
                    }
                  } else if (resp.success === 0) {
                    if (resp.message) {
                    }
                  } else if (resp.message && resp.status_code !== 200) {
                  } else {
                  }
                }
              },
              (err) => {
                if (err.error.statusCode === 403) {
                } else if (err.error.error.message) {
                } else {
                }
              }
            );
        } catch (err) {
          console.log("ERROR: Adding to cart API call failed");
        }
      }

      if (ORG_DETAILS.NAME === "LushNGreen" && this.product.product_type == "Simple") {
      let userId = this.localService.get('UserId');
      let obj =
      {
        domain_name: ORG_DETAILS.DOMAIN_NAME,
        user_id: ORG_DETAILS.USER_ID,
        extras: {
          find: {
            product_id: Number(this.newProductDetails.id),
            product_cost: Number(this.newProductDetails.pricing.raw.price),
            quantity: 1,
            customer_type:"individual customer",
            customer_id: Number(userId)
          },
        },
      };

    this.appService.postApiCall(obj, ENDPOINTS.STRUCTURED_PROMOTION).subscribe(
      (resp) => {
        if (resp) {
          if (resp.success === 1 && resp.status_code === 200) {
            for (let j = 0; j < this.appService.cartProducts.results.length;j++) {
              if (
                this.appService.cartProducts.results[j].product_id === this.newProductDetails.id
              ) {                      
                  this.appService.cartProducts.results[j]["discount_amount"] =
                    resp.result.data.discount_summary[0].discount_amount;
           
                this.appService.cartProducts.results[j][
                  "after_dicount_price"
                ] = resp.result.data.discount_summary[0].after_dicount_price;
                console.log(
                  "this.appService.cartProducts.results[i].product.fixed_amount" +
                  this.appService.cartProducts.results[j].
                    after_dicount_price
                );
                this.cartService.updateCartItem(
                  this.appService.cartProducts.results
                );
                console.log(
                  "this.appService.cartProducts.results[i].discount_amount" +
                    this.appService.cartProducts.results[j].discount_amount
                );
              }
            }
            if(resp.result.data.additional_discount.length > 0){
              if(resp.result.data.additional_discount[0].offer_type){
  if(resp.result.data.additional_discount[0].offer_type === "Free Product"){
    this.appService.cartProducts.results.forEach((item,i) => {
      console.log("Discount Product id",resp.result.data.additional_discount[0].product_id)
      console.log("Product added in cart",item.product_id)
      if( resp.result.data.additional_discount[0].product_id === item.product_id){
        console.log("testtt" + item.product_id)
        item.product['free_product_name'] = resp.result.data.additional_discount[0].free_product_name
        item.product['free_product_id'] = resp.result.data.additional_discount[0].free_product_id
        item.product['free_qty'] = resp.result.data.additional_discount[0].free_qty
      }
  })
  this.cartService.updateCartItem(this.appService.cartProducts.results); 
}     
  }
}
  //           let cartItemsString = JSON.stringify(
  //             this.appService.cartProducts.results
  //           );
  //           this.localService.set("cart", cartItemsString);
  //         } else if (resp.success === 0) {
  //           if (resp.message) {
  //           }
  //         } else if (resp.message && resp.status_code !== 200) {
  //         } else {
  //         }
  //       }
  //     },
  //     (err) => {
  //       if (err.error.statusCode === 403) {
  //       } else if (err.error.error.message) {
  //       } else {
  //       }
  //     }
  //   );
  //     }

  //             if (ORG_DETAILS.NAME === "Vistas") {
  //               let cartItemsString = JSON.stringify(
  //                 this.appService.cartProducts.results
  //               );
  //               console.log("Item in cart: ", this.appService.cartProducts.results)
  //               this.localService.set("cart", cartItemsString);
  //               this.router.navigate(["/checkout-new"]);
  //               console.log("Item in cart: ", this.appService.cartProducts.results)
                
  //             }
           
  // }

    let cartItemsString = JSON.stringify(
      this.appService.cartProducts.results
    );
    console.log("Item in cart: ", this.appService.cartProducts.results)
    this.localService.set("cart", cartItemsString);
    this.router.navigate(["/checkout-new"]);
    console.log("Item in cart: ", this.appService.cartProducts.results)

} else if (resp.success === 0) {
  if (resp.message) {
  }
} else if (resp.message && resp.status_code !== 200) {
} else {
}
}
},
(err) => {
if (err.error.statusCode === 403) {
} else if (err.error.error.message) {
} else {
}
}
);
      }
    }
   
  }

  buyNowBaby() {
    let maxorderedquantity=this.appService.cartProducts.results.reduce((partialSum, a) => partialSum + a.quantity, 0)
    if(maxorderedquantity>=Number(this.localService.get('max_cart_qty')))
    {
      this.alertService.error("Maximum allowed quantity is " + this.localService.get('max_cart_qty') + " only", this.options)
          return false;
    } else {
      let tempArray = this.appService.cartProducts.results;
      let cartQty = 0;
  
      tempArray.forEach((item) => {
        cartQty += item.quantity;
      });
  
      if (this.showSize) {
        if(this.config.title!=="Deera" && this.config.title!=="Babys Pride" && this.config.title!=="LushNGreen" && this.config.title!=="KatbookStore" && this.config.title!=="Taazah" && this.config.title!=="HOB" && this.config.title!=="PaulCaroline" && this.config.title !=='Srimaware'){
          if (this.newProductDetails.hasOwnProperty("variant")) {
            let cartdetails = this.sizeVariable;
            cartdetails.brand = { name: "" };
            cartdetails.categories = [];
            cartdetails.assets = this.newProductDetails.assets;
            cartdetails.name =
              this.newProductDetails.name + " - " + this.sizeVariable.option;
            cartdetails.parentcategories = this.newProductDetails.parentcategories;
            this.cartService.addToCart(cartdetails);
            this.addCart = true;
            // for (let i = 0; i < this.appService.cartProducts.results.length; i++) {
            //   this.cartData.push(this.appService.cartProducts.results[i].product_id);
            // } 
          
        
        }   else {
          this.cartService.addToCart(this.newProductDetails);
        }

        } else if(this.config.title==="Deera"  && this.product.product_type == "Simple"){
          this.cartService.addToCart(this.newProductDetails);
        }
    
      } else {
        this.cartService.addToCart(this.newProductDetails);
      }
      if((this.config.title==="Babys Pride" || this.config.title==="LushNGreen" || this.config.title==="KatbookStore" || this.config.title==="Taazah" || this.config.title==="HOB" || this.config.title==="PaulCaroline" || this.config.title=='Srimaware')  && this.product.product_type == "Variable"){
        console.log("ffffffffffffffffffffffffff")
        this.product.variant.option_values.forEach((element, index) => {
          if (element.is_default === true) {
             this.baby_variant_price = element.pricing.raw.price;
            this.baby_variant_id = element.id
          }
        });
      }
      // if (ORG_DETAILS.NAME === "KatbookStore") {
      //   let cartItemsString = JSON.stringify(
      //     this.appService.cartProducts.results
      //   );
      //   console.log("Item in cart: ", this.appService.cartProducts.results)
      //   this.localService.set("cart", cartItemsString);
      //   this.router.navigate(["/checkout-new"]);
      //   window.scrollTo(0,0);
      //   console.log("Item in cart: ", this.appService.cartProducts.results)
      // }
      // else{

      // }
  // if((this.config.title==="Deera" || this.config.title==="Babys Pride" )  && this.product.product_type == "Variable"){
  //       this.product.variant.option_values.forEach((element, index) => {
  //         if (element.is_default === true) {
  //            this.deera_variant_price = element.pricing.raw.price;
  //           this.deera_variant_id = element.id
  //         }
  //       });
        
  //     }
  //  if(this.config.title==="LushNGreen"){
  //   console.log("In1",this.product.variant.option_values)
  //       for(let i=0;this.product.variant.option_values.length >= 0; i++) {
  //         console.log("In2")
  //         for( let j=0; this.product.variant.option_values[i].child.length >=0; j++){
  //           console.log("In3",i)
  //           console.log("In3",j)
  //           if(this.product.variant.option_values[i].child[j].is_default){
  //           if (this.product.variant.option_values[i].child[j].is_default === true) {
  //             console.log("In4")
  //             this.deera_variant_price = this.product.variant.option_values[i].child[j].pricing.raw.price;
  //             console.log("llldkksl",this.deera_variant_price)
  //            this.deera_variant_id = this.product.variant.option_values[i].child[j].id
  //            console.log("trysdergh",this.deera_variant_id)

  //          }
  //         }
  //         break;
  //         }
  //         break;
  //       };
  //      }
      // item.pricing.raw.price=this.priceOfVariant
      if((this.config.title==="Deera" || this.config.title === "Babys Pride" || this.config.title==="LushNGreen" || this.config.title==="KatbookStore" || this.config.title==="Taazah" || this.config.title==="HOB" || this.config.title==="PaulCaroline" || this.config.title=='Srimaware') && this.product.product_type == "Variable"){
        console.log("this.baby_variant_id"+this.baby_variant_id)
        let requestData = {
          "domain_name": ORG_DETAILS.DOMAIN_NAME,
          "user_id": ORG_DETAILS.USER_ID,
          "extras": {
            "find": {
              "id": Number(this.baby_variant_id)
            },
            "pagination": false,
            "paginationDetails": {
              "limit": 0,
              "pageSize": 2
            },
            "sorting": true,
            "sortingDetails": {
              "sortfield": "", "sortorder": 1
            }
          }
        }
        this.checkoutApiService.checkoutAPICall(ENDPOINTS.PRODUCT_DETAILS, requestData).then(
          respData => {
            let res: any = respData;
            if (res.success) {
              
              var data = res.data[0];
              this.deera_price_data = data;
              console.log("this.deera_price_data", this.deera_price_data)
              this.cartService.addToCart(data);
              this.addCart = true;
              for (let i = 0; i < this.appService.cartProducts.results.length; i++) {
                this.cartData.push(this.appService.cartProducts.results[i].product_id);
              }
              
              if ((ORG_DETAILS.NAME === "Babys Pride" || ORG_DETAILS.NAME ==="LushNGreen"|| this.config.title==="KatbookStore" || this.config.title==="Taazah" || this.config.title==="HOB" || this.config.title==="PaulCaroline" || this.config.title=='Srimaware') && this.product.product_type == "Variable") {
                let tempArray = this.appService.cartProducts.results;
                let obj = {
                  domain_name: ORG_DETAILS.DOMAIN_NAME,
                  user_id: ORG_DETAILS.USER_ID,
                  extras: {
                    find: {
                      product_id: Number(this.baby_variant_id),
                      product_cost: Number(this.baby_variant_price),
                      quantity: 1,
                    },
                  },
                };
                try {
                  this.appService
                    .postApiCall(obj, ENDPOINTS.QUANTITY_PROMOTION)
                    .subscribe(
                      (resp) => {
                        console.log("POST API CALL RESPONSE: ", resp);
                        console.log("APP service: ", this.appService);
                        if (resp) {
                          console.log("ADD TO CART: ", resp)
                          if (resp.success === 1 && resp.status_code === 200) {
                            for (
                              let j = 0;
                              j < this.appService.cartProducts.results.length;
                              j++
                            ) {
                              if (
                                this.appService.cartProducts.results[j].product_id ===
                                this.deera_variant_id
                              ) {
                                console.log("VALID ENTRY?")
                                this.appService.cartProducts.results[j].product.discount_value =
                                  resp.result.data.discount_applied_to_product_value;
                                ;
                                this.appService.cartProducts.results[j].product.per_quantity_amount = resp.result.data.per_quantity_amount;
                                this.appService.cartProducts.results[j].product.discount_amount =
                                  Number(resp.result.data.discount_amount);
                                this.appService.cartProducts.results[j].product.fixed_amount =
                                  Number(resp.result.data.fixed_amount);
                                this.appService.cartProducts.results[
                                  j
                                ].product.discount_percentage = Number(
                                  resp.result.data.discount_percentage
                                );
                                this.congratulationBanner =
                                  resp.result.data.congratulations_banner_message;
                                //   this.congratulationBanner.forEach((element, index) => {
                                //     this.congratulationBanner1 = element
                                // });
                                this.upsellBanner =
                                  resp.result.data.upsell_banner_message;
                                this.percentageValue = Number(
                                  resp.result.data.discount_percentage
                                );
                                this.fixedAmount = Number(resp.result.data.fixed_amount);
                                this.discountValue = Number(
                                  resp.result.data.discount_applied_to_product_value
                                );
                                this.promotionType = resp.result.data.promotion_type;
                                this.promotionType.forEach((element, index) => {
                                  if (element === 'Product discount') {
                                    this.productPromotion = 'Product discount'
                                  }
                                  if (element === 'Quantity discount') {
                                    this.quantityPromotion = 'Quantity discount'
                                  }
                                });
                                this.productQuantity = Number(
                                  this.appService.cartProducts.results[j].quantity
                                );
                                this.productQuantity1 = true;
                                if (resp.result.data.discount_percentage > 0) {
                                  this.appService.cartProducts.results[j][
                                    "fixed_amount"
                                  ] = resp.result.data.discount_amount;
                                } else {
                                  this.appService.cartProducts.results[j][
                                    "fixed_amount"
                                  ] = resp.result.data.fixed_amount;
                                }
                                this.appService.cartProducts.results[j][
                                  "discount_percentage"
                                ] = resp.result.data.discount_percentage;
                                this.congratulationBanner = resp.result.data.congratulations_banner_message;
                                //   this.congratulationBanner.forEach((element, index) => {
                                //     this.congratulationBanner1 = element
                                // });
                                // this.upsellBanner = resp.result.data.upsell_banner_message;
                                this.percentageValue = Number(resp.result.data.discount_percentage);
                                this.fixedAmount = Number(resp.result.data.fixed_amount);
                                this.discountValue = Number(resp.result.data.discount_applied_to_product_value);
                                this.promotionType = resp.result.data.promotion_type;
                                this.promotionType.forEach((element, index) => {
                                  if (element === 'Product discount') {
                                    this.productPromotion = 'Product discount'
                                  }
                                  if (element === 'Quantity discount') {
                                    this.quantityPromotion = 'Quantity discount'
                                  }
                                });
                                this.productQuantity = Number(this.appService.cartProducts.results[j].quantity);
                                this.productQuantity1 = true;
                                if (resp.result.data.discount_percentage > 0) {
                                  this.appService.cartProducts.results[j]['fixed_amount'] = resp.result.data.discount_amount;
                                }
                                else {
                                  this.appService.cartProducts.results[j]['fixed_amount'] = resp.result.data.fixed_amount;
                                }
                                try {
                                  this.cartService.updateCartItem(
                                    this.appService.cartProducts.results
                                  );
                                } catch (err) {
                                  console.log("Error in updating cart item")
                                }
                              }
                            }
                            if (ORG_DETAILS.NAME === "Deera" || ORG_DETAILS.NAME === "Babys Pride" || ORG_DETAILS.NAME === "LushNGreen" ||ORG_DETAILS.NAME === "Vistas" ||ORG_DETAILS.NAME === "KatbookStore" || this.config.title==="Taazah"  || this.config.title==="HOB" || this.config.title==="PaulCaroline" || this.config.title=='Srimaware') {
                              let cartItemsString = JSON.stringify(
                                this.appService.cartProducts.results
                              );
                              console.log("Item in cart: ", this.appService.cartProducts.results)
                              this.localService.set("cart", cartItemsString);
                              this.router.navigate(["/checkout-new"]);
                              console.log("Item in cart: ", this.appService.cartProducts.results)
                            }
                          } else if (resp.success === 0) {
                            if (resp.message) {
                            }
                          } else if (resp.message && resp.status_code !== 200) {
                          } else {
                          }
                        }
                      },
                      (err) => {
                        if (err.error.statusCode === 403) {
                        } else if (err.error.error.message) {
                        } else {
                        }
                      }
                    );
                } catch (err) {
                  console.log("ERROR: Adding to cart API call failed");
                }
              }
            }
      } )}
      this.addCart = true;
      for (let i = 0; i < this.appService.cartProducts.results.length; i++) {
        this.cartData.push(this.appService.cartProducts.results[i].product_id);
      }
      if (ORG_DETAILS.NAME === "Deera" && this.product.product_type == "Simple") {
        let tempArray = this.appService.cartProducts.results;
        let obj = {
          domain_name: ORG_DETAILS.DOMAIN_NAME,
          user_id: ORG_DETAILS.USER_ID,
          extras: {
            find: {
              product_id: Number(this.newProductDetails.id),
              product_cost: Number(this.newProductDetails.pricing.raw.cost),
              quantity: 1,
            },
          },
        };
        try {
          this.appService
            .postApiCall(obj, ENDPOINTS.QUANTITY_PROMOTION)
            .subscribe(
              (resp) => {
                console.log("POST API CALL RESPONSE: ", resp);
                console.log("APP service: ", this.appService);
                if (resp) {
                  console.log("ADD TO CART: ", resp)
                  if (resp.success === 1 && resp.status_code === 200) {
                    for (
                      let j = 0;
                      j < this.appService.cartProducts.results.length;
                      j++
                    ) {
                      if (
                        this.appService.cartProducts.results[j].product_id ===
                        this.newProductDetails.id
                      ) {
                        console.log("VALID ENTRY?")
                        this.appService.cartProducts.results[j].product.discount_value =
                          resp.result.data.discount_applied_to_product_value;
                        ;
                        this.appService.cartProducts.results[j].product.per_quantity_amount = resp.result.data.per_quantity_amount;
                        this.appService.cartProducts.results[j].product.discount_amount =
                          Number(resp.result.data.discount_amount);
                        this.appService.cartProducts.results[j].product.fixed_amount =
                          Number(resp.result.data.fixed_amount);
                        this.appService.cartProducts.results[
                          j
                        ].product.discount_percentage = Number(
                          resp.result.data.discount_percentage
                        );
                        this.congratulationBanner =
                          resp.result.data.congratulations_banner_message;
                        //   this.congratulationBanner.forEach((element, index) => {
                        //     this.congratulationBanner1 = element
                        // });
                        this.upsellBanner =
                          resp.result.data.upsell_banner_message;
                        this.percentageValue = Number(
                          resp.result.data.discount_percentage
                        );
                        this.fixedAmount = Number(resp.result.data.fixed_amount);
                        this.discountValue = Number(
                          resp.result.data.discount_applied_to_product_value
                        );
                        this.promotionType = resp.result.data.promotion_type;
                        this.promotionType.forEach((element, index) => {
                          if (element === 'Product discount') {
                            this.productPromotion = 'Product discount'
                          }
                          if (element === 'Quantity discount') {
                            this.quantityPromotion = 'Quantity discount'
                          }
                        });
                        this.productQuantity = Number(
                          this.appService.cartProducts.results[j].quantity
                        );
                        this.productQuantity1 = true;
                        if (resp.result.data.discount_percentage > 0) {
                          this.appService.cartProducts.results[j][
                            "fixed_amount"
                          ] = resp.result.data.discount_amount;
                        } else {
                          this.appService.cartProducts.results[j][
                            "fixed_amount"
                          ] = resp.result.data.fixed_amount;
                        }
                        this.appService.cartProducts.results[j][
                          "discount_percentage"
                        ] = resp.result.data.discount_percentage;
                        try {
                          this.cartService.updateCartItem(
                            this.appService.cartProducts.results
                          );
                        } catch (err) {
                          console.log("Error in updating cart item")
                        }
                      }
                    }
                    if (ORG_DETAILS.NAME === "Deera" || ORG_DETAILS.NAME === "Babys Pride" || ORG_DETAILS.NAME === "LushNGreen"||ORG_DETAILS.NAME === "Vistas"||ORG_DETAILS.NAME === "KatbookStore" || this.config.title==="Taazah"  || this.config.title==="HOB" || this.config.title==="PaulCaroline" || this.config.title=='Srimaware') {
                      let cartItemsString = JSON.stringify(
                        this.appService.cartProducts.results
                      );
                      console.log("Item in cart: ", this.appService.cartProducts.results)
                      this.localService.set("cart", cartItemsString);
                      this.router.navigate(["/checkout-new"]);
                      console.log("Item in cart: ", this.appService.cartProducts.results)
                    }
                  } else if (resp.success === 0) {
                    if (resp.message) {
                    }
                  } else if (resp.message && resp.status_code !== 200) {
                  } else {
                  }
                }
              },
              (err) => {
                if (err.error.statusCode === 403) {
                } else if (err.error.error.message) {
                } else {
                }
              }
            );
        } catch (err) {
          console.log("ERROR: Adding to cart API call failed");
        }
      }

    }
   
  }

  buyNow1() {
    if (ORG_DETAILS.NAME === "Deera" || ORG_DETAILS.NAME === "Babys Pride" || ORG_DETAILS.NAME === "LushNGreen" || ORG_DETAILS.NAME === "BestGifts" || ORG_DETAILS.NAME === "Vistas" || ORG_DETAILS.NAME === "Schift Cosmetics" || this.config.title==="Taazah") {
      this.router.navigate(["/checkout-new"]);
    }
  }
  buyNow2(){
    let tempArray = this.appService.cartProducts.results;
    let cartQty = 0;
    let userId = this.localService.get('UserId');
    tempArray.forEach((item) => {
      cartQty += item.quantity;
    });
    if (ORG_DETAILS.NAME === "Schift Cosmetics") {
      let userId = this.localService.get('UserId');
      let obj =
      {
        domain_name: ORG_DETAILS.DOMAIN_NAME,
        user_id: ORG_DETAILS.USER_ID,
        extras: {
          find: {
            product_id: Number(this.newProductDetails.id),
            product_cost: Number(this.newProductDetails.pricing.raw.price),
            quantity: 1,
            customer_type:"individual customer",
            customer_id: Number(userId)
          },
        },
      };

    this.appService.postApiCall(obj, ENDPOINTS.STRUCTURED_PROMOTION).subscribe(
      (resp) => {
        if (resp) {
          if (resp.success === 1 && resp.status_code === 200) {
            for (let j = 0; j < this.appService.cartProducts.results.length;j++) {
              if (
                this.appService.cartProducts.results[j].product_id === this.newProductDetails.id
              ) {                      
                  this.appService.cartProducts.results[j]["discount_amount"] =
                    resp.result.data.discount_summary[0].discount_amount;
           
                this.appService.cartProducts.results[j][
                  "after_dicount_price"
                ] = resp.result.data.discount_summary[0].after_dicount_price;
                console.log(
                  "this.appService.cartProducts.results[i].product.fixed_amount" +
                  this.appService.cartProducts.results[j].
                    after_dicount_price
                );
                this.cartService.updateCartItem(
                  this.appService.cartProducts.results
                );
                console.log(
                  "this.appService.cartProducts.results[i].discount_amount" +
                    this.appService.cartProducts.results[j].discount_amount
                );
              }
            }
            if(resp.result.data.additional_discount.length > 0){
              if(resp.result.data.additional_discount[0].offer_type){
  if(resp.result.data.additional_discount[0].offer_type === "Free Product"){
    this.appService.cartProducts.results.forEach((item,i) => {
      console.log("Discount Product id",resp.result.data.additional_discount[0].product_id)
      console.log("Product added in cart",item.product_id)
      if( resp.result.data.additional_discount[0].product_id === item.product_id){
        console.log("testtt" + item.product_id)
        item.product['free_product_name'] = resp.result.data.additional_discount[0].free_product_name
        item.product['free_product_id'] = resp.result.data.additional_discount[0].free_product_id
        item.product['free_qty'] = resp.result.data.additional_discount[0].free_qty
      }
  })
  this.cartService.updateCartItem(this.appService.cartProducts.results); 
}     
  }
}
  //           let cartItemsString = JSON.stringify(
  //             this.appService.cartProducts.results
  //           );
  //           this.localService.set("cart", cartItemsString);
  //         } else if (resp.success === 0) {
  //           if (resp.message) {
  //           }
  //         } else if (resp.message && resp.status_code !== 200) {
  //         } else {
  //         }
  //       }
  //     },
  //     (err) => {
  //       if (err.error.statusCode === 403) {
  //       } else if (err.error.error.message) {
  //       } else {
  //       }
  //     }
  //   );
  //     }

  //             if (ORG_DETAILS.NAME === "Vistas") {
  //               let cartItemsString = JSON.stringify(
  //                 this.appService.cartProducts.results
  //               );
  //               console.log("Item in cart: ", this.appService.cartProducts.results)
  //               this.localService.set("cart", cartItemsString);
  //               this.router.navigate(["/checkout-new"]);
  //               console.log("Item in cart: ", this.appService.cartProducts.results)
                
  //             }
           
  // }
  if (ORG_DETAILS.NAME === "Schift Cosmetics") {
    let cartItemsString = JSON.stringify(
      this.appService.cartProducts.results
    );
    console.log("Item in cart: ", this.appService.cartProducts.results)
    this.localService.set("cart", cartItemsString);
    this.router.navigate(["/checkout-new"]);
    console.log("Item in cart: ", this.appService.cartProducts.results)
  }
} else if (resp.success === 0) {
  if (resp.message) {
  }
} else if (resp.message && resp.status_code !== 200) {
} else {
}
}
},
(err) => {
if (err.error.statusCode === 403) {
} else if (err.error.error.message) {
} else {
}
}
);
}
    if (this.showSize) {
      if (this.newProductDetails.hasOwnProperty("variant")) {
        // item.pricing.raw.price=this.priceOfVariant
        let cartdetails = this.sizeVariable;
        cartdetails.brand = { name: "" };
        cartdetails.categories = [];
        cartdetails.assets = this.newProductDetails.assets;
        cartdetails.name =
          this.newProductDetails.name + " - " + this.sizeVariable.option;
        cartdetails.parentcategories = this.newProductDetails.parentcategories;
        this.cartService.addToCart(cartdetails);
      } else {
        this.cartService.addToCart(this.newProductDetails);
        // {
        //   var today = moment();
        //   this.showAlerts = true;
        //   console.log("Acceptance timings", this.acceptanceTiming)
        //   var timeAvailable :boolean ;
      
        //   if(this.acceptanceTiming && this.acceptanceTiming.length === 0)
        //   {
        //     this.router.navigate(['/checkout-new'])
        //     return
        //   }
        //   if(timeAvailable === true)
        //   {
        //     this.router.navigate(['/checkout-new'])
        //   }
        //   else
        //   {
        //     // this.alertService.error('Restaurant opening soon',this.options)
        //     this.alertService.error('Currently orders are not being accepted!!! We are open from (11:30 AM to 3:30 PM and 6:30 PM to 10:00 PM) for taking orders',this.options)
        //   }
      
        // }
      }
    } else {
      this.cartService.addToCart(this.newProductDetails);
     
    }
    this.addCart = true;
    for (let i = 0; i < this.appService.cartProducts.results.length; i++) {
      this.cartData.push(this.appService.cartProducts.results[i].product_id);
    }
    if ( ORG_DETAILS.NAME === "ShubhCards" || ORG_DETAILS.NAME === "SriSenbaga") {
      this.router.navigate(["/checkout-new"]);
    }
    
    if (ORG_DETAILS.NAME === "Vistas") {
      let userId = this.localService.get('UserId');
      let obj =
      {
        domain_name: ORG_DETAILS.DOMAIN_NAME,
        user_id: ORG_DETAILS.USER_ID,
        extras: {
          find: {
            product_id: Number(this.newProductDetails.id),
            product_cost: Number(this.newProductDetails.pricing.raw.price),
            quantity: 1,
            customer_id: Number(userId)
          },
        },
      };

    this.appService.postApiCall(obj, ENDPOINTS.STRUCTURED_PROMOTION).subscribe(
      (resp) => {
        if (resp) {
          if (resp.success === 1 && resp.status_code === 200) {
            for (let j = 0; j < this.appService.cartProducts.results.length;j++) {
              if (
                this.appService.cartProducts.results[j].product_id === this.newProductDetails.id
              ) {                      
                  this.appService.cartProducts.results[j]["discount_amount"] =
                    resp.result.data.discount_summary[0].discount_amount;
           
                this.appService.cartProducts.results[j][
                  "after_dicount_price"
                ] = resp.result.data.discount_summary[0].after_dicount_price;
                console.log(
                  "this.appService.cartProducts.results[i].product.fixed_amount" +
                  this.appService.cartProducts.results[j].
                    after_dicount_price
                );
                this.cartService.updateCartItem(
                  this.appService.cartProducts.results
                );
                console.log(
                  "this.appService.cartProducts.results[i].discount_amount" +
                    this.appService.cartProducts.results[j].discount_amount
                );
              }
            }
  //           let cartItemsString = JSON.stringify(
  //             this.appService.cartProducts.results
  //           );
  //           this.localService.set("cart", cartItemsString);
  //         } else if (resp.success === 0) {
  //           if (resp.message) {
  //           }
  //         } else if (resp.message && resp.status_code !== 200) {
  //         } else {
  //         }
  //       }
  //     },
  //     (err) => {
  //       if (err.error.statusCode === 403) {
  //       } else if (err.error.error.message) {
  //       } else {
  //       }
  //     }
  //   );
  //     }

  //             if (ORG_DETAILS.NAME === "Vistas") {
  //               let cartItemsString = JSON.stringify(
  //                 this.appService.cartProducts.results
  //               );
  //               console.log("Item in cart: ", this.appService.cartProducts.results)
  //               this.localService.set("cart", cartItemsString);
  //               this.router.navigate(["/checkout-new"]);
  //               console.log("Item in cart: ", this.appService.cartProducts.results)
                
  //             }
           
  // }
  if (ORG_DETAILS.NAME === "Vistas") {
    let cartItemsString = JSON.stringify(
      this.appService.cartProducts.results
    );
    console.log("Item in cart: ", this.appService.cartProducts.results)
    this.localService.set("cart", cartItemsString);
    this.router.navigate(["/checkout-new"]);
    console.log("Item in cart: ", this.appService.cartProducts.results)
  }
} else if (resp.success === 0) {
  if (resp.message) {
  }
} else if (resp.message && resp.status_code !== 200) {
} else {
}
}
},
(err) => {
if (err.error.statusCode === 403) {
} else if (err.error.error.message) {
} else {
}
}
);
}
}
buyNowLush(item) {
  let maxorderedquantity=this.appService.cartProducts.results.reduce((partialSum, a) => partialSum + a.quantity, 0)
  if(maxorderedquantity>=Number(this.localService.get('max_cart_qty')))
  {
    this.alertService.error("Maximum allowed quantity is " + this.localService.get('max_cart_qty') + " only", this.options)
        return false;
  } else {
    let tempArray = this.appService.cartProducts.results;
    let cartQty = 0;

    tempArray.forEach((item) => {
      cartQty += item.quantity;
    });

   
      // this.cartService.addToCart(this.newProductDetails);

  // console.log("In1",this.product.variant.option_values)
  //     for(let i=0;this.product.variant.option_values.length >= 0; i++) {
  //       console.log("In2")
  //       for( let j=0; this.product.variant.option_values[i].child.length >=0; j++){
  //         console.log("In3",i)
  //         console.log("In3",j)
  //         if(this.product.variant.option_values[i].child[j].is_default){
  //         if (this.product.variant.option_values[i].child[j].is_default === true) {
  //           console.log("In4")
  //           this.deera_variant_price = this.product.variant.option_values[i].child[j].pricing.raw.price;
  //           console.log("llldkksl",this.deera_variant_price)
  //          this.deera_variant_id = this.product.variant.option_values[i].child[j].id
  //          console.log("trysdergh",this.deera_variant_id)

  //        }
  //       }
  //       break;
  //       }
  //       break;
  //     };

    if(this.product.product_type == "Variable"){
      let requestData = {
        "domain_name": ORG_DETAILS.DOMAIN_NAME,
        "user_id": ORG_DETAILS.USER_ID,
        "extras": {
          "find": {
            "id": Number(item)
          },
          "pagination": false,
          "paginationDetails": {
            "limit": 0,
            "pageSize": 2
          },
          "sorting": true,
          "sortingDetails": {
            "sortfield": "", "sortorder": 1
          }
        }
      }
      this.checkoutApiService.checkoutAPICall(ENDPOINTS.PRODUCT_DETAILS, requestData).then(
        respData => {
          let res: any = respData;
          if (res.success) {
            
            var data = res.data[0];
            this.deera_price_data = data;
            console.log("this.deera_price_data", this.deera_price_data)
            this.cartService.addToCart(data);
            this.addCart = true;
            for (let i = 0; i < this.appService.cartProducts.results.length; i++) {
              this.cartData.push(this.appService.cartProducts.results[i].product_id);
            }
            if(this.config.title !== 'PaulCaroline'){
              if (this.product.product_type == "Variable") {
                let tempArray = this.appService.cartProducts.results;
                let obj = {
                  domain_name: ORG_DETAILS.DOMAIN_NAME,
                  user_id: ORG_DETAILS.USER_ID,
                  extras: {
                    find: {
                      product_id: Number(this.deera_variant_id),
                      product_cost: Number(this.deera_variant_price),
                      quantity: 1,
                    },
                  },
                };
                try {
                  this.appService
                    .postApiCall(obj, ENDPOINTS.QUANTITY_PROMOTION)
                    .subscribe(
                      (resp) => {
                        console.log("POST API CALL RESPONSE: ", resp);
                        console.log("APP service: ", this.appService);
                        if (resp) {
                          console.log("ADD TO CART: ", resp)
                          if (resp.success === 1 && resp.status_code === 200) {
                            for (
                              let j = 0;
                              j < this.appService.cartProducts.results.length;
                              j++
                            ) {
                              if (
                                this.appService.cartProducts.results[j].product_id ===
                                this.deera_variant_id
                              ) {
                                console.log("VALID ENTRY?")
                                this.appService.cartProducts.results[j].product.discount_value =
                                  resp.result.data.discount_applied_to_product_value;
                                ;
                                this.appService.cartProducts.results[j].product.per_quantity_amount = resp.result.data.per_quantity_amount;
                                this.appService.cartProducts.results[j].product.discount_amount =
                                  Number(resp.result.data.discount_amount);
                                this.appService.cartProducts.results[j].product.fixed_amount =
                                  Number(resp.result.data.fixed_amount);
                                this.appService.cartProducts.results[
                                  j
                                ].product.discount_percentage = Number(
                                  resp.result.data.discount_percentage
                                );
                                this.congratulationBanner =
                                  resp.result.data.congratulations_banner_message;
                                //   this.congratulationBanner.forEach((element, index) => {
                                //     this.congratulationBanner1 = element
                                // });
                                this.upsellBanner =
                                  resp.result.data.upsell_banner_message;
                                this.percentageValue = Number(
                                  resp.result.data.discount_percentage
                                );
                                this.fixedAmount = Number(resp.result.data.fixed_amount);
                                this.discountValue = Number(
                                  resp.result.data.discount_applied_to_product_value
                                );
                                this.promotionType = resp.result.data.promotion_type;
                                this.promotionType.forEach((element, index) => {
                                  if (element === 'Product discount') {
                                    this.productPromotion = 'Product discount'
                                  }
                                  if (element === 'Quantity discount') {
                                    this.quantityPromotion = 'Quantity discount'
                                  }
                                });
                                this.productQuantity = Number(
                                  this.appService.cartProducts.results[j].quantity
                                );
                                this.productQuantity1 = true;
                                if (resp.result.data.discount_percentage > 0) {
                                  this.appService.cartProducts.results[j][
                                    "fixed_amount"
                                  ] = resp.result.data.discount_amount;
                                } else {
                                  this.appService.cartProducts.results[j][
                                    "fixed_amount"
                                  ] = resp.result.data.fixed_amount;
                                }
                                this.appService.cartProducts.results[j][
                                  "discount_percentage"
                                ] = resp.result.data.discount_percentage;
                                this.congratulationBanner = resp.result.data.congratulations_banner_message;
                                //   this.congratulationBanner.forEach((element, index) => {
                                //     this.congratulationBanner1 = element
                                // });
                                // this.upsellBanner = resp.result.data.upsell_banner_message;
                                this.percentageValue = Number(resp.result.data.discount_percentage);
                                this.fixedAmount = Number(resp.result.data.fixed_amount);
                                this.discountValue = Number(resp.result.data.discount_applied_to_product_value);
                                this.promotionType = resp.result.data.promotion_type;
                                this.promotionType.forEach((element, index) => {
                                  if (element === 'Product discount') {
                                    this.productPromotion = 'Product discount'
                                  }
                                  if (element === 'Quantity discount') {
                                    this.quantityPromotion = 'Quantity discount'
                                  }
                                });
                                this.productQuantity = Number(this.appService.cartProducts.results[j].quantity);
                                this.productQuantity1 = true;
                                if (resp.result.data.discount_percentage > 0) {
                                  this.appService.cartProducts.results[j]['fixed_amount'] = resp.result.data.discount_amount;
                                }
                                else {
                                  this.appService.cartProducts.results[j]['fixed_amount'] = resp.result.data.fixed_amount;
                                }
                                try {
                                  this.cartService.updateCartItem(
                                    this.appService.cartProducts.results
                                  );
                                } catch (err) {
                                  console.log("Error in updating cart item")
                                }
                              }
                            }
                              let cartItemsString = JSON.stringify(
                                this.appService.cartProducts.results
                              );
                              console.log("Item in cart: ", this.appService.cartProducts.results)
                              this.localService.set("cart", cartItemsString);
                              this.router.navigate(["/checkout-new"]);
                              console.log("Item in cart: ", this.appService.cartProducts.results)
                          } else if (resp.success === 0) {
                            if (resp.message) {
                            }
                          } else if (resp.message && resp.status_code !== 200) {
                          } else {
                          }
                        }
                      },
                      (err) => {
                        if (err.error.statusCode === 403) {
                        } else if (err.error.error.message) {
                        } else {
                        }
                      }
                    );
                } catch (err) {
                  console.log("ERROR: Adding to cart API call failed");
                }
              }
            } else if(this.config.title == 'PaulCaroline'){
              if(this.product.product_type == "Variable"){
                  
          let obj =
          {
            domain_name: ORG_DETAILS.DOMAIN_NAME,
            user_id: ORG_DETAILS.USER_ID,
            extras: {
              find: {
                product_id: Number(data.id),
                product_cost: Number(data.pricing.raw.price),
                quantity: 1,
              },
            },
          };

        this.appService.postApiCall(obj, ENDPOINTS.STRUCTURED_PROMOTION).subscribe(
          (resp) => {
            if (resp) {
              if (resp.success === 1 && resp.status_code === 200) {
                for (let j = 0; j < this.appService.cartProducts.results.length;j++) {
                  if (
                    this.appService.cartProducts.results[j].product_id === data.id
                  ) {                      
                      this.appService.cartProducts.results[j]["discount_amount"] =
                        resp.result.data.discount_summary[0].discount_amount;
               
                    this.appService.cartProducts.results[j][
                      "after_dicount_price"
                    ] = resp.result.data.discount_summary[0].after_dicount_price;
                    console.log(
                      "this.appService.cartProducts.results[i].product.fixed_amount" +
                      this.appService.cartProducts.results[j].
                        after_dicount_price
                    );
                    this.cartService.updateCartItem(
                      this.appService.cartProducts.results
                    );
                    console.log(
                      "this.appService.cartProducts.results[i].product.fixed_amount" +
                        this.appService.cartProducts.results[j].discount_amount
                    );
                  }
                }
                let cartItemsString = JSON.stringify(
                  this.appService.cartProducts.results
                );
                this.localService.set("cart", cartItemsString);
                this.router.navigate(["/checkout-new"]);
                console.log("Item in cart: ", this.appService.cartProducts.results)
              } else if (resp.success === 0) {
                if (resp.message) {
                }
              } else if (resp.message && resp.status_code !== 200) {
              } else {
              }
            }
          },
          (err) => {
            if (err.error.statusCode === 403) {
            } else if (err.error.error.message) {
            } else {
            }
          }
        );
              }
            }
    
          }
    } )}
    
    this.addCart = true;
    for (let i = 0; i < this.appService.cartProducts.results.length; i++) {
      this.cartData.push(this.appService.cartProducts.results[i].product_id);
    }

  }
 
}
  productDetails(id?: number, categoryPath?: string, uniqueName?: string){
    if(this.config.title === 'Vistas'){
      this.router.navigate(['/product-details',id], { relativeTo:this.route,  skipLocationChange: false })
      
        // this.getProductDetails(id)
        let requestBody = {
          domain_name: ORG_DETAILS.DOMAIN_NAME,
          user_id: ORG_DETAILS.USER_ID,
          extras: {
            find: {
              id: Number(id),
            },
            pagination: false,
            paginationDetails: {
              limit: 0,
              pageSize: 2,
            },
            sorting: true,
            sortingDetails: {
              sortfield: "",
              sortorder: 1,
            },
          },
        };
        this.getProductDetailsById(requestBody);
       
        window.scrollTo(0,0);
        // location.reload();
    }
    else if(this.config.title === 'Babys Pride'){
      this.router.navigate(['/product-details',id], { relativeTo:this.route,  skipLocationChange: false })
      
        // this.getProductDetails(id)
        let requestBody = {
          domain_name: ORG_DETAILS.DOMAIN_NAME,
          user_id: ORG_DETAILS.USER_ID,
          extras: {
            find: {
              id: Number(id),
            },
            pagination: false,
            paginationDetails: {
              limit: 0,
              pageSize: 2,
            },
            sorting: true,
            sortingDetails: {
              sortfield: "",
              sortorder: 1,
            },
          },
        };
        this.getProductDetails(id)
        this.getProductDetailsById(requestBody);
       
        window.scrollTo(0,0);
        // location.reload();
    }
    else if(this.config.title === 'KatbookStore'){
      this.router.navigate(['/product-details',id], { relativeTo:this.route,  skipLocationChange: false })
      
        // this.getProductDetails(id)
        let requestBody = {
          domain_name: ORG_DETAILS.DOMAIN_NAME,
          user_id: ORG_DETAILS.USER_ID,
          extras: {
            find: {
              id: Number(id),
            },
            pagination: false,
            paginationDetails: {
              limit: 0,
              pageSize: 2,
            },
            sorting: true,
            sortingDetails: {
              sortfield: "",
              sortorder: 1,
            },
          },
        };
        this.getProductDetails(id)
        this.getProductDetailsById(requestBody);
       
        window.scrollTo(0,0);
        // location.reload();
    }
    else if(this.config.title === 'LushNGreen'){
      categoryPath = categoryPath.replace('/', '');
      categoryPath = categoryPath.replace(/ /g, '-');
      uniqueName = uniqueName.replace(/ /g, '-');
      uniqueName = uniqueName.replace(/\(|\)/g, '');
      console.log("111", categoryPath, uniqueName);
      const params = categoryPath.split('/');
      params.push(uniqueName);

      this.router.navigate(['/product', ...params]);
      
        // this.getProductDetails(id)
        let requestBody = {
          domain_name: ORG_DETAILS.DOMAIN_NAME,
          user_id: ORG_DETAILS.USER_ID,
          extras: {
            find: {
              id: Number(id),
            },
            pagination: false,
            paginationDetails: {
              limit: 0,
              pageSize: 2,
            },
            sorting: true,
            sortingDetails: {
              sortfield: "",
              sortorder: 1,
            },
          },
        };
        this.getProductDetails(id)
        this.getProductDetailsById(requestBody);
       
        window.scrollTo(0,0);
        // location.reload();
    }
    else if(this.config.title === 'Taazah'){
      this.router.navigate(['/product-details',id], { relativeTo:this.route,  skipLocationChange: false })
      
        // this.getProductDetails(id)
        let requestBody = {
          domain_name: ORG_DETAILS.DOMAIN_NAME,
          user_id: ORG_DETAILS.USER_ID,
          extras: {
            find: {
              id: Number(id),
            },
            pagination: false,
            paginationDetails: {
              limit: 0,
              pageSize: 2,
            },
            sorting: true,
            sortingDetails: {
              sortfield: "",
              sortorder: 1,
            },
          },
        };
        this.getProductDetails(id)
        this.getProductDetailsById(requestBody);
       
        window.scrollTo(0,0);
        // location.reload();
    }
    else if(this.config.title === 'HOB' || this.config.title === 'PaulCaroline' || this.config.title=='Srimaware'){
      console.log("Redirection detail")
      categoryPath = categoryPath.replace('/', '');
      categoryPath = categoryPath.replace(/ /g, '-');
      uniqueName = uniqueName.replace(/ /g, '-');
      uniqueName = uniqueName.replace(/\(|\)/g, '');
      console.log("111", categoryPath, uniqueName);
      const params = categoryPath.split('/');
      params.push(uniqueName);
      let requestBody = {
        domain_name: ORG_DETAILS.DOMAIN_NAME,
        user_id: ORG_DETAILS.USER_ID,
        extras: {
          find: {
            id: Number(id),
          },
          pagination: false,
          paginationDetails: {
            limit: 0,
            pageSize: 2,
          },
          sorting: true,
          sortingDetails: {
            sortfield: "",
            sortorder: 1,
          },
        },
      };
      this.getProductDetails(id)
      this.getProductDetailsById(requestBody);
      this.router.navigate(['/product', ...params]);
      
        // this.getProductDetails(id)
      
       
        window.scrollTo(0,0);
        // location.reload();
    }
    else{
      console.log("Redirection detail else")
      this.router.navigate(['/product-details',id], { relativeTo:this.route,  skipLocationChange: false })
      
      this.getProductDetails(id)
      let requestBody = {
        domain_name: ORG_DETAILS.DOMAIN_NAME,
        user_id: ORG_DETAILS.USER_ID,
        extras: {
          find: {
            id: Number(id),
          },
          pagination: false,
          paginationDetails: {
            limit: 0,
            pageSize: 2,
          },
          sorting: true,
          sortingDetails: {
            sortfield: "",
            sortorder: 1,
          },
        },
      };
      this.getProductDetailsById(requestBody);
      window.scrollTo(0,0);

   
  }}
  isValueNaN(value: any): boolean {
    console.log(value,"order summary value")
    
    if(value=='NaN '){
      value=this.current_index


    }
    return isNaN(value);
    
  }
  deleteItemBestGifts(index) {
    delete this.imagelist[index]

  }

  incrementNumberOfProductsForBestGifts() {
    if(Number(this.localService.get('max_cart_qty')) <= this.bestGiftsCalculateCartAndCurrentQuantity()) {
      this.alertService.error('maximum Cart value has been reached!', this.options);
      return
    }
    console.log("before changes: ", this.modelForBindingTextInputs)
    for (let j = 0; j < this.numberOfMaskUploads; j++) {
      this.imagelist['maskImage_' + this.numberOfProductsBestGifts + '_' + j] = ""
    }
    this.numberOfProductsBestGifts += 1;
    console.log("changes: ", this.modelForBindingTextInputs)

  }


  getPromotionBanner() {
    let obj = {
      domain_name: ORG_DETAILS.DOMAIN_NAME,
      user_id: ORG_DETAILS.USER_ID,
      extras: {
        find: {},
      },
    };

    this.appService.postApiCall(obj, ENDPOINTS.PROMOTIONS_BANNER).subscribe(
      (resp) => {
        if (resp) {
          if (resp.success === 1 && resp.status_code === 200) {
            this.banner = resp.result.data[0]["eligible_banner_message"];
            if (this.config.title === "Deera") {
              this.promotionData = resp.result.data;

              this.promotionData.forEach((data) => {
                console.log("this.promotionData" + data.automate_discount_values)
                data.product_discount.amount_or_percentage.product_details.forEach(
                  (data1) => {

                  }
                );
              });
            }
          } else if (resp.success === 0) {
            if (resp.message) {
            }
          } else if (resp.message && resp.status_code !== 200) {
          } else {
          }
        }
      },
      (err) => {
        if (err.error.statusCode === 403) {
        } else if (err.error.error.message) {
        } else {
        }
      }
    );
  }

  calculateTotal() {
    if (this.appService.cartProducts.results.length > 0) {
      this.totalPrice = 0;
      this.appService.cartProducts.results.forEach((obj) => {
        this.totalPrice += obj.cost * obj.quantity;
      });
    } else {
      this.totalPrice = 0;
    }
  }

  closeVideo() {
    var videos = document.querySelectorAll("iframe, video");
    Array.prototype.forEach.call(videos, function (video) {
      if (video.tagName.toLowerCase() === "video") {
        video.pause();
      } else {
        var src = video.src;
        video.src = src;
      }
    });
  }


  saveForm() {
    if (this.enquiryForm.controls.name.value === "") {
      this.validateForm = true;
      // this.enquiryForm.controls['name'].setErrors({'incorrect':true});
    } else if (this.enquiryForm.controls.message.value === "") {

      this.validateForm = true;
    } else if (this.enquiryForm.controls.email.value === "") {

      this.validateForm = true;
    } else if (this.enquiryForm.controls.phone_number.value === "") {

      this.validateForm = true;
    }

    if (this.enquiryForm.valid && (/\S/.test(this.enquiryForm.value.message))) {
      this.validateForm = false;
      var formData = {}
      var formDataJson;
      let session_id = this.localService.get("session_id");



      // let _key = enc.Utf8.parse("@NcRfUjXn2r5u7x!A%D*G-KaPdSgVkYp");
      // let _iv =  enc.Utf8.parse('\x00\x01\x02\x03\x04\x05\x06\x07\x08\x09\x0a\x0b\x0c\x0d\x0e\x0f');
      // let encrypted =AES.encrypt (
      // JSON.stringify({
      //   "domain_name": ORG_DETAILS.DOMAIN_NAME,
      //   "user_id": ORG_DETAILS.USER_ID,
      //   "timestamp": new Date().getTime(),
      //   "payload": {
      //     "order_creation":{  
      //     "name":this.enquiryForm.value.name,
      //     "email":this.enquiryForm.value.email,
      //     "phone_number":this.enquiryForm.value.phone_number,
      //     "category":this.enquiryForm.value.category,
      //     "message":this.enquiryForm.value.message,
      //     "member_id":this.memberId,
      //     "status":"New",
      //     "system_label":"New"
      //   }  
      //   },
      //   "extras": {
      //     "find": {
      //       "id": ""
      //     }
      //   }
      // }), _key, {
      //     iv: _iv,
      //     format: crypto.format.Hex,
      //     mode: crypto.mode.CTR,
      //     padding: crypto.pad.NoPadding
      // }).toString();
      // let requestData = {
      //   payload: encrypted
      // }

      let enquiry = {
        "name": this.enquiryForm.value.name,
        "email": this.enquiryForm.value.email,
        "phone_number": this.enquiryForm.value.phone_number,
        "category": this.enquiryForm.value.category,
        "message": this.enquiryForm.value.message,
        "member_id": this.memberId,
        "customer_id": this.customer_id,
        "status": "New",
        "system_label": "New",
        "companyName": this.companyName,
        "enquiry_status": true,
      }
      let requestData = {
        domain_name: ORG_DETAILS.DOMAIN_NAME,
        user_id: ORG_DETAILS.USER_ID,
        payload: {
          order_creation: enquiry
        },
        extras: {
          find: {
            id: ""
          }
        }
      }

      // let requestData = {
      //   payload: encrypted
      // }
      this.checkoutApiService.checkoutAPICall(ENDPOINTS.ORDER_UPDATION, requestData).then(
        respData => {
          let res: any = respData;
          if (res.success) {
            let OrderId = res.data[0].id;
            this.closeModal.nativeElement.click();
            this.checkoutLocalStorageService.setOrderId({ orderId: OrderId });
            this.alertService.success('Request Submitted', this.options);
            this.enquiryForm.reset({
              name: "",
              email: "",
              phone_number: "",
              category: "",
              message: ""
            })
            
            this.checkoutLocalStorageService.removeOrderId();
            
          }
        }
      )
    }

    if(this.config.title=="Accel"){
      document.getElementById("launch-model-accel").click();
    }

    // formData["name"] = this.enquiryForm.value.name;
    // formData["email"] = this.enquiryForm.value.email;
    // formData["phone_number"] = this.enquiryForm.value.phone_number;
    // formData["category"] = this.enquiryForm.value.category;
    // formData["message"] = this.enquiryForm.value.message;
    // formData["member_id"] = this.memberId;
    // formData['status'] = 'New'
    // formDataJson = {
    //   domain_name: ORG_DETAILS.DOMAIN_NAME,
    //   user_id: ORG_DETAILS.USER_ID,
    //   payload: {
    //     enquiry_creation: formData
    //   }
    // }
    // MAKE A SERVICE CALL HERE...
    // this.appService.postApiCall(formDataJson, ENDPOINTS.ADD_ENQUIRY).subscribe(
    //   resp => {
    //     if (resp) {
    //       if (resp.success === 1 && resp.status_code === 200) {
    //         this.alertService.success('Request Received', this.options);
    //         window.scrollTo({top: 0, behavior: 'smooth'});

    //       }
    //       else if (resp.success === 0) {
    //         if (resp.message) {
    //           this.alertService.error(resp.message, this.options);
    //           window.scrollTo({top: 0, behavior: 'smooth'});
    //         }
    //       }
    //       else if (resp.message && resp.status_code !== 200) {
    //         this.alertService.error(resp.message, this.options);
    //         window.scrollTo({top: 0, behavior: 'smooth'});
    //       }
    //       else {
    //         this.alertService.error('Something bad happened. Please try again!', this.options);
    //         window.scrollTo({top: 0, behavior: 'smooth'});
    //       }
    //     }
    //   },
    //   err => {
    //     if (err.error.statusCode === 403) {
    //       this.alertService.error('Session Time Out! Please login Again', this.options)
    //       this.router.navigate([`/login-new`], { skipLocationChange: false });
    //     }
    //     else if (err.error.message) {
    //       this.alertService.error(err.error.message, this.options)
    //       window.scrollTo({top: 0, behavior: 'smooth'});
    //     }
    //     else if (err.error.error.message) {
    //       this.alertService.error(err.error.error.message, this.options)
    //       window.scrollTo({top: 0, behavior: 'smooth'});
    //     }
    //     else {
    //       this.alertService.error('Something bad happened. Please try again!', this.options);
    //       window.scrollTo({top: 0, behavior: 'smooth'});
    //     }
    //   }
    // )
    //   ;

  }
  saveForm_accel() {
    if (this.enquiryForm.controls.name.value === "") {
      this.validateForm = true;
      // this.enquiryForm.controls['name'].setErrors({'incorrect':true});
    } else if (this.enquiryForm.controls.message.value === "") {

      this.validateForm = true;
    } else if (this.enquiryForm.controls.email.value === "") {

      this.validateForm = true;
    } else if (this.enquiryForm.controls.phone_number.value === "") {

      this.validateForm = true;
    }

    if (this.enquiryForm.valid && (/\S/.test(this.enquiryForm.value.message))) {
      this.validateForm = false;
      var formData = {}
      var formDataJson;
      let session_id = this.localService.get("session_id");



      // let _key = enc.Utf8.parse("@NcRfUjXn2r5u7x!A%D*G-KaPdSgVkYp");
      // let _iv =  enc.Utf8.parse('\x00\x01\x02\x03\x04\x05\x06\x07\x08\x09\x0a\x0b\x0c\x0d\x0e\x0f');
      // let encrypted =AES.encrypt (
      // JSON.stringify({
      //   "domain_name": ORG_DETAILS.DOMAIN_NAME,
      //   "user_id": ORG_DETAILS.USER_ID,
      //   "timestamp": new Date().getTime(),
      //   "payload": {
      //     "order_creation":{  
      //     "name":this.enquiryForm.value.name,
      //     "email":this.enquiryForm.value.email,
      //     "phone_number":this.enquiryForm.value.phone_number,
      //     "category":this.enquiryForm.value.category,
      //     "message":this.enquiryForm.value.message,
      //     "member_id":this.memberId,
      //     "status":"New",
      //     "system_label":"New"
      //   }  
      //   },
      //   "extras": {
      //     "find": {
      //       "id": ""
      //     }
      //   }
      // }), _key, {
      //     iv: _iv,
      //     format: crypto.format.Hex,
      //     mode: crypto.mode.CTR,
      //     padding: crypto.pad.NoPadding
      // }).toString();
      // let requestData = {
      //   payload: encrypted
      // }

      let enquiry = {
        "name": this.enquiryForm.value.name,
        "email": this.enquiryForm.value.email,
        "phone_number": this.enquiryForm.value.phone_number,
        "category": this.enquiryForm.value.category,
        "message": this.enquiryForm.value.message,
        "member_id": this.memberId,
        "customer_id": Number(this.customer_id),
        "status": "New",
        "system_label": "New",
        "companyName": this.companyName,
        "enquiry_status": true,
      }
      let requestData = {
        domain_name: ORG_DETAILS.DOMAIN_NAME,
        user_id: ORG_DETAILS.USER_ID,
        payload: {
          order_creation: enquiry
        },
        extras: {
          find: {
            id: ""
          }
        }
      }

      // let requestData = {
      //   payload: encrypted
      // }
      document.getElementById("launch-model-accel").click();
      this.checkoutApiService.checkoutAPICall(ENDPOINTS.ORDER_UPDATION, requestData).then(
        respData => {
          let res: any = respData;
          if (res.success) {
            let OrderId = res.data[0].id;
            this.closeModal.nativeElement.click();
            this.checkoutLocalStorageService.setOrderId({ orderId: OrderId });
            this.alertService.success('Request Submitted', this.options);
            this.enquiryForm.reset({
              name: "",
              email: "",
              phone_number: "",
              category: "",
              message: ""
            })
            
            this.checkoutLocalStorageService.removeOrderId();
            
          }
        }
      )
    }

   

    // formData["name"] = this.enquiryForm.value.name;
    // formData["email"] = this.enquiryForm.value.email;
    // formData["phone_number"] = this.enquiryForm.value.phone_number;
    // formData["category"] = this.enquiryForm.value.category;
    // formData["message"] = this.enquiryForm.value.message;
    // formData["member_id"] = this.memberId;
    // formData['status'] = 'New'
    // formDataJson = {
    //   domain_name: ORG_DETAILS.DOMAIN_NAME,
    //   user_id: ORG_DETAILS.USER_ID,
    //   payload: {
    //     enquiry_creation: formData
    //   }
    // }
    // MAKE A SERVICE CALL HERE...
    // this.appService.postApiCall(formDataJson, ENDPOINTS.ADD_ENQUIRY).subscribe(
    //   resp => {
    //     if (resp) {
    //       if (resp.success === 1 && resp.status_code === 200) {
    //         this.alertService.success('Request Received', this.options);
    //         window.scrollTo({top: 0, behavior: 'smooth'});

    //       }
    //       else if (resp.success === 0) {
    //         if (resp.message) {
    //           this.alertService.error(resp.message, this.options);
    //           window.scrollTo({top: 0, behavior: 'smooth'});
    //         }
    //       }
    //       else if (resp.message && resp.status_code !== 200) {
    //         this.alertService.error(resp.message, this.options);
    //         window.scrollTo({top: 0, behavior: 'smooth'});
    //       }
    //       else {
    //         this.alertService.error('Something bad happened. Please try again!', this.options);
    //         window.scrollTo({top: 0, behavior: 'smooth'});
    //       }
    //     }
    //   },
    //   err => {
    //     if (err.error.statusCode === 403) {
    //       this.alertService.error('Session Time Out! Please login Again', this.options)
    //       this.router.navigate([`/login-new`], { skipLocationChange: false });
    //     }
    //     else if (err.error.message) {
    //       this.alertService.error(err.error.message, this.options)
    //       window.scrollTo({top: 0, behavior: 'smooth'});
    //     }
    //     else if (err.error.error.message) {
    //       this.alertService.error(err.error.error.message, this.options)
    //       window.scrollTo({top: 0, behavior: 'smooth'});
    //     }
    //     else {
    //       this.alertService.error('Something bad happened. Please try again!', this.options);
    //       window.scrollTo({top: 0, behavior: 'smooth'});
    //     }
    //   }
    // )
    //   ;

  }
  // reviewredirect(){
  //   document.getElementById('nav-Reviews').scrollIntoView();
  //   this.changeTab('Reviews');
  // }
  reviewredirect() {
    if(config.title === "Schift Cosmetics" || config.title === "LushNGreen"){
      //  this.router.navigate([``], { queryParams: { type: 'nav-Reviews' }, relativeTo: this.route, skipLocationChange: false });
 //window.scroll(0,4200)
 // document.getElementById("gallery_sec").scrollIntoView();
 document.getElementById("nav-Reviewstab").scrollIntoView();
 this.changeTab('Reviews');

       }
      }
//   showMenuSection(sectionId) {
 
//  console.log("rsateytqrwytqr")
//  var url1 = document.getElementById("nav-Reviews")
//  if(url1==null){
//    setTimeout(() => {
//      this.delayedFunction();
//      }, 100);

//  }
//  else{
//    document.getElementById("nav-Reviews").scrollIntoView();

//  }

 
  
 
// }
// delayedFunction(){
//  document.getElementById("nav-Reviews").scrollIntoView();


// }
  submitEnquiry(product) {
    console.log("this.memberId"+this.memberId);
    // this.enquiryForm.controls['category'].setValue(this.product.categories[0].categories)
    // document.getElementById('launch-model').click();

    let userId = this.localService.get('UserId');
    console.log("userid", userId)
    let beaubelleUserName = this.appService.userName;
    this.memberId = product.memberId;
    this.companyName = product.name;
    if (userId) {
      this.enquiryForm.reset({ name: "", message: "", })
      if (beaubelleUserName) {
        this.enquiryForm.controls['name'].setValue(beaubelleUserName)
      }
      this.enquiryForm.controls['email'].setValue(this.customerLoginStorageService.getCustomerData().email)
      this.enquiryForm.controls['phone_number'].setValue(this.customerLoginStorageService.getCustomerData().mobileNo)
      this.enquiryForm.controls['category'].setValue(product.categories[0].categories)
      document.getElementById('launch-model').click();

    } else {
      this.router.navigate(['/login-new'], { queryParams: { productId: product.id, }, relativeTo: this.route, skipLocationChange: false })
    }
  }


  submitEnquiry_accel(product) {
    console.log("this.memberId"+this.memberId);
    // this.enquiryForm.controls['category'].setValue(this.product.categories[0].categories)
    // document.getElementById('launch-model').click();

    let userId = this.localService.get('UserId');
    console.log("userid", userId)
    console.log("this.appService.userName", this.appService.userName)
    let beaubelleUserName = this.appService.userName;
    this.memberId = product.memberId;
    this.companyName = product.name;
    if (userId) {
      this.enquiryForm.reset({ name: "", message: "", })
      if (beaubelleUserName) {
        this.enquiryForm.controls['name'].setValue(beaubelleUserName)
      }
      this.enquiryForm.controls['email'].setValue(this.customerLoginStorageService.getCustomerData().email)
      this.enquiryForm.controls['phone_number'].setValue(this.customerLoginStorageService.getCustomerData().mobileNo)
      this.enquiryForm.controls['category'].setValue(product.categories[0].categories)
      document.getElementById('launch-model-accel').click();

    } else {
      this.router.navigate(['/login-new'], { queryParams: { productId: product.id, }, relativeTo: this.route, skipLocationChange: false })
    }
  }

  cancelData() {

  }
  selectOptionCarience(value, id, index) {
    this.isActive = 0;
    this.newActive = 0;
    this.child_index=0;
    console.log(this.product, 'products')
    console.log(this.product.length)
    console.log(this.product[0])
    //for(let i=0;i<=this.product.length;i++){
    //if(this.product[i].id == id){
    //this.products[i].size[0]=value;
    //this.products[i].subname = this.products[i].name + " - " + value
    if(this.product.variant.variant_child)
    {
      this.selectColour(this.product.variant.option_values[index].child[this.child_index].color, this.product.id, 0)
    }
    
    //}
    //}
    this.current_index = index
    this.selectedOption1 = value;
  }




  selectOptionSpecialWires1(value,id,index){

   // this.child_index=0;
    // for(let i=0;i<this.products.length;i++){
      // if(this.products[i].id == id){
        //var product=this.products[i];
        this.current_index=index;
        this.specialval = true;
        console.log("specialval"+this.specialval)
        this.child_index=0;
        // product['current_index']=index;
        // product['child_index']=0;
        if(this.product.variant.variant_child)
                        {
        this.selectColour(this.product.variant.option_values[index].child[this.child_index].color,this.product.id,0)
      }
    //}
   // }
    //this.products[i].current_index!=null?product.current_index:0=index
    this.selectedOption1=value;
  }
  selectOptionLush(value,id,index){

    // this.child_index=0;
     // for(let i=0;i<this.products.length;i++){
       // if(this.products[i].id == id){
         //var product=this.products[i];
         this.current_index=index;
         this.specialval = true;
         console.log("specialval"+this.specialval)
         this.child_index=0;
         // product['current_index']=index;
         // product['child_index']=0;
         if(this.product.variant.variant_child)
                         {
         this.selectColour(this.product.variant.option_values[index].child[this.child_index].color,this.product.id,0)
       }
     //}
    // }
     //this.products[i].current_index!=null?product.current_index:0=index
     this.selectedOption1=value;
   }
  selectOptionAvonSeals(value, id, index) {
    console.log(this.product, 'products')
    console.log(this.product.length)
    console.log(this.product[0])
    //for(let i=0;i<=this.product.length;i++){
    //if(this.product[i].id == id){
    //this.products[i].size[0]=value;
    //this.products[i].subname = this.products[i].name + " - " + value
    // this.selectColour(this.product.variant.option_values[0].child[0].color, this.product.id, 0)
    //}
    //}
    this.current_index = index
    this.selectedOption1 = value;
    console.log(index,"index11")
    
    for (let j = 0; j < this.product.variant.option_values.length; j++) {
      console.log(this.product.variant.option_values[index],"index22")
      console.log(this.product.variant.option_values[j],"j")
      this.product.variant.option_values[j].is_default = false
      // this.product.variant.option_values[j].is_default = false
      // if (index == j) {
        // this.product.variant.option_values[index].is_default = true;
      // } 
      if (this.product.variant.option_values[j].id===this.product.variant.option_values[index].id) {
        console.log("truee")
        this.product.variant.option_values[index].is_default = true;
        this.avonSealsPrice = this.product.variant.option_values[index].pricing.raw.price;
        this.avonSealsDescription = this.product.variant.option_values[index].description;
        this.avonSealsWeight = this.product.variant.option_values[index].weight;
      }
    }
   
   
  }
closeLinen(){
  document.getElementById("linenclose").click()
  this.review_list = [];
  this.one_star = 0;
  this.two_star = 0;
  this.three_star = 0;
  this.four_star = 0;
  this.five_star = 0;
  this.number_of_reviews = 0;
  this.width1 = 0;
  this.width2 =0;
  this.width3 =0;
  this.width4 =0;
  this.width5 =0;
}
starReview(rate){
  // this.review_list = [];
  let requestBody = {
    "domain_name": ORG_DETAILS.DOMAIN_NAME,
    "user_id": ORG_DETAILS.USER_ID,
    "extras": {
      "find": {
        "parent_id" : this.id,
        "status" : "Approved",
        "rating" : rate,
      },
      "pagination": true,
      "paginationDetails": {
        "limit": 0,
        "pageSize": 10
      },
      "sorting": true,
      "sortingDetails": {
        "email": -1
      }
    }
  }
  this.appService.postApiCall(requestBody,ENDPOINTS.GETALLREVIEW,).subscribe(
    resp => {
    
      if (resp) {
        console.log("reviewtest1")
        //  this.review = resp.result.data;
         this.review_list = resp.result.data;
      }
    }
  )
  
}
getReviewDetailsSchift(id) {

  this.review_list = [];
  this.one_star = 0;
  this.two_star = 0;
  this.three_star = 0;
  this.four_star = 0;
  this.five_star = 0;
  this.number_of_reviews = 0;
  this.width1 = 0;
  this.width2 =0;
  this.width3 =0;
  this.width4 =0;
  this.width5 =0;
  console.log("reviewtest2",this.schiftId )
  if(config.title === "Schift Cosmetics"){
    let requestBodySchiftReview = {
      "domain_name": ORG_DETAILS.DOMAIN_NAME,
      "user_id": ORG_DETAILS.USER_ID,
      "extras": {
        "find": {
          "product_id" : id,
          // "rating" : 5
        },
        "pagination": true,
        "paginationDetails": {
          "limit": 0,
          "pageSize": 10
        },
        "sorting": true,
        "sortingDetails": {
          "email": -1
        }
      }
    }
    this.appService.postApiCall(requestBodySchiftReview,ENDPOINTS.GETALLREVIEW,).subscribe(
      resp => {
      
        if (resp) {
          console.log("resp.result.data",resp.result)
          console.log("reviewtest3")
          let review = resp.result.data;
          this.reviewData = resp.result.data;
          let reviewList = resp.result.data;
          reviewList.forEach(e=>{
            if(e.status == "Approved"){
              this.review_list.push(e)
            }
          })

          if(review !== undefined && review.length !== 0){
            console.log("reviewtest4")
          this.total_rating = review.length
          this.productRating.controls.rating.setValue(this.review_list[0].rating)
          console.log("total", this.total_rating)
           review.forEach(element => {
             if(element.status == "Approved"){
             if(element.rating == 1){
               this.one_star = this.one_star + 1
             }
             else if(element.rating == 2){
              this.two_star = this.two_star + 1
            }
            else if(element.rating == 3){
              this.three_star = this.three_star + 1
            }
            else if(element.rating == 4){
              this.four_star = this.four_star + 1
            }
            else if(element.rating == 5){
              this.five_star = this.five_star + 1
            }
          }
           });

           this.number_of_reviews = this.one_star + this.two_star + this.three_star + this.four_star + this.five_star;

           this.width1 = (this.one_star*100)/this.total_rating
           this.width2 = (this.two_star*100)/this.total_rating
           this.width3 = (this.three_star*100)/this.total_rating
           this.width4 = (this.four_star*100)/this.total_rating
           this.width5 = (this.five_star*100)/this.total_rating
           if( this.number_of_reviews == 0) {
              this.product_rating = 0; 
           } else {
            this.product_rating = Number((((1*this.one_star) + (2*this.two_star) + (3*this.three_star) + (4*this.four_star) + (5*this.five_star)) / ((this.one_star) + (this.two_star) + (this.three_star) + (this.four_star) + (this.five_star))).toFixed(1))
          }
          this.productRating.controls.rating.setValue(this.product_rating.toString())
        }


        
        }
      },
      err => {
        if (err.error.statusCode === 403) {
          this.alertService.error('Session Time Out! Please login Again', this.options)
          this.router.navigate([`/login-new`], { skipLocationChange: false });
        }
        else if (err.error.message) {
          this.alertService.error(err.error.message, this.options)
        }
        else {
          this.alertService.error('Something bad happened. Please try again!', this.options);
        }
      }
    )
  }
  document.getElementById('star-inner').style.width = (this.product_rating * 20) + "%"
}
  getReviewDetails() {
    this.review_list = [];
  this.one_star = 0;
  this.two_star = 0;
  this.three_star = 0;
  this.four_star = 0;
  this.five_star = 0;
  this.number_of_reviews = 0;
  this.width1 = 0;
  this.width2 =0;
  this.width3 =0;
  this.width4 =0;
  this.width5 =0;
  console.log("reviewtest2",this.schiftId )
  
  if(config.title === "Deera"){
    let requestBody = {
      "domain_name": ORG_DETAILS.DOMAIN_NAME,
      "user_id": ORG_DETAILS.USER_ID,
      "extras": {
        "find": {
          "product_id" : this.schiftId,
          // "rating" : 5
        },
        "pagination": true,
        "paginationDetails": {
          "limit": 0,
          "pageSize": 10
        },
        "sorting": true,
        "sortingDetails": {
          "email": -1
        }
      }
    }
    this.appService.postApiCall(requestBody,ENDPOINTS.GETALLREVIEW,).subscribe(
      resp => {
      
        if (resp) {
          console.log("resp.result.data",resp.result)
          console.log("reviewtest3")
          let review = resp.result.data;
          this.reviewData = resp.result.data;
          let reviewList = resp.result.data;
          reviewList.forEach(e=>{
            if(e.status == "Approved"){
              this.review_list.push(e)
            }
          })

          if(review !== undefined && review.length !== 0){
            console.log("reviewtest4")
          this.total_rating = review.length
          this.productRating.controls.rating.setValue(this.review_list[0].rating)
          console.log("total", this.total_rating)
           review.forEach(element => {
             if(element.status == "Approved"){
             if(element.rating == 1){
               this.one_star = this.one_star + 1
             }
             else if(element.rating == 2){
              this.two_star = this.two_star + 1
            }
            else if(element.rating == 3){
              this.three_star = this.three_star + 1
            }
            else if(element.rating == 4){
              this.four_star = this.four_star + 1
            }
            else if(element.rating == 5){
              this.five_star = this.five_star + 1
            }
          }
           });

           this.number_of_reviews = this.one_star + this.two_star + this.three_star + this.four_star + this.five_star;

           this.width1 = (this.one_star*100)/this.total_rating
           this.width2 = (this.two_star*100)/this.total_rating
           this.width3 = (this.three_star*100)/this.total_rating
           this.width4 = (this.four_star*100)/this.total_rating
           this.width5 = (this.five_star*100)/this.total_rating
           if( this.number_of_reviews == 0) {
              this.product_rating = 0; 
           } else {
            this.product_rating = Number((((1*this.one_star) + (2*this.two_star) + (3*this.three_star) + (4*this.four_star) + (5*this.five_star)) / ((this.one_star) + (this.two_star) + (this.three_star) + (this.four_star) + (this.five_star))).toFixed(1))
          }
          this.productRating.controls.rating.setValue(this.product_rating.toString())
        }


        
        }
      },
      err => {
        if (err.error.statusCode === 403) {
          this.alertService.error('Session Time Out! Please login Again', this.options)
          this.router.navigate([`/login-new`], { skipLocationChange: false });
        }
        else if (err.error.message) {
          this.alertService.error(err.error.message, this.options)
        }
        else {
          this.alertService.error('Something bad happened. Please try again!', this.options);
        }
      }
    )
  }
    else{
      if(config.title !== "Schift Cosmetics"){
      let requestBody = {
        "domain_name": ORG_DETAILS.DOMAIN_NAME,
        "user_id": ORG_DETAILS.USER_ID,
        "extras": {
          "find": {
            "parent_id" : this.id,
            // "rating" : 5
          },
          "pagination": true,
          "paginationDetails": {
            "limit": 0,
            "pageSize": 10
          },
          "sorting": true,
          "sortingDetails": {
            "email": -1
          }
        }
      }
      this.appService.postApiCall(requestBody,ENDPOINTS.GETALLREVIEW,).subscribe(
        resp => {
        
          if (resp) {
            console.log("resp.result.data",resp.result)
            console.log("reviewtest3")
            let review = resp.result.data;
            this.reviewData = resp.result.data;
            let reviewList = resp.result.data;
            reviewList.forEach(e=>{
              if(e.status == "Approved"){
                this.review_list.push(e)
              }
            })
  
            if(review !== undefined && review.length !== 0){
              console.log("reviewtest4")
            this.total_rating = review.length
            this.productRating.controls.rating.setValue(this.review_list[0].rating)
            console.log("total", this.total_rating)
             review.forEach(element => {
               if(element.status == "Approved"){
               if(element.rating == 1){
                 this.one_star = this.one_star + 1
               }
               else if(element.rating == 2){
                this.two_star = this.two_star + 1
              }
              else if(element.rating == 3){
                this.three_star = this.three_star + 1
              }
              else if(element.rating == 4){
                this.four_star = this.four_star + 1
              }
              else if(element.rating == 5){
                this.five_star = this.five_star + 1
              }
            }
             });
  
             this.number_of_reviews = this.one_star + this.two_star + this.three_star + this.four_star + this.five_star;
  
             this.width1 = (this.one_star*100)/this.total_rating
             this.width2 = (this.two_star*100)/this.total_rating
             this.width3 = (this.three_star*100)/this.total_rating
             this.width4 = (this.four_star*100)/this.total_rating
             this.width5 = (this.five_star*100)/this.total_rating
             if( this.number_of_reviews == 0) {
                this.product_rating = 0; 
             } else {
              this.product_rating = Number((((1*this.one_star) + (2*this.two_star) + (3*this.three_star) + (4*this.four_star) + (5*this.five_star)) / ((this.one_star) + (this.two_star) + (this.three_star) + (this.four_star) + (this.five_star))).toFixed(1))
            }
            this.productRating.controls.rating.setValue(this.product_rating.toString())
          }
  
  
          
          }
        },
        err => {
          if (err.error.statusCode === 403) {
            this.alertService.error('Session Time Out! Please login Again', this.options)
            this.router.navigate([`/login-new`], { skipLocationChange: false });
          }
          else if (err.error.message) {
            this.alertService.error(err.error.message, this.options)
          }
          else {
            this.alertService.error('Something bad happened. Please try again!', this.options);
          }
        }
      )
    }
    }
    // MAKE A SERVICE CALL HERE...
    if(config.title !== "HOB" && config.title !== "UrbanBox"){
    document.getElementById('star-inner').style.width = (this.product_rating * 20) + "%"
    }
  }
  get fullStars(): number[] {
    const stars = Math.floor(this.product_rating);
    return Array(stars).fill(0).map((_, index) => index + 1);
  }

  get halfStar(): boolean {
    return this.product_rating % 1 !== 0;
  }

  get emptyStars(): number[] {
    const stars = Math.floor(5 - this.product_rating);
    return Array(stars).fill(0).map((_, index) => index + 1);
  }
productReview(){
//   for (let j = 0; j < this.product.variant.option_values.length; j++) {
//   this.router.navigate(["/product-review", this.product.variant.option_values.id], {
//     relativeTo: this.route,
//     skipLocationChange: false,
//   });
// }
document.getElementById("launch-model-linen").click();
this.getReviewDetails();
}
productReviewSchift(){
  //   for (let j = 0; j < this.product.variant.option_values.length; j++) {
  //   this.router.navigate(["/product-review", this.product.variant.option_values.id], {
  //     relativeTo: this.route,
  //     skipLocationChange: false,
  //   });
  // }
  document.getElementById("launch-model-linen").click();
  console.log("Review id of the product",this.productIdSchift)
  this.getReviewDetailsSchift(this.productIdSchift);
  }

  selectOptionLinenRaj(value, id, index) {
    console.log(this.product, 'products')
    console.log(this.product.length)
    console.log(this.product[0])
    //for(let i=0;i<=this.product.length;i++){
    //if(this.product[i].id == id){
    //this.products[i].size[0]=value;
    //this.products[i].subname = this.products[i].name + " - " + value
    // this.selectColour(this.product.variant.option_values[0].child[0].color, this.product.id, 0)
    //}
    //}
    this.current_index = index
    this.selectedOption1 = value;
    console.log(index,"index11")
    
    for (let j = 0; j < this.product.variant.option_values.length; j++) {
      console.log(this.product.variant.option_values[index],"index22")
      console.log(this.product.variant.option_values[j],"j")
      this.product.variant.option_values[j].is_default = false
      // this.product.variant.option_values[j].is_default = false
      // if (index == j) {
        // this.product.variant.option_values[index].is_default = true;
      // } 
      if (this.product.variant.option_values[j].id===this.product.variant.option_values[index].id) {
        console.log("truee")
        // this.router.navigate(["/product-details", this.product.variant.option_values[j].id], {
        //   relativeTo: this.route,
        //   skipLocationChange: false,
        // });
        this.product.variant.option_values[index].is_default = true;
        this.linenRajPrice = this.product.variant.option_values[index].pricing.raw.price;
        this.linenRajDescription = this.product.variant.option_values[index].description;
        this.linenRajWeight = this.product.variant.option_values[index].weight;
      }
    }
   
   
  }
  // selectOptionVistas(value, id, index) {
  //   console.log(this.product, 'products')
  //   console.log(this.product.length)
  //   console.log(this.product[0])
  //   this.current_index = index
  //   this.selectedOption1 = value;
  //   console.log(index,"index11")
    
  //   for (let j = 0; j < this.product.variant.option_values.length; j++) {
  //     console.log(this.product.variant.option_values[j],"j")
  //     this.product.variant.option_values[j].is_default = false
  //     if (this.product.variant.option_values[j].id===this.product.variant.option_values[index].id) {
  //       console.log("truee")
  //       this.product.variant.option_values[index].is_default = true;
  //     }
  //   }
   
   
  // }
  asset_selector(item,i){

this.asset_index=i;
this.image_preview = true;
    this.video_preview = false;
    this.mainImagePreview = i.image_source;
    this.isActive = i;
    this.newActive = i;
  }
  findIndexById(id) {
    console.log("product Paul",this.product.variant.option_values[0].child,id,this.current_index)
    this.paulIndex = Number(this.product.variant.option_values[this.current_index].child.findIndex(item => item.id === id)) ;
    console.log("product Index",this.product.variant.option_values[this.current_index].child,id,this.paulIndex)
    if(this.paulIndex >= 0){
    this.product.variant.option_values[0].child[0].is_default=false;
      this.product.variant.option_values[this.current_index].child[this.paulIndex].is_default=true;
      console.log(this.product.variant.option_values[0].child,"this.product.variant.option_values[0].child", this.paulIndex, this.product.variant.option_values[0].child[this.paulIndex].is_default)
    }
      if(this.paulIndex== -1){
this.paulIndex=0
      }  }
  selectColour(color, id, index) {
    this.isActive = 0;
    this.newActive = 0;
    this.asset_index=0;
    console.log("1111")
    console.log(this.product.length)
    
    // for(let i=0;i<=this.product.length;i++){
    console.log("1112")
    console.log(this.product.id,id,index)
    //if(this.product[i].id == id){
    // this.products[i].size[1]=color;
    //this.products[i].subname = this.products[i].name +" - "+ this.products[i].size[0]  +" - "+  color
    if(this.config.title=='PaulCaroline' || this.config.title=='HOB' || this.config.title=='Srimaware'){
this.findIndexById (Number(this.childPaulid))

    }
    //this.paulIndex = Number(index)
      for (let j = 0; j < this.product.variant.option_values[this.current_index].child.length; j++) {
        this.product.variant.option_values[this.current_index].child[j].is_default = false
        console.log()
        if (index == j) {
          this.product.variant.option_values[this.current_index].child[index].is_default = true;
          this.child_index=index;
        }
      }
  }
  selectColourPaul(color, id, index) {
    this.isActive = 0;
    this.newActive = 0;
    this.asset_index=0;
    console.log("1111")
    console.log(this.product.length)
    this.disableindex =""
    // for(let i=0;i<=this.product.length;i++){
    console.log("1112")
    console.log(this.product.id,id,index)
    //if(this.product[i].id == id){
    // this.products[i].size[1]=color;
    //this.products[i].subname = this.products[i].name +" - "+ this.products[i].size[0]  +" - "+  color
this.findIndexById (Number(this.childPaulid))
this.paulIndex = Number(index)
this.child_index = Number(index)
      for (let j = 0; j < this.product.variant.option_values[this.current_index].child.length; j++) {
        this.product.variant.option_values[this.current_index].child[j].is_default = false
        console.log()
        if (index == j) {
          this.product.variant.option_values[this.current_index].child[index].is_default = true;
          this.child_index=index;
         
        }
      }
      this.stikeouttype(color);
  }

  stikeouttype(type){
    for(let k = 0;k < this.product.variant.option_values.length; k++){
      for(let l = 0;l < this.product.variant.option_values[k].child.length; l++){
      var valueofStock = this.product.variant.option_values[k].child[l].stock_status
      console.log("valueofStock",type,this.product.variant.option_values[k].child[l].type)
      
      if(this.product.variant.option_values[k].child[l].type === type){
          if(this.product.variant.option_values[k].child[l].stock_status == 'Out of Stock'){
          this.disableColor = true
          console.log("Test or jjs",k)
        this.disableindex = k
        
      }

      else{
        this.unDisable = k

        console.log("Test is jjs",k)
    }
    }
     
      
    }
  }
  console.log("this.disableColor",this.disableColor)
  }
  selectSpecial(id,index){
    for(let i=0;i<this.products.length;i++){
      if(this.products[i].id == id){
        // this.products[i].size[1]=color;
        // this.products[i].subname = this.products[i].name +" - "+ this.products[i].size[0]  +" - "+  color
        for(let k=0;k<this.products[i].variant.option_values[this.products[i].current_index!=null?this.products[i].current_index:0].child.length;k++){
            if(index==k){
            this.products[i].variant.option_values[this.products[i].current_index!=null?this.products[i].current_index:0].child[k].is_default=true;
          }
          else{
            this.products[i].variant.option_values[this.products[i].current_index!=null?this.products[i].current_index:0].child[k].is_default=false
        
          }
        }
      }
    }
  }
  onClick(event) {
    console.log("clickoodjdj",event)
    const imgElem = event.target;
    var target = event.target || event.srcElement || event.currentTarget;
    var srcAttr = target.attributes.src;
    this.imgSrc = "https://images-na.ssl-images-amazon.com/images/M/MV5BMTM0MDgwNjMyMl5BMl5BanBnXkFtZTcwNTg3NzAzMw@@._V1_.jpg";
  }
  interfaceToConvertFormToUnrefinedData(data: any, imageListToBeConverted): any {
   

    let count = 1;
    let quantity = 0;
    let dataToBeReturned: any = {
      quantity: imageListToBeConverted.quantity,
      uploaded_images: [

      ]
    };


    if(!this.editModeBestGifts) {
      for(let i = 0; i<this.numberOfProductsBestGifts; i++) {
        let key = i+1
          imageListToBeConverted.uploaded_images.forEach(element => {
            if(!data['individualQuantity'+i]) {
              data['individualQuantity'+i] = 1; 
            }
            if(Object.keys(element).includes("quantity_"+key)) {
              for(let j = 0; j<data['individualQuantity'+i]; j++) {
                let temp = {}
                temp["quantity_" + count] = element["quantity_"+key]
                if(data['text_'+i]) {
                  temp["quantity_"+count]["text"] = data['text_'+i]
                }  else {
                  temp["quantity_"+count]["text"] = ""
                }
                dataToBeReturned.uploaded_images.push(temp)
                count = count + 1;
                quantity = quantity + 1;
              }    
            }
          });
      }
    } else {
      for(let i = 0; i<this.numberOfProductsBestGifts; i++) {
        let key = i+1
          imageListToBeConverted.uploaded_images.forEach(element => {
            if(!data['individualQuantity'+i]) {
              data['individualQuantity'+i] = 1; 
            }

            if(Object.keys(element).includes("quantity_"+key)) {
              for(let j = 0; j<data['individualQuantity'+i]; j++) {
                let temp = {}
                temp["quantity_" + count] = element["quantity_"+key]  
                if(data['text_'+i]) {
                  temp["quantity_"+count]["text"] = data['text_'+i]
                }  else {
                  temp["quantity_"+count]["text"] = ""
                }
                dataToBeReturned.uploaded_images.push(temp)
                count = count + 1;
                quantity = quantity + 1;
              }    
            }
          });
      }
    }
    dataToBeReturned.quantity = quantity
    this.imageListBestGifts = dataToBeReturned.uploaded_images
    
    return dataToBeReturned;
    
  }


  /**
   * Function to collect data from the model on save
   * @param data - form data received from the modal.
   * @returns void
   */
  onClickSubmit(data) {

    /**
     * Piece of code to check if all the mask images under a product is uploaded
     * -----
     * if all the masks under a product is filled, product is allowed to be saved
     * if all the masks under a product is not filled, product is deleted
     * if some of the masks under a product is not filled, return is called, and code does not proceed
     * -----
     * if all of the products had no masks and were deleted, close modal, and reset the counter back to zero
     */

    let countOfDeletedProducts = 0 // need to keep track of the number of products it deletes to reduced from global variable
    
    console.log("current size of cart: ",  this.bestGiftsCalculateCartAndCurrentQuantity())
    if(Number(this.localService.get('max_cart_qty')) < this.bestGiftsCalculateCartAndCurrentQuantity()) {
      this.alertService.error('maximum Cart value has been reached!', this.options);
      return
    }


    for(let i=0; i<this.numberOfProductsBestGifts; i++) {
      let emptyMaskCounter = 0;     // Keeps count of all the empty masks per product

      for(let j=0; j<this.numberOfMaskUploads; j++) {
        if(this.imagelist["maskImage_" + i+ "_" + j] == "") {
          emptyMaskCounter += 1;
        }
      }

      // if some of the masks under a product is not filled, return is called, and code does not proceed
      if(emptyMaskCounter != 0 && emptyMaskCounter < this.numberOfMaskUploads && this.currentUserType !== "business customer") {
        this.alertService.warn("Please upload all images as per product!", this.options)
        return
      }

      // if all the masks under a product is not filled, product is deleted
      if(emptyMaskCounter == this.numberOfMaskUploads) {
        for(let maskNumber=0; maskNumber<this.numberOfMaskUploads; maskNumber++) {
          delete this.imagelist["maskImage_"+i+"_"+maskNumber];
        }
        countOfDeletedProducts += 1;
      }

    }

    

    // Updates the number of products based on number of products deleted
    this.numberOfProductsBestGifts = this.numberOfProductsBestGifts - countOfDeletedProducts;

    // If all products were deleted, reset the image list to initial state
    if(this.numberOfProductsBestGifts == 0) {
      this.imageListReset()
      
      // if its not edit mode or add item, no need to call or update cart, hence just break out of function
      if(!this.editModeBestGifts) {
        document.getElementById("bestgifts_close").click();
        this.imageListBestGifts = []

        return 
      }  else {
        console.log("clearing the cart!")
        let index = 0;
        this.appService.cartProducts.results.forEach((element, i) => {
          if(element.id == this.newProductDetails.product_id) {
            console.log("removing the cartttttttttttttttttttttttttttttt")
            index = i
          }
        })
        this.appService.cartProducts.results.splice(index,1);
        console.log("removing the cartttttttttttttttttttttttttttttt")
        this.cartService.updateCartItem(this.appService.cartProducts.results);

        this.imageListBestGifts = []
        this.editModeBestGifts = false
        document.getElementById("bestgifts_close").click();
        return
      }
    }

  
    


    // Set the headers for sending the data to cart
    let headers = new HttpHeaders().set("source", "Product").set("domain_name", ORG_DETAILS.DOMAIN_NAME);

    let imageData = new FormData();
   

    if (!this.editModeBestGifts) {

      for (let index in this.imageListForUpload) {
        let element = this.imageListForUpload[index]
        this.imageIndexes1.push({
          imageIndex: index,
          name: this.imageListForUpload[index].name
        })
        if (typeof (element) == "object") {
          imageData.append("upload", element)
        } else if (typeof (element) == "string") {
          this.refinedMaskImages[index] = element
        }
      };
  
  
  

      this.appService.sendImage(imageData, headers).subscribe((resp) => {
        this.remapImagesAndUpdateCart(resp.result.data, data.form.value)

        document.getElementById("bestgifts_close").click();
        this.editModeBestGifts = true
      })
    } else {


      console.log(this.imageListForUpload)
      console.log(this.imagelist)
      for (let index in this.imageListForUpload) {
        let element = this.imageListForUpload[index];
        this.imageIndexes1.push({
          imageIndex: index,
          name: this.imageListForUpload[index].name
        })
        if (typeof (element) == "object") {
          imageData.append("upload", element);
        } else if (typeof (element) == "string") {
          if(this.imagelist[index] != "") {
            this.refinedMaskImages[index] = element;
          }
        }
      };
  
  
  

      this.appService.sendImage(imageData, headers).subscribe((resp) => {
        resp.result.data.forEach((entry) => {
          this.imageIndexes1.forEach((value, index) => {
            if (value.name == entry.originalname) {
              this.refinedMaskImages[value.imageIndex] = entry.location
            }
          })
        })


        let optionalDataForBestgifts = {}
        optionalDataForBestgifts["quantity"] = this.numberOfProductsBestGifts
        optionalDataForBestgifts["uploaded_images"] = []
        for (let productIndex = 1; productIndex < this.numberOfProductsBestGifts + 1; productIndex++) {
          let temp = {}
          temp["quantity_" + productIndex] = {}
          for (let maskIndex = 1; maskIndex < this.numberOfMaskUploads + 1; maskIndex++) {
            let tempIndex = productIndex - 1
            let tempIndex2 = maskIndex - 1
            temp["quantity_" + (productIndex)]["image_" + (maskIndex)] = this.refinedMaskImages["maskImage_" + tempIndex + "_" + tempIndex2]
          }
          optionalDataForBestgifts["uploaded_images"].push(temp)
        }



        let finalImageList = this.interfaceToConvertFormToUnrefinedData(data.form.value, optionalDataForBestgifts)
        console.log("final image list: ", finalImageList)

        this.increaseItem(this.newProductDetails.id, finalImageList)

        this.imageListBackup = this.imageListBestGifts

        document.getElementById("bestgifts_close").click();
      })
    }
  }

  openbagForLinenRaja(){
    document.getElementById("openbag").click()
  
  }
  remapImagesAndUpdateCart(awsResponse, data: any) {
    awsResponse.forEach((entry) => {
      this.imageIndexes1.forEach((value, index) => {
        if (value.name == entry.originalname) {
          this.refinedMaskImages[value.imageIndex] = entry.location
        }
      })
    })

    let optionalDataForBestgifts = {}
    optionalDataForBestgifts["quantity"] = this.numberOfProductsBestGifts
    optionalDataForBestgifts["uploaded_images"] = []
    for (let productIndex = 1; productIndex < this.numberOfProductsBestGifts + 1; productIndex++) {
      let temp = {}
      temp["quantity_" + productIndex] = {}
      for (let maskIndex = 1; maskIndex < this.numberOfMaskUploads + 1; maskIndex++) {
        let tempIndex = productIndex - 1
        let tempIndex2 = maskIndex - 1
        temp["quantity_" + (productIndex)]["image_" + (maskIndex)] = this.refinedMaskImages["maskImage_" + tempIndex + "_" + tempIndex2]
      }
      temp["quantity_" + (productIndex)]["text"] = "";
      if(this.modelForBindingTextInputs["text_" + (productIndex-1)] ) {
        temp["quantity_" + (productIndex)]["text"] = this.modelForBindingTextInputs["text_" + (productIndex-1)]       
      }
      optionalDataForBestgifts["uploaded_images"].push(temp)
    }
    // this.cartService.addToCart()
    
    // Conversion to duplicate data depending on quantity
    let finalImageList = this.interfaceToConvertFormToUnrefinedData(data, optionalDataForBestgifts)

    this.cartService.addToCart(this.newProductDetails, finalImageList)
    document.getElementById("bestgiftsloader").style.display="block"
    let obj =
    {
      domain_name: ORG_DETAILS.DOMAIN_NAME,
      user_id: ORG_DETAILS.USER_ID,
      extras: {
        find: {
          product_id: Number(this.newProductDetails.id),
          product_cost: Number(this.newProductDetails.pricing.raw.price),
          quantity: finalImageList.quantity,
          customer_id: Number(this.customer_id),
          customer_type:this.customerType1
        },
      },
    };

  this.appService.postApiCall(obj, ENDPOINTS.STRUCTURED_PROMOTION).subscribe(
    (resp) => {
      if (resp) {
        if (resp.success === 1 && resp.status_code === 200) {
          for (let j = 0; j < this.appService.cartProducts.results.length;j++) {
            if (
              this.appService.cartProducts.results[j].product_id === this.newProductDetails.id
            ) {                      
                this.appService.cartProducts.results[j]["discount_amount"] =
                  resp.result.data.discount_summary[0].discount_amount;
         
              this.appService.cartProducts.results[j][
                "after_dicount_price"
              ] = resp.result.data.discount_summary[0].after_dicount_price;

              this.appService.cartProducts.results[j][
                "per_quantity_amount"
              ] = resp.result.data.discount_summary[0].per_quantity_amount;
              
              this.cartService.updateCartItem(
                this.appService.cartProducts.results
              );
            }
          }
          let cartItemsString = JSON.stringify(
            this.appService.cartProducts.results
          );
          this.localService.set("cart", cartItemsString);
          document.getElementById("bestgiftsloader").style.display="none"
        } else if (resp.success === 0) {
          if (resp.message) {
          }
        } else if (resp.message && resp.status_code !== 200) {
        } else {
        }
      }
    },
    (err) => {
      if (err.error.statusCode === 403) {
      } else if (err.error.error.message) {
      } else {
      }
    }
  );
  }
  imageupload2(event : any) : void
  {
      
      let dragEvent = false
      let file_data = {name : "",size: 0}
      //CHECKING DRAG EVENT OR UPLOAD EVENT
      if (event.target && event.target.files && event.target.files[0]) {
          
          file_data = event.target.files[0]
      }
      else
      {
          file_data = event.dataTransfer.files[0]
          dragEvent = true
      }

      var reader = new FileReader();

      this.imageName = file_data.name
  
      
      let splitFileName =this.imageName.split(".")
      //CHECKING FILE NAME
      if (splitFileName.length ==0 )
      {
          this.enquiryForm_special.controls['imageFile'].setErrors({'invalid': true});
          return
      }
      
      if(file_data.size == 0)
      {
          this.enquiryForm_special.controls['imageFile'].setErrors({'sizezero': true});
          return
      }
      
      if(Math.round((file_data.size/1000)) > 2000)
      {
          this.enquiryForm_special.controls['imageFile'].setErrors({'sizehigh': true});
          return
      }
      
      //CHECKING FILE TYPE
      if (!["jpg","jpeg","png","gif","JPG","JPEG","PNG","GIF"].includes(splitFileName[splitFileName.length -1]))
      {
          this.enquiryForm_special.controls['imageFile'].setErrors({'type': true});
          return
      }
      this.enquiryForm_special.controls['imageFile'].setErrors({'invalid': false});
      this.enquiryForm_special.controls['imageFile'].setErrors({'type': false});
      this.enquiryForm_special.controls['imageFile'].setErrors({'sizehigh': false});
      this.enquiryForm_special.controls['imageFile'].setErrors({'sizezero': false}); 
      
      reader.onload = (evt:any)=>{
          this.previewImgUrl = evt.target.result;
          this.enquiryForm_special.controls['imageFile'].setValue(evt.target.result)
          // this.imgFile=event.target.files[0];
      }

      //BASED ON EVENT READ FILE 
      if(!dragEvent)
      {
      reader.readAsDataURL(event.target.files[0]);
      this.imgFile2=event.target.files[0];
      }
      else
      {
       reader.readAsDataURL(event.dataTransfer.files[0]);
       this.imgFile2=event.dataTransfer.files[0];
      }
  }



  imgFromCartToLocal() {

    let dataInFormFormat = {}

    let count = 1;

    for(let i=0; i<this.imageListBestGifts.length; i++) {
      let temp = {
        quantity: 1,
        details: {}
      }
      for(let j=i+1; j<this.imageListBestGifts.length; j++) {

      
        if(JSON.stringify(this.imageListBestGifts[i]["quantity_" + (i+1)]) == JSON.stringify(this.imageListBestGifts[j]["quantity_" + (j+1)])) {
          temp.quantity = temp.quantity + 1;
          if(Object.keys(temp.details).length == 0) {
            temp.details = this.imageListBestGifts[i]["quantity_" + (i+1)]
          }

          if (j == (this.imageListBestGifts.length)-1){
            dataInFormFormat["quantity_"+count] = temp
            i = j - 1;
            count = count + 1;
            break
          }
        } else if (j == this.imageListBestGifts.length-1){
          temp.details = this.imageListBestGifts[i]["quantity_" + (i+1)]
          dataInFormFormat["quantity_"+count] = temp
          i = j - 1;
          count = count + 1;
          break
        } else {
          temp.details = this.imageListBestGifts[i]["quantity_" + (i+1)]
          dataInFormFormat["quantity_"+count] = temp
          i = j - 1 ;
          count = count + 1;
          break
        }
      }

      if(i+1 == this.imageListBestGifts.length && i == 0){
        temp.details = this.imageListBestGifts[i]["quantity_" + (i+1)]
        dataInFormFormat["quantity_"+count] = temp
        count = count + 1;
        break
      }else if(i+1 == this.imageListBestGifts.length && (JSON.stringify(this.imageListBestGifts[i]["quantity_" + (i+1)]) != JSON.stringify(this.imageListBestGifts[i-1]["quantity_" + (i)]))) {
        temp.details = this.imageListBestGifts[i]["quantity_" + (i+1)]
        dataInFormFormat["quantity_"+count] = temp
        count = count + 1;
        break
      }
    }

     Object.keys(dataInFormFormat).forEach((element, index) => {
      let j = 0
      for (let maskNumber in dataInFormFormat[element]["details"]) {
        if(maskNumber != "text") {
          this.imagelist["maskImage_" + index + "_" + j] = dataInFormFormat[element]["details"][maskNumber]
          j = j + 1
        }
      }
      this.numberOfProductsBestGifts = this.numberOfProductsBestGifts - dataInFormFormat[element]["quantity"] + 1;
      this.modelForBindingTextInputs["text_" + index] = dataInFormFormat[element]["details"]["text"];
      this.modelForBindingInputs["individualQuantity_" + index] = dataInFormFormat[element]["quantity"]
      // console.warn(this.modelForBindingInputs)
    })

    console.log("image list best gifts: ", this.imageListBestGifts)
    console.log("image list: ", this.imagelist)
    // this.imageListBestGifts.forEach((element, index) => {
    //   for (let x in element) {
    //     let j = 0
    //     for (let maskNumber in element[x]) {
    //       if(maskNumber != "text") {
    //         this.imageListForUpload["maskImage_" + index + "_" + j] = element[x][maskNumber]
    //         j = j + 1
    //       }
    //     }
    //   }
    // });

    this.imageListForUpload = JSON.parse(JSON.stringify(this.imagelist))
  }

  imgFormChange() {
    let tempArray = []
    this.appService.cartProducts.results.forEach((element) => {
      if (element.product_id == this.newProductDetails.id) {
        tempArray = element.uploaded_images
      }
    })
    this.imagelist = {}
    tempArray.forEach((element, index) => {
      for (let x in element) {
        let j = 0
        for (let maskNumber in element[x]) {
          if(maskNumber != "text") {
            this.imagelist["maskImage_" + index + "_" + j] = element[x][maskNumber]
            this.imageListForUpload["maskImage_" + index + "_" + j] = element[x][maskNumber]
            j = j + 1
          }
        }
      }
    });
    if (Object.keys(this.imagelist).length == 0) {
      for (let i = 0; i < this.numberOfMaskUploads; i++) {
        this.imagelist["maskImage_0_" + i] = ""
      }
    }
    this.numberOfProductsBestGifts = Object.keys(this.imagelist).length / this.numberOfMaskUploads
    
  }

  reorderImages() {

    let tempArrayForImages = {}
    let tempIndexForReordering = 0
    let keysOfImageList = Object.keys(this.imagelist).sort()
    for (let x = 0; x < keysOfImageList.length / this.numberOfMaskUploads; x++) {
      for (let y = 0; y < this.numberOfMaskUploads; y++) {
        tempArrayForImages["maskImage_" + x + "_" + y] = this.imagelist[keysOfImageList[tempIndexForReordering]]
        tempIndexForReordering = tempIndexForReordering + 1;
      }
    }
    
    this.imagelist = tempArrayForImages
  }

  reorderRefinedImages() {
    let tempArrayForImages = {}
    let tempIndexForReordering = 0
    let keysOfImageList = Object.keys(this.imagelist).sort()
    for (let x = 0; x < keysOfImageList.length / this.numberOfMaskUploads; x++) {
      for (let y = 0; y < this.numberOfMaskUploads; y++) {
        tempArrayForImages["maskImage_" + x + "_" + y] = this.refinedMaskImages[keysOfImageList[tempIndexForReordering]]
        tempIndexForReordering = tempIndexForReordering + 1;
      }
    }

    this.refinedMaskImages = tempArrayForImages
  }

  reorderImageListForUpload () {
    
    let tempArrayForImages = {}
    let tempIndexForReordering = 0
    let keysOfImageList = Object.keys(this.imagelist).sort()
    for (let x = 0; x < keysOfImageList.length / this.numberOfMaskUploads; x++) {
      for (let y = 0; y < this.numberOfMaskUploads; y++) {
        tempArrayForImages["maskImage_" + x + "_" + y] = this.imageListForUpload[keysOfImageList[tempIndexForReordering]]
        tempIndexForReordering = tempIndexForReordering + 1;
      }
    }

    this.imageListForUpload = tempArrayForImages
  }


  imageListReset() {
    this.imagelist ={}

    this.numberOfProductsBestGifts = 1;
    for (let i = 0; i < this.numberOfMaskUploads; i++) {
      this.imagelist['maskImage_0_' + i] = ""
    }

    this.refinedMaskImages = {}
    this.imageListForUpload = {}
    this.modelForBindingInputs = {}
    this.modelForBindingTextInputs = {}
    console.log("reset everything")
  }


  closeModalWithRefresh() {
     
    if ((this.appService.productIdinCart.indexOf(this.newProductDetails.id) ==
      -1) ||
      (this.showSize &&
        this.appService.productIdinCart.indexOf(this.checkVariantInCart) ==
        -1)) {
          this.editModeBestGifts = false


          this.imageListBestGifts = []
          // this might be needed to change
          this.resetBestGifts()
        }

    this.imgFormChange()
    this.imgFromCartToLocal()
    // this.numberOfProductsBestGifts = Object.keys(this.imagelist).length / this.numberOfMaskUploads
  }

  redirectLogin() {
    this.router.navigate([`/login-new`], { skipLocationChange: false });
  }

  resetBestGifts() {
    this.imageListReset()
    this.modelForBindingInputs = {}
    this.modelForBindingTextInputs = {}
  }
  saveForm_special() {


    if (this.enquiryForm_special.controls.name.value === "") {
      this.validateForm = true;
    } else if (this.enquiryForm_special.controls.message.value === "") {
      this.validateForm = true;
    } else if (this.enquiryForm_special.controls.email.value === "") {
      this.validateForm = true;
    } else if (this.enquiryForm_special.controls.phone_number.value === "") {
      this.validateForm = true;
    }

    if (this.enquiryForm_special.valid && (/\S/.test(this.enquiryForm_special.value.message) ) ){
      this.validateForm = false;
      var formData = {};
      var formDataJson;
      var deleteVariable=[];
      let session_id = this.localService.get("session_id");
      let formData_imageCate = new FormData()
      let headers = new HttpHeaders().set("source", "Product").set("domain_name", ORG_DETAILS.DOMAIN_NAME);
      let enquiry = {
        name: this.enquiryForm_special.value.name,
        email: this.enquiryForm_special.value.email,
        phone_number: this.enquiryForm_special.value.phone_number,
        category: this.enquiryForm_special.value.category,
        message: this.enquiryForm_special.value.message,
        product_name: this.enquiryForm_special.value.product_name,
        quantity:this.enquiryForm_special.value.quantity,
        diameter: this.enquiryForm_special.value.diameter,
        e_length: this.enquiryForm_special.value.e_length,
        member_id: this.memberId,
        status: "New",
        system_label: "New",
        companyName: this.companyName,
        enquiry_status:true,
      };

console.log(this.enquiryForm_special.value.message,"test13")

console.log(this.enquiryForm_special.value.message[0],"test123")

if (/\S/.test(this.enquiryForm_special.value.message)) {
  console.log("1")
}
else{
  console.log("0")
}
if(this.imgFile2!==''){
  formData_imageCate.append('upload',this.imgFile2)
}
this.appService.sendImage(formData_imageCate,headers).subscribe(resp=>
  {
    if(resp && resp.success===1 && resp.status_code===200){

        let imgVariable=resp.result.data[0];
        if(this.enquiryForm_special.value.imageFile!==''){
          enquiry["imageFile"]=imgVariable.location;
            deleteVariable.push(imgVariable.bucket + '/' + imgVariable.key)
        }
        let requestData = {
          domain_name: ORG_DETAILS.DOMAIN_NAME,
          user_id: ORG_DETAILS.USER_ID,
          payload: {
            order_creation: enquiry,
          },
          extras: {
            find: {
              id: "",
            },
          },
        };
      
      this.checkoutApiService
        .checkoutAPICall(ENDPOINTS.ORDER_UPDATION, requestData)
        .then((respData) => {
          let res: any = respData;
          if (res.success) {
            let OrderId = res.data[0].id;
            this.closeModal.nativeElement.click();
            this.checkoutLocalStorageService.setOrderId({ orderId: OrderId });
            this.alertService.success("Request Submitted", this.options);
            this.enquiryForm_special.reset({
              name: "",
              email: "",
              phone_number: "",
              category: "",
              message: "",
              e_length: "",
              diameter: "",
              quantity: ""
            });
          }
        });
      }
    });
    }
  }
  saveForm_vimpro() {
    // if (/\S/.test(this.enquiryForm.value.message)) {
    //   this.validateForm = false;
    
      
    // }
    // else{
    //   this.validateForm = true;
    
    // }


    if (this.enquiryForm_vimpro.controls.name.value === "") {
      this.validateForm = true;
    } else if (this.enquiryForm_vimpro.controls.message.value === "") {
      this.validateForm = true;
    } else if (this.enquiryForm_vimpro.controls.email.value === "") {
      this.validateForm = true;
    } else if (this.enquiryForm_vimpro.controls.phone_number.value === "") {
      this.validateForm = true;
    }
    // else if (this.enquiryForm_vimpro.controls.thickness.value === "") {
    //   this.validateForm = true;
    // }else if (this.enquiryForm_vimpro.controls.length.value === "") {
    //   this.validateForm = true;
    // }else if (this.enquiryForm_vimpro.controls.height.value === "") {
    //   this.validateForm = true;
    // }
    // else if (this.enquiryForm_vimpro.controls.quantity.value === "") {
    //   this.validateForm = true;
    // }
    

    if (this.enquiryForm_vimpro.valid && (/\S/.test(this.enquiryForm_vimpro.value.message) ) ){
      this.validateForm = false;
      var formData = {};
      var formDataJson;
      let session_id = this.localService.get("session_id");

      // let _key = enc.Utf8.parse("@NcRfUjXn2r5u7x!A%D*G-KaPdSgVkYp");
      // let _iv =  enc.Utf8.parse('\x00\x01\x02\x03\x04\x05\x06\x07\x08\x09\x0a\x0b\x0c\x0d\x0e\x0f');
      // let encrypted =AES.encrypt (
      // JSON.stringify({
      //   "domain_name": ORG_DETAILS.DOMAIN_NAME,
      //   "user_id": ORG_DETAILS.USER_ID,
      //   "timestamp": new Date().getTime(),
      //   "payload": {
      //     "order_creation":{
      //     "name":this.enquiryForm.value.name,
      //     "email":this.enquiryForm.value.email,
      //     "phone_number":this.enquiryForm.value.phone_number,
      //     "category":this.enquiryForm.value.category,
      //     "message":this.enquiryForm.value.message,
      //     "member_id":this.memberId,
      //     "status":"New",
      //     "system_label":"New"
      //   }
      //   },
      //   "extras": {
      //     "find": {
      //       "id": ""
      //     }
      //   }
      // }), _key, {
      //     iv: _iv,
      //     format: crypto.format.Hex,
      //     mode: crypto.mode.CTR,
      //     padding: crypto.pad.NoPadding
      // }).toString();
      // let requestData = {
      //   payload: encrypted
      // }

      let enquiry = {
        name: this.enquiryForm_vimpro.value.name,
        email: this.enquiryForm_vimpro.value.email,
        phone_number: this.enquiryForm_vimpro.value.phone_number,
        category: this.enquiryForm_vimpro.value.category,
        message: this.enquiryForm_vimpro.value.message,
        e_length: this.enquiryForm_vimpro.value.length,
       thickness: this.enquiryForm_vimpro.value.thickness,
       height: this.enquiryForm_vimpro.value.height,
       width: this.enquiryForm_vimpro.value.width,
       quantity:this.enquiryForm_vimpro.value.quantity,
      material: this.enquiryForm_vimpro.value.material,
      color: this.enquiryForm_vimpro.value.color,
      usage: this.enquiryForm_vimpro.value.usage,
        member_id: this.memberId,
        status: "New",
        system_label: "New",
        companyName: this.companyName,
        enquiry_status:true,
      };
      let requestData = {
        domain_name: ORG_DETAILS.DOMAIN_NAME,
        user_id: ORG_DETAILS.USER_ID,
        payload: {
          order_creation: enquiry,
        },
        extras: {
          find: {
            id: "",
          },
        },
      };
console.log(this.enquiryForm_vimpro.value.message.length,"test123")
//console.log(this.enquiryForm.value.message.trim(),"test123")

console.log(this.enquiryForm_vimpro.value.message[0],"test123")




if (/\S/.test(this.enquiryForm_vimpro.value.message)) {
  console.log("1")

  //console.log(this.enquiryForm.value.message[0]== null,"test123")
  // string is not empty and not just whitespace
}
else{
  console.log("0")
}



console.log(this.enquiryForm.value.message[0] === "space","test123")
console.log(this.enquiryForm.value.message[0]=== 'space',"test123")
      // let requestData = {
      //   payload: encrypted
      // }
      this.checkoutApiService
        .checkoutAPICall(ENDPOINTS.ORDER_UPDATION, requestData)
        .then((respData) => {
          let res: any = respData;
          if (res.success) {
            let OrderId = res.data[0].id;
            this.closeModal.nativeElement.click();
            this.checkoutLocalStorageService.setOrderId({ orderId: OrderId });
            this.alertService.success("Request Submitted", this.options);
            
            this.enquiryForm_vimpro.reset({
              name: "",
              email: "",
              phone_number: "",
              category: "",
              message: "",
            });
          }
        });
    }

    // formData["name"] = this.enquiryForm.value.name;
    // formData["email"] = this.enquiryForm.value.email;
    // formData["phone_number"] = this.enquiryForm.value.phone_number;
    // formData["category"] = this.enquiryForm.value.category;
    // formData["message"] = this.enquiryForm.value.message;
    // formData["member_id"] = this.memberId;
    // formData['status'] = 'New'
    // formDataJson = {
    //   domain_name: ORG_DETAILS.DOMAIN_NAME,
    //   user_id: ORG_DETAILS.USER_ID,
    //   payload: {
    //     enquiry_creation: formData
    //   }
    // }
    // MAKE A SERVICE CALL HERE...
    // this.appService.postApiCall(formDataJson, ENDPOINTS.ADD_ENQUIRY).subscribe(
    //   resp => {
    //     if (resp) {
    //       if (resp.success === 1 && resp.status_code === 200) {
    //         this.alertService.success('Request Received', this.options);
    //         window.scrollTo({top: 0, behavior: 'smooth'});

    //       }
    //       else if (resp.success === 0) {
    //         if (resp.message) {
    //           this.alertService.error(resp.message, this.options);
    //           window.scrollTo({top: 0, behavior: 'smooth'});
    //         }
    //       }
    //       else if (resp.message && resp.status_code !== 200) {
    //         this.alertService.error(resp.message, this.options);
    //         window.scrollTo({top: 0, behavior: 'smooth'});
    //       }
    //       else {
    //         this.alertService.error('Something bad happened. Please try again!', this.options);
    //         window.scrollTo({top: 0, behavior: 'smooth'});
    //       }
    //     }
    //   },
    //   err => {
    //     if (err.error.statusCode === 403) {
    //       this.alertService.error('Session Time Out! Please login Again', this.options)
    //       this.router.navigate([`/login-new`], { skipLocationChange: false });
    //     }
    //     else if (err.error.message) {
    //       this.alertService.error(err.error.message, this.options)
    //       window.scrollTo({top: 0, behavior: 'smooth'});
    //     }
    //     else if (err.error.error.message) {
    //       this.alertService.error(err.error.error.message, this.options)
    //       window.scrollTo({top: 0, behavior: 'smooth'});
    //     }
    //     else {
    //       this.alertService.error('Something bad happened. Please try again!', this.options);
    //       window.scrollTo({top: 0, behavior: 'smooth'});
    //     }
    //   }
    // )
    //   ;
  }

  submitEnquiryForVimpro(product){
    this.vimpro_pro_name=product.name;
    let userId = this.localService.get('UserId');
      let aiemaUserName = this.appService.userName;
      this.memberId = product.memberId;
      this.companyName = product.name;
      if (userId) {
        this.enquiryForm_vimpro.reset({ name: "", message: "" });
        this.enquiryForm_vimpro.controls['name'].setValue(aiemaUserName)
        this.enquiryForm_vimpro.controls["email"].setValue(
          this.customerLoginStorageService.getCustomerData().email
        );
        this.enquiryForm_vimpro.controls["phone_number"].setValue(
          this.customerLoginStorageService.getCustomerData().mobileNo
        );
        this.enquiryForm_vimpro.controls["category"].setValue(
          product.categories[0].categories
        );
        this.enquiryForm_vimpro.controls["product_name"].setValue(
          product.name
          
        );
        
        
        this.material_vimpro=[];
        product.product_material.forEach(element => {
          this.material_vimpro.push(element.name)
        });
        this.color_vimpro=[];
        product.color.forEach(element => {
          if(element.name.toLowerCase().includes('standard'))
          {
            this.color_vimpro.push('Black')
            this.color_vimpro.push('White')
            this.color_vimpro.push('Green')
          }
          else{
            this.color_vimpro.push(element.name)
          }
          
        });
        // if(product.color==null||product.color==undefined){
        //   this.color_vimpro.push('Black')
        //   this.color_vimpro.push('White')
        //   this.color_vimpro.push('Green')
        // }
        this.enquiryForm_vimpro.controls['material'].setValue( this.material_vimpro[0], {onlySelf: true});
        this.enquiryForm_vimpro.controls['color'].setValue( this.color_vimpro[0], {onlySelf: true});
        this.enquiryForm_vimpro.controls['usage'].setValue( this.usage_vimpro[0], {onlySelf: true});
        document.getElementById("launch-model-vimpro").click();
      } else {
        this.router.navigate(["/login-new"], {
          queryParams: { productId: product.id },
          relativeTo: this.route,
          skipLocationChange: false,
        });
      }
    }
    submitEnquiryForSpecial(product){
      this.special_pro_name=product.name;
      let userId = this.localService.get('UserId');
        let aiemaUserName = this.appService.userName;
        this.memberId = product.memberId;
        this.companyName = product.name;
        console.log("ppppaoappp")
        if (userId) {
        console.log("ttttttttt")

          this.enquiryForm_special.reset({ name: "", message: "" });
          this.enquiryForm_special.controls['name'].setValue(aiemaUserName)
          this.enquiryForm_special.controls["email"].setValue(
            this.customerLoginStorageService.getCustomerData().email
          );
          this.enquiryForm_special.controls["phone_number"].setValue(
            this.customerLoginStorageService.getCustomerData().mobileNo
          );
          this.enquiryForm_special.controls["category"].setValue(
            product.categories[0].categories
          );
          this.enquiryForm_special.controls["product_name"].setValue(
            product.name
            
          );
          document.getElementById("launch-model-special").click();
        } else {
          this.router.navigate(["/login-new"], {
            relativeTo: this.route,
            skipLocationChange: false,
          });
        }
      }
  /**
   * Function when called will delete all the mask images under the product number
   * @param indexOfProduct:number, used as the number in "maskImage_(indexOfProduct)_maskNumber"
   */
  deleteProductImages(indexOfProduct: number) {

    // removes all the mask images from the image list
    for(let maskNumber=0; maskNumber<this.numberOfMaskUploads; maskNumber++) {
      delete this.imagelist["maskImage_"+indexOfProduct+"_"+maskNumber];
    }

    this.numberOfProductsBestGifts -= 1;
    this.reorderImages();

  }


  bestGiftsChangeQuantity (index, minimum: number, event) {


    if(Number(this.localService.get('max_cart_qty')) < this.bestGiftsCalculateCartAndCurrentQuantity()) {
      
    } else {
      if(event.target.value <= minimum) {
        event.target.value = minimum
        this.modelForBindingInputs['individualQuantity_'+index] = minimum
      } 
    }

  }

  decreaseBestGiftsIndividualQuantity(i) {
    if(this.modelForBindingInputs['individualQuantity_'+i] - 1 > 0) {
      this.modelForBindingInputs['individualQuantity_'+i] = this.modelForBindingInputs['individualQuantity_'+i] - 1;
    }
  }

  increaseBestGiftsIndividualQuantity(i) {
    if(Number(this.localService.get('max_cart_qty')) <= this.bestGiftsCalculateCartAndCurrentQuantity()) {
      this.alertService.error('maximum Cart value has been reached!', this.options);
    } else {
      this.modelForBindingInputs['individualQuantity_'+i] = this.modelForBindingInputs['individualQuantity_'+i] + 1;
    }
  }

  onDeleteInBestGifts (index: number) {
    let indexToDelete = index - 1; 
    if(indexToDelete != Object.keys(this.modelForBindingInputs).length-1) {
      for(let i=indexToDelete; i<Object.keys(this.modelForBindingInputs).length-1; i++) {
        this.modelForBindingInputs["individualQuantity_" +i] = this.modelForBindingInputs["individualQuantity_" +(i+1)];
        this.modelForBindingTextInputs["text_"+i] = this.modelForBindingTextInputs["text_"+(i+1)];
      }  
      delete this.modelForBindingInputs["individualQuantity_" + (Object.keys(this.modelForBindingInputs).length-1)]
      delete this.modelForBindingTextInputs["text_" + (Object.keys(this.modelForBindingTextInputs).length-1)]
    } else {
      delete this.modelForBindingInputs["individualQuantity_" + indexToDelete]
      delete this.modelForBindingTextInputs["text_" + indexToDelete]
    }

  }

  /**
   * Function written to calculate the cart quantity and the current quantity in the modal 
   * (event if the data in the modal is not saved.)
   */
  bestGiftsCalculateCartAndCurrentQuantity(): number {
    let currentCart = this.appService.cartProducts.results;

    let updatedCartLength: number = 0;
    let modalQuantity: number = 0;


    // For in through all the current quantities in the modal
    for(let quantity in this.modelForBindingInputs) {
      modalQuantity += parseInt(this.modelForBindingInputs[quantity])
    }

    // Remove the existing current product quantity from the total
    currentCart.forEach((product) => {
      updatedCartLength += product.quantity
      if(product.product_id == this.newProductDetails.id) {
        updatedCartLength -= product.quantity
      }
    })


    return (modalQuantity + updatedCartLength)
  }


  getBestGiftsProfileDetails(id) {
    let requestBody = {
      "domain_name": ORG_DETAILS.DOMAIN_NAME,
      "user_id": ORG_DETAILS.USER_ID,
      "extras": {
        "find": {
          "id" : id
        }
      }
    }
    // MAKE A SERVICE CALL HERE...
    this.appService.postApiCall(requestBody,ENDPOINTS.GET_CUSTOMER,).subscribe(
      resp => {
        if (resp) {
       
          this.customerType1= resp.result.data[0].customer_type;
        }
        else{
        }
       
      },
      err => {
       
       
      }
    )
}

scrollToElement() {
  var elmnt = document.getElementById("deeraChart");
  elmnt.scrollIntoView({behavior:'smooth'});
}
getSocialMediaDetails(){
   
  // REQUEST DATA
  let request_data = {
    "domain_name": ORG_DETAILS.DOMAIN_NAME,
    "user_id": ORG_DETAILS.USER_ID,
    "extras": {
        "find": {}
    }
  }
  // MAKE AN API CALL
  this.appService.postApiCall(request_data, ENDPOINTS.STORE_GALLERY).subscribe(  //LINE 
    resp => {
      let respData = resp.result.data[0];
      if(respData.social){
        if(respData.social.media.length > 0){          
          this.socialMediaData = respData.social.media;
        }
        
        this.socialMediaData.forEach(social => {
         if(social.media_name === 'Facebook' && social.media_link !== ''){
            this.facebookLink = social.media_link
         } else if(social.media_name === 'Twitter' && social.media_link !== ''){
          this.twitterLink = social.media_link
         } else if(social.media_name === 'Instagram' && social.media_link !== ''){
          this.instagramLink = social.media_link
         } else if(social.media_name === 'WhatsApp' && social.media_link !== ''){
          this.whatsappLink = social.media_link
         }
        
      });
      }
    },
    err => {
      if (err.error.error.message) {
        console.log(err.error.error.message)
      }
      
      else{
        console.log('Something bad happened; Please try again!')
      }
    })
}
windowOpen(social){
  window.open(social)
}
remindLater(){
  let userId = this.localService.get('UserId');
  if(userId){
    this.alertService.success("Remainder Initiated. You will receive notification once the product is available", this.options);
    window.scrollTo({top: 0, behavior: 'smooth'});
  }
  else{
    this.router.navigate(["/login-new"], {
      queryParams: { "forLogin": ""},
      relativeTo: this.route,
      skipLocationChange: false,
    });
  }
}
productsListHob(category: string) {
  const params = category.split('/').map(param => param.replace(/\s+/g, '-'));
    console.log("URL BBJAH1111111111111111111", params)
    this.router.navigate(['/productListing', ...params]).then(() => {
      this.scrollToSection();
    });
}
scrollToSection(fragment: string = 'targetSection') {
  const targetElement = document.getElementById(fragment);
  if (targetElement) {
    targetElement.scrollIntoView({ behavior: 'smooth' });
  } else {
    console.log(`${fragment} not found, retrying...`);
    setTimeout(() => {
      this.scrollToSection(fragment);
    }, 500);
  }
}
getCurrentURL () {
  return window.location.href
}
splitProductString(productString: string) {
  // Split the uniqueName into parts
  
  const parts = productString.split('-');

  // Initialize IDs
  this.productId = '';
  this.productChildId = '';

  // Extract possible numeric IDs from the end
  const possibleChildId = parts[parts.length - 1];
  const possibleParentId = parts[parts.length - 2];
console.log("Test for possible ids :",possibleChildId,possibleParentId)
  // Assign child ID if the last part is numeric
  if (!isNaN(Number(possibleChildId))) {
    this.productChildId = parts.pop(); // Remove and assign last part as Product Child ID
  }

  // Assign parent ID if the new last part is numeric
  if (!isNaN(Number(possibleParentId))) {
    this.productId = parts.pop(); // Remove and assign second last part as Product ID
  }

  // The remaining parts form the product name
  const name = parts.join('-');

  console.log("Parsed Details:", {
    productName: name,
    productId: this.productId,
    productChildId: this.productChildId,
  });
}

findVariant(){
  console.log("Test that it appears here")
  let requestData = {
    "domain_name": ORG_DETAILS.DOMAIN_NAME,
    "user_id": ORG_DETAILS.USER_ID,
    "outlet_id":Number(this.outletId),
    // "outlet_id":"",
    "extras": {
      "find": {
        "id": Number(this.childPaulid),
        // "outlet_id":this.outletId,
      },
      "pagination": false,
      "paginationDetails": {
        "limit": 0,
        "pageSize": 2
      },
      "sorting": true,
      "sortingDetails": {
        "sortfield": "sort_order",
        "sortorder": 1
      }
    }
  }
  this.appService.postApiCall(requestData, ENDPOINTS.PRODUCT_DETAILS).subscribe(
    resp => {
      console.log("childProduct",resp.result.data,this.varianName)
      if(ORG_DETAILS.NAME==='Srimaware'){
        this.splitAndStoreParts(resp.result.data[0].name)
      }
      else if(ORG_DETAILS.NAME==='HOB' || ORG_DETAILS.NAME==='PaulCaroline'){
        this.splitAndStoreHOB(resp.result.data[0].name)
      }
      else{
      this.splitAndStoreLastTwoWords(resp.result.data[0].name)
    }
      const index = this.product.variant.option_values.findIndex(item => item.option === this.varianName);
      console.log("ProductTssaa",resp.result.data,this.product.variant.option_values,index)
      this.current_index = index;
      if(this.product.variant.option_values[index].child){
      const childindex = this.product.variant.option_values[index].child.findIndex(item => item.type === this.childName);
      console.log("Indexof the child found",childindex)
      if(ORG_DETAILS.NAME==='LushNGreen'){
        this.onConfirm1(this.product.variant.option_values,this.id, index)
        this.selectColour(this.product.variant.option_values[index].child[this.child_index].color,this.product.id,childindex)
      }
      else if(ORG_DETAILS.NAME==='Srimaware'){
        this.onConfirmPaul(this.product.variant.option_values,this.id, index)
        this.selectColourPaul(this.product.variant.option_values[index].child[this.child_index].color,this.product.id,childindex)
      }
      else if(ORG_DETAILS.NAME==='HOB' || ORG_DETAILS.NAME==='PaulCaroline') {
        if(this.product.variant.option_values[index].child){
          console.log("Entering here is good",index)
          this.onConfirmPaul(this.product.variant.option_values,this.id, index)
          this.selectColourPaul(this.product.variant.option_values[index].child[this.child_index].color,this.product.id,childindex)
        }
      }
      }
     
      if(ORG_DETAILS.NAME==='HOB' || ORG_DETAILS.NAME==='PaulCaroline') {
      if(!this.product.variant.option_values[index].child){
        this.onConfirmPaul(this.product.variant.option_values,this.id, index)
      }

      }
    }
  )
}
splitAndStoreLastTwoWords(productString: string) {
  const parts = productString.split(' ');
console.log("Name of the variant",productString)
  this.childName = parts.pop();
  this.varianName = parts.pop();
  console.log("Name of the variant color",this.varianName)
  return
}
splitAndStoreParts(productString: string) {
  console.log("Original product string:", productString, this.product.name);

  // Remove the product name (`this.product.name`) from the beginning of the string
  const trimmedString = productString.replace(this.product.name, '').trim();

  console.log("Trimmed product string (without main product name):", trimmedString);

  const parts = trimmedString.split(' ');

  // Extract the last word as the childName (e.g., "Red")
  this.childName = parts.pop();

  // The remaining words form the middle descriptive part
  const middlePart = parts.join(' '); // Combine remaining words
this.varianName = middlePart
  console.log("Middle descriptive part:", middlePart);
  console.log("Last word (child name):", this.childName);

  return;
}
splitAndStoreHOB(productString: string) {
  console.log("Original product string:", productString, this.product.name);

  // Remove the product name (`this.product.name`) from the beginning of the string
  const trimmedString = productString.replace(this.product.name, '').trim();
  console.log("Trimmed product string (without main product name):", trimmedString);

  const parts = trimmedString.split(' ');

  if (this.product.variant.option_values[this.current_index]?.child) {
    // Extract the first word as `varianName` (e.g., "M")
    this.varianName = parts.shift(); // Take the first word
    // Combine the rest as `childName` (e.g., "Red Sauce")
    this.childName = parts.join(' '); // Combine remaining words
  } else {
    // In case `child` is not present, the last word is `varianName`
    this.childName = null; // No child name in this case
    this.varianName = parts.pop(); // Take the last word
  }

  console.log("Variant Name:", this.varianName);
  console.log("Child Name:", this.childName);

  return;
}
}
